const statesncities = [
    {
        "state": "Alabama",
        "abbr": "AL",
        "cities": [
            "Abbeville",
            "Abernant",
            "Adamsville",
            "Addison",
            "Adger",
            "Akron",
            "Alabaster",
            "Alberta",
            "Albertville",
            "Alexander City",
            "Alexandria",
            "Aliceville",
            "Allgood",
            "Alma",
            "Alpine",
            "Alton",
            "Altoona",
            "Andalusia",
            "Anderson",
            "Annemanie",
            "Anniston",
            "Arab",
            "Ardmore",
            "Ariton",
            "Arley",
            "Arlington",
            "Ashford",
            "Ashland",
            "Ashville",
            "Athens",
            "Atmore",
            "Attalla",
            "Auburn",
            "Auburn University",
            "Autaugaville",
            "Axis",
            "Baileyton",
            "Banks",
            "Bankston",
            "Bay Minette",
            "Bayou La Batre",
            "Bear Creek",
            "Beatrice",
            "Beaverton",
            "Belk",
            "Bellamy",
            "Belle Mina",
            "Bellwood",
            "Berry",
            "Bessemer",
            "Billingsley",
            "Birmingham",
            "Black",
            "Blountsville",
            "Boaz",
            "Boligee",
            "Bon Air",
            "Bon Secour",
            "Booth",
            "Boykin",
            "Brantley",
            "Bremen",
            "Brent",
            "Brewton",
            "Bridgeport",
            "Brierfield",
            "Brilliant",
            "Brooklyn",
            "Brookside",
            "Brookwood",
            "Brownsboro",
            "Brundidge",
            "Bryant",
            "Bucks",
            "Buhl",
            "Burnt Corn",
            "Burnwell",
            "Butler",
            "Bynum",
            "Calera",
            "Calvert",
            "Camden",
            "Camp Hill",
            "Campbell",
            "Capshaw",
            "Carbon Hill",
            "Cardiff",
            "Carlton",
            "Carrollton",
            "Castleberry",
            "Catherine",
            "Cecil",
            "Cedar Bluff",
            "Centre",
            "Centreville",
            "Chancellor",
            "Chapman",
            "Chatom",
            "Chelsea",
            "Cherokee",
            "Childersburg",
            "Choccolocco",
            "Chunchula",
            "Citronelle",
            "Clanton",
            "Clay",
            "Clayton",
            "Cleveland",
            "Clinton",
            "Clio",
            "Clopton",
            "Cloverdale",
            "Coaling",
            "Coden",
            "Coffee Springs",
            "Coffeeville",
            "Coker",
            "Collinsville",
            "Columbia",
            "Columbiana",
            "Cook Springs",
            "Coosada",
            "Cordova",
            "Cottondale",
            "Cottonton",
            "Cottonwood",
            "Courtland",
            "Cowarts",
            "Coy",
            "Cragford",
            "Crane Hill",
            "Creola",
            "Cromwell",
            "Cropwell",
            "Crossville",
            "Cuba",
            "Cullman",
            "Cusseta",
            "Dadeville",
            "Daleville",
            "Danville",
            "Daphne",
            "Dauphin Island",
            "Daviston",
            "Dawson",
            "De Armanville",
            "Deatsville",
            "Decatur",
            "Deer Park",
            "Delmar",
            "Delta",
            "Demopolis",
            "Detroit",
            "Dickinson",
            "Dixons Mills",
            "Docena",
            "Dolomite",
            "Dora",
            "Dothan",
            "Double Springs",
            "Douglas",
            "Dozier",
            "Duncanville",
            "Dutton",
            "East Tallassee",
            "Eastaboga",
            "Echola",
            "Eclectic",
            "Edwardsville",
            "Eight Mile",
            "Elba",
            "Elberta",
            "Eldridge",
            "Elkmont",
            "Elmore",
            "Elrod",
            "Emelle",
            "Empire",
            "Enterprise",
            "Epes",
            "Equality",
            "Estillfork",
            "Ethelsville",
            "Eufaula",
            "Eutaw",
            "Eva",
            "Evergreen",
            "Excel",
            "Fackler",
            "Fairfield",
            "Fairhope",
            "Falkville",
            "Faunsdale",
            "Fayette",
            "Fitzpatrick",
            "Five Points",
            "Flat Rock",
            "Flomaton",
            "Florala",
            "Florence",
            "Foley",
            "Forest Home",
            "Forkland",
            "Fort Davis",
            "Fort Deposit",
            "Fort Mitchell",
            "Fort Payne",
            "Fort Rucker",
            "Fosters",
            "Franklin",
            "Frankville",
            "Frisco City",
            "Fruitdale",
            "Fruithurst",
            "Fulton",
            "Fultondale",
            "Furman",
            "Fyffe",
            "Gadsden",
            "Gainestown",
            "Gainesville",
            "Gallant",
            "Gallion",
            "Gantt",
            "Garden City",
            "Gardendale",
            "Gaylesville",
            "Geneva",
            "Georgiana",
            "Geraldine",
            "Gilbertown",
            "Glen Allen",
            "Glenwood",
            "Goodsprings",
            "Goodwater",
            "Goodway",
            "Gordo",
            "Gordon",
            "Goshen",
            "Grady",
            "Graham",
            "Grand Bay",
            "Grant",
            "Graysville",
            "Green Pond",
            "Greensboro",
            "Greenville",
            "Grove Hill",
            "Groveoak",
            "Guin",
            "Gulf Shores",
            "Guntersville",
            "Gurley",
            "Hackleburg",
            "Haleyville",
            "Hamilton",
            "Hanceville",
            "Hardaway",
            "Harpersville",
            "Hartford",
            "Hartselle",
            "Harvest",
            "Hatchechubbee",
            "Hayden",
            "Hayneville",
            "Hazel Green",
            "Headland",
            "Heflin",
            "Helena",
            "Henagar",
            "Higdon",
            "Highland Home",
            "Hillsboro",
            "Hodges",
            "Hollins",
            "Holly Pond",
            "Hollytree",
            "Hollywood",
            "Holy Trinity",
            "Honoraville",
            "Hoover",
            "Hope Hull",
            "Horton",
            "Houston",
            "Huntsville",
            "Hurtsboro",
            "Huxford",
            "Ider",
            "Irvington",
            "Iuka",
            "Jachin",
            "Jack",
            "Jackson",
            "Jacksons Gap",
            "Jacksonville",
            "Jasper",
            "Jefferson",
            "Jemison",
            "Jones",
            "Joppa",
            "Kansas",
            "Kellerman",
            "Kellyton",
            "Kennedy",
            "Kent",
            "Killen",
            "Kimberly",
            "Kinston",
            "Knoxville",
            "Laceys Spring",
            "Lafayette",
            "Lanett",
            "Langston",
            "Lapine",
            "Lawley",
            "Leeds",
            "Leesburg",
            "Leighton",
            "Lenox",
            "Leroy",
            "Lester",
            "Letohatchee",
            "Lexington",
            "Lillian",
            "Lincoln",
            "Linden",
            "Lineville",
            "Lisman",
            "Little River",
            "Livingston",
            "Loachapoka",
            "Lockhart",
            "Locust Fork",
            "Logan",
            "Louisville",
            "Lower Peach Tree",
            "Lowndesboro",
            "Loxley",
            "Luverne",
            "Lynn",
            "Madison",
            "Magnolia",
            "Magnolia Springs",
            "Malcolm",
            "Malvern",
            "Maplesville",
            "Marbury",
            "Margaret",
            "Marion",
            "Marion Junction",
            "Mathews",
            "Maylene",
            "McCalla",
            "McIntosh",
            "McKenzie",
            "McShan",
            "McWilliams",
            "Megargel",
            "Melvin",
            "Mentone",
            "Meridianville",
            "Mexia",
            "Midland City",
            "Midway",
            "Millbrook",
            "Millerville",
            "Millport",
            "Millry",
            "Minter",
            "Mobile",
            "Monroeville",
            "Montevallo",
            "Montgomery",
            "Montrose",
            "Moody",
            "Mooresville",
            "Morris",
            "Morvin",
            "Moulton",
            "Moundville",
            "Mount Hope",
            "Mount Meigs",
            "Mount Olive",
            "Mount Vernon",
            "Mulga",
            "Munford",
            "Muscadine",
            "Muscle Shoals",
            "Myrtlewood",
            "Nanafalia",
            "Natural Bridge",
            "Nauvoo",
            "Needham",
            "New Brockton",
            "New Castle",
            "New Hope",
            "New Market",
            "Newbern",
            "Newell",
            "Newton",
            "Newville",
            "Normal",
            "Northport",
            "Notasulga",
            "Oak Hill",
            "Oakman",
            "Odenville",
            "Ohatchee",
            "Oneonta",
            "Opelika",
            "Opp",
            "Orange Beach",
            "Orrville",
            "Owens Cross Roads",
            "Ozark",
            "Paint Rock",
            "Palmerdale",
            "Panola",
            "Pansey",
            "Parrish",
            "Pelham",
            "Pell City",
            "Pennington",
            "Perdido",
            "Perdue Hill",
            "Perote",
            "Peterman",
            "Peterson",
            "Petrey",
            "Phenix City",
            "Phil Campbell",
            "Piedmont",
            "Pike Road",
            "Pinckard",
            "Pine Apple",
            "Pine Hill",
            "Pine Level",
            "Pinson",
            "Pisgah",
            "Pittsview",
            "Plantersville",
            "Pleasant Grove",
            "Point Clear",
            "Prattville",
            "Princeton",
            "Quinton",
            "Ragland",
            "Rainbow City",
            "Rainsville",
            "Ralph",
            "Ramer",
            "Ranburne",
            "Randolph",
            "Range",
            "Red Bay",
            "Red Level",
            "Reform",
            "Remlap",
            "Repton",
            "River Falls",
            "Riverside",
            "Roanoke",
            "Robertsdale",
            "Rockford",
            "Rogersville",
            "Russellville",
            "Rutledge",
            "Ryland",
            "Safford",
            "Saginaw",
            "Saint Elmo",
            "Saint Stephens",
            "Salem",
            "Salitpa",
            "Samantha",
            "Samson",
            "Saraland",
            "Sardis",
            "Satsuma",
            "Sawyerville",
            "Sayre",
            "Scottsboro",
            "Seale",
            "Section",
            "Selma",
            "Seminole",
            "Semmes",
            "Shannon",
            "Sheffield",
            "Shelby",
            "Shorter",
            "Shorterville",
            "Silas",
            "Siluria",
            "Silverhill",
            "Sipsey",
            "Skipperville",
            "Slocomb",
            "Smiths",
            "Snow Hill",
            "Somerville",
            "Spanish Fort",
            "Spring Garden",
            "Springville",
            "Sprott",
            "Spruce Pine",
            "Stanton",
            "Stapleton",
            "Steele",
            "Sterrett",
            "Stevenson",
            "Stockton",
            "Sulligent",
            "Sumiton",
            "Summerdale",
            "Sunflower",
            "Sweet Water",
            "Sycamore",
            "Sylacauga",
            "Sylvania",
            "Talladega",
            "Tallassee",
            "Tanner",
            "Theodore",
            "Thomaston",
            "Thomasville",
            "Thorsby",
            "Tibbie",
            "Titus",
            "Toney",
            "Town Creek",
            "Townley",
            "Toxey",
            "Trafford",
            "Trenton",
            "Trinity",
            "Troy",
            "Trussville",
            "Tuscaloosa",
            "Tuscumbia",
            "Tuskegee",
            "Tuskegee Institute",
            "Tyler",
            "Union Grove",
            "Union Springs",
            "Uniontown",
            "Uriah",
            "Valhermoso Springs",
            "Valley",
            "Valley Head",
            "Vance",
            "Vandiver",
            "Verbena",
            "Vernon",
            "Vina",
            "Vincent",
            "Vinegar Bend",
            "Vinemont",
            "Vredenburgh",
            "Wadley",
            "Wagarville",
            "Walker Springs",
            "Walnut Grove",
            "Ward",
            "Warrior",
            "Waterloo",
            "Watson",
            "Wattsville",
            "Waverly",
            "Weaver",
            "Webb",
            "Wedowee",
            "Wellington",
            "Weogufka",
            "West Blocton",
            "West Greene",
            "Westover",
            "Wetumpka",
            "Whatley",
            "Wilmer",
            "Wilsonville",
            "Wilton",
            "Winfield",
            "Wing",
            "Woodland",
            "Woodstock",
            "Woodville",
            "York"
        ]
    },
    {
        "state": "Alaska",
        "abbr": "AK",
        "cities": [
            "Adak",
            "Akiachak",
            "Akiak",
            "Akutan",
            "Alakanuk",
            "Aleknagik",
            "Allakaket",
            "Ambler",
            "Anaktuvuk Pass",
            "Anchor Point",
            "Anchorage",
            "Anderson",
            "Angoon",
            "Aniak",
            "Anvik",
            "Arctic Village",
            "Atka",
            "Atqasuk",
            "Auke Bay",
            "Barrow",
            "Beaver",
            "Bethel",
            "Bettles Field",
            "Big Lake",
            "Brevig Mission",
            "Buckland",
            "Cantwell",
            "Central",
            "Chalkyitsik",
            "Chefornak",
            "Chevak",
            "Chicken",
            "Chignik",
            "Chignik Lagoon",
            "Chignik Lake",
            "Chitina",
            "Chugiak",
            "Circle",
            "Clam Gulch",
            "Clarks Point",
            "Clear",
            "Coffman Cove",
            "Cold Bay",
            "College",
            "Cooper Landing",
            "Copper Center",
            "Cordova",
            "Craig",
            "Crooked Creek",
            "Deering",
            "Delta Junction",
            "Denali National Park",
            "Dillingham",
            "Douglas",
            "Dutch Harbor",
            "Eagle",
            "Eagle River",
            "Eek",
            "Egegik",
            "Eielson AFB",
            "Ekwok",
            "Elfin Cove",
            "Elim",
            "Elmendorf AFB",
            "Emmonak",
            "Ester",
            "Fairbanks",
            "False Pass",
            "Flat",
            "Fort Richardson",
            "Fort Wainwright",
            "Fort Yukon",
            "Funny River",
            "Gakona",
            "Galena",
            "Gambell",
            "Girdwood",
            "Glennallen",
            "Goodnews Bay",
            "Grayling",
            "Gustavus",
            "Haines",
            "Healy",
            "Holy Cross",
            "Homer",
            "Hoonah",
            "Hooper Bay",
            "Hope",
            "Houston",
            "Hughes",
            "Huslia",
            "Hydaburg",
            "Hyder",
            "Iliamna",
            "Indian",
            "Juneau",
            "Kake",
            "Kaktovik",
            "Kalskag",
            "Kaltag",
            "Karluk",
            "Kasigluk",
            "Kasilof",
            "Kenai",
            "Ketchikan",
            "Kiana",
            "King Cove",
            "King Salmon",
            "Kipnuk",
            "Kivalina",
            "Klawock",
            "Knik",
            "Kobuk",
            "Kodiak",
            "Kotlik",
            "Kotzebue",
            "Koyuk",
            "Koyukuk",
            "Kwethluk",
            "Kwigillingok",
            "Lake Minchumina",
            "Larsen Bay",
            "Levelock",
            "Lower Kalskag",
            "Manley Hot Springs",
            "Manokotak",
            "Marshall",
            "McGrath",
            "Mekoryuk",
            "Metlakatla",
            "Meyers Chuck",
            "Minto",
            "Moose Pass",
            "Mountain Village",
            "Naknek",
            "Napakiak",
            "Nenana",
            "New Stuyahok",
            "Nightmute",
            "Nikiski",
            "Nikolai",
            "Nikolski",
            "Ninilchik",
            "Noatak",
            "Nome",
            "Nondalton",
            "Noorvik",
            "North Pole",
            "Northway",
            "Nuiqsut",
            "Nulato",
            "Nunapitchuk",
            "Old Harbor",
            "Ouzinkie",
            "Palmer",
            "Pedro Bay",
            "Pelican",
            "Perryville",
            "Petersburg",
            "Pilot Point",
            "Pilot Station",
            "Platinum",
            "Point Baker",
            "Point Hope",
            "Point Lay",
            "Port Alexander",
            "Port Alsworth",
            "Port Heiden",
            "Port Lions",
            "Prudhoe Bay",
            "Quinhagak",
            "Rampart",
            "Red Devil",
            "Ruby",
            "Russian Mission",
            "Saint George Island",
            "Saint Marys",
            "Saint Michael",
            "Saint Paul Island",
            "Salcha",
            "Sand Point",
            "Savoonga",
            "Scammon Bay",
            "Selawik",
            "Seldovia",
            "Seward",
            "Shageluk",
            "Shaktoolik",
            "Sheldon Point",
            "Shishmaref",
            "Shungnak",
            "Sitka",
            "Skagway",
            "Skwentna",
            "Sleetmute",
            "Soldotna",
            "South Naknek",
            "Stebbins",
            "Sterling",
            "Stevens Village",
            "Sutton",
            "Takotna",
            "Talkeetna",
            "Tanacross",
            "Tanana",
            "Tatitlek",
            "Teller",
            "Tenakee Springs",
            "Tetlin",
            "Thorne Bay",
            "Togiak",
            "Tok",
            "Toksook Bay",
            "Trapper Creek",
            "Tuluksak",
            "Tuntutuliak",
            "Tununak",
            "Two Rivers",
            "Tyonek",
            "Unalakleet",
            "Unalaska",
            "Valdez",
            "Venetie",
            "Wainwright",
            "Wales",
            "Ward Cove",
            "Wasilla",
            "White Mountain",
            "Whittier",
            "Willow",
            "Wrangell",
            "Yakutat"
        ]
    },
    {
        "state": "Arizona",
        "abbr": "AZ",
        "cities": [
            "Aguila",
            "Ajo",
            "Alpine",
            "Amado",
            "Anthem",
            "Apache Junction",
            "Arivaca",
            "Arizona City",
            "Arlington",
            "Ash Fork",
            "Avondale",
            "Bagdad",
            "Bapchule",
            "Bellemont",
            "Benson",
            "Big Park",
            "Bisbee",
            "Black Canyon City",
            "Blue",
            "Blue Gap",
            "Bouse",
            "Bowie",
            "Buckeye",
            "Bullhead City",
            "Bylas",
            "Cameron",
            "Camp Verde",
            "Carefree",
            "Casa Grande",
            "Cashion",
            "Catalina",
            "Cave Creek",
            "Central",
            "Chambers",
            "Chandler",
            "Chandler Heights",
            "Chinle",
            "Chino Valley",
            "Chloride",
            "Cibecue",
            "Cibola",
            "Clarkdale",
            "Clay Springs",
            "Claypool",
            "Clifton",
            "Cochise",
            "Colorado City",
            "Concho",
            "Congress",
            "Coolidge",
            "Cornville",
            "Cortaro",
            "Cottonwood",
            "Crown King",
            "Dateland",
            "Dennehotso",
            "Dewey",
            "Dolan Springs",
            "Douglas",
            "Dragoon",
            "Duncan",
            "Eagar",
            "Eden",
            "Ehrenberg",
            "El Mirage",
            "Elfrida",
            "Elgin",
            "Eloy",
            "Flagstaff",
            "Florence",
            "Forest Lakes",
            "Fort Apache",
            "Fort Defiance",
            "Fort Huachuca",
            "Fort Mcdowell",
            "Fort Mohave",
            "Fort Thomas",
            "Fountain Hills",
            "Fredonia",
            "Gadsden",
            "Ganado",
            "Gila Bend",
            "Gilbert",
            "Glendale",
            "Globe",
            "Gold Camp",
            "Golden Valley",
            "Goodyear",
            "Grand Canyon",
            "Gray Mountain",
            "Green Valley",
            "Greer",
            "Hackberry",
            "Happy Jack",
            "Hayden",
            "Heber",
            "Hereford",
            "Higley",
            "Holbrook",
            "Hotevilla",
            "Houck",
            "Huachuca City",
            "Hualapai",
            "Humboldt",
            "Indian Wells",
            "Iron Springs",
            "Jerome",
            "Joseph City",
            "Kaibito",
            "Kayenta",
            "Keams Canyon",
            "Kearny",
            "Kingman",
            "Kirkland",
            "Kykotsmovi Village",
            "Lake Havasu City",
            "Lake Montezuma",
            "Lakeside",
            "Laveen",
            "Leupp",
            "Litchfield Park",
            "Littlefield",
            "Lukachukai",
            "Luke AFB",
            "Lukeville",
            "Lupton",
            "Mammoth",
            "Many Farms",
            "Marana",
            "Marble Canyon",
            "Maricopa",
            "Mayer",
            "Mcnary",
            "McNeal",
            "Meadview",
            "Mesa",
            "Mesquite",
            "Miami",
            "Mohave Valley",
            "Monument Valley",
            "Morenci",
            "Mormon Lake",
            "Morristown",
            "Mount Lemmon",
            "Munds Park",
            "Naco",
            "Navajo",
            "Nazlini",
            "New River",
            "Nogales",
            "North Rim",
            "Nutrioso",
            "Oatman",
            "Oracle",
            "Overgaard",
            "Page",
            "Palo Verde",
            "Paradise Valley",
            "Parker",
            "Parks",
            "Patagonia",
            "Paulden",
            "Payson",
            "Peach Springs",
            "Pearce",
            "Peoria",
            "Peridot",
            "Petrified Forest Natl Pk",
            "Phoenix",
            "Picacho",
            "Pima",
            "Pine",
            "Pinedale",
            "Pinetop",
            "Pinon",
            "Pirtleville",
            "Polacca",
            "Pomerene",
            "Poston",
            "Prescott",
            "Prescott Valley",
            "Quartzsite",
            "Queen Creek",
            "Red Rock",
            "Red Valley",
            "Rillito",
            "Rimrock",
            "Rio Rico",
            "Rio Verde",
            "Rock Point",
            "Roll",
            "Roosevelt",
            "Round Rock",
            "Sacaton",
            "Safford",
            "Sahuarita",
            "Saint David",
            "Saint Johns",
            "Saint Michaels",
            "Salome",
            "San Carlos",
            "San Luis",
            "San Manuel",
            "San Simon",
            "Sanders",
            "Sasabe",
            "Sawmill",
            "Scottsdale",
            "Second Mesa",
            "Sedona",
            "Seligman",
            "Sells",
            "Shonto",
            "Show Low",
            "Sierra Vista",
            "Skull Valley",
            "Snowflake",
            "Solomon",
            "Somerton",
            "Sonoita",
            "Springerville",
            "Stanfield",
            "Sun City",
            "Sun City West",
            "Sun Valley",
            "Supai",
            "Superior",
            "Surprise",
            "Tacna",
            "Taylor",
            "Teec Nos Pos",
            "Tempe",
            "Temple Bar Marina",
            "Thatcher",
            "Tolleson",
            "Tombstone",
            "Tonalea",
            "Tonopah",
            "Tonto Basin",
            "Topawa",
            "Topock",
            "Tortilla Flat",
            "Tsaile",
            "Tuba City",
            "Tubac",
            "Tucson",
            "Tumacacori",
            "Vail",
            "Valentine",
            "Valley Farms",
            "Vernon",
            "Waddell",
            "Wellton",
            "Wenden",
            "White Mountain Lake",
            "Whiteriver",
            "Wickenburg",
            "Wikieup",
            "Willcox",
            "Williams",
            "Willow Beach",
            "Window Rock",
            "Winkelman",
            "Winslow",
            "Wittmann",
            "Woodruff",
            "Yarnell",
            "Young",
            "Youngtown",
            "Yucca",
            "Yuma"
        ]
    },
    {
        "state": "Arkansas",
        "abbr": "AR",
        "cities": [
            "Adona",
            "Alco",
            "Alexander",
            "Alicia",
            "Alix",
            "Alleene",
            "Alma",
            "Almyra",
            "Alpena",
            "Alpine",
            "Altheimer",
            "Altus",
            "Amagon",
            "Amity",
            "Antoine",
            "Arkadelphia",
            "Arkansas City",
            "Armorel",
            "Ash Flat",
            "Ashdown",
            "Atkins",
            "Aubrey",
            "Augusta",
            "Austin",
            "Avoca",
            "Bald Knob",
            "Banks",
            "Barling",
            "Barton",
            "Bassett",
            "Bates",
            "Batesville",
            "Bauxite",
            "Bay",
            "Bearden",
            "Beaver",
            "Bee Branch",
            "Beebe",
            "Beech Grove",
            "Beedeville",
            "Beirne",
            "Bella Vista",
            "Belleville",
            "Ben Lomond",
            "Benton",
            "Bentonville",
            "Bergman",
            "Berryville",
            "Bexar",
            "Big Flat",
            "Bigelow",
            "Biggers",
            "Birdeye",
            "Biscoe",
            "Bismarck",
            "Black Oak",
            "Black Rock",
            "Blevins",
            "Blue Mountain",
            "Bluff City",
            "Bluffton",
            "Blytheville",
            "Board Camp",
            "Boles",
            "Bonnerdale",
            "Bono",
            "Booneville",
            "Boswell",
            "Bradford",
            "Bradley",
            "Branch",
            "Brickeys",
            "Briggsville",
            "Brinkley",
            "Brockwell",
            "Brookland",
            "Bryant",
            "Buckner",
            "Bull Shoals",
            "Burdette",
            "Cabot",
            "Caddo Gap",
            "Caldwell",
            "Cale",
            "Calico Rock",
            "Calion",
            "Camden",
            "Camp",
            "Canehill",
            "Caraway",
            "Carlisle",
            "Carthage",
            "Casa",
            "Cash",
            "Casscoe",
            "Cave City",
            "Cave Springs",
            "Cecil",
            "Cedarville",
            "Center Ridge",
            "Centerton",
            "Centerville",
            "Charleston",
            "Charlotte",
            "Cherokee Village",
            "Cherry Valley",
            "Chester",
            "Chidester",
            "Choctaw",
            "Clarendon",
            "Clarkedale",
            "Clarkridge",
            "Clarksville",
            "Cleveland",
            "Clinton",
            "Coal Hill",
            "College Station",
            "Colt",
            "Columbus",
            "Combs",
            "Compton",
            "Concord",
            "Conway",
            "Cord",
            "Corning",
            "Cotter",
            "Cotton Plant",
            "Cove",
            "Coy",
            "Crawfordsville",
            "Crocketts Bluff",
            "Crossett",
            "Crumrod",
            "Curtis",
            "Cushman",
            "Damascus",
            "Danville",
            "Dardanelle",
            "Datto",
            "De Queen",
            "De Valls Bluff",
            "De Witt",
            "Decatur",
            "Deer",
            "Delaplaine",
            "Delaware",
            "Delight",
            "Dell",
            "Dennard",
            "Dermott",
            "Des Arc",
            "Desha",
            "Diamond City",
            "Diaz",
            "Dierks",
            "Doddridge",
            "Dolph",
            "Donaldson",
            "Dover",
            "Drasco",
            "Driver",
            "Dumas",
            "Dyer",
            "Dyess",
            "Earle",
            "Edgemont",
            "Edmondson",
            "Egypt",
            "El Dorado",
            "El Paso",
            "Elaine",
            "Elizabeth",
            "Elkins",
            "Elm Springs",
            "Emerson",
            "Emmet",
            "England",
            "Enola",
            "Ethel",
            "Etowah",
            "Eudora",
            "Eureka Springs",
            "Evansville",
            "Evening Shade",
            "Everton",
            "Fairfield Bay",
            "Farmington",
            "Fayetteville",
            "Fifty Six",
            "Fisher",
            "Flippin",
            "Floral",
            "Fordyce",
            "Foreman",
            "Forrest City",
            "Fort Smith",
            "Fouke",
            "Fountain Hill",
            "Fox",
            "Franklin",
            "Frenchmans Bayou",
            "Friendship",
            "Fulton",
            "Gamaliel",
            "Garfield",
            "Garland City",
            "Garner",
            "Gassville",
            "Gateway",
            "Genoa",
            "Gentry",
            "Gepp",
            "Gilbert",
            "Gillett",
            "Gillham",
            "Gilmore",
            "Glencoe",
            "Glenwood",
            "Goodwin",
            "Goshen",
            "Gosnell",
            "Gould",
            "Grady",
            "Grannis",
            "Grapevine",
            "Gravelly",
            "Gravette",
            "Green Forest",
            "Greenbrier",
            "Greenland",
            "Greenway",
            "Greenwood",
            "Gregory",
            "Griffithville",
            "Grubbs",
            "Guion",
            "Gurdon",
            "Guy",
            "Hackett",
            "Hagarville",
            "Hamburg",
            "Hampton",
            "Hardy",
            "Harrell",
            "Harriet",
            "Harrisburg",
            "Harrison",
            "Hartford",
            "Hartman",
            "Harvey",
            "Hasty",
            "Hatfield",
            "Hattieville",
            "Hatton",
            "Havana",
            "Haynes",
            "Hazen",
            "Heber Springs",
            "Hector",
            "Helena",
            "Henderson",
            "Henning",
            "Hensley",
            "Hermitage",
            "Heth",
            "Hickory Plains",
            "Hickory Ridge",
            "Higden",
            "Higginson",
            "Hindsville",
            "Hiwasse",
            "Holly Grove",
            "Hope",
            "Horatio",
            "Horseshoe Bend",
            "Hot Springs",
            "Hot Springs National Park",
            "Hot Springs Village",
            "Houston",
            "Howell",
            "Hoxie",
            "Hughes",
            "Humnoke",
            "Humphrey",
            "Hunter",
            "Huntington",
            "Huntsville",
            "Huttig",
            "Ida",
            "Imboden",
            "Ivan",
            "Jacksonport",
            "Jacksonville",
            "Jasper",
            "Jefferson",
            "Jennie",
            "Jerome",
            "Jersey",
            "Jerusalem",
            "Jessieville",
            "Johnson",
            "Joiner",
            "Jones Mill",
            "Jonesboro",
            "Judsonia",
            "Junction City",
            "Keiser",
            "Kensett",
            "Keo",
            "Kingsland",
            "Kingston",
            "Kirby",
            "Knobel",
            "Knoxville",
            "La Grange",
            "Lafe",
            "Lake City",
            "Lake Village",
            "Lakeview",
            "Lamar",
            "Lambrook",
            "Laneburg",
            "Langley",
            "Lavaca",
            "Lawson",
            "Leachville",
            "Lead Hill",
            "Leola",
            "Lepanto",
            "Leslie",
            "Letona",
            "Lewisville",
            "Lexa",
            "Light",
            "Lincoln",
            "Little Rock",
            "Little Rock Air Force Base",
            "Lockesburg",
            "Locust Grove",
            "London",
            "Lonoke",
            "Lonsdale",
            "Louann",
            "Lowell",
            "Luxora",
            "Lynn",
            "Mabelvale",
            "Madison",
            "Magazine",
            "Magness",
            "Magnolia",
            "Malvern",
            "Mammoth Spring",
            "Manila",
            "Mansfield",
            "Marble Falls",
            "Marcella",
            "Marianna",
            "Marion",
            "Marked Tree",
            "Marmaduke",
            "Marshall",
            "Marvell",
            "Maumelle",
            "Mayflower",
            "Maynard",
            "Maysville",
            "McCaskill",
            "McCrory",
            "McDougal",
            "McGehee",
            "McNeil",
            "McRae",
            "Melbourne",
            "Mellwood",
            "Mena",
            "Menifee",
            "Midland",
            "Midway",
            "Mineral Springs",
            "Minturn",
            "Moko",
            "Monette",
            "Monroe",
            "Monticello",
            "Montrose",
            "Moro",
            "Morrilton",
            "Morrow",
            "Moscow",
            "Mount Holly",
            "Mount Ida",
            "Mount Judea",
            "Mount Pleasant",
            "Mount Vernon",
            "Mountain Home",
            "Mountain Pine",
            "Mountain View",
            "Mountainburg",
            "Mulberry",
            "Murfreesboro",
            "Nashville",
            "Natural Dam",
            "New Blaine",
            "New Edinburg",
            "Newark",
            "Newhope",
            "Newport",
            "Norfork",
            "Norman",
            "Norphlet",
            "North Little Rock",
            "O Kean",
            "Oak Grove",
            "Oakland",
            "Oark",
            "Oden",
            "Ogden",
            "Oil Trough",
            "Okolona",
            "Ola",
            "Omaha",
            "Oneida",
            "Onia",
            "Osceola",
            "Oxford",
            "Ozan",
            "Ozark",
            "Ozone",
            "Palestine",
            "Pangburn",
            "Paragould",
            "Paris",
            "Parkdale",
            "Parkin",
            "Parks",
            "Paron",
            "Parthenon",
            "Patterson",
            "Pea Ridge",
            "Peach Orchard",
            "Pearcy",
            "Peel",
            "Pelsor",
            "Pencil Bluff",
            "Perry",
            "Perryville",
            "Pettigrew",
            "Pickens",
            "Piggott",
            "Pindall",
            "Pine Bluff",
            "Pineville",
            "Plainview",
            "Pleasant Grove",
            "Pleasant Plains",
            "Plumerville",
            "Pocahontas",
            "Pollard",
            "Ponca",
            "Poplar Grove",
            "Portia",
            "Portland",
            "Pottsville",
            "Poughkeepsie",
            "Powhatan",
            "Poyen",
            "Prairie Grove",
            "Prattsville",
            "Prescott",
            "Prim",
            "Proctor",
            "Protem",
            "Pyatt",
            "Quitman",
            "Ratcliff",
            "Ravenden",
            "Ravenden Springs",
            "Rector",
            "Redfield",
            "Reydell",
            "Reyno",
            "Ripley",
            "Rison",
            "Rivervale",
            "Roe",
            "Rogers",
            "Roland",
            "Romance",
            "Rose Bud",
            "Rosie",
            "Rosston",
            "Rover",
            "Royal",
            "Rudy",
            "Russell",
            "Russellville",
            "Saffell",
            "Sage",
            "Saint Charles",
            "Saint Francis",
            "Saint Joe",
            "Saint Paul",
            "Salado",
            "Salem",
            "Saratoga",
            "Scotland",
            "Scott",
            "Scranton",
            "Searcy",
            "Sedgwick",
            "Sheridan",
            "Sherrill",
            "Sherwood",
            "Shirley",
            "Sidney",
            "Siloam Springs",
            "Sims",
            "Smackover",
            "Smithville",
            "Snow Lake",
            "Solgohachia",
            "Sparkman",
            "Springdale",
            "Springfield",
            "Stamps",
            "Star City",
            "State University",
            "Stephens",
            "Story",
            "Strawberry",
            "Strong",
            "Sturkie",
            "Stuttgart",
            "Subiaco",
            "Success",
            "Sulphur Rock",
            "Sulphur Springs",
            "Summers",
            "Summit",
            "Sweet Home",
            "Swifton",
            "Taylor",
            "Texarkana",
            "Theodosia",
            "Thida",
            "Thornton",
            "Tichnor",
            "Tillar",
            "Tilly",
            "Timbo",
            "Tomato",
            "Tontitown",
            "Traskwood",
            "Trumann",
            "Tucker",
            "Tuckerman",
            "Tumbling Shoals",
            "Tupelo",
            "Turner",
            "Turrell",
            "Twist",
            "Tyronza",
            "Ulm",
            "Umpire",
            "Uniontown",
            "Urbana",
            "Valley Springs",
            "Van Buren",
            "Vandervoort",
            "Vanndale",
            "Vendor",
            "Village",
            "Vilonia",
            "Viola",
            "Violet Hill",
            "Wabash",
            "Wabbaseka",
            "Walcott",
            "Waldenburg",
            "Waldo",
            "Waldron",
            "Walnut Ridge",
            "Ward",
            "Warm Springs",
            "Warren",
            "Washington",
            "Watson",
            "Weiner",
            "Wesley",
            "West Fork",
            "West Helena",
            "West Memphis",
            "West Point",
            "West Ridge",
            "Western Grove",
            "Wheatley",
            "Whelen Springs",
            "White Hall",
            "Wickes",
            "Wideman",
            "Widener",
            "Wilburn",
            "Williford",
            "Willisville",
            "Wilmar",
            "Wilmot",
            "Wilson",
            "Wilton",
            "Winchester",
            "Winslow",
            "Winthrop",
            "Wiseman",
            "Witter",
            "Witts Springs",
            "Woodson",
            "Wooster",
            "Wright",
            "Wrightsville",
            "Wynne",
            "Yellville",
            "Yorktown"
        ]
    },
    {
        "state": "California",
        "abbr": "CA",
        "cities": [
            "Acampo",
            "Acton",
            "Adelanto",
            "Adin",
            "Agoura Hills",
            "Aguanga",
            "Ahwahnee",
            "Alameda",
            "Alamo",
            "Albany",
            "Albion",
            "Alderpoint",
            "Alhambra",
            "Aliso Viejo",
            "Alleghany",
            "Alpaugh",
            "Alpine",
            "Alta",
            "Alta Loma",
            "Altadena",
            "Altaville",
            "Alturas",
            "Alviso",
            "Amador City",
            "Amboy",
            "American Canyon",
            "Anaheim",
            "Anderson",
            "Angels Camp",
            "Angelus Oaks",
            "Angwin",
            "Annapolis",
            "Antelope",
            "Antioch",
            "Anza",
            "Apple Valley",
            "Applegate",
            "Aptos",
            "Arbuckle",
            "Arcadia",
            "Arcata",
            "Armona",
            "Arnold",
            "Aromas",
            "Arroyo Grande",
            "Artesia",
            "Artois",
            "Arvin",
            "Atascadero",
            "Atherton",
            "Atwater",
            "Atwood",
            "Auberry",
            "Auburn",
            "Avalon",
            "Avenal",
            "Avery",
            "Avila Beach",
            "Azusa",
            "Badger",
            "Baker",
            "Bakersfield",
            "Baldwin Park",
            "Ballico",
            "Bangor",
            "Banning",
            "Banta",
            "Bard",
            "Barstow",
            "Bass Lake",
            "Bayside",
            "Beale AFB",
            "Beaumont",
            "Beckwourth",
            "Belden",
            "Bell",
            "Bell Gardens",
            "Bella Vista",
            "Bellflower",
            "Belmont",
            "Belvedere Tiburon",
            "Ben Lomond",
            "Benicia",
            "Benton",
            "Berkeley",
            "Berry Creek",
            "Bethel Island",
            "Beverly Hills",
            "Bieber",
            "Big Bar",
            "Big Bear City",
            "Big Bear Lake",
            "Big Bend",
            "Big Creek",
            "Big Oak Flat",
            "Big Pine",
            "Big Sur",
            "Biggs",
            "Biola",
            "Birds Landing",
            "Bishop",
            "Blairsden-Graeagle",
            "Blocksburg",
            "Bloomington",
            "Blue Jay",
            "Blue Lake",
            "Blythe",
            "Bodega",
            "Bodega Bay",
            "Bodfish",
            "Bolinas",
            "Bonita",
            "Bonsall",
            "Boonville",
            "Boron",
            "Borrego Springs",
            "Boulder Creek",
            "Boulevard",
            "Boyes Hot Springs",
            "Bradley",
            "Brandeis",
            "Branscomb",
            "Brawley",
            "Brea",
            "Brentwood",
            "Bridgeport",
            "Bridgeville",
            "Brisbane",
            "Brookdale",
            "Brooks",
            "Browns Valley",
            "Brownsville",
            "Bryn Mawr",
            "Buellton",
            "Buena Park",
            "Burbank",
            "Burlingame",
            "Burney",
            "Burnt Ranch",
            "Burrel",
            "Burson",
            "Butte City",
            "Buttonwillow",
            "Byron",
            "Cabazon",
            "Calabasas",
            "Calexico",
            "Caliente",
            "California City",
            "California Hot Springs",
            "Calimesa",
            "Calipatria",
            "Calistoga",
            "Callahan",
            "Calpella",
            "Calpine",
            "Camarillo",
            "Cambria",
            "Camino",
            "Camp Meeker",
            "Camp Nelson",
            "Camp Pendleton",
            "Campbell",
            "Campo",
            "Campo Seco",
            "Camptonville",
            "Canby",
            "Canoga Park",
            "Cantil",
            "Cantua Creek",
            "Canyon",
            "Canyon Country",
            "Canyondam",
            "Capay",
            "Capistrano Beach",
            "Capitola",
            "Cardiff By The Sea",
            "Carlotta",
            "Carlsbad",
            "Carmel",
            "Carmel Valley",
            "Carmichael",
            "Carnelian Bay",
            "Carpinteria",
            "Carson",
            "Caruthers",
            "Casmalia",
            "Caspar",
            "Cassel",
            "Castaic",
            "Castella",
            "Castro Valley",
            "Castroville",
            "Cathedral City",
            "Catheys Valley",
            "Cayucos",
            "Cazadero",
            "Cedar Glen",
            "Cedar Ridge",
            "Cedarpines Park",
            "Cedarville",
            "Ceres",
            "Cerritos",
            "Challenge",
            "Chatsworth",
            "Chester",
            "Chicago Park",
            "Chico",
            "Chilcoot",
            "Chinese Camp",
            "Chino",
            "Chino Hills",
            "Chowchilla",
            "Chualar",
            "Chula Vista",
            "Cima",
            "Citrus Heights",
            "City Of Industry",
            "Claremont",
            "Clarksburg",
            "Clayton",
            "Clearlake",
            "Clearlake Oaks",
            "Clearlake Park",
            "Clements",
            "Clio",
            "Clipper Mills",
            "Cloverdale",
            "Clovis",
            "Coachella",
            "Coalinga",
            "Coarsegold",
            "Cobb",
            "Coleville",
            "Colfax",
            "College City",
            "Coloma",
            "Colton",
            "Columbia",
            "Colusa",
            "Comptche",
            "Compton",
            "Concord",
            "Cool",
            "Copperopolis",
            "Corcoran",
            "Corning",
            "Corona",
            "Corona Del Mar",
            "Coronado",
            "Corte Madera",
            "Costa Mesa",
            "Cotati",
            "Cottonwood",
            "Coulterville",
            "Courtland",
            "Covelo",
            "Covina",
            "Coyote",
            "Crescent City",
            "Crescent Mills",
            "Cressey",
            "Crest Park",
            "Crestline",
            "Creston",
            "Crockett",
            "Crows Landing",
            "Culver City",
            "Cupertino",
            "Cutler",
            "Cutten",
            "Cypress",
            "Daggett",
            "Daly City",
            "Dana Point",
            "Danville",
            "Dardanelle",
            "Darwin",
            "Davenport",
            "Davis",
            "Davis Creek",
            "Death Valley",
            "Deer Park",
            "Del Mar",
            "Del Rey",
            "Delano",
            "Delhi",
            "Denair",
            "Descanso",
            "Desert Center",
            "Desert Hot Springs",
            "Diablo",
            "Diamond Bar",
            "Diamond Springs",
            "Dillon Beach",
            "Dinuba",
            "Dixon",
            "Dobbins",
            "Dorris",
            "Dos Palos",
            "Dos Rios",
            "Douglas City",
            "Douglas Flat",
            "Downey",
            "Downieville",
            "Doyle",
            "Drytown",
            "Duarte",
            "Dublin",
            "Ducor",
            "Dulzura",
            "Duncans Mills",
            "Dunlap",
            "Dunnigan",
            "Dunsmuir",
            "Durham",
            "Dutch Flat",
            "Eagleville",
            "Earlimart",
            "Earp",
            "East Irvine",
            "Echo Lake",
            "Edison",
            "Edwards",
            "El Cajon",
            "El Centro",
            "El Cerrito",
            "El Dorado",
            "El Dorado Hills",
            "El Granada",
            "El Macero",
            "El Monte",
            "El Nido",
            "El Portal",
            "El Segundo",
            "El Sobrante",
            "El Verano",
            "Eldridge",
            "Elk",
            "Elk Creek",
            "Elk Grove",
            "Elmira",
            "Elverta",
            "Emeryville",
            "Emigrant Gap",
            "Empire",
            "Encinitas",
            "Encino",
            "Escalon",
            "Escondido",
            "Esparto",
            "Essex",
            "Etna",
            "Eureka",
            "Exeter",
            "Fair Oaks",
            "Fairfax",
            "Fairfield",
            "Fall River Mills",
            "Fallbrook",
            "Farmersville",
            "Farmington",
            "Fawnskin",
            "Feather Falls",
            "Fellows",
            "Felton",
            "Ferndale",
            "Fiddletown",
            "Fields Landing",
            "Fillmore",
            "Finley",
            "Firebaugh",
            "Fish Camp",
            "Five Points",
            "Floriston",
            "Flournoy",
            "Folsom",
            "Fontana",
            "Foothill Ranch",
            "Forbestown",
            "Forest Falls",
            "Forest Knolls",
            "Forest Ranch",
            "Foresthill",
            "Forestville",
            "Forks Of Salmon",
            "Fort Bidwell",
            "Fort Bragg",
            "Fort Dick",
            "Fort Irwin",
            "Fort Jones",
            "Fortuna",
            "Foster City",
            "Fountain Valley",
            "Fowler",
            "Frazier Park",
            "Freedom",
            "Fremont",
            "French Camp",
            "French Gulch",
            "Fresno",
            "Friant",
            "Fullerton",
            "Fulton",
            "Galt",
            "Garberville",
            "Garden Grove",
            "Garden Valley",
            "Gardena",
            "Gasquet",
            "Gazelle",
            "Georgetown",
            "Gerber",
            "Geyserville",
            "Gilroy",
            "Glen Ellen",
            "Glencoe",
            "Glendale",
            "Glendora",
            "Glenhaven",
            "Glenn",
            "Glennville",
            "Gold Run",
            "Goleta",
            "Gonzales",
            "Goodyears Bar",
            "Goshen",
            "Granada Hills",
            "Grand Terrace",
            "Granite Bay",
            "Grass Valley",
            "Graton",
            "Green Valley Lake",
            "Greenbrae",
            "Greenfield",
            "Greenview",
            "Greenville",
            "Greenwood",
            "Grenada",
            "Gridley",
            "Grimes",
            "Grizzly Flats",
            "Groveland",
            "Grover Beach",
            "Guadalupe",
            "Gualala",
            "Guasti",
            "Guatay",
            "Guerneville",
            "Guinda",
            "Gustine",
            "Hacienda Heights",
            "Half Moon Bay",
            "Hamilton City",
            "Hanford",
            "Happy Camp",
            "Harbor City",
            "Harmony",
            "Hat Creek",
            "Hathaway Pines",
            "Hawaiian Gardens",
            "Hawthorne",
            "Hayfork",
            "Hayward",
            "Healdsburg",
            "Heber",
            "Helendale",
            "Helm",
            "Hemet",
            "Herald",
            "Hercules",
            "Herlong",
            "Hermosa Beach",
            "Hesperia",
            "Hickman",
            "Highland",
            "Hilmar",
            "Hinkley",
            "Hollister",
            "Holt",
            "Holtville",
            "Holy City",
            "Homeland",
            "Homewood",
            "Honeydew",
            "Hood",
            "Hoopa",
            "Hopland",
            "Hornbrook",
            "Hornitos",
            "Hughson",
            "Hume",
            "Huntington Beach",
            "Huntington Park",
            "Huron",
            "Hyampom",
            "Hydesville",
            "Idyllwild",
            "Igo",
            "Imperial",
            "Imperial Beach",
            "Independence",
            "Indian Wells",
            "Indio",
            "Inglewood",
            "Inverness",
            "Inyokern",
            "Ione",
            "Irvine",
            "Isleton",
            "Ivanhoe",
            "Jackson",
            "Jacumba",
            "Jamestown",
            "Jamul",
            "Janesville",
            "Jenner",
            "Johannesburg",
            "Jolon",
            "Joshua Tree",
            "Julian",
            "Junction City",
            "June Lake",
            "Kaweah",
            "Keeler",
            "Keene",
            "Kelseyville",
            "Kentfield",
            "Kenwood",
            "Kerman",
            "Kernville",
            "Kettleman City",
            "Keyes",
            "King City",
            "Kings Beach",
            "Kings Canyon National Pk",
            "Kingsburg",
            "Kirkwood",
            "Kit Carson",
            "Klamath",
            "Klamath River",
            "Kneeland",
            "Knights Landing",
            "Knightsen",
            "Korbel",
            "Kyburz",
            "La Canada Flintridge",
            "La Crescenta",
            "La Grange",
            "La Habra",
            "La Honda",
            "La Jolla",
            "La Mesa",
            "La Mirada",
            "La Palma",
            "La Presa",
            "La Puente",
            "La Quinta",
            "La Verne",
            "Ladera Ranch",
            "Lafayette",
            "Laguna Beach",
            "Laguna Hills",
            "Laguna Niguel",
            "Lagunitas",
            "Lake Arrowhead",
            "Lake City",
            "Lake Elsinore",
            "Lake Forest",
            "Lake Hughes",
            "Lake Isabella",
            "Lake of the Woods",
            "Lakehead",
            "Lakeport",
            "Lakeshore",
            "Lakeside",
            "Lakewood",
            "Lamont",
            "Lancaster",
            "Landers",
            "Larkspur",
            "Lathrop",
            "Laton",
            "Lawndale",
            "Laytonville",
            "Le Grand",
            "Lebec",
            "Lee Vining",
            "Leggett",
            "Lemon Cove",
            "Lemon Grove",
            "Lemoore",
            "Lewiston",
            "Likely",
            "Lincoln",
            "Lincoln Acres",
            "Linden",
            "Lindsay",
            "Litchfield",
            "Little Lake",
            "Littleriver",
            "Littlerock",
            "Live Oak",
            "Livermore",
            "Livingston",
            "Llano",
            "Lockeford",
            "Lockwood",
            "Lodi",
            "Loleta",
            "Loma Linda",
            "Loma Mar",
            "Lomita",
            "Lompoc",
            "Lone Pine",
            "Long Barn",
            "Long Beach",
            "Lookout",
            "Loomis",
            "Los Alamitos",
            "Los Alamos",
            "Los Altos",
            "Los Angeles",
            "Los Banos",
            "Los Gatos",
            "Los Molinos",
            "Los Olivos",
            "Los Osos",
            "Lost Hills",
            "Lotus",
            "Lower Lake",
            "Loyalton",
            "Lucerne",
            "Lucerne Valley",
            "Ludlow",
            "Lynwood",
            "Lyoth",
            "Lytle Creek",
            "Macdoel",
            "Mad River",
            "Madeline",
            "Madera",
            "Madison",
            "Magalia",
            "Malibu",
            "Mammoth Lakes",
            "Manchester",
            "Manhattan Beach",
            "Manteca",
            "Manton",
            "March Air Force Base",
            "Maricopa",
            "Marina",
            "Marina Del Rey",
            "Mariposa",
            "Markleeville",
            "Marshall",
            "Martell",
            "Martinez",
            "Marysville",
            "Mather",
            "Maxwell",
            "Maywood",
            "Mcarthur",
            "Mcclellan AFB",
            "Mccloud",
            "McFarland",
            "Mckinleyville",
            "McKittrick",
            "Meadow Valley",
            "Meadow Vista",
            "Mecca",
            "Mendocino",
            "Mendota",
            "Menifee",
            "Menlo Park",
            "Mentone",
            "Merced",
            "Meridian",
            "Mi Wuk Village",
            "Middletown",
            "Midpines",
            "Midway City",
            "Milford",
            "Mill Creek",
            "Mill Valley",
            "Millbrae",
            "Millville",
            "Milpitas",
            "Mineral",
            "Mira Loma",
            "Miramonte",
            "Miranda",
            "Mission Hills",
            "Mission Viejo",
            "Moccasin",
            "Modesto",
            "Mojave",
            "Mokelumne Hill",
            "Mono Hot Springs",
            "Monrovia",
            "Montague",
            "Montara",
            "Montclair",
            "Monte Rio",
            "Montebello",
            "Monterey",
            "Monterey Park",
            "Montgomery Creek",
            "Montrose",
            "Moorpark",
            "Moraga",
            "Moreno Valley",
            "Morgan Hill",
            "Morongo Valley",
            "Morro Bay",
            "Moss Beach",
            "Moss Landing",
            "Mount Aukum",
            "Mount Hamilton",
            "Mount Hermon",
            "Mount Laguna",
            "Mount Shasta",
            "Mount Wilson",
            "Mountain Center",
            "Mountain Pass",
            "Mountain Ranch",
            "Mountain View",
            "Mt Baldy",
            "Murphys",
            "Murrieta",
            "Myers Flat",
            "Napa",
            "National City",
            "Navarro",
            "Needles",
            "Nelson",
            "Nevada City",
            "New Almaden",
            "New Cuyama",
            "New Pine Creek",
            "Newark",
            "Newberry Springs",
            "Newbury Park",
            "Newcastle",
            "Newhall",
            "Newman",
            "Newport Beach",
            "Newport Coast",
            "Nicasio",
            "Nice",
            "Nicolaus",
            "Niland",
            "Nipomo",
            "Nipton",
            "Norco",
            "Norden",
            "North Fork",
            "North Highlands",
            "North Hills",
            "North Hollywood",
            "North Palm Springs",
            "North San Juan",
            "Northridge",
            "Norwalk",
            "Novato",
            "Nubieber",
            "Nuevo",
            "O Neals",
            "Oak Park",
            "Oak Run",
            "Oak View",
            "Oakdale",
            "Oakhurst",
            "Oakland",
            "Oakley",
            "Oakville",
            "Obrien",
            "Occidental",
            "Oceano",
            "Oceanside",
            "Ocotillo",
            "Ojai",
            "Olancha",
            "Old Station",
            "Olema",
            "Olivehurst",
            "Olympic Valley",
            "Ontario",
            "Onyx",
            "Orange",
            "Orange Cove",
            "Orangevale",
            "Oregon House",
            "Orick",
            "Orinda",
            "Orland",
            "Orleans",
            "Oro Grande",
            "Orosi",
            "Oroville",
            "Oxnard",
            "Pacific Grove",
            "Pacific Palisades",
            "Pacifica",
            "Pacoima",
            "Paicines",
            "Pala",
            "Palermo",
            "Palm Desert",
            "Palm Springs",
            "Palmdale",
            "Palo Alto",
            "Palo Cedro",
            "Palo Verde",
            "Palomar Mountain",
            "Palos Verdes Peninsula",
            "Panorama City",
            "Paradise",
            "Paramount",
            "Parker Dam",
            "Parlier",
            "Pasadena",
            "Paskenta",
            "Paso Robles",
            "Patterson",
            "Patton",
            "Pauma Valley",
            "Paynes Creek",
            "Pearblossom",
            "Pebble Beach",
            "Penn Valley",
            "Penngrove",
            "Penryn",
            "Perris",
            "Pescadero",
            "Petaluma",
            "Petrolia",
            "Phelan",
            "Phillipsville",
            "Philo",
            "Pico Rivera",
            "Piedmont",
            "Piedra",
            "Piercy",
            "Pilot Hill",
            "Pine Grove",
            "Pine Valley",
            "Pinecrest",
            "Pinole",
            "Pinon Hills",
            "Pioneer",
            "Pioneertown",
            "Piru",
            "Pismo Beach",
            "Pittsburg",
            "Pixley",
            "Placentia",
            "Placerville",
            "Planada",
            "Platina",
            "Playa Del Rey",
            "Pleasant Grove",
            "Pleasant Hill",
            "Pleasanton",
            "Plymouth",
            "Point Arena",
            "Point Mugu Nawc",
            "Point Reyes Station",
            "Pollock Pines",
            "Pomona",
            "Pope Valley",
            "Port Costa",
            "Port Hueneme",
            "Port Hueneme Cbc Base",
            "Porterville",
            "Portola",
            "Portola Valley",
            "Posey",
            "Potrero",
            "Potter Valley",
            "Poway",
            "Prather",
            "Princeton",
            "Proberta",
            "Quincy",
            "Rackerby",
            "Rail Road Flat",
            "Raisin",
            "Ramona",
            "Ranchita",
            "Rancho Cordova",
            "Rancho Cucamonga",
            "Rancho Mirage",
            "Rancho Palos Verdes",
            "Rancho Santa Fe",
            "Rancho Santa Margarita",
            "Randsburg",
            "Ravendale",
            "Raymond",
            "Red Bluff",
            "Red Mountain",
            "Redcrest",
            "Redding",
            "Redlands",
            "Redondo Beach",
            "Redway",
            "Redwood City",
            "Redwood Estates",
            "Redwood Valley",
            "Reedley",
            "Represa",
            "Rescue",
            "Reseda",
            "Rialto",
            "Richgrove",
            "Richmond",
            "Richvale",
            "Ridgecrest",
            "Rimforest",
            "Rio Dell",
            "Rio Linda",
            "Rio Nido",
            "Rio Oso",
            "Rio Vista",
            "Ripon",
            "River Pines",
            "Riverbank",
            "Riverdale",
            "Riverside",
            "Robbins",
            "Rocklin",
            "Rodeo",
            "Rohnert Park",
            "Rosamond",
            "Rosemead",
            "Roseville",
            "Ross",
            "Rough And Ready",
            "Round Mountain",
            "Rowland Heights",
            "Rumsey",
            "Running Springs",
            "Rutherford",
            "Ryde",
            "Sacramento",
            "Saint Helena",
            "Salida",
            "Salinas",
            "Salton City",
            "Salyer",
            "Samoa",
            "San Andreas",
            "San Anselmo",
            "San Ardo",
            "San Bernardino",
            "San Bruno",
            "San Carlos",
            "San Clemente",
            "San Diego",
            "San Dimas",
            "San Fernando",
            "San Francisco",
            "San Gabriel",
            "San Geronimo",
            "San Gregorio",
            "San Jacinto",
            "San Joaquin",
            "San Jose",
            "San Juan Bautista",
            "San Juan Capistrano",
            "San Leandro",
            "San Lorenzo",
            "San Lucas",
            "San Luis Obispo",
            "San Luis Rey",
            "San Marcos",
            "San Marino",
            "San Martin",
            "San Mateo",
            "San Miguel",
            "San Pablo",
            "San Pedro",
            "San Quentin",
            "San Rafael",
            "San Ramon",
            "San Simeon",
            "San Ysidro",
            "Sanger",
            "Santa Ana",
            "Santa Barbara",
            "Santa Clara",
            "Santa Clarita",
            "Santa Cruz",
            "Santa Fe Springs",
            "Santa Margarita",
            "Santa Maria",
            "Santa Monica",
            "Santa Paula",
            "Santa Rita Park",
            "Santa Rosa",
            "Santa Ynez",
            "Santa Ysabel",
            "Santee",
            "Saratoga",
            "Sausalito",
            "Scotia",
            "Scott Bar",
            "Scotts Valley",
            "Seal Beach",
            "Seaside",
            "Sebastopol",
            "Seeley",
            "Seiad Valley",
            "Selma",
            "Sequoia National Park",
            "Shafter",
            "Shandon",
            "Shasta",
            "Shasta Lake",
            "Shaver Lake",
            "Sheep Ranch",
            "Sheridan",
            "Sherman Oaks",
            "Shingle Springs",
            "Shingletown",
            "Shoshone",
            "Sierra City",
            "Sierra Madre",
            "Sierraville",
            "Silverado",
            "Simi Valley",
            "Skyforest",
            "Sloughhouse",
            "Smartville",
            "Smith River",
            "Snelling",
            "Soda Springs",
            "Solana Beach",
            "Soledad",
            "Solvang",
            "Somerset",
            "Somes Bar",
            "Somis",
            "Sonoma",
            "Sonora",
            "Soquel",
            "Soulsbyville",
            "South Dos Palos",
            "South El Monte",
            "South Gate",
            "South Lake Tahoe",
            "South Pasadena",
            "South San Francisco",
            "Spreckels",
            "Spring Garden",
            "Spring Valley",
            "Springville",
            "Squaw Valley",
            "Standard",
            "Standish",
            "Stanford",
            "Stanton",
            "Stevenson Ranch",
            "Stevinson",
            "Stewarts Point",
            "Stinson Beach",
            "Stirling City",
            "Stockton",
            "Stonyford",
            "Storrie",
            "Stratford",
            "Strathmore",
            "Strawberry",
            "Strawberry Valley",
            "Studio City",
            "Sugarloaf",
            "Suisun City",
            "Sultana",
            "Summerland",
            "Sun City",
            "Sun Valley",
            "Sunland",
            "Sunnyvale",
            "Sunol",
            "Sunset Beach",
            "Surfside",
            "Susanville",
            "Sutter",
            "Sutter Creek",
            "Sylmar",
            "Taft",
            "Tahoe City",
            "Tahoe Vista",
            "Tahoma",
            "Talmage",
            "Tarzana",
            "Taylorsville",
            "Tecate",
            "Tecopa",
            "Tehachapi",
            "Tehama",
            "Temecula",
            "Temple City",
            "Templeton",
            "Termo",
            "Terra Bella",
            "The Sea Ranch",
            "Thermal",
            "Thornton",
            "Thousand Oaks",
            "Thousand Palms",
            "Three Rivers",
            "Tipton",
            "Tollhouse",
            "Toluca Lake",
            "Tomales",
            "Topanga",
            "Topaz",
            "Torrance",
            "Trabuco Canyon",
            "Tracy",
            "Tranquillity",
            "Traver",
            "Travis AFB",
            "Tres Pinos",
            "Trinidad",
            "Trinity Center",
            "Trona",
            "Truckee",
            "Tujunga",
            "Tulare",
            "Tulelake",
            "Tuolumne",
            "Tupman",
            "Turlock",
            "Tustin",
            "Twain",
            "Twain Harte",
            "Twentynine Palms",
            "Twin Bridges",
            "Twin Peaks",
            "Ukiah",
            "Union City",
            "Universal City",
            "Upland",
            "Upper Lake",
            "Vacaville",
            "Valencia",
            "Vallecito",
            "Vallejo",
            "Valley Center",
            "Valley Ford",
            "Valley Springs",
            "Valley Village",
            "Valyermo",
            "Van Nuys",
            "Venice",
            "Ventura",
            "Verdi",
            "Verdugo City",
            "Vernalis",
            "Victor",
            "Victorville",
            "Vidal",
            "Villa Grande",
            "Villa Park",
            "Vina",
            "Vineburg",
            "Vinton",
            "Visalia",
            "Vista",
            "Volcano",
            "Wallace",
            "Walnut",
            "Walnut Creek",
            "Walnut Grove",
            "Warner Springs",
            "Wasco",
            "Washington",
            "Waterford",
            "Watsonville",
            "Waukena",
            "Weaverville",
            "Weed",
            "Weimar",
            "Weldon",
            "Wendel",
            "Weott",
            "West Covina",
            "West Hills",
            "West Hollywood",
            "West Point",
            "West Sacramento",
            "Westlake Village",
            "Westley",
            "Westminster",
            "Westmorland",
            "Westport",
            "Westwood",
            "Wheatland",
            "Whiskeytown",
            "White Water",
            "Whitethorn",
            "Whitmore",
            "Whittier",
            "Wildomar",
            "Williams",
            "Willits",
            "Willow Creek",
            "Willows",
            "Wilmington",
            "Wilseyville",
            "Wilton",
            "Winchester",
            "Windsor",
            "Winnetka",
            "Winterhaven",
            "Winters",
            "Winton",
            "Wishon",
            "Witter Springs",
            "Wofford Heights",
            "Woodacre",
            "Woodbridge",
            "Woodlake",
            "Woodland",
            "Woodland Hills",
            "Woody",
            "Wrightwood",
            "Yermo",
            "Yettem",
            "Yolo",
            "Yorba Linda",
            "Yorkville",
            "Yosemite National Park",
            "Yountville",
            "Yreka",
            "Yuba City",
            "Yucaipa",
            "Yucca Valley",
            "Zamora",
            "Zenia"
        ]
    },
    {
        "state": "Colorado",
        "abbr": "CO",
        "cities": [
            "Agate",
            "Aguilar",
            "Akron",
            "Alamosa",
            "Allenspark",
            "Alma",
            "Almont",
            "Amherst",
            "Anton",
            "Antonito",
            "Arapahoe",
            "Arboles",
            "Arlington",
            "Arriba",
            "Arvada",
            "Aspen",
            "Atwood",
            "Ault",
            "Aurora",
            "Austin",
            "Avon",
            "Avondale",
            "Bailey",
            "Basalt",
            "Battlement Mesa",
            "Bayfield",
            "Bedrock",
            "Bellvue",
            "Bennett",
            "Berthoud",
            "Bethune",
            "Beulah",
            "Black Hawk",
            "Blanca",
            "Boncarbo",
            "Bond",
            "Boone",
            "Boulder",
            "Branson",
            "Breckenridge",
            "Briggsdale",
            "Brighton",
            "Broomfield",
            "Brush",
            "Buena Vista",
            "Buffalo Creek",
            "Burlington",
            "Burns",
            "Byers",
            "Cahone",
            "Calhan",
            "Campo",
            "Canon City",
            "Capulin",
            "Carbondale",
            "Carr",
            "Cascade",
            "Castle Rock",
            "Cedaredge",
            "Center",
            "Central City",
            "Chama",
            "Cheraw",
            "Cheyenne Wells",
            "Chimney Rock",
            "Chromo",
            "Cimarron",
            "Clark",
            "Clifton",
            "Climax",
            "Coal Creek",
            "Coaldale",
            "Coalmont",
            "Collbran",
            "Colorado City",
            "Colorado Springs",
            "Commerce City",
            "Como",
            "Conejos",
            "Conifer",
            "Cope",
            "Cortez",
            "Cory",
            "Cotopaxi",
            "Cowdrey",
            "Craig",
            "Crawford",
            "Creede",
            "Crested Butte",
            "Crestone",
            "Cripple Creek",
            "Crook",
            "Crowley",
            "Dacono",
            "De Beque",
            "Deer Trail",
            "Del Norte",
            "Delta",
            "Denver",
            "Dillon",
            "Dinosaur",
            "Divide",
            "Dolores",
            "Dove Creek",
            "Drake",
            "Dumont",
            "Dupont",
            "Durango",
            "Eads",
            "Eagle",
            "Eastlake",
            "Eaton",
            "Eckert",
            "Eckley",
            "Edwards",
            "Egnar",
            "El Jebel",
            "Elbert",
            "Eldorado Springs",
            "Elizabeth",
            "Empire",
            "Englewood",
            "Erie",
            "Estes Park",
            "Evans",
            "Evergreen",
            "Fairplay",
            "Firestone",
            "Flagler",
            "Fleming",
            "Florence",
            "Florissant",
            "Fort Collins",
            "Fort Garland",
            "Fort Lupton",
            "Fort Lyon",
            "Fort Morgan",
            "Fountain",
            "Fowler",
            "Franktown",
            "Fraser",
            "Frederick",
            "Frisco",
            "Fruita",
            "Galeton",
            "Garcia",
            "Gardner",
            "Gateway",
            "Genoa",
            "Georgetown",
            "Gilcrest",
            "Gill",
            "Glade Park",
            "Glen Haven",
            "Glenwood Springs",
            "Golden",
            "Granada",
            "Granby",
            "Grand Junction",
            "Grand Lake",
            "Granite",
            "Grant",
            "Greeley",
            "Green Mountain Falls",
            "Grover",
            "Guffey",
            "Gulnare",
            "Gunnison",
            "Gypsum",
            "Hamilton",
            "Hartman",
            "Hartsel",
            "Hasty",
            "Haswell",
            "Haxtun",
            "Hayden",
            "Henderson",
            "Hereford",
            "Hesperus",
            "Hillrose",
            "Hillside",
            "Hoehne",
            "Holly",
            "Holyoke",
            "Homelake",
            "Hooper",
            "Hot Sulphur Springs",
            "Hotchkiss",
            "Howard",
            "Hudson",
            "Hugo",
            "Hygiene",
            "Idaho Springs",
            "Idalia",
            "Idledale",
            "Ignacio",
            "Iliff",
            "Indian Hills",
            "Jamestown",
            "Jaroso",
            "Jefferson",
            "Jelm",
            "Joes",
            "Johnstown",
            "Julesburg",
            "Karval",
            "Keenesburg",
            "Kersey",
            "Kim",
            "Kiowa",
            "Kirk",
            "Kit Carson",
            "Kittredge",
            "Kremmling",
            "La Jara",
            "La Junta",
            "La Salle",
            "La Veta",
            "Lafayette",
            "Lake City",
            "Lake George",
            "Lamar",
            "Laporte",
            "Larkspur",
            "Las Animas",
            "Lazear",
            "Leadville",
            "Lewis",
            "Limon",
            "Lindon",
            "Littleton",
            "Livermore",
            "Lochbuie",
            "Log Lane Village",
            "Loma",
            "Lone Tree",
            "Longmont",
            "Louisville",
            "Louviers",
            "Loveland",
            "Lucerne",
            "Lyons",
            "Mack",
            "Maher",
            "Manassa",
            "Mancos",
            "Manitou Springs",
            "Manzanola",
            "Marvel",
            "Masonville",
            "Matheson",
            "Maybell",
            "McClave",
            "McCoy",
            "Mead",
            "Meeker",
            "Meredith",
            "Merino",
            "Mesa",
            "Mesa Verde National Park",
            "Milliken",
            "Minturn",
            "Model",
            "Moffat",
            "Molina",
            "Monarch",
            "Monte Vista",
            "Montrose",
            "Monument",
            "Morrison",
            "Mosca",
            "Nathrop",
            "Naturita",
            "Nederland",
            "New Castle",
            "New Raymer",
            "Niwot",
            "Norwood",
            "Nucla",
            "Nunn",
            "Oak Creek",
            "Ohio City",
            "Olathe",
            "Olney Springs",
            "Ophir",
            "Orchard",
            "Ordway",
            "Otis",
            "Ouray",
            "Ovid",
            "Padroni",
            "Pagosa Springs",
            "Palisade",
            "Palmer Lake",
            "Paoli",
            "Paonia",
            "Parachute",
            "Paradox",
            "Parker",
            "Parlin",
            "Parshall",
            "Peetz",
            "Penrose",
            "Peyton",
            "Phippsburg",
            "Pierce",
            "Pine",
            "Pinecliffe",
            "Pitkin",
            "Placerville",
            "Platteville",
            "Pleasant View",
            "Poncha Springs",
            "Powderhorn",
            "Pritchett",
            "Pueblo",
            "Ramah",
            "Rand",
            "Rangely",
            "Red Cliff",
            "Red Feather Lakes",
            "Red Wing",
            "Redvale",
            "Rico",
            "Ridgway",
            "Rifle",
            "Rockvale",
            "Rocky Ford",
            "Roggen",
            "Rollinsville",
            "Romeo",
            "Rush",
            "Rye",
            "Saguache",
            "Salida",
            "San Luis",
            "San Pablo",
            "Sanford",
            "Sargents",
            "Sedalia",
            "Sedgwick",
            "Seibert",
            "Severance",
            "Shawnee",
            "Sheridan Lake",
            "Sherrelwood",
            "Silt",
            "Silver Plume",
            "Silverthorne",
            "Silverton",
            "Simla",
            "Slater",
            "Snowmass",
            "Snowmass Village",
            "Snyder",
            "Somerset",
            "South Fork",
            "Springfield",
            "Starkville",
            "Steamboat Springs",
            "Sterling",
            "Stoneham",
            "Strasburg",
            "Stratton",
            "Sugar City",
            "Swink",
            "Tabernash",
            "Telluride",
            "Thornton",
            "Timnath",
            "Toponas",
            "Towaoc",
            "Trinchera",
            "Trinidad",
            "Twin Lakes",
            "Two Buttes",
            "U S A F Academy",
            "Vail",
            "Vernon",
            "Victor",
            "Vilas",
            "Villa Grove",
            "Vona",
            "Walden",
            "Walsenburg",
            "Walsh",
            "Ward",
            "Watkins",
            "Weldona",
            "Wellington",
            "Westcliffe",
            "Westminster",
            "Weston",
            "Wetmore",
            "Wheat Ridge",
            "Whitewater",
            "Wiggins",
            "Wild Horse",
            "Wiley",
            "Windsor",
            "Winter Park",
            "Wolcott",
            "Woodland Park",
            "Woodrow",
            "Woody Creek",
            "Wray",
            "Yampa",
            "Yellow Jacket",
            "Yoder",
            "Yuma"
        ]
    },
    {
        "state": "Connecticut",
        "abbr": "CT",
        "cities": [
            "Abington",
            "Amston",
            "Andover",
            "Ansonia",
            "Ashford",
            "Avon",
            "Ballouville",
            "Baltic",
            "Bantam",
            "Beacon Falls",
            "Bethany",
            "Bethel",
            "Bethlehem",
            "Bloomfield",
            "Bolton",
            "Botsford",
            "Bozrah",
            "Branford",
            "Bridgeport",
            "Bridgewater",
            "Bristol",
            "Broad Brook",
            "Brookfield",
            "Brooklyn",
            "Burlington",
            "Canaan",
            "Canterbury",
            "Canton",
            "Canton Center",
            "Centerbrook",
            "Central Village",
            "Chaplin",
            "Cheshire",
            "Chester",
            "Clinton",
            "Cobalt",
            "Colchester",
            "Colebrook",
            "Collinsville",
            "Columbia",
            "Cornwall",
            "Cornwall Bridge",
            "Cos Cob",
            "Coventry",
            "Cromwell",
            "Danbury",
            "Danielson",
            "Darien",
            "Dayville",
            "Deep River",
            "Derby",
            "Durham",
            "East Berlin",
            "East Canaan",
            "East Glastonbury",
            "East Granby",
            "East Haddam",
            "East Hampton",
            "East Hartford",
            "East Hartland",
            "East Haven",
            "East Killingly",
            "East Lyme",
            "East Windsor",
            "East Windsor Hill",
            "East Woodstock",
            "Eastford",
            "Easton",
            "Ellington",
            "Enfield",
            "Essex",
            "Fabyan",
            "Fairfield",
            "Falls Village",
            "Farmington",
            "Gales Ferry",
            "Gaylordsville",
            "Georgetown",
            "Gilman",
            "Glasgo",
            "Glastonbury",
            "Goshen",
            "Granby",
            "Greens Farms",
            "Greenwich",
            "Grosvenor Dale",
            "Groton",
            "Guilford",
            "Haddam",
            "Hadlyme",
            "Hamden",
            "Hampton",
            "Hanover",
            "Hartford",
            "Harwinton",
            "Hawleyville",
            "Hebron",
            "Higganum",
            "Ivoryton",
            "Jewett City",
            "Kensington",
            "Kent",
            "Killingworth",
            "Lakeside",
            "Lakeville",
            "Lebanon",
            "Ledyard",
            "Litchfield",
            "Madison",
            "Manchester",
            "Mansfield Center",
            "Mansfield Depot",
            "Marion",
            "Marlborough",
            "Melrose",
            "Meriden",
            "Middle Haddam",
            "Middlebury",
            "Middlefield",
            "Middletown",
            "Milford",
            "Milldale",
            "Monroe",
            "Montville",
            "Moodus",
            "Moosup",
            "Morris",
            "Mystic",
            "Naugatuck",
            "New Britain",
            "New Canaan",
            "New Fairfield",
            "New Hartford",
            "New Haven",
            "New London",
            "New Milford",
            "New Preston Marble Dale",
            "Newington",
            "Newtown",
            "Niantic",
            "Norfolk",
            "North Branford",
            "North Canton",
            "North Franklin",
            "North Granby",
            "North Grosvenordale",
            "North Haven",
            "North Stonington",
            "North Westchester",
            "North Windham",
            "Northfield",
            "Northford",
            "Norwalk",
            "Norwich",
            "Oakdale",
            "Oakville",
            "Old Greenwich",
            "Old Lyme",
            "Old Mystic",
            "Old Saybrook",
            "Oneco",
            "Orange",
            "Oxford",
            "Pawcatuck",
            "Pequabuck",
            "Pine Meadow",
            "Plainfield",
            "Plainville",
            "Plantsville",
            "Pleasant Valley",
            "Plymouth",
            "Pomfret",
            "Pomfret Center",
            "Poquonock",
            "Portland",
            "Preston",
            "Prospect",
            "Putnam",
            "Quaker Hill",
            "Quinebaug",
            "Redding",
            "Redding Center",
            "Redding Ridge",
            "Ridgefield",
            "Riverside",
            "Riverton",
            "Rockfall",
            "Rocky Hill",
            "Rogers",
            "Roxbury",
            "Salem",
            "Salisbury",
            "Sandy Hook",
            "Scotland",
            "Seymour",
            "Sharon",
            "Shelton",
            "Sherman",
            "Simsbury",
            "Somers",
            "Somersville",
            "South Britain",
            "South Glastonbury",
            "South Kent",
            "South Lyme",
            "South Willington",
            "South Windham",
            "South Windsor",
            "South Woodstock",
            "Southbury",
            "Southington",
            "Southport",
            "Stafford",
            "Stafford Springs",
            "Staffordville",
            "Stamford",
            "Sterling",
            "Stevenson",
            "Stonington",
            "Storrs Mansfield",
            "Stratford",
            "Suffield",
            "Taconic",
            "Taftville",
            "Tariffville",
            "Terryville",
            "Thomaston",
            "Thompson",
            "Tolland",
            "Torrington",
            "Trumbull",
            "Uncasville",
            "Unionville",
            "Vernon Rockville",
            "Versailles",
            "Voluntown",
            "W Hartford",
            "Wallingford",
            "Washington",
            "Washington Depot",
            "Waterbury",
            "Waterford",
            "Watertown",
            "Wauregan",
            "Weatogue",
            "West Cornwall",
            "West Granby",
            "West Hartland",
            "West Haven",
            "West Mystic",
            "West Simsbury",
            "West Suffield",
            "Westbrook",
            "Weston",
            "Westport",
            "Wethersfield",
            "Willimantic",
            "Willington",
            "Wilton",
            "Winchester Center",
            "Windham",
            "Windsor",
            "Windsor Locks",
            "Winsted",
            "Wolcott",
            "Woodbridge",
            "Woodbury",
            "Woodstock",
            "Woodstock Valley",
            "Yantic"
        ]
    },
    {
        "state": "Delaware",
        "abbr": "DE",
        "cities": [
            "Bear",
            "Bethany Beach",
            "Bethel",
            "Bridgeville",
            "Camden Wyoming",
            "Cheswold",
            "Claymont",
            "Clayton",
            "Dagsboro",
            "Delaware City",
            "Delmar",
            "Dover",
            "Dover AFB",
            "Ellendale",
            "Farmington",
            "Felton",
            "Fenwick Island",
            "Frankford",
            "Frederica",
            "Georgetown",
            "Greenwood",
            "Harbeson",
            "Harrington",
            "Hartly",
            "Hockessin",
            "Houston",
            "Kenton",
            "Kirkwood",
            "Laurel",
            "Lewes",
            "Lincoln",
            "Little Creek",
            "Magnolia",
            "Marydel",
            "Middletown",
            "Milford",
            "Millsboro",
            "Millville",
            "Milton",
            "Montchanin",
            "Nassau",
            "New Castle",
            "Newark",
            "Newport",
            "Ocean View",
            "Odessa",
            "Port Penn",
            "Rehoboth Beach",
            "Rockland",
            "Saint Georges",
            "Seaford",
            "Selbyville",
            "Smyrna",
            "Townsend",
            "Viola",
            "Wilmington",
            "Winterthur",
            "Woodside",
            "Yorklyn"
        ]
    },
    {
        "state": "Florida",
        "abbr": "FL",
        "cities": [
            "Alachua",
            "Alford",
            "Altamonte Springs",
            "Altha",
            "Altoona",
            "Alturas",
            "Alva",
            "Anna Maria",
            "Anthony",
            "Apalachicola",
            "Apollo Beach",
            "Apopka",
            "Arcadia",
            "Archer",
            "Argyle",
            "Aripeka",
            "Astatula",
            "Astor",
            "Atlantic Beach",
            "Auburndale",
            "Avon Park",
            "Babson Park",
            "Bagdad",
            "Baker",
            "Balm",
            "Barberville",
            "Bartow",
            "Bascom",
            "Bay Pines",
            "Bell",
            "Belle Glade",
            "Belleair Beach",
            "Belleview",
            "Beverly Hills",
            "Big Pine Key",
            "Blountstown",
            "Boca Grande",
            "Boca Raton",
            "Bokeelia",
            "Bonifay",
            "Bonita Springs",
            "Bostwick",
            "Bowling Green",
            "Boynton Beach",
            "Bradenton",
            "Bradenton Beach",
            "Bradley",
            "Brandon",
            "Branford",
            "Bristol",
            "Bronson",
            "Brooker",
            "Brooksville",
            "Bryant",
            "Bryceville",
            "Bunnell",
            "Bushnell",
            "Callahan",
            "Campbellton",
            "Canal Point",
            "Candler",
            "Cantonment",
            "Cape Canaveral",
            "Cape Coral",
            "Captiva",
            "Carrabelle",
            "Caryville",
            "Cassadaga",
            "Casselberry",
            "Cedar Key",
            "Center Hill",
            "Century",
            "Chattahoochee",
            "Chiefland",
            "Chipley",
            "Chokoloskee",
            "Christmas",
            "Citra",
            "Citrus Ridge",
            "Clarcona",
            "Clarksville",
            "Clearwater",
            "Clearwater Beach",
            "Clermont",
            "Clewiston",
            "Cocoa",
            "Cocoa Beach",
            "Coleman",
            "Copeland",
            "Cortez",
            "Cottondale",
            "Crawfordville",
            "Crescent City",
            "Crestview",
            "Cross City",
            "Crystal Beach",
            "Crystal River",
            "Crystal Springs",
            "Cypress",
            "Dade City",
            "Dania",
            "Davenport",
            "Day",
            "Daytona Beach",
            "De Leon Springs",
            "Debary",
            "Deerfield Beach",
            "Defuniak Springs",
            "Deland",
            "Delray Beach",
            "Deltona",
            "Destin",
            "Doctors Inlet",
            "Dover",
            "Dundee",
            "Dunedin",
            "Dunnellon",
            "Durant",
            "Eagle Lake",
            "Earleton",
            "East Palatka",
            "Eastlake Weir",
            "Eastpoint",
            "Eaton Park",
            "Ebro",
            "Edgewater",
            "Eglin AFB",
            "Elfers",
            "Elkton",
            "Ellenton",
            "Englewood",
            "Estero",
            "Eustis",
            "Everglades City",
            "Evinston",
            "Fairfield",
            "Fedhaven",
            "Felda",
            "Fellsmere",
            "Fernandina Beach",
            "Ferndale",
            "Flagler Beach",
            "Florahome",
            "Floral City",
            "Florida City",
            "Fort Lauderdale",
            "Fort McCoy",
            "Fort Meade",
            "Fort Myers",
            "Fort Myers Beach",
            "Fort Ogden",
            "Fort Pierce",
            "Fort Walton Beach",
            "Fort White",
            "Fountain",
            "Freeport",
            "Frostproof",
            "Fruitland Park",
            "Gainesville",
            "Geneva",
            "Georgetown",
            "Gibsonton",
            "Glen Saint Mary",
            "Glenwood",
            "Goldenrod",
            "Gonzalez",
            "Goodland",
            "Gotha",
            "Graceville",
            "Graham",
            "Grand Island",
            "Grand Ridge",
            "Grandin",
            "Grant",
            "Green Cove Springs",
            "Greensboro",
            "Greenville",
            "Greenwood",
            "Gretna",
            "Grove City",
            "Groveland",
            "Gulf Breeze",
            "Gulf Hammock",
            "Haines City",
            "Hallandale",
            "Hampton",
            "Harold",
            "Hastings",
            "Havana",
            "Hawthorne",
            "Heathrow",
            "Hernando",
            "Hialeah",
            "High Springs",
            "Highland City",
            "Highland Park",
            "Hilliard",
            "Hobe Sound",
            "Holder",
            "Holiday",
            "Hollister",
            "Hollywood",
            "Holmes Beach",
            "Holt",
            "Homeland",
            "Homestead",
            "Homosassa",
            "Homosassa Springs",
            "Horseshoe Beach",
            "Hosford",
            "Howey In The Hills",
            "Hudson",
            "Hunters Creek",
            "Hurlburt Field",
            "Immokalee",
            "Indialantic",
            "Indian Lake Estates",
            "Indian Rocks Beach",
            "Indiantown",
            "Inglis",
            "Intercession City",
            "Interlachen",
            "Inverness",
            "Islamorada",
            "Island Grove",
            "Istachatta",
            "Jacksonville",
            "Jacksonville Beach",
            "Jasper",
            "Jay",
            "Jennings",
            "Jensen Beach",
            "Jupiter",
            "Kathleen",
            "Kenansville",
            "Key Biscayne",
            "Key Colony Beach",
            "Key Largo",
            "Key West",
            "Keystone Heights",
            "Killarney",
            "Kinard",
            "Kissimmee",
            "La Crosse",
            "Labelle",
            "Lacoochee",
            "Lady Lake",
            "Lake Alfred",
            "Lake Butler",
            "Lake Butter",
            "Lake City",
            "Lake Como",
            "Lake Geneva",
            "Lake Hamilton",
            "Lake Harbor",
            "Lake Helen",
            "Lake Lucerne",
            "Lake Mary",
            "Lake Monroe",
            "Lake Panasoffkee",
            "Lake Placid",
            "Lake Wales",
            "Lake Worth",
            "Lakeland",
            "Lamont",
            "Lanark Village",
            "Land O Lakes",
            "Lantana",
            "Largo",
            "Laurel",
            "Laurel Hill",
            "Lawtey",
            "Lecanto",
            "Lee",
            "Leesburg",
            "Lehigh Acres",
            "Lithia",
            "Live Oak",
            "Lloyd",
            "Lochloosa",
            "Long Key",
            "Longboat Key",
            "Longwood",
            "Lorida",
            "Loughman",
            "Lowell",
            "Loxahatchee",
            "Lulu",
            "Lutz",
            "Lynn Haven",
            "Macclenny",
            "Madison",
            "Maitland",
            "Malabar",
            "Malone",
            "Manasota",
            "Mango",
            "Marathon",
            "Marathon Shores",
            "Marco Island",
            "Marianna",
            "Mary Esther",
            "Mascotte",
            "Mayo",
            "McAlpin",
            "McDavid",
            "McIntosh",
            "Melbourne",
            "Melbourne Beach",
            "Melrose",
            "Memphis",
            "Merritt Island",
            "Mexico Beach",
            "Miami",
            "Miami Beach",
            "Micanopy",
            "Miccosukee Cpo",
            "Mid Florida",
            "Middleburg",
            "Midway",
            "Milligan",
            "Milton",
            "Mims",
            "Minneola",
            "Miramar Beach",
            "Molino",
            "Monticello",
            "Montverde",
            "Moore Haven",
            "Morriston",
            "Mossy Head",
            "Mount Dora",
            "Mount Pleasant",
            "Mulberry",
            "Murdock",
            "Myakka City",
            "Myrtle Grove",
            "Nalcrest",
            "Naples",
            "Neptune Beach",
            "New Port Richey",
            "New Smyrna Beach",
            "Newberry",
            "Niceville",
            "Nichols",
            "Nobleton",
            "Nocatee",
            "Nokomis",
            "Noma",
            "North Fort Myers",
            "North Miami Beach",
            "North Palm Beach",
            "North Port",
            "O Brien",
            "Oak Hill",
            "Oakland",
            "Ocala",
            "Ochopee",
            "Ocklawaha",
            "Ocoee",
            "Odessa",
            "Okahumpka",
            "Okeechobee",
            "Old Town",
            "Oldsmar",
            "Olustee",
            "Ona",
            "Oneco",
            "Opa Locka",
            "Orange City",
            "Orange Lake",
            "Orange Park",
            "Orange Springs",
            "Orlando",
            "Ormond Beach",
            "Osprey",
            "Osteen",
            "Otter Creek",
            "Oviedo",
            "Oxford",
            "Ozona",
            "Pahokee",
            "Paisley",
            "Palatka",
            "Palm Bay",
            "Palm Beach",
            "Palm City",
            "Palm Coast",
            "Palm Harbor",
            "Palm River-Clair Mel",
            "Palm Valley",
            "Palmdale",
            "Palmetto",
            "Panacea",
            "Panama City",
            "Panama City Beach",
            "Parrish",
            "Patrick AFB",
            "Paxton",
            "Pembroke Pines",
            "Penney Farms",
            "Pensacola",
            "Perry",
            "Pierson",
            "Pine Island Ridge",
            "Pine Ridge",
            "Pineland",
            "Pinellas Park",
            "Pinetta",
            "Placida",
            "Plant City",
            "Plymouth",
            "Point Washington",
            "Polk City",
            "Pomona Park",
            "Pompano Beach",
            "Ponce De Leon",
            "Ponte Vedra Beach",
            "Port Charlotte",
            "Port Orange",
            "Port Richey",
            "Port Saint Joe",
            "Port Saint Lucie",
            "Port Salerno",
            "Port St. Lucie",
            "Punta Gorda",
            "Putnam Hall",
            "Quincy",
            "Raiford",
            "Reddick",
            "River Ranch",
            "Riverview",
            "Rockledge",
            "Roseland",
            "Rotonda West",
            "Ruskin",
            "Safety Harbor",
            "Saint Augustine",
            "Saint Cloud",
            "Saint James City",
            "Saint Leo",
            "Saint Marks",
            "Saint Petersburg",
            "Salem",
            "San Antonio",
            "San Mateo",
            "Sanderson",
            "Sanford",
            "Sanibel",
            "Santa Rosa Beach",
            "Sarasota",
            "Satellite Beach",
            "Satsuma",
            "Scottsmoor",
            "Sebastian",
            "Sebring",
            "Seffner",
            "Seminole",
            "Seville",
            "Shady Grove",
            "Shalimar",
            "Sharpes",
            "Silver Springs",
            "Sneads",
            "Sopchoppy",
            "Sorrento",
            "South Bay",
            "Sparr",
            "Spring Hill",
            "St. Augustine",
            "St. Leo",
            "Starke",
            "Steinhatchee",
            "Stuart",
            "Sugarloaf Shores",
            "Sumatra",
            "Summerfield",
            "Summerland Key",
            "Sumterville",
            "Sun City",
            "Sun City Center",
            "Sunnyside",
            "Suwannee",
            "Sydney",
            "Tallahassee",
            "Tallevast",
            "Tampa",
            "Tangerine",
            "Tarpon Springs",
            "Tavares",
            "Tavernier",
            "Telogia",
            "Terra Ceia",
            "The Villages",
            "Thonotosassa",
            "Titusville",
            "Trenton",
            "Trilby",
            "Umatilla",
            "Valparaiso",
            "Valrico",
            "Vanderbilt Beach",
            "Venice",
            "Venus",
            "Vernon",
            "Vero Beach",
            "Wabasso",
            "Wacissa",
            "Wakulla Springs",
            "Waldo",
            "Wauchula",
            "Wausau",
            "Waverly",
            "Webster",
            "Weirsdale",
            "Welaka",
            "Wellborn",
            "West Little River",
            "West Palm Beach",
            "Weston",
            "Westville",
            "Wewahitchka",
            "White Springs",
            "Wildwood",
            "Williston",
            "Wimauma",
            "Windermere",
            "Winter Beach",
            "Winter Garden",
            "Winter Haven",
            "Winter Park",
            "Winter Springs",
            "Woodville",
            "Worthington Springs",
            "Yalaha",
            "Yankeetown",
            "Youngstown",
            "Yulee",
            "Zellwood",
            "Zephyrhills",
            "Zolfo Springs"
        ]
    },
    {
        "state": "Georgia",
        "abbr": "GA",
        "cities": [
            "Abbeville",
            "Acworth",
            "Adairsville",
            "Adel",
            "Adrian",
            "Ailey",
            "Alamo",
            "Alapaha",
            "Albany",
            "Allenhurst",
            "Allentown",
            "Alma",
            "Alpharetta",
            "Alston",
            "Alto",
            "Ambrose",
            "Americus",
            "Andersonville",
            "Appling",
            "Arabi",
            "Aragon",
            "Argyle",
            "Arlington",
            "Armuchee",
            "Arnoldsville",
            "Ashburn",
            "Athens",
            "Atlanta",
            "Attapulgus",
            "Auburn",
            "Augusta",
            "Austell",
            "Avera",
            "Avondale Estates",
            "Axson",
            "Baconton",
            "Bainbridge",
            "Baldwin",
            "Ball Ground",
            "Barnesville",
            "Barney",
            "Bartow",
            "Barwick",
            "Baxley",
            "Bellville",
            "Berlin",
            "Bethlehem",
            "Bishop",
            "Blackshear",
            "Blairsville",
            "Blakely",
            "Bloomingdale",
            "Blue Ridge",
            "Bluffton",
            "Blythe",
            "Bogart",
            "Bolingbroke",
            "Bonaire",
            "Boneville",
            "Boston",
            "Bostwick",
            "Bowdon",
            "Bowdon Junction",
            "Bowersville",
            "Bowman",
            "Box Springs",
            "Braselton",
            "Bremen",
            "Brinson",
            "Bristol",
            "Bronwood",
            "Brookfield",
            "Brooklet",
            "Brooks",
            "Broxton",
            "Brunswick",
            "Buchanan",
            "Buckhead",
            "Buena Vista",
            "Buford",
            "Butler",
            "Byromville",
            "Byron",
            "Cadwell",
            "Cairo",
            "Calhoun",
            "Calvary",
            "Camak",
            "Camilla",
            "Canon",
            "Canton",
            "Carlton",
            "Carnesville",
            "Carrollton",
            "Cartersville",
            "Cassville",
            "Cataula",
            "Cave Spring",
            "Cecil",
            "Cedar Springs",
            "Cedartown",
            "Centerville",
            "Chatsworth",
            "Chauncey",
            "Cherrylog",
            "Chester",
            "Chestnut Mountain",
            "Chickamauga",
            "Chula",
            "Cisco",
            "Clarkdale",
            "Clarkesville",
            "Clarkston",
            "Claxton",
            "Clayton",
            "Clermont",
            "Cleveland",
            "Climax",
            "Clinchfield",
            "Clyo",
            "Cobb",
            "Cobbtown",
            "Cochran",
            "Cohutta",
            "Colbert",
            "Coleman",
            "Collins",
            "Colquitt",
            "Columbus",
            "Comer",
            "Commerce",
            "Concord",
            "Conley",
            "Conyers",
            "Coolidge",
            "Coosa",
            "Cordele",
            "Cornelia",
            "Cotton",
            "Covington",
            "Crandall",
            "Crawford",
            "Crawfordville",
            "Crescent",
            "Culloden",
            "Cumming",
            "Cusseta",
            "Cuthbert",
            "Dacula",
            "Dahlonega",
            "Daisy",
            "Dallas",
            "Dalton",
            "Damascus",
            "Danielsville",
            "Danville",
            "Darien",
            "Davisboro",
            "Dawson",
            "Dawsonville",
            "De Soto",
            "Dearing",
            "Decatur",
            "Demorest",
            "Denton",
            "Dewy Rose",
            "Dexter",
            "Dillard",
            "Dixie",
            "Doerun",
            "Donalsonville",
            "Douglas",
            "Douglasville",
            "Dover",
            "Dry Branch",
            "Du Pont",
            "Dublin",
            "Dudley",
            "Duluth",
            "East Ellijay",
            "East Point",
            "Eastanollee",
            "Eastman",
            "Eatonton",
            "Eden",
            "Edison",
            "Elberton",
            "Elko",
            "Ellabell",
            "Ellaville",
            "Ellenton",
            "Ellenwood",
            "Ellerslie",
            "Ellijay",
            "Emerson",
            "Enigma",
            "Epworth",
            "Esom Hill",
            "Eton",
            "Evans",
            "Experiment",
            "Fairburn",
            "Fairmount",
            "Fargo",
            "Farmington",
            "Fayetteville",
            "Felton",
            "Fitzgerald",
            "Fleming",
            "Flintstone",
            "Flovilla",
            "Flowery Branch",
            "Folkston",
            "Forest Park",
            "Forsyth",
            "Fort Benning",
            "Fort Gaines",
            "Fort Oglethorpe",
            "Fort Stewart",
            "Fort Valley",
            "Fortson",
            "Fowlstown",
            "Franklin",
            "Franklin Springs",
            "Funston",
            "Gainesville",
            "Garfield",
            "Gay",
            "Geneva",
            "Georgetown",
            "Gibson",
            "Gillsville",
            "Girard",
            "Glenn",
            "Glennville",
            "Glenwood",
            "Good Hope",
            "Gordon",
            "Gough",
            "Gracewood",
            "Grantville",
            "Gray",
            "Grayson",
            "Graysville",
            "Greensboro",
            "Greenville",
            "Griffin",
            "Grovetown",
            "Guyton",
            "Haddock",
            "Hagan",
            "Hahira",
            "Hamilton",
            "Hampton",
            "Haralson",
            "Hardwick",
            "Harlem",
            "Harrison",
            "Hartsfield",
            "Hartwell",
            "Hawkinsville",
            "Hazlehurst",
            "Helen",
            "Helena",
            "Hephzibah",
            "Hiawassee",
            "High Shoals",
            "Hillsboro",
            "Hinesville",
            "Hiram",
            "Hoboken",
            "Hogansville",
            "Holly Springs",
            "Homer",
            "Homerville",
            "Hortense",
            "Hoschton",
            "Howard",
            "Hull",
            "Ideal",
            "Ila",
            "Inman",
            "Iron City",
            "Irwinton",
            "Irwinville",
            "Jackson",
            "Jacksonville",
            "Jakin",
            "Jasper",
            "Jefferson",
            "Jeffersonville",
            "Jekyll Island",
            "Jenkinsburg",
            "Jersey",
            "Jesup",
            "Jewell",
            "Jonesboro",
            "Juliette",
            "Junction City",
            "Kathleen",
            "Kennesaw",
            "Keysville",
            "Kings Bay",
            "Kingsland",
            "Kingston",
            "Kite",
            "Knoxville",
            "La Fayette",
            "Lagrange",
            "Lake Park",
            "Lakeland",
            "Lakemont",
            "Lavonia",
            "Lawrenceville",
            "Leary",
            "Lebanon",
            "Leesburg",
            "Lenox",
            "Leslie",
            "Lexington",
            "Lilburn",
            "Lilly",
            "Lincolnton",
            "Lindale",
            "Lithia Springs",
            "Lithonia",
            "Lizella",
            "Locust Grove",
            "Loganville",
            "Lookout Mountain",
            "Louisville",
            "Louvale",
            "Lovejoy",
            "Ludowici",
            "Lula",
            "Lumber City",
            "Lumpkin",
            "Luthersville",
            "Lyerly",
            "Lyons",
            "Mableton",
            "Macon",
            "Madison",
            "Manassas",
            "Manchester",
            "Manor",
            "Mansfield",
            "Marble Hill",
            "Marietta",
            "Marshallville",
            "Martin",
            "Matthews",
            "Mauk",
            "Maxeys",
            "Maysville",
            "McCaysville",
            "Mcdonough",
            "McIntyre",
            "McRae",
            "Meansville",
            "Meigs",
            "Meldrim",
            "Menlo",
            "Meridian",
            "Mershon",
            "Mesena",
            "Metter",
            "Midland",
            "Midville",
            "Midway",
            "Milan",
            "Milledgeville",
            "Millen",
            "Millwood",
            "Milner",
            "Mineral Bluff",
            "Mitchell",
            "Molena",
            "Monroe",
            "Montezuma",
            "Monticello",
            "Montrose",
            "Moreland",
            "Morgan",
            "Morganton",
            "Morris",
            "Morrow",
            "Morven",
            "Moultrie",
            "Mount Airy",
            "Mount Berry",
            "Mount Vernon",
            "Mount Zion",
            "Mountain City",
            "Murrayville",
            "Musella",
            "Mystic",
            "Nahunta",
            "Nashville",
            "Naylor",
            "Nelson",
            "Newborn",
            "Newington",
            "Newnan",
            "Newton",
            "Nicholls",
            "Nicholson",
            "Norcross",
            "Norman Park",
            "Norristown",
            "Norwood",
            "Nunez",
            "Oakfield",
            "Oakman",
            "Oakwood",
            "Ochlocknee",
            "Ocilla",
            "Oconee",
            "Odum",
            "Offerman",
            "Oglethorpe",
            "Oliver",
            "Omaha",
            "Omega",
            "Orchard Hill",
            "Oxford",
            "Palmetto",
            "Parrott",
            "Patterson",
            "Pavo",
            "Peachtree City",
            "Pearson",
            "Pelham",
            "Pembroke",
            "Pendergrass",
            "Perkins",
            "Perry",
            "Pine Lake",
            "Pine Mountain",
            "Pine Mountain Valley",
            "Pinehurst",
            "Pineview",
            "Pitts",
            "Plainfield",
            "Plains",
            "Plainville",
            "Pooler",
            "Portal",
            "Porterdale",
            "Poulan",
            "Powder Springs",
            "Preston",
            "Pulaski",
            "Putney",
            "Quitman",
            "Rabun Gap",
            "Ranger",
            "Ray City",
            "Rayle",
            "Rebecca",
            "Red Oak",
            "Redan",
            "Register",
            "Reidsville",
            "Rentz",
            "Resaca",
            "Rex",
            "Reynolds",
            "Rhine",
            "Riceboro",
            "Richland",
            "Richmond Hill",
            "Rincon",
            "Ringgold",
            "Rising Fawn",
            "Riverdale",
            "Roberta",
            "Rochelle",
            "Rock Spring",
            "Rockledge",
            "Rockmart",
            "Rocky Face",
            "Rocky Ford",
            "Rome",
            "Roopville",
            "Rossville",
            "Roswell",
            "Royston",
            "Rupert",
            "Rutledge",
            "Rydal",
            "Saint George",
            "Saint Marys",
            "Saint Simons Island",
            "Sale City",
            "Sandersville",
            "Sapelo Island",
            "Sardis",
            "Sargent",
            "Sasser",
            "Sautee Nacoochee",
            "Savannah",
            "Scotland",
            "Scottdale",
            "Screven",
            "Sea Island",
            "Senoia",
            "Seville",
            "Shady Dale",
            "Shannon",
            "Sharon",
            "Sharpsburg",
            "Shellman",
            "Shiloh",
            "Siloam",
            "Silver Creek",
            "Smarr",
            "Smithville",
            "Smyrna",
            "Snellville",
            "Social Circle",
            "Soperton",
            "Sparks",
            "Sparta",
            "Springfield",
            "Stapleton",
            "Statenville",
            "Statesboro",
            "Statham",
            "Stephens",
            "Stillmore",
            "Stockbridge",
            "Stockton",
            "Stone Mountain",
            "Suches",
            "Sugar Valley",
            "Summertown",
            "Summerville",
            "Sumner",
            "Sunny Side",
            "Surrency",
            "Suwanee",
            "Swainsboro",
            "Sycamore",
            "Sylvania",
            "Sylvester",
            "Talbotton",
            "Talking Rock",
            "Tallapoosa",
            "Tallulah Falls",
            "Talmo",
            "Tarrytown",
            "Tate",
            "Taylorsville",
            "Temple",
            "Tennga",
            "Tennille",
            "The Rock",
            "Thomaston",
            "Thomasville",
            "Thomson",
            "Tifton",
            "Tiger",
            "Tignall",
            "Toccoa",
            "Toomsboro",
            "Townsend",
            "Trenton",
            "Trion",
            "Tucker",
            "Tunnel Hill",
            "Turin",
            "Turnerville",
            "Twin City",
            "Ty Ty",
            "Tybee Island",
            "Tyrone",
            "Unadilla",
            "Union City",
            "Union Point",
            "Upatoi",
            "Uvalda",
            "Valdosta",
            "Valona",
            "Varnell",
            "Vidalia",
            "Vienna",
            "Villa Rica",
            "Waco",
            "Wadley",
            "Waleska",
            "Walthourville",
            "Waresboro",
            "Warm Springs",
            "Warner Robins",
            "Warrenton",
            "Warthen",
            "Warwick",
            "Washington",
            "Watkinsville",
            "Waverly",
            "Waverly Hall",
            "Waycross",
            "Waynesboro",
            "Waynesville",
            "West Green",
            "West Point",
            "Weston",
            "Whigham",
            "White",
            "White Oak",
            "White Plains",
            "Whitesburg",
            "Wildwood",
            "Wiley",
            "Willacoochee",
            "Williamson",
            "Winder",
            "Winston",
            "Winterville",
            "Woodbine",
            "Woodbury",
            "Woodland",
            "Woodstock",
            "Wray",
            "Wrens",
            "Wrightsville",
            "Yatesville",
            "Young Harris",
            "Zebulon"
        ]
    },
    {
        "state": "Hawaii",
        "abbr": "HI",
        "cities": [
            "Aiea",
            "Anahola",
            "Barbers Point N A S",
            "Camp H M Smith",
            "Captain Cook",
            "Eleele",
            "Ewa Beach",
            "Fort Shafter",
            "Haiku",
            "Hakalau",
            "Haleiwa",
            "Hana",
            "Hanalei",
            "Hanamaulu",
            "Hanapepe",
            "Hauula",
            "Hawaii National Park",
            "Hawaiian Ocean View",
            "Hawi",
            "Hickam AFB",
            "Hilo",
            "Holualoa",
            "Honaunau",
            "Honokaa",
            "Honolulu",
            "Honomu",
            "Hoolehua",
            "Kaaawa",
            "Kahuku",
            "Kahului",
            "Kailua",
            "Kailua Kona",
            "Kalaheo",
            "Kalaupapa",
            "Kamuela",
            "Kaneohe",
            "Kapaa",
            "Kapaau",
            "Kapolei",
            "Kaumakani",
            "Kaunakakai",
            "Kawela Bay",
            "Keaau",
            "Kealakekua",
            "Kealia",
            "Keauhou",
            "Kekaha",
            "Kihei",
            "Kilauea",
            "Koloa",
            "Kualapuu",
            "Kula",
            "Kunia",
            "Kurtistown",
            "Lahaina",
            "Laie",
            "Lanai City",
            "Laupahoehoe",
            "Lawai",
            "Lihue",
            "M C B H Kaneohe Bay",
            "Makawao",
            "Makaweli",
            "Maunaloa",
            "Mililani",
            "Mountain View",
            "Naalehu",
            "Ninole",
            "Ocean View",
            "Ookala",
            "Paauhau",
            "Paauilo",
            "Pahala",
            "Pahoa",
            "Paia",
            "Papaaloa",
            "Papaikou",
            "Pearl City",
            "Pearl Harbor",
            "Pepeekeo",
            "Princeville",
            "Pukalani",
            "Puunene",
            "Schofield Barracks",
            "Tripler Army Medical Ctr",
            "Volcano",
            "Wahiawa",
            "Waialua",
            "Waianae",
            "Waikoloa",
            "Wailuku",
            "Waimanalo",
            "Waimea",
            "Waipahu",
            "Wake Island",
            "Wheeler Army Airfield"
        ]
    },
    {
        "state": "Idaho",
        "abbr": "ID",
        "cities": [
            "Aberdeen",
            "Ahsahka",
            "Albion",
            "Almo",
            "American Falls",
            "Arbon",
            "Arco",
            "Arimo",
            "Ashton",
            "Athol",
            "Atlanta",
            "Atomic City",
            "Avery",
            "Bancroft",
            "Banks",
            "Basalt",
            "Bayview",
            "Bellevue",
            "Bern",
            "Blackfoot",
            "Blanchard",
            "Bliss",
            "Bloomington",
            "Boise",
            "Bonners Ferry",
            "Bovill",
            "Bruneau",
            "Buhl",
            "Burley",
            "Calder",
            "Caldwell",
            "Cambridge",
            "Carey",
            "Careywood",
            "Carmen",
            "Cascade",
            "Castleford",
            "Cataldo",
            "Challis",
            "Chester",
            "Clark Fork",
            "Clarkia",
            "Clayton",
            "Clifton",
            "Cobalt",
            "Cocolalla",
            "Coeur D Alene",
            "Colburn",
            "Conda",
            "Coolin",
            "Corral",
            "Cottonwood",
            "Council",
            "Craigmont",
            "Culdesac",
            "Dayton",
            "Deary",
            "Declo",
            "Desmet",
            "Dietrich",
            "Dingle",
            "Donnelly",
            "Dover",
            "Downey",
            "Driggs",
            "Dubois",
            "Eagle",
            "Eastport",
            "Eden",
            "Elk City",
            "Elk River",
            "Ellis",
            "Emmett",
            "Fairfield",
            "Farmington",
            "Felt",
            "Fenn",
            "Ferdinand",
            "Fernwood",
            "Filer",
            "Firth",
            "Fish Haven",
            "Fort Hall",
            "Franklin",
            "Freedom",
            "Fruitland",
            "Fruitvale",
            "Garden Valley",
            "Genesee",
            "Geneva",
            "Georgetown",
            "Gibbonsville",
            "Glenns Ferry",
            "Gooding",
            "Grace",
            "Grand View",
            "Grangeville",
            "Greencreek",
            "Greenleaf",
            "Hagerman",
            "Hailey",
            "Hamer",
            "Hammett",
            "Hansen",
            "Harrison",
            "Harvard",
            "Hayden",
            "Hazelton",
            "Heyburn",
            "Hill City",
            "Holbrook",
            "Homedale",
            "Hope",
            "Horseshoe Bend",
            "Howe",
            "Huston",
            "Idaho City",
            "Idaho Falls",
            "Indian Valley",
            "Inkom",
            "Iona",
            "Irwin",
            "Island Park",
            "Jerome",
            "Jordan Valley",
            "Juliaetta",
            "Kamiah",
            "Kellogg",
            "Kendrick",
            "Ketchum",
            "Kimberly",
            "King Hill",
            "Kingston",
            "Kooskia",
            "Kootenai",
            "Kuna",
            "Laclede",
            "Lake Fork",
            "Lapwai",
            "Lava Hot Springs",
            "Leadore",
            "Lemhi",
            "Lenore",
            "Letha",
            "Lewiston",
            "Lewisville",
            "Lowman",
            "Lucile",
            "Mackay",
            "Macks Inn",
            "Malad City",
            "Malta",
            "Marsing",
            "May",
            "McCall",
            "McCammon",
            "Medimont",
            "Melba",
            "Menan",
            "Meridian",
            "Mesa",
            "Middleton",
            "Midvale",
            "Minidoka",
            "Monteview",
            "Montpelier",
            "Moore",
            "Moreland",
            "Moscow",
            "Mountain Home",
            "Mountain Home A F B",
            "Moyie Springs",
            "Mullan",
            "Murphy",
            "Murray",
            "Murtaugh",
            "Nampa",
            "Naples",
            "New Meadows",
            "New Plymouth",
            "Newdale",
            "Nezperce",
            "Nordman",
            "North Fork",
            "Notus",
            "Nyssa",
            "Oakley",
            "Ola",
            "Oldtown",
            "Orofino",
            "Osburn",
            "Paris",
            "Parker",
            "Parma",
            "Paul",
            "Payette",
            "Peck",
            "Picabo",
            "Pierce",
            "Pinehurst",
            "Pingree",
            "Placerville",
            "Plummer",
            "Pocatello",
            "Pollock",
            "Ponderay",
            "Porthill",
            "Post Falls",
            "Potlatch",
            "Preston",
            "Priest River",
            "Princeton",
            "Rathdrum",
            "Reubens",
            "Rexburg",
            "Richfield",
            "Rigby",
            "Riggins",
            "Ririe",
            "Roberts",
            "Rockland",
            "Rogerson",
            "Rupert",
            "Sagle",
            "Saint Anthony",
            "Saint Charles",
            "Saint Maries",
            "Salmon",
            "Samuels",
            "Sandpoint",
            "Santa",
            "Shelley",
            "Shoshone",
            "Shoup",
            "Silverton",
            "Smelterville",
            "Soda Springs",
            "Spalding",
            "Spencer",
            "Spirit Lake",
            "Springfield",
            "Squirrel",
            "Stanley",
            "Star",
            "Stites",
            "Sugar City",
            "Sun Valley",
            "Swan Valley",
            "Swanlake",
            "Sweet",
            "Tendoy",
            "Tensed",
            "Terreton",
            "Teton",
            "Tetonia",
            "Thatcher",
            "Troy",
            "Twin Falls",
            "Ucon",
            "Victor",
            "Viola",
            "Wallace",
            "Warren",
            "Wayan",
            "Weippe",
            "Weiser",
            "Wendell",
            "Weston",
            "White Bird",
            "Wilder",
            "Winchester",
            "Worley",
            "Yellow Pine"
        ]
    },
    {
        "state": "Illinois",
        "abbr": "IL",
        "cities": [
            "Abingdon",
            "Adair",
            "Addieville",
            "Addison",
            "Adrian",
            "Akin",
            "Albany",
            "Albers",
            "Albion",
            "Alden",
            "Aledo",
            "Alexander",
            "Alexis",
            "Algonquin",
            "Alhambra",
            "Allendale",
            "Allerton",
            "Alma",
            "Alpha",
            "Alsey",
            "Alsip",
            "Altamont",
            "Alto Pass",
            "Alton",
            "Altona",
            "Alvin",
            "Amboy",
            "Amf Ohare",
            "Anchor",
            "Ancona",
            "Andalusia",
            "Andover",
            "Anna",
            "Annapolis",
            "Annawan",
            "Antioch",
            "Apple River",
            "Arcola",
            "Arenzville",
            "Argenta",
            "Arlington",
            "Arlington Heights",
            "Armington",
            "Armstrong",
            "Aroma Park",
            "Arrowsmith",
            "Arthur",
            "Ashkum",
            "Ashland",
            "Ashley",
            "Ashmore",
            "Ashton",
            "Assumption",
            "Astoria",
            "Athens",
            "Atkinson",
            "Atlanta",
            "Atwater",
            "Atwood",
            "Auburn",
            "Augusta",
            "Aurora",
            "Ava",
            "Aviston",
            "Avon",
            "Baileyville",
            "Baldwin",
            "Bardolph",
            "Barnhill",
            "Barrington",
            "Barry",
            "Barstow",
            "Bartelso",
            "Bartlett",
            "Basco",
            "Batavia",
            "Batchtown",
            "Bath",
            "Baylis",
            "Beardstown",
            "Beason",
            "Beaverville",
            "Beckemeyer",
            "Bedford Park",
            "Beecher",
            "Beecher City",
            "Belknap",
            "Belle Rive",
            "Belleville",
            "Bellflower",
            "Bellmont",
            "Bellwood",
            "Belvidere",
            "Bement",
            "Benld",
            "Bensenville",
            "Benson",
            "Benton",
            "Berkeley",
            "Berwick",
            "Berwyn",
            "Bethalto",
            "Bethany",
            "Big Rock",
            "Biggsville",
            "Bingham",
            "Birds",
            "Bishop Hill",
            "Bismarck",
            "Blackstone",
            "Blandinsville",
            "Bloomingdale",
            "Bloomington",
            "Blue Island",
            "Blue Mound",
            "Bluff Springs",
            "Bluffs",
            "Bluford",
            "Boles",
            "Bolingbrook",
            "Bondville",
            "Bone Gap",
            "Bonfield",
            "Bonnie",
            "Boody",
            "Bourbonnais",
            "Bowen",
            "Braceville",
            "Bradford",
            "Bradley",
            "Braidwood",
            "Breese",
            "Bridgeport",
            "Bridgeview",
            "Brighton",
            "Brimfield",
            "Bristol",
            "Broadlands",
            "Broadview",
            "Brocton",
            "Brookfield",
            "Brookport",
            "Broughton",
            "Browning",
            "Browns",
            "Brownstown",
            "Brushy Mound",
            "Brussels",
            "Bryant",
            "Buckingham",
            "Buckley",
            "Buckner",
            "Buda",
            "Buffalo",
            "Buffalo Grove",
            "Buffalo Prairie",
            "Bulpitt",
            "Buncombe",
            "Bunker Hill",
            "Burbank",
            "Bureau",
            "Burlington",
            "Burnside",
            "Burnt Prairie",
            "Bushnell",
            "Butler",
            "Byron",
            "Cabery",
            "Cache",
            "Cairo",
            "Caledonia",
            "Calhoun",
            "Calumet City",
            "Camargo",
            "Cambria",
            "Cambridge",
            "Camden",
            "Cameron",
            "Camp Grove",
            "Camp Point",
            "Campbell Hill",
            "Campus",
            "Canton",
            "Cantrall",
            "Capron",
            "Carbon Cliff",
            "Carbondale",
            "Carlinville",
            "Carlock",
            "Carlyle",
            "Carman",
            "Carmi",
            "Carol Stream",
            "Carpentersville",
            "Carrier Mills",
            "Carrollton",
            "Carterville",
            "Carthage",
            "Cary",
            "Casey",
            "Caseyville",
            "Castleton",
            "Catlin",
            "Cave In Rock",
            "Cedar Point",
            "Cedarville",
            "Centralia",
            "Cerro Gordo",
            "Chadwick",
            "Chambersburg",
            "Champaign",
            "Chana",
            "Chandlerville",
            "Channahon",
            "Chapin",
            "Charleston",
            "Chatham",
            "Chatsworth",
            "Chebanse",
            "Chenoa",
            "Cherry",
            "Cherry Valley",
            "Chester",
            "Chesterfield",
            "Chestnut",
            "Chicago",
            "Chicago Heights",
            "Chicago Ridge",
            "Chillicothe",
            "Chrisman",
            "Christopher",
            "Cicero",
            "Cisco",
            "Cisne",
            "Cissna Park",
            "Clare",
            "Claremont",
            "Clarendon Hills",
            "Clay City",
            "Clayton",
            "Claytonville",
            "Clifton",
            "Clinton",
            "Coal City",
            "Coal Valley",
            "Coatsburg",
            "Cobden",
            "Coello",
            "Coffeen",
            "Colchester",
            "Coleta",
            "Colfax",
            "Collinsville",
            "Collison",
            "Colona",
            "Colp",
            "Columbia",
            "Colusa",
            "Compton",
            "Concord",
            "Congerville",
            "Cooksville",
            "Cordova",
            "Cornell",
            "Cornland",
            "Cortland",
            "Cottage Hills",
            "Coulterville",
            "Country Club Hills",
            "Cowden",
            "Creal Springs",
            "Crescent City",
            "Creston",
            "Crete",
            "Creve Coeur",
            "Cropsey",
            "Crossville",
            "Crystal Lake",
            "Cuba",
            "Cullom",
            "Cutler",
            "Cypress",
            "Dahinda",
            "Dahlgren",
            "Dakota",
            "Dale",
            "Dallas City",
            "Dalton City",
            "Dalzell",
            "Dana",
            "Danforth",
            "Danvers",
            "Danville",
            "Darien",
            "Davis",
            "Davis Junction",
            "Dawson",
            "De Land",
            "De Soto",
            "Decatur",
            "Deer Creek",
            "Deer Grove",
            "Deerfield",
            "Dekalb",
            "Delavan",
            "Dement",
            "Dennison",
            "Depue",
            "Des Plaines",
            "Dewey",
            "Dewitt",
            "Dieterich",
            "Divernon",
            "Dix",
            "Dixon",
            "Dolton",
            "Dongola",
            "Donnellson",
            "Donovan",
            "Dorsey",
            "Dover",
            "Dow",
            "Dowell",
            "Downers Grove",
            "Downs",
            "Du Bois",
            "Du Quoin",
            "Dundas",
            "Dundee",
            "Dunfermline",
            "Dunlap",
            "Dupo",
            "Durand",
            "Dwight",
            "Eagarville",
            "Earlville",
            "East Alton",
            "East Carondelet",
            "East Dubuque",
            "East Galesburg",
            "East Lynn",
            "East Moline",
            "East Peoria",
            "East Saint Louis",
            "Easton",
            "Eddyville",
            "Edelstein",
            "Edgewood",
            "Edinburg",
            "Edwards",
            "Edwardsville",
            "Effingham",
            "El Paso",
            "Elburn",
            "Eldena",
            "Eldorado",
            "Eldred",
            "Eleroy",
            "Elgin",
            "Elizabeth",
            "Elizabethtown",
            "Elk Grove Village",
            "Elkhart",
            "Elkville",
            "Ellery",
            "Elliott",
            "Ellis Grove",
            "Ellisville",
            "Ellsworth",
            "Elmhurst",
            "Elmwood",
            "Elmwood Park",
            "Elsah",
            "Elvaston",
            "Elwin",
            "Elwood",
            "Emden",
            "Emington",
            "Emma",
            "Energy",
            "Enfield",
            "Eola",
            "Equality",
            "Erie",
            "Esmond",
            "Essex",
            "Eureka",
            "Evanston",
            "Evansville",
            "Evergreen Park",
            "Ewing",
            "Fairbury",
            "Fairfield",
            "Fairmount",
            "Fairview",
            "Fairview Heights",
            "Farina",
            "Farmer City",
            "Farmersville",
            "Farmington",
            "Fenton",
            "Ferris",
            "Fiatt",
            "Fidelity",
            "Fieldon",
            "Fillmore",
            "Findlay",
            "Fisher",
            "Fithian",
            "Flanagan",
            "Flat Rock",
            "Flora",
            "Flossmoor",
            "Foosland",
            "Forest City",
            "Forest Park",
            "Forrest",
            "Forreston",
            "Forsyth",
            "Fort Sheridan",
            "Fowler",
            "Fox Lake",
            "Fox River Grove",
            "Fox Valley",
            "Frankfort",
            "Frankfort Heights",
            "Franklin",
            "Franklin Grove",
            "Franklin Park",
            "Frederick",
            "Freeburg",
            "Freeman Spur",
            "Freeport",
            "Fulton",
            "Fults",
            "Galatia",
            "Galena",
            "Galesburg",
            "Galt",
            "Galva",
            "Garden Prairie",
            "Gardner",
            "Garrett",
            "Gays",
            "Geff",
            "Geneseo",
            "Geneva",
            "Genoa",
            "Georgetown",
            "Gerlaw",
            "German Valley",
            "Germantown",
            "Gibson City",
            "Gifford",
            "Gilberts",
            "Gillespie",
            "Gilman",
            "Gilson",
            "Girard",
            "Gladstone",
            "Glasford",
            "Glen Carbon",
            "Glen Ellyn",
            "Glenarm",
            "Glencoe",
            "Glendale Heights",
            "Glenview",
            "Glenview Nas",
            "Glenwood",
            "Godfrey",
            "Golconda",
            "Golden",
            "Golden Eagle",
            "Golden Gate",
            "Golf",
            "Good Hope",
            "Goodfield",
            "Goodwine",
            "Goreville",
            "Gorham",
            "Grafton",
            "Grand Chain",
            "Grand Ridge",
            "Grand Tower",
            "Granite City",
            "Grant Park",
            "Grantsburg",
            "Granville",
            "Graymont",
            "Grayslake",
            "Grayville",
            "Great Lakes",
            "Green Valley",
            "Greenfield",
            "Greenup",
            "Greenview",
            "Greenville",
            "Gridley",
            "Griggsville",
            "Groveland",
            "Gurnee",
            "Hagarstown",
            "Hamburg",
            "Hamel",
            "Hamilton",
            "Hamletsburg",
            "Hammond",
            "Hampshire",
            "Hampton",
            "Hanna City",
            "Hanover",
            "Hanover Park",
            "Hardin",
            "Harmon",
            "Harrisburg",
            "Harristown",
            "Hartford",
            "Hartsburg",
            "Harvard",
            "Harvel",
            "Harvey",
            "Harwood Heights",
            "Havana",
            "Hazel Crest",
            "Hebron",
            "Hecker",
            "Henderson",
            "Hennepin",
            "Henning",
            "Henry",
            "Herald",
            "Herod",
            "Herrick",
            "Herrin",
            "Herscher",
            "Hettick",
            "Heyworth",
            "Hickory Hills",
            "Hidalgo",
            "Highland",
            "Highland Park",
            "Highwood",
            "Hillsboro",
            "Hillsdale",
            "Hillside",
            "Hillview",
            "Hillyard",
            "Hinckley",
            "Hindsboro",
            "Hines",
            "Hinsdale",
            "Hoffman",
            "Hoffman Estates",
            "Holcomb",
            "Homer",
            "Hometown",
            "Homewood",
            "Hoopeston",
            "Hooppole",
            "Hopedale",
            "Hopkins Park",
            "Hoyleton",
            "Hudson",
            "Huey",
            "Hull",
            "Humboldt",
            "Hume",
            "Huntley",
            "Huntsville",
            "Hurst",
            "Hutsonville",
            "Illinois City",
            "Illiopolis",
            "Ina",
            "Indianola",
            "Industry",
            "Ingleside",
            "Ingraham",
            "Iola",
            "Ipava",
            "Iroquois",
            "Irving",
            "Irvington",
            "Island Lake",
            "Itasca",
            "Iuka",
            "Ivesdale",
            "Jacksonville",
            "Jacob",
            "Janesville",
            "Jerseyville",
            "Jewett",
            "Johnsonville",
            "Johnston City",
            "Joliet",
            "Jonesboro",
            "Joppa",
            "Joy",
            "Junction",
            "Justice",
            "Kampsville",
            "Kane",
            "Kaneville",
            "Kankakee",
            "Kansas",
            "Karbers Ridge",
            "Karnak",
            "Kasbeer",
            "Keenes",
            "Keensburg",
            "Keithsburg",
            "Kell",
            "Kempton",
            "Kenilworth",
            "Kenney",
            "Kent",
            "Kewanee",
            "Keyesport",
            "Kilbourne",
            "Kincaid",
            "Kinderhook",
            "Kingston",
            "Kingston Mines",
            "Kinmundy",
            "Kinsman",
            "Kirkland",
            "Kirkwood",
            "Knoxville",
            "La Fayette",
            "La Grange",
            "La Grange Park",
            "La Harpe",
            "La Moille",
            "La Place",
            "La Prairie",
            "La Rose",
            "La Salle",
            "Lacon",
            "Ladd",
            "Lafox",
            "Lake Bluff",
            "Lake Forest",
            "Lake Fork",
            "Lake in the Hills",
            "Lake Villa",
            "Lake Zurich",
            "Lakewood",
            "Lanark",
            "Lancaster",
            "Lane",
            "Lansing",
            "Latham",
            "Laura",
            "Lawndale",
            "Lawrenceville",
            "Le Roy",
            "Leaf River",
            "Lebanon",
            "Lee",
            "Lee Center",
            "Leland",
            "Lemont",
            "Lena",
            "Lenzburg",
            "Leonore",
            "Lerna",
            "Lewistown",
            "Lexington",
            "Liberty",
            "Libertyville",
            "Lima",
            "Lincoln",
            "Lincoln S New Salem",
            "Lincolnshire",
            "Lincolnwood",
            "Lindenwood",
            "Lisle",
            "Litchfield",
            "Literberry",
            "Little York",
            "Littleton",
            "Liverpool",
            "Livingston",
            "Loami",
            "Lockport",
            "Loda",
            "Logan",
            "Lomax",
            "Lombard",
            "London Mills",
            "Long Grove",
            "Long Point",
            "Longview",
            "Loogootee",
            "Loraine",
            "Lostant",
            "Louisville",
            "Lovejoy",
            "Loves Park",
            "Lovington",
            "Lowder",
            "Lowpoint",
            "Ludlow",
            "Lyndon",
            "Lynn Center",
            "Lyons",
            "Macedonia",
            "Machesney Park",
            "Mackinaw",
            "Macomb",
            "Macon",
            "Madison",
            "Maeystown",
            "Magnolia",
            "Mahomet",
            "Makanda",
            "Malden",
            "Malta",
            "Manchester",
            "Manhattan",
            "Manito",
            "Manlius",
            "Mansfield",
            "Manteno",
            "Maple Park",
            "Mapleton",
            "Maquon",
            "Marengo",
            "Marietta",
            "Marine",
            "Marion",
            "Marissa",
            "Mark",
            "Maroa",
            "Marseilles",
            "Marshall",
            "Martinsville",
            "Martinton",
            "Maryville",
            "Mascoutah",
            "Mason",
            "Mason City",
            "Matherville",
            "Matteson",
            "Mattoon",
            "Maunie",
            "Maywood",
            "Mazon",
            "McClure",
            "McConnell",
            "Mchenry",
            "McLean",
            "McLeansboro",
            "McNabb",
            "Mechanicsburg",
            "Media",
            "Medinah",
            "Medora",
            "Melrose Park",
            "Melvin",
            "Menard",
            "Mendon",
            "Mendota",
            "Meredosia",
            "Merna",
            "Metamora",
            "Metcalf",
            "Metropolis",
            "Michael",
            "Middletown",
            "Midlothian",
            "Milan",
            "Milford",
            "Mill Shoals",
            "Millbrook",
            "Millcreek",
            "Milledgeville",
            "Miller City",
            "Millington",
            "Millstadt",
            "Milmine",
            "Milton",
            "Mineral",
            "Minier",
            "Minonk",
            "Minooka",
            "Mode",
            "Modesto",
            "Modoc",
            "Mokena",
            "Moline",
            "Momence",
            "Monee",
            "Monmouth",
            "Monroe Center",
            "Montgomery",
            "Monticello",
            "Montrose",
            "Mooseheart",
            "Moro",
            "Morris",
            "Morrison",
            "Morrisonville",
            "Morton",
            "Morton Grove",
            "Mossville",
            "Mound City",
            "Mounds",
            "Mount Auburn",
            "Mount Carmel",
            "Mount Carroll",
            "Mount Erie",
            "Mount Morris",
            "Mount Olive",
            "Mount Prospect",
            "Mount Pulaski",
            "Mount Sterling",
            "Mount Vernon",
            "Moweaqua",
            "Mozier",
            "Mt Zion",
            "Muddy",
            "Mulberry Grove",
            "Mulkeytown",
            "Muncie",
            "Mundelein",
            "Murdock",
            "Murphysboro",
            "Murrayville",
            "Muscatine",
            "Nachusa",
            "Naperville",
            "Nashville",
            "Nason",
            "National Stock Yards",
            "Nauvoo",
            "Nebo",
            "Nelson",
            "Neoga",
            "Neponset",
            "New Athens",
            "New Baden",
            "New Bedford",
            "New Berlin",
            "New Boston",
            "New Burnside",
            "New Canton",
            "New Douglas",
            "New Haven",
            "New Holland",
            "New Lenox",
            "New Memphis",
            "New Salem",
            "New Windsor",
            "Newark",
            "Newman",
            "Newton",
            "Niantic",
            "Niles",
            "Nilwood",
            "Niota",
            "Noble",
            "Nokomis",
            "Nora",
            "Normal",
            "Norris",
            "Norris City",
            "North Aurora",
            "North Chicago",
            "North Henderson",
            "Northbrook",
            "O Fallon",
            "Oak Brook",
            "Oak Forest",
            "Oak Lawn",
            "Oak Park",
            "Oakdale",
            "Oakford",
            "Oakland",
            "Oakley",
            "Oakwood",
            "Oblong",
            "Oconee",
            "Odell",
            "Odin",
            "Ogden",
            "Oglesby",
            "Ohio",
            "Ohlman",
            "Okawville",
            "Olive Branch",
            "Olmsted",
            "Olney",
            "Olympia Fields",
            "Omaha",
            "Onarga",
            "Oneida",
            "Opdyke",
            "Opheim",
            "Oquawka",
            "Orangeville",
            "Oraville",
            "Oreana",
            "Oregon",
            "Orient",
            "Orion",
            "Orland Park",
            "Osco",
            "Oswego",
            "Ottawa",
            "Owaneco",
            "Ozark",
            "Palatine",
            "Palestine",
            "Palmer",
            "Palmyra",
            "Paloma",
            "Palos Heights",
            "Palos Hills",
            "Palos Park",
            "Pana",
            "Panama",
            "Papineau",
            "Paris",
            "Park Forest",
            "Park Ridge",
            "Parkersburg",
            "Patoka",
            "Patterson",
            "Paw Paw",
            "Pawnee",
            "Paxton",
            "Payson",
            "Pearl",
            "Pearl City",
            "Pecatonica",
            "Pekin",
            "Penfield",
            "Peoria",
            "Peotone",
            "Percy",
            "Perks",
            "Perry",
            "Peru",
            "Pesotum",
            "Petersburg",
            "Philadelphia",
            "Philo",
            "Piasa",
            "Pierron",
            "Pinckneyville",
            "Piper City",
            "Pittsburg",
            "Pittsfield",
            "Plainfield",
            "Plainville",
            "Plano",
            "Plato Center",
            "Pleasant Hill",
            "Pleasant Plains",
            "Plymouth",
            "Pocahontas",
            "Polo",
            "Pomona",
            "Pontiac",
            "Poplar Grove",
            "Port Byron",
            "Posen",
            "Potomac",
            "Prairie City",
            "Prairie Du Rocher",
            "Preemption",
            "Princeton",
            "Princeville",
            "Prophetstown",
            "Prospect Heights",
            "Pulaski",
            "Putnam",
            "Quincy",
            "Radom",
            "Raleigh",
            "Ramsey",
            "Rankin",
            "Ransom",
            "Rantoul",
            "Rapids City",
            "Raritan",
            "Raymond",
            "Red Bud",
            "Reddick",
            "Redmon",
            "Renault",
            "Reynolds",
            "Richland",
            "Richmond",
            "Richton Park",
            "Richview",
            "Ridge Farm",
            "Ridgway",
            "Ridott",
            "Rinard",
            "Ringwood",
            "Rio",
            "River Forest",
            "River Grove",
            "Riverdale",
            "Riverside",
            "Riverton",
            "Roanoke",
            "Robbins",
            "Roberts",
            "Robinson",
            "Rochelle",
            "Rochester",
            "Rock City",
            "Rock Falls",
            "Rock Island",
            "Rockbridge",
            "Rockford",
            "Rockport",
            "Rockton",
            "Rockwood",
            "Rolling Meadows",
            "Rome",
            "Romeoville",
            "Roodhouse",
            "Rosamond",
            "Roscoe",
            "Roselle",
            "Roseville",
            "Rosiclare",
            "Rossville",
            "Round Lake",
            "Roxana",
            "Royal",
            "Royalton",
            "Rushville",
            "Russell",
            "Rutland",
            "Sadorus",
            "Sailor Springs",
            "Saint Anne",
            "Saint Augustine",
            "Saint Charles",
            "Saint David",
            "Saint Elmo",
            "Saint Francisville",
            "Saint Jacob",
            "Saint Joseph",
            "Saint Libory",
            "Saint Peter",
            "Sainte Marie",
            "Salem",
            "San Jose",
            "Sandoval",
            "Sandwich",
            "Saunemin",
            "Savanna",
            "Savoy",
            "Sawyerville",
            "Saybrook",
            "Scales Mound",
            "Schaumburg",
            "Scheller",
            "Schiller Park",
            "Sciota",
            "Scioto Mills",
            "Scott Air Force Base",
            "Scottville",
            "Seaton",
            "Seatonville",
            "Secor",
            "Seneca",
            "Serena",
            "Sesser",
            "Seward",
            "Seymour",
            "Shabbona",
            "Shannon",
            "Shattuc",
            "Shawneetown",
            "Sheffield",
            "Shelbyville",
            "Sheldon",
            "Sheridan",
            "Sherman",
            "Sherrard",
            "Shipman",
            "Shirland",
            "Shirley",
            "Shobonier",
            "Shumway",
            "Sibley",
            "Sidell",
            "Sidney",
            "Sigel",
            "Silvis",
            "Simpson",
            "Sims",
            "Skokie",
            "Smithboro",
            "Smithfield",
            "Smithshire",
            "Smithton",
            "Solon Mills",
            "Somonauk",
            "Sorento",
            "South Beloit",
            "South Elgin",
            "South Holland",
            "South Pekin",
            "South Roxana",
            "South Wilmington",
            "Sparland",
            "Sparta",
            "Speer",
            "Spring Grove",
            "Spring Valley",
            "Springerton",
            "Springfield",
            "Standard",
            "Standard City",
            "Stanford",
            "Staunton",
            "Steeleville",
            "Steger",
            "Sterling",
            "Steward",
            "Stewardson",
            "Stillman Valley",
            "Stockland",
            "Stockton",
            "Stone Park",
            "Stonefort",
            "Stonington",
            "Stoy",
            "Strasburg",
            "Strawn",
            "Streamwood",
            "Streator",
            "Stronghurst",
            "Sublette",
            "Sugar Grove",
            "Sullivan",
            "Summerfield",
            "Summit",
            "Summit Argo",
            "Sumner",
            "Sutter",
            "Sycamore",
            "Table Grove",
            "Tallula",
            "Tamaroa",
            "Tamms",
            "Tampico",
            "Taylor Ridge",
            "Taylor Springs",
            "Taylorville",
            "Techny",
            "Tennessee",
            "Teutopolis",
            "Texico",
            "Thawville",
            "Thayer",
            "Thebes",
            "Thomasboro",
            "Thompsonville",
            "Thomson",
            "Thornton",
            "Tilden",
            "Tilton",
            "Timewell",
            "Tinley Park",
            "Tiskilwa",
            "Toledo",
            "Tolono",
            "Toluca",
            "Tonica",
            "Topeka",
            "Toulon",
            "Tovey",
            "Towanda",
            "Tower Hill",
            "Tremont",
            "Trenton",
            "Trilla",
            "Triumph",
            "Trivoli",
            "Troy",
            "Troy Grove",
            "Tunnel Hill",
            "Tuscola",
            "Ullin",
            "Union",
            "Union Hill",
            "Unity",
            "Urbana",
            "Ursa",
            "Utica",
            "Valier",
            "Valmeyer",
            "Van Orin",
            "Vandalia",
            "Varna",
            "Venice",
            "Vergennes",
            "Vermilion",
            "Vermont",
            "Vernon",
            "Vernon Hills",
            "Verona",
            "Versailles",
            "Victoria",
            "Vienna",
            "Villa Grove",
            "Villa Park",
            "Villa Ridge",
            "Viola",
            "Virden",
            "Virgil",
            "Virginia",
            "Wadsworth",
            "Waggoner",
            "Walnut",
            "Walnut Hill",
            "Walsh",
            "Walshville",
            "Waltonville",
            "Wapella",
            "Warren",
            "Warrensburg",
            "Warrenville",
            "Warsaw",
            "Wasco",
            "Washburn",
            "Washington",
            "Wataga",
            "Waterloo",
            "Waterman",
            "Watseka",
            "Watson",
            "Wauconda",
            "Waukegan",
            "Waverly",
            "Wayne",
            "Wayne City",
            "Waynesville",
            "Wedron",
            "Weldon",
            "Wellington",
            "Wenona",
            "West Brooklyn",
            "West Chicago",
            "West Frankfort",
            "West Liberty",
            "West Point",
            "West Salem",
            "West Union",
            "West York",
            "Westchester",
            "Western Springs",
            "Westfield",
            "Westmont",
            "Westville",
            "Wheaton",
            "Wheeler",
            "Wheeling",
            "White Hall",
            "White Heath",
            "Whittington",
            "Williamsfield",
            "Williamsville",
            "Willisville",
            "Willow Hill",
            "Willow Springs",
            "Wilmette",
            "Wilmington",
            "Wilsonville",
            "Winchester",
            "Windsor",
            "Winfield",
            "Winnebago",
            "Winnetka",
            "Winslow",
            "Winthrop Harbor",
            "Witt",
            "Wolf Lake",
            "Wonder Lake",
            "Wood Dale",
            "Wood River",
            "Woodhull",
            "Woodland",
            "Woodlawn",
            "Woodridge",
            "Woodson",
            "Woodstock",
            "Woosung",
            "Worden",
            "Worth",
            "Wrights",
            "Wyanet",
            "Wyoming",
            "Xenia",
            "Yale",
            "Yates City",
            "Yorkville",
            "Zeigler",
            "Zion"
        ]
    },
    {
        "state": "Indiana",
        "abbr": "IN",
        "cities": [
            "Advance",
            "Akron",
            "Alamo",
            "Albany",
            "Albion",
            "Alexandria",
            "Ambia",
            "Amboy",
            "Amo",
            "Anderson",
            "Andrews",
            "Angola",
            "Arcadia",
            "Arcola",
            "Argos",
            "Arlington",
            "Ashley",
            "Athens",
            "Atlanta",
            "Attica",
            "Atwood",
            "Auburn",
            "Aurora",
            "Austin",
            "Avilla",
            "Avoca",
            "Avon",
            "Bainbridge",
            "Bargersville",
            "Batesville",
            "Bath",
            "Battle Ground",
            "Bedford",
            "Beech Grove",
            "Bellmore",
            "Bennington",
            "Bentonville",
            "Berne",
            "Bethlehem",
            "Beverly Shores",
            "Bicknell",
            "Bippus",
            "Birdseye",
            "Blanford",
            "Bloomfield",
            "Bloomingdale",
            "Bloomington",
            "Bluffton",
            "Boggstown",
            "Boone Grove",
            "Boonville",
            "Borden",
            "Boston",
            "Boswell",
            "Bourbon",
            "Bowling Green",
            "Bradford",
            "Branchville",
            "Brazil",
            "Bremen",
            "Bridgeton",
            "Brimfield",
            "Bringhurst",
            "Bristol",
            "Bristow",
            "Brook",
            "Brooklyn",
            "Brookston",
            "Brookville",
            "Brownsburg",
            "Brownstown",
            "Brownsville",
            "Bruceville",
            "Bryant",
            "Buck Creek",
            "Buckskin",
            "Buffalo",
            "Bunker Hill",
            "Burket",
            "Burlington",
            "Burnettsville",
            "Burrows",
            "Butler",
            "Butlerville",
            "Cambridge City",
            "Camby",
            "Camden",
            "Campbellsburg",
            "Canaan",
            "Cannelburg",
            "Cannelton",
            "Carbon",
            "Carlisle",
            "Carmel",
            "Cartersburg",
            "Carthage",
            "Cayuga",
            "Cedar Grove",
            "Cedar Lake",
            "Celestine",
            "Centerpoint",
            "Centerville",
            "Central",
            "Chalmers",
            "Chandler",
            "Charlestown",
            "Charlottesville",
            "Chesterton",
            "Chrisney",
            "Churubusco",
            "Cicero",
            "Clarks Hill",
            "Clarksburg",
            "Clarksville",
            "Clay City",
            "Claypool",
            "Clayton",
            "Clear Creek",
            "Clifford",
            "Clinton",
            "Cloverdale",
            "Coal City",
            "Coalmont",
            "Coatesville",
            "Colfax",
            "Columbia City",
            "Columbus",
            "Commiskey",
            "Connersville",
            "Converse",
            "Cortland",
            "Corunna",
            "Cory",
            "Corydon",
            "Covington",
            "Craigville",
            "Crandall",
            "Crane",
            "Crawfordsville",
            "Cromwell",
            "Cross Plains",
            "Crothersville",
            "Crown Point",
            "Culver",
            "Cutler",
            "Cynthiana",
            "Dale",
            "Daleville",
            "Dana",
            "Danville",
            "Darlington",
            "Dayton",
            "Decatur",
            "Decker",
            "Deedsville",
            "Delong",
            "Delphi",
            "Demotte",
            "Denver",
            "Depauw",
            "Deputy",
            "Derby",
            "Dillsboro",
            "Donaldson",
            "Dublin",
            "Dubois",
            "Dugger",
            "Dunkirk",
            "Dunreith",
            "Dupont",
            "Dyer",
            "Earl Park",
            "East Chicago",
            "East Enterprise",
            "Eaton",
            "Eckerty",
            "Economy",
            "Edinburgh",
            "Edwardsport",
            "Elberfeld",
            "Elizabeth",
            "Elizabethtown",
            "Elkhart",
            "Ellettsville",
            "Elnora",
            "Elwood",
            "Eminence",
            "English",
            "Etna Green",
            "Evanston",
            "Evansville",
            "Fair Oaks",
            "Fairbanks",
            "Fairland",
            "Fairmount",
            "Falmouth",
            "Farmersburg",
            "Farmland",
            "Ferdinand",
            "Fillmore",
            "Finly",
            "Fishers",
            "Flat Rock",
            "Flora",
            "Florence",
            "Floyds Knobs",
            "Folsomville",
            "Fontanet",
            "Forest",
            "Fort Branch",
            "Fort Ritner",
            "Fort Wayne",
            "Fortville",
            "Fountain City",
            "Fountaintown",
            "Fowler",
            "Fowlerton",
            "Francesville",
            "Francisco",
            "Frankfort",
            "Franklin",
            "Frankton",
            "Fredericksburg",
            "Freedom",
            "Freelandville",
            "Freetown",
            "Fremont",
            "French Lick",
            "Friendship",
            "Fulda",
            "Fulton",
            "Galveston",
            "Garrett",
            "Gary",
            "Gas City",
            "Gaston",
            "Geneva",
            "Gentryville",
            "Georgetown",
            "Glenwood",
            "Goldsmith",
            "Goodland",
            "Goshen",
            "Gosport",
            "Grabill",
            "Grammer",
            "Grandview",
            "Granger",
            "Grantsburg",
            "Grass Creek",
            "Graysville",
            "Greencastle",
            "Greenfield",
            "Greens Fork",
            "Greensboro",
            "Greensburg",
            "Greentown",
            "Greenville",
            "Greenwood",
            "Griffin",
            "Griffith",
            "Grissom AFB",
            "Grovertown",
            "Guilford",
            "Gwynneville",
            "Hagerstown",
            "Hamblen",
            "Hamilton",
            "Hamlet",
            "Hammond",
            "Hanna",
            "Hanover",
            "Hardinsburg",
            "Harlan",
            "Harmony",
            "Harrison",
            "Harrodsburg",
            "Hartford City",
            "Hartsville",
            "Hatfield",
            "Haubstadt",
            "Hayden",
            "Hazleton",
            "Hebron",
            "Helmsburg",
            "Helt",
            "Heltonville",
            "Hemlock",
            "Henryville",
            "Highland",
            "Hillisburg",
            "Hillsboro",
            "Hillsdale",
            "Hoagland",
            "Hobart",
            "Hobbs",
            "Holland",
            "Holton",
            "Homer",
            "Hope",
            "Howe",
            "Hudson",
            "Huntertown",
            "Huntingburg",
            "Huntington",
            "Huron",
            "Hymera",
            "Idaville",
            "Indianapolis",
            "Ingalls",
            "Inglefield",
            "Ireland",
            "Jackson",
            "Jamestown",
            "Jasonville",
            "Jasper",
            "Jefferson",
            "Jeffersonville",
            "Jonesboro",
            "Jonesville",
            "Judson",
            "Kempton",
            "Kendallville",
            "Kennard",
            "Kentland",
            "Kewanna",
            "Keystone",
            "Kimmell",
            "Kingman",
            "Kingsbury",
            "Kingsford Heights",
            "Kirklin",
            "Knightstown",
            "Knightsville",
            "Knox",
            "Kokomo",
            "Koleen",
            "Kouts",
            "Kurtz",
            "La Crosse",
            "La Fontaine",
            "La Porte",
            "Laconia",
            "Ladoga",
            "Lafayette",
            "Lagrange",
            "Lagro",
            "Lake Cicott",
            "Lake Station",
            "Lake Village",
            "Laketon",
            "Lakeville",
            "Lamar",
            "Lanesville",
            "Laotto",
            "Lapaz",
            "Lapel",
            "Larwill",
            "Laurel",
            "Lawrenceburg",
            "Leavenworth",
            "Lebanon",
            "Leesburg",
            "Leiters Ford",
            "Leo",
            "Leopold",
            "Leroy",
            "Lewis",
            "Lewisville",
            "Lexington",
            "Liberty",
            "Liberty Center",
            "Liberty Mills",
            "Ligonier",
            "Lincoln City",
            "Linden",
            "Linn Grove",
            "Linton",
            "Little York",
            "Lizton",
            "Logansport",
            "Loogootee",
            "Losantville",
            "Lovett",
            "Lowell",
            "Lucerne",
            "Lynn",
            "Lynnville",
            "Lyons",
            "Mackey",
            "Macy",
            "Madison",
            "Manilla",
            "Marengo",
            "Mariah Hill",
            "Marion",
            "Markle",
            "Markleville",
            "Marshall",
            "Martinsville",
            "Marysville",
            "Matthews",
            "Mauckport",
            "Maxwell",
            "Mays",
            "McCordsville",
            "Mecca",
            "Medaryville",
            "Medora",
            "Mellott",
            "Memphis",
            "Mentone",
            "Merom",
            "Merrillville",
            "Metamora",
            "Mexico",
            "Miami",
            "Michigan City",
            "Michigantown",
            "Middlebury",
            "Middletown",
            "Midland",
            "Milan",
            "Milford",
            "Mill Creek",
            "Millersburg",
            "Millhousen",
            "Milltown",
            "Milroy",
            "Milton",
            "Mishawaka",
            "Mitchell",
            "Modoc",
            "Mongo",
            "Monon",
            "Monroe",
            "Monroe City",
            "Monroeville",
            "Monrovia",
            "Monterey",
            "Montezuma",
            "Montgomery",
            "Monticello",
            "Montmorenci",
            "Montpelier",
            "Mooreland",
            "Moores Hill",
            "Mooresville",
            "Morgantown",
            "Morocco",
            "Morris",
            "Morristown",
            "Mount Ayr",
            "Mount Saint Francis",
            "Mount Summit",
            "Mount Vernon",
            "Mulberry",
            "Muncie",
            "Munster",
            "Nabb",
            "Napoleon",
            "Nappanee",
            "Nashville",
            "Nebraska",
            "Needham",
            "New Albany",
            "New Carlisle",
            "New Castle",
            "New Goshen",
            "New Harmony",
            "New Haven",
            "New Lebanon",
            "New Lisbon",
            "New Market",
            "New Middletown",
            "New Palestine",
            "New Paris",
            "New Point",
            "New Richmond",
            "New Ross",
            "New Salisbury",
            "New Trenton",
            "New Washington",
            "New Waverly",
            "Newberry",
            "Newburgh",
            "Newport",
            "Newtown",
            "Nineveh",
            "Noble",
            "Noblesville",
            "Norman",
            "North Judson",
            "North Liberty",
            "North Manchester",
            "North Salem",
            "North Vernon",
            "North Webster",
            "Notre Dame",
            "Oakford",
            "Oakland City",
            "Oaktown",
            "Oakville",
            "Odon",
            "Oldenburg",
            "Onward",
            "Oolitic",
            "Ora",
            "Orestes",
            "Orland",
            "Orleans",
            "Osceola",
            "Osgood",
            "Ossian",
            "Otisco",
            "Otterbein",
            "Otwell",
            "Owensburg",
            "Owensville",
            "Oxford",
            "Palmyra",
            "Paoli",
            "Paragon",
            "Paris Crossing",
            "Parker City",
            "Patoka",
            "Patricksburg",
            "Patriot",
            "Paxton",
            "Pekin",
            "Pendleton",
            "Pennville",
            "Perrysville",
            "Pershing",
            "Peru",
            "Petersburg",
            "Petroleum",
            "Pierceton",
            "Pierceville",
            "Pimento",
            "Pine Village",
            "Pittsboro",
            "Plainfield",
            "Plainville",
            "Pleasant Lake",
            "Pleasant Mills",
            "Plymouth",
            "Poland",
            "Poneto",
            "Portage",
            "Porter",
            "Portland",
            "Poseyville",
            "Prairie Creek",
            "Prairieton",
            "Preble",
            "Princeton",
            "Putnamville",
            "Quincy",
            "Ragsdale",
            "Ramsey",
            "Redkey",
            "Reelsville",
            "Remington",
            "Rensselaer",
            "Reynolds",
            "Richland",
            "Richmond",
            "Ridgeville",
            "Riley",
            "Rising Sun",
            "Roachdale",
            "Roann",
            "Roanoke",
            "Rochester",
            "Rockfield",
            "Rockport",
            "Rockville",
            "Rolling Prairie",
            "Rome",
            "Rome City",
            "Romney",
            "Rosedale",
            "Roselawn",
            "Rossville",
            "Royal Center",
            "Rushville",
            "Russellville",
            "Russiaville",
            "Saint Anthony",
            "Saint Bernice",
            "Saint Croix",
            "Saint Joe",
            "Saint John",
            "Saint Mary Of The Woods",
            "Saint Meinrad",
            "Saint Paul",
            "Salamonia",
            "Salem",
            "San Pierre",
            "Sandborn",
            "Santa Claus",
            "Saratoga",
            "Schererville",
            "Schneider",
            "Schnellville",
            "Scipio",
            "Scotland",
            "Scott",
            "Scottsburg",
            "Sedalia",
            "Seelyville",
            "Sellersburg",
            "Selma",
            "Servia",
            "Seymour",
            "Sharpsville",
            "Shelburn",
            "Shelby",
            "Shelbyville",
            "Shepardsville",
            "Sheridan",
            "Shipshewana",
            "Shirley",
            "Shoals",
            "Sidney",
            "Silver Lake",
            "Smithville",
            "Solsberry",
            "Somerset",
            "Somerville",
            "South Bend",
            "South Milford",
            "South Whitley",
            "Spencer",
            "Spencerville",
            "Spiceland",
            "Springport",
            "Springville",
            "Spurgeon",
            "Stanford",
            "Star City",
            "State Line",
            "Staunton",
            "Stendal",
            "Stilesville",
            "Stinesville",
            "Stockwell",
            "Straughn",
            "Stroh",
            "Sullivan",
            "Sulphur",
            "Sulphur Springs",
            "Sumava Resorts",
            "Summitville",
            "Sunman",
            "Swayzee",
            "Sweetser",
            "Switz City",
            "Syracuse",
            "Talbot",
            "Taswell",
            "Taylorsville",
            "Tefft",
            "Tell City",
            "Templeton",
            "Tennyson",
            "Terre Haute",
            "Thayer",
            "Thorntown",
            "Tippecanoe",
            "Tipton",
            "Topeka",
            "Trafalgar",
            "Troy",
            "Tunnelton",
            "Twelve Mile",
            "Tyner",
            "Underwood",
            "Union City",
            "Union Mills",
            "Uniondale",
            "Unionville",
            "Universal",
            "Upland",
            "Urbana",
            "Vallonia",
            "Valparaiso",
            "Van Buren",
            "Veedersburg",
            "Velpen",
            "Vernon",
            "Versailles",
            "Vevay",
            "Vincennes",
            "Wabash",
            "Wadesville",
            "Wakarusa",
            "Waldron",
            "Walkerton",
            "Wallace",
            "Walton",
            "Wanatah",
            "Warren",
            "Warsaw",
            "Washington",
            "Waterloo",
            "Waveland",
            "Wawaka",
            "Waynetown",
            "Webster",
            "West Baden Springs",
            "West College Corner",
            "West Harrison",
            "West Lafayette",
            "West Lebanon",
            "West Middleton",
            "West Newton",
            "West Terre Haute",
            "Westfield",
            "Westphalia",
            "Westpoint",
            "Westport",
            "Westville",
            "Wheatfield",
            "Wheatland",
            "Wheeler",
            "Whiteland",
            "Whitestown",
            "Whiting",
            "Wilkinson",
            "Williams",
            "Williamsburg",
            "Williamsport",
            "Winamac",
            "Winchester",
            "Windfall",
            "Wingate",
            "Winona Lake",
            "Winslow",
            "Wolcott",
            "Wolcottville",
            "Wolflake",
            "Woodburn",
            "Worthington",
            "Wyatt",
            "Yeoman",
            "Yoder",
            "Yorktown",
            "Young America",
            "Zanesville",
            "Zionsville"
        ]
    },
    {
        "state": "Iowa",
        "abbr": "IA",
        "cities": [
            "Ackley",
            "Ackworth",
            "Adair",
            "Adel",
            "Afton",
            "Agency",
            "Ainsworth",
            "Akron",
            "Albert City",
            "Albia",
            "Albion",
            "Alburnett",
            "Alden",
            "Alexander",
            "Algona",
            "Alleman",
            "Allendorf",
            "Allerton",
            "Allison",
            "Alta",
            "Alta Vista",
            "Alton",
            "Altoona",
            "Alvord",
            "Amana",
            "Ames",
            "Anamosa",
            "Andover",
            "Andrew",
            "Anita",
            "Ankeny",
            "Anthon",
            "Aplington",
            "Arcadia",
            "Archer",
            "Aredale",
            "Argyle",
            "Arion",
            "Arispe",
            "Arlington",
            "Armstrong",
            "Arnolds Park",
            "Arthur",
            "Ashton",
            "Aspinwall",
            "Atalissa",
            "Atkins",
            "Atlantic",
            "Auburn",
            "Audubon",
            "Aurelia",
            "Aurora",
            "Austinville",
            "Avoca",
            "Ayrshire",
            "Badger",
            "Bagley",
            "Baldwin",
            "Bancroft",
            "Barnes City",
            "Barnum",
            "Batavia",
            "Battle Creek",
            "Baxter",
            "Bayard",
            "Beacon",
            "Beaman",
            "Beaver",
            "Bedford",
            "Belle Plaine",
            "Bellevue",
            "Belmond",
            "Bennett",
            "Benton",
            "Bernard",
            "Berwick",
            "Bettendorf",
            "Bevington",
            "Birmingham",
            "Blairsburg",
            "Blairstown",
            "Blakesburg",
            "Blanchard",
            "Blencoe",
            "Blockton",
            "Bloomfield",
            "Blue Grass",
            "Bode",
            "Bonaparte",
            "Bondurant",
            "Boone",
            "Booneville",
            "Bouton",
            "Boxholm",
            "Boyden",
            "Braddyville",
            "Bradford",
            "Bradgate",
            "Brandon",
            "Brayton",
            "Breda",
            "Bridgewater",
            "Brighton",
            "Bristow",
            "Britt",
            "Bronson",
            "Brooklyn",
            "Brunsville",
            "Bryant",
            "Buckeye",
            "Buckingham",
            "Buffalo",
            "Buffalo Center",
            "Burlington",
            "Burnside",
            "Burr Oak",
            "Burt",
            "Bussey",
            "Calamus",
            "Callender",
            "Calmar",
            "Calumet",
            "Camanche",
            "Cambridge",
            "Cantril",
            "Carbon",
            "Carlisle",
            "Carpenter",
            "Carroll",
            "Carson",
            "Carter Lake",
            "Cascade",
            "Casey",
            "Castalia",
            "Castana",
            "Cedar",
            "Cedar Falls",
            "Cedar Rapids",
            "Center Junction",
            "Center Point",
            "Centerville",
            "Central City",
            "Chapin",
            "Chariton",
            "Charles City",
            "Charlotte",
            "Charter Oak",
            "Chatsworth",
            "Chelsea",
            "Cherokee",
            "Chester",
            "Chillicothe",
            "Churdan",
            "Cincinnati",
            "Clare",
            "Clarence",
            "Clarinda",
            "Clarion",
            "Clarksville",
            "Clear Lake",
            "Clearfield",
            "Cleghorn",
            "Clemons",
            "Clermont",
            "Climbing Hill",
            "Clinton",
            "Clio",
            "Clive",
            "Clutier",
            "Coggon",
            "Coin",
            "Colesburg",
            "Colfax",
            "College Springs",
            "Collins",
            "Colo",
            "Columbia",
            "Columbus City",
            "Columbus Junction",
            "Colwell",
            "Conesville",
            "Conrad",
            "Conroy",
            "Coon Rapids",
            "Cooper",
            "Coralville",
            "Corning",
            "Correctionville",
            "Corwith",
            "Corydon",
            "Coulter",
            "Council Bluffs",
            "Craig",
            "Crawfordsville",
            "Crescent",
            "Cresco",
            "Creston",
            "Cromwell",
            "Crystal Lake",
            "Cumberland",
            "Cumming",
            "Curlew",
            "Cushing",
            "Cylinder",
            "Dakota City",
            "Dallas",
            "Dallas Center",
            "Dana",
            "Danbury",
            "Danville",
            "Davenport",
            "Davis City",
            "Dawson",
            "Dayton",
            "De Soto",
            "De Witt",
            "Decatur",
            "Decorah",
            "Dedham",
            "Deep River",
            "Defiance",
            "Delaware",
            "Delhi",
            "Delmar",
            "Deloit",
            "Delta",
            "Denison",
            "Denmark",
            "Denver",
            "Derby",
            "Des Moines",
            "Dewar",
            "Dexter",
            "Diagonal",
            "Dickens",
            "Dike",
            "Dixon",
            "Dolliver",
            "Donahue",
            "Donnellson",
            "Doon",
            "Dorchester",
            "Douds",
            "Dougherty",
            "Dow City",
            "Dows",
            "Drakesville",
            "Dubuque",
            "Dumont",
            "Duncombe",
            "Dundee",
            "Dunkerton",
            "Dunlap",
            "Durango",
            "Durant",
            "Dyersville",
            "Dysart",
            "Eagle Grove",
            "Earlham",
            "Earling",
            "Earlville",
            "Early",
            "Eddyville",
            "Edgewood",
            "Elberon",
            "Eldon",
            "Eldora",
            "Eldridge",
            "Elgin",
            "Elk Horn",
            "Elkader",
            "Elkhart",
            "Elkport",
            "Elliott",
            "Ellston",
            "Ellsworth",
            "Elma",
            "Elmore",
            "Elwood",
            "Ely",
            "Emerson",
            "Emmetsburg",
            "Epworth",
            "Essex",
            "Estherville",
            "Evansdale",
            "Everly",
            "Exira",
            "Exline",
            "Fairbank",
            "Fairfax",
            "Fairfield",
            "Farley",
            "Farmersburg",
            "Farmington",
            "Farnhamville",
            "Farragut",
            "Fayette",
            "Fenton",
            "Ferguson",
            "Fertile",
            "Floris",
            "Floyd",
            "Fonda",
            "Fontanelle",
            "Forest City",
            "Fort Atkinson",
            "Fort Dodge",
            "Fort Madison",
            "Fostoria",
            "Fredericksburg",
            "Frederika",
            "Fremont",
            "Fruitland",
            "Galt",
            "Galva",
            "Garber",
            "Garden City",
            "Garden Grove",
            "Garnavillo",
            "Garner",
            "Garrison",
            "Garwin",
            "Geneva",
            "George",
            "Gibson",
            "Gifford",
            "Gilbert",
            "Gilbertville",
            "Gillett Grove",
            "Gilman",
            "Gilmore City",
            "Gladbrook",
            "Glenwood",
            "Glidden",
            "Goldfield",
            "Goodell",
            "Goose Lake",
            "Gowrie",
            "Graettinger",
            "Grafton",
            "Grand Junction",
            "Grand Mound",
            "Grand River",
            "Grandview",
            "Granger",
            "Grant",
            "Granville",
            "Gravity",
            "Gray",
            "Greeley",
            "Greene",
            "Greenfield",
            "Greenville",
            "Grimes",
            "Grinnell",
            "Griswold",
            "Grundy Center",
            "Gruver",
            "Guernsey",
            "Guthrie Center",
            "Guttenberg",
            "Halbur",
            "Hamburg",
            "Hamilton",
            "Hamlin",
            "Hampton",
            "Hancock",
            "Hanlontown",
            "Harcourt",
            "Hardy",
            "Harlan",
            "Harper",
            "Harpers Ferry",
            "Harris",
            "Hartford",
            "Hartley",
            "Hartwick",
            "Harvey",
            "Hastings",
            "Havelock",
            "Haverhill",
            "Hawarden",
            "Hawkeye",
            "Hayesville",
            "Hazleton",
            "Hedrick",
            "Henderson",
            "Hiawatha",
            "Highlandville",
            "Hills",
            "Hillsboro",
            "Hinton",
            "Holland",
            "Holstein",
            "Holy Cross",
            "Homestead",
            "Honey Creek",
            "Hopkinton",
            "Hornick",
            "Hospers",
            "Houghton",
            "Hubbard",
            "Hudson",
            "Hull",
            "Humboldt",
            "Humeston",
            "Huxley",
            "Ida Grove",
            "Imogene",
            "Independence",
            "Indianola",
            "Inwood",
            "Ionia",
            "Iowa City",
            "Iowa Falls",
            "Ira",
            "Ireton",
            "Irwin",
            "Jamaica",
            "Janesville",
            "Jefferson",
            "Jesup",
            "Jewell",
            "Johnston",
            "Joice",
            "Jolley",
            "Kalona",
            "Kamrar",
            "Kanawha",
            "Kellerton",
            "Kelley",
            "Kellogg",
            "Kensett",
            "Keokuk",
            "Keosauqua",
            "Keota",
            "Kesley",
            "Keswick",
            "Keystone",
            "Killduff",
            "Kimballton",
            "Kingsley",
            "Kirkman",
            "Kirkville",
            "Kiron",
            "Klemme",
            "Knierim",
            "Knoxville",
            "La Motte",
            "La Porte City",
            "Lacona",
            "Ladora",
            "Lake City",
            "Lake Mills",
            "Lake Park",
            "Lake View",
            "Lakota",
            "Lamoni",
            "Lamont",
            "Lanesboro",
            "Langworthy",
            "Lansing",
            "Larchwood",
            "Larrabee",
            "Latimer",
            "Laurel",
            "Laurens",
            "Lawler",
            "Lawton",
            "Le Claire",
            "Le Grand",
            "Le Mars",
            "Ledyard",
            "Lehigh",
            "Leighton",
            "Leland",
            "Lenox",
            "Leon",
            "Lester",
            "Letts",
            "Lewis",
            "Liberty Center",
            "Libertyville",
            "Lidderdale",
            "Lime Springs",
            "Lincoln",
            "Linden",
            "Lineville",
            "Linn Grove",
            "Lisbon",
            "Liscomb",
            "Little Cedar",
            "Little Rock",
            "Little Sioux",
            "Littleport",
            "Livermore",
            "Lockridge",
            "Logan",
            "Lohrville",
            "Lone Rock",
            "Lone Tree",
            "Long Grove",
            "Lorimor",
            "Lost Nation",
            "Lovilia",
            "Low Moor",
            "Lowden",
            "Lu Verne",
            "Luana",
            "Lucas",
            "Luther",
            "Luxemburg",
            "Luzerne",
            "Lynnville",
            "Lytton",
            "Mabel",
            "Macedonia",
            "Macksburg",
            "Madrid",
            "Magnolia",
            "Malcom",
            "Mallard",
            "Malvern",
            "Manchester",
            "Manilla",
            "Manly",
            "Manning",
            "Manson",
            "Mapleton",
            "Maquoketa",
            "Marathon",
            "Marble Rock",
            "Marcus",
            "Marengo",
            "Marion",
            "Marne",
            "Marquette",
            "Marshalltown",
            "Martelle",
            "Martensdale",
            "Martinsburg",
            "Mason City",
            "Masonville",
            "Massena",
            "Matlock",
            "Maurice",
            "Maxwell",
            "May City",
            "Maynard",
            "McCallsburg",
            "McCausland",
            "McClelland",
            "McGregor",
            "McIntire",
            "Mechanicsville",
            "Mediapolis",
            "Melbourne",
            "Melcher",
            "Melrose",
            "Melvin",
            "Menlo",
            "Meriden",
            "Merrill",
            "Meservey",
            "Middle Amana",
            "Middletown",
            "Miles",
            "Milford",
            "Millersburg",
            "Millerton",
            "Milo",
            "Milton",
            "Minburn",
            "Minden",
            "Mineola",
            "Mingo",
            "Missouri Valley",
            "Mitchellville",
            "Modale",
            "Mondamin",
            "Monmouth",
            "Monona",
            "Monroe",
            "Montezuma",
            "Monticello",
            "Montour",
            "Montpelier",
            "Montrose",
            "Moorhead",
            "Moorland",
            "Moravia",
            "Morley",
            "Morning Sun",
            "Morrison",
            "Moscow",
            "Moulton",
            "Mount Auburn",
            "Mount Ayr",
            "Mount Pleasant",
            "Mount Sterling",
            "Mount Union",
            "Mount Vernon",
            "Moville",
            "Murray",
            "Mystic",
            "Nashua",
            "Nemaha",
            "Neola",
            "Nevada",
            "New Albin",
            "New Hampton",
            "New Hartford",
            "New Liberty",
            "New London",
            "New Market",
            "New Providence",
            "New Sharon",
            "New Vienna",
            "New Virginia",
            "Newell",
            "Newhall",
            "Newton",
            "Nichols",
            "Nodaway",
            "Nora Springs",
            "North Buena Vista",
            "North English",
            "North Liberty",
            "North Washington",
            "Northboro",
            "Northwood",
            "Norwalk",
            "Norway",
            "Oakdale",
            "Oakland",
            "Oakville",
            "Ocheyedan",
            "Odebolt",
            "Oelwein",
            "Ogden",
            "Okoboji",
            "Olds",
            "Olin",
            "Ollie",
            "Onawa",
            "Onslow",
            "Oran",
            "Orange City",
            "Orchard",
            "Orient",
            "Osage",
            "Osceola",
            "Oskaloosa",
            "Ossian",
            "Otho",
            "Otley",
            "Oto",
            "Ottosen",
            "Ottumwa",
            "Oxford",
            "Oxford Junction",
            "Oyens",
            "Pacific Junction",
            "Packwood",
            "Palmer",
            "Palo",
            "Panama",
            "Panora",
            "Parkersburg",
            "Parnell",
            "Paton",
            "Patterson",
            "Paullina",
            "Pella",
            "Peosta",
            "Percival",
            "Perry",
            "Persia",
            "Peru",
            "Peterson",
            "Pierson",
            "Pilot Grove",
            "Pilot Mound",
            "Pisgah",
            "Plainfield",
            "Plano",
            "Pleasant Hill",
            "Pleasant Valley",
            "Pleasantville",
            "Plover",
            "Plymouth",
            "Pocahontas",
            "Polk City",
            "Pomeroy",
            "Popejoy",
            "Portsmouth",
            "Postville",
            "Prairie City",
            "Prairieburg",
            "Prescott",
            "Preston",
            "Primghar",
            "Princeton",
            "Prole",
            "Promise City",
            "Protivin",
            "Pulaski",
            "Quasqueton",
            "Quimby",
            "Radcliffe",
            "Rake",
            "Ralston",
            "Randalia",
            "Randall",
            "Randolph",
            "Raymond",
            "Readlyn",
            "Reasnor",
            "Red Oak",
            "Redding",
            "Redfield",
            "Reinbeck",
            "Rembrandt",
            "Remsen",
            "Renwick",
            "Rhodes",
            "Riceville",
            "Richland",
            "Ricketts",
            "Ridgeway",
            "Rinard",
            "Ringsted",
            "Rippey",
            "Riverside",
            "Riverton",
            "Robins",
            "Rock Falls",
            "Rock Rapids",
            "Rock Valley",
            "Rockford",
            "Rockwell",
            "Rockwell City",
            "Rodney",
            "Roland",
            "Rolfe",
            "Rome",
            "Rose Hill",
            "Rowan",
            "Rowley",
            "Royal",
            "Rudd",
            "Runnells",
            "Russell",
            "Ruthven",
            "Rutland",
            "Ryan",
            "Sabula",
            "Sac City",
            "Saint Ansgar",
            "Saint Anthony",
            "Saint Charles",
            "Saint Donatus",
            "Saint Lucas",
            "Saint Marys",
            "Saint Olaf",
            "Saint Paul",
            "Salem",
            "Salix",
            "Sanborn",
            "Scarville",
            "Schaller",
            "Schleswig",
            "Scranton",
            "Searsboro",
            "Selma",
            "Sergeant Bluff",
            "Seymour",
            "Shambaugh",
            "Shannon City",
            "Sharpsburg",
            "Sheffield",
            "Shelby",
            "Sheldahl",
            "Sheldon",
            "Shell Rock",
            "Shellsburg",
            "Shenandoah",
            "Sherrill",
            "Sibley",
            "Sidney",
            "Sigourney",
            "Silver City",
            "Sioux Center",
            "Sioux City",
            "Sioux Rapids",
            "Slater",
            "Sloan",
            "Smithland",
            "Soldier",
            "Solon",
            "Somers",
            "South Amana",
            "South English",
            "Spencer",
            "Sperry",
            "Spillville",
            "Spirit Lake",
            "Spragueville",
            "Springbrook",
            "Springville",
            "Stacyville",
            "Stanhope",
            "Stanley",
            "Stanton",
            "Stanwood",
            "State Center",
            "Steamboat Rock",
            "Stockport",
            "Stockton",
            "Storm Lake",
            "Story City",
            "Stout",
            "Stratford",
            "Strawberry Point",
            "Struble",
            "Stuart",
            "Sully",
            "Sumner",
            "Superior",
            "Sutherland",
            "Swaledale",
            "Swan",
            "Swea City",
            "Swedesburg",
            "Swisher",
            "Tabor",
            "Tama",
            "Teeds Grove",
            "Templeton",
            "Tennant",
            "Terril",
            "Thayer",
            "Thompson",
            "Thor",
            "Thornburg",
            "Thornton",
            "Thurman",
            "Tiffin",
            "Tingley",
            "Tipton",
            "Titonka",
            "Toddville",
            "Toeterville",
            "Toledo",
            "Tracy",
            "Traer",
            "Treynor",
            "Tripoli",
            "Troy Mills",
            "Truesdale",
            "Truro",
            "Turin",
            "Udell",
            "Underwood",
            "Union",
            "Unionville",
            "University Park",
            "Urbana",
            "Urbandale",
            "Ute",
            "Vail",
            "Van Horne",
            "Van Meter",
            "Van Wert",
            "Varina",
            "Ventura",
            "Victor",
            "Villisca",
            "Vincent",
            "Vining",
            "Vinton",
            "Viola",
            "Volga",
            "Wadena",
            "Walcott",
            "Walford",
            "Walker",
            "Wall Lake",
            "Wallingford",
            "Walnut",
            "Wapello",
            "Washington",
            "Washta",
            "Waterloo",
            "Waterville",
            "Watkins",
            "Waucoma",
            "Waukee",
            "Waukon",
            "Waverly",
            "Wayland",
            "Webb",
            "Webster",
            "Webster City",
            "Weldon",
            "Wellman",
            "Wellsburg",
            "Welton",
            "Wesley",
            "West Bend",
            "West Branch",
            "West Burlington",
            "West Chester",
            "West Des Moines",
            "West Grove",
            "West Liberty",
            "West Point",
            "West Union",
            "Westfield",
            "Westgate",
            "Westphalia",
            "Westside",
            "Wever",
            "What Cheer",
            "Wheatland",
            "Whiting",
            "Whittemore",
            "Whitten",
            "Williams",
            "Williamsburg",
            "Williamson",
            "Wilton",
            "Winfield",
            "Winterset",
            "Winthrop",
            "Wiota",
            "Woden",
            "Woodbine",
            "Woodburn",
            "Woodward",
            "Woolstock",
            "Worthington",
            "Wyoming",
            "Yale",
            "Yarmouth",
            "Yorktown",
            "Zearing",
            "Zwingle"
        ]
    },
    {
        "state": "Kansas",
        "abbr": "KS",
        "cities": [
            "Abbyville",
            "Abilene",
            "Admire",
            "Agenda",
            "Agra",
            "Albert",
            "Alden",
            "Alexander",
            "Allen",
            "Alma",
            "Almena",
            "Alta Vista",
            "Altamont",
            "Alton",
            "Altoona",
            "Americus",
            "Andale",
            "Andover",
            "Anthony",
            "Arcadia",
            "Argonia",
            "Arkansas City",
            "Arlington",
            "Arma",
            "Arnold",
            "Ashland",
            "Assaria",
            "Atchison",
            "Athol",
            "Atlanta",
            "Attica",
            "Atwood",
            "Auburn",
            "Augusta",
            "Aurora",
            "Axtell",
            "Baileyville",
            "Baldwin City",
            "Barnard",
            "Barnes",
            "Bartlett",
            "Basehor",
            "Baxter Springs",
            "Bazine",
            "Beattie",
            "Beaumont",
            "Beeler",
            "Belle Plaine",
            "Belleville",
            "Beloit",
            "Belpre",
            "Belvue",
            "Bendena",
            "Benedict",
            "Bennington",
            "Bentley",
            "Benton",
            "Bern",
            "Berryton",
            "Beverly",
            "Bird City",
            "Bison",
            "Bloom",
            "Blue Mound",
            "Blue Rapids",
            "Bluff City",
            "Bogue",
            "Bonner Springs",
            "Bremen",
            "Brewster",
            "Bronson",
            "Brookville",
            "Brownell",
            "Bucklin",
            "Bucyrus",
            "Buffalo",
            "Buhler",
            "Bunker Hill",
            "Burden",
            "Burdett",
            "Burdick",
            "Burlingame",
            "Burlington",
            "Burns",
            "Burr Oak",
            "Burrton",
            "Bushton",
            "Byers",
            "Caldwell",
            "Cambridge",
            "Caney",
            "Canton",
            "Carbondale",
            "Cassoday",
            "Catharine",
            "Cawker City",
            "Cedar",
            "Cedar Point",
            "Cedar Vale",
            "Centerville",
            "Centralia",
            "Chanute",
            "Chapman",
            "Chase",
            "Chautauqua",
            "Cheney",
            "Cherokee",
            "Cherryvale",
            "Chetopa",
            "Cimarron",
            "Circleville",
            "Claflin",
            "Clay Center",
            "Clayton",
            "Clearview City",
            "Clearwater",
            "Clifton",
            "Clyde",
            "Coats",
            "Coffeyville",
            "Colby",
            "Coldwater",
            "Colfax",
            "Collyer",
            "Colony",
            "Columbus",
            "Colwich",
            "Concordia",
            "Conway Springs",
            "Coolidge",
            "Copeland",
            "Corning",
            "Cottonwood Falls",
            "Council Grove",
            "Courtland",
            "Coyville",
            "Crestline",
            "Cuba",
            "Cummings",
            "Cunningham",
            "Damar",
            "Danville",
            "De Soto",
            "Dearing",
            "Deerfield",
            "Delia",
            "Delphos",
            "Denison",
            "Dennis",
            "Denton",
            "Derby",
            "Dexter",
            "Dighton",
            "Dodge City",
            "Dorrance",
            "Douglass",
            "Dover",
            "Downs",
            "Dresden",
            "Durham",
            "Dwight",
            "Easton",
            "Edgerton",
            "Edna",
            "Edson",
            "Edwardsville",
            "Effingham",
            "El Dorado",
            "Elbing",
            "Elk City",
            "Elk Falls",
            "Elkhart",
            "Ellinwood",
            "Ellis",
            "Ellsworth",
            "Elmdale",
            "Elsmore",
            "Elwood",
            "Emmett",
            "Emporia",
            "Englewood",
            "Ensign",
            "Enterprise",
            "Erie",
            "Esbon",
            "Eskridge",
            "Eudora",
            "Eureka",
            "Everest",
            "Fairview",
            "Fall River",
            "Falun",
            "Farlington",
            "Florence",
            "Fontana",
            "Ford",
            "Formoso",
            "Fort Leavenworth",
            "Fort Riley",
            "Fort Scott",
            "Fostoria",
            "Fowler",
            "Frankfort",
            "Franklin",
            "Fredonia",
            "Freeport",
            "Frontenac",
            "Fulton",
            "Galena",
            "Galesburg",
            "Galva",
            "Garden City",
            "Garden Plain",
            "Gardner",
            "Garfield",
            "Garnett",
            "Gas",
            "Gaylord",
            "Gem",
            "Geneseo",
            "Geuda Springs",
            "Girard",
            "Glade",
            "Glasco",
            "Glen Elder",
            "Goddard",
            "Goessel",
            "Goff",
            "Goodland",
            "Gorham",
            "Gove",
            "Grainfield",
            "Grantville",
            "Great Bend",
            "Greeley",
            "Green",
            "Greenleaf",
            "Greensburg",
            "Greenwich",
            "Grenola",
            "Gridley",
            "Grinnell",
            "Gypsum",
            "Haddam",
            "Halstead",
            "Hamilton",
            "Hanover",
            "Hanston",
            "Hardtner",
            "Harper",
            "Hartford",
            "Harveyville",
            "Havana",
            "Haven",
            "Havensville",
            "Haviland",
            "Hays",
            "Haysville",
            "Hazelton",
            "Healy",
            "Hepler",
            "Herington",
            "Herndon",
            "Hesston",
            "Hiawatha",
            "Highland",
            "Hill City",
            "Hillsboro",
            "Hillsdale",
            "Hoisington",
            "Holcomb",
            "Hollenberg",
            "Holton",
            "Holyrood",
            "Home",
            "Hope",
            "Horton",
            "Howard",
            "Hoxie",
            "Hoyt",
            "Hudson",
            "Hugoton",
            "Humboldt",
            "Hunter",
            "Hutchinson",
            "Independence",
            "Ingalls",
            "Inman",
            "Iola",
            "Isabel",
            "Iuka",
            "Jamestown",
            "Jennings",
            "Jetmore",
            "Jewell",
            "Johnson",
            "Junction City",
            "Kanopolis",
            "Kanorado",
            "Kansas City",
            "Kechi",
            "Kendall",
            "Kensington",
            "Kincaid",
            "Kingman",
            "Kinsley",
            "Kiowa",
            "Kirwin",
            "Kismet",
            "La Crosse",
            "La Cygne",
            "La Harpe",
            "Lake City",
            "Lakin",
            "Lamont",
            "Lancaster",
            "Lane",
            "Lansing",
            "Larned",
            "Latham",
            "Lawrence",
            "Le Roy",
            "Leavenworth",
            "Lebanon",
            "Lebo",
            "Lecompton",
            "Lehigh",
            "Lenora",
            "Leon",
            "Leonardville",
            "Leoti",
            "Levant",
            "Lewis",
            "Liberal",
            "Liberty",
            "Liebenthal",
            "Lincoln",
            "Lincolnville",
            "Lindsborg",
            "Linn",
            "Linwood",
            "Little River",
            "Logan",
            "Long Island",
            "Longford",
            "Longton",
            "Lorraine",
            "Lost Springs",
            "Louisburg",
            "Louisville",
            "Lucas",
            "Ludell",
            "Luray",
            "Lyndon",
            "Lyons",
            "Macksville",
            "Madison",
            "Mahaska",
            "Maize",
            "Manhattan",
            "Mankato",
            "Manter",
            "Maple City",
            "Maple Hill",
            "Mapleton",
            "Marienthal",
            "Marion",
            "Marquette",
            "Marysville",
            "Matfield Green",
            "Mayetta",
            "Mayfield",
            "McConnell A F B",
            "McCracken",
            "McCune",
            "McDonald",
            "McFarland",
            "McLouth",
            "Mcpherson",
            "Meade",
            "Medicine Lodge",
            "Melvern",
            "Meriden",
            "Milan",
            "Milford",
            "Milton",
            "Miltonvale",
            "Minneapolis",
            "Minneola",
            "Moline",
            "Montezuma",
            "Monument",
            "Moran",
            "Morganville",
            "Morland",
            "Morrill",
            "Morrowville",
            "Moscow",
            "Mound City",
            "Mound Valley",
            "Moundridge",
            "Mount Hope",
            "Mulberry",
            "Mullinville",
            "Mulvane",
            "Munden",
            "Murdock",
            "Muscotah",
            "Narka",
            "Nashville",
            "Natoma",
            "Neal",
            "Nekoma",
            "Neodesha",
            "Neosho Falls",
            "Neosho Rapids",
            "Ness City",
            "Netawaka",
            "New Albany",
            "New Cambria",
            "New Century",
            "Newton",
            "Nickerson",
            "Ninnescah",
            "Niotaze",
            "Norcatur",
            "North Newton",
            "Norton",
            "Nortonville",
            "Norway",
            "Norwich",
            "Oakley",
            "Oberlin",
            "Offerle",
            "Ogallah",
            "Ogden",
            "Oketo",
            "Olathe",
            "Olmitz",
            "Olpe",
            "Olsburg",
            "Onaga",
            "Oneida",
            "Opolis",
            "Osage City",
            "Osawatomie",
            "Osborne",
            "Oskaloosa",
            "Oswego",
            "Otis",
            "Ottawa",
            "Overbrook",
            "Oxford",
            "Ozawkie",
            "Palco",
            "Palmer",
            "Paola",
            "Paradise",
            "Park",
            "Parker",
            "Parsons",
            "Partridge",
            "Pawnee Rock",
            "Paxico",
            "Peabody",
            "Peck",
            "Penokee",
            "Perry",
            "Peru",
            "Pfeifer",
            "Phillipsburg",
            "Piedmont",
            "Pierceville",
            "Piqua",
            "Pittsburg",
            "Plains",
            "Plainville",
            "Pleasanton",
            "Plevna",
            "Pomona",
            "Portis",
            "Potter",
            "Potwin",
            "Powhattan",
            "Prairie View",
            "Pratt",
            "Prescott",
            "Pretty Prairie",
            "Princeton",
            "Protection",
            "Quenemo",
            "Quinter",
            "Rago",
            "Ramona",
            "Randall",
            "Randolph",
            "Ransom",
            "Rantoul",
            "Raymond",
            "Reading",
            "Redfield",
            "Republic",
            "Rexford",
            "Richfield",
            "Richland",
            "Richmond",
            "Riley",
            "Riverton",
            "Robinson",
            "Rock",
            "Rolla",
            "Rosalia",
            "Rose Hill",
            "Ross",
            "Rossville",
            "Roxbury",
            "Rozel",
            "Rush Center",
            "Russell",
            "Sabetha",
            "Saint Francis",
            "Saint George",
            "Saint John",
            "Saint Marys",
            "Saint Paul",
            "Salina",
            "Satanta",
            "Savonburg",
            "Sawyer",
            "Scammon",
            "Scandia",
            "Schoenchen",
            "Scott City",
            "Scranton",
            "Sedan",
            "Sedgwick",
            "Selden",
            "Seneca",
            "Severy",
            "Sharon",
            "Sharon Springs",
            "Shawnee Mission",
            "Silver Lake",
            "Simpson",
            "Smith Center",
            "Smolan",
            "Sodville",
            "Soldier",
            "Solomon",
            "South Haven",
            "South Hutchinson",
            "Spearville",
            "Spivey",
            "Spring Hill",
            "St. George",
            "Stafford",
            "Stark",
            "Sterling",
            "Stilwell",
            "Stockton",
            "Strong City",
            "Stuttgart",
            "Sublette",
            "Summerfield",
            "Sun City",
            "Sycamore",
            "Sylvan Grove",
            "Sylvia",
            "Syracuse",
            "Talmage",
            "Tampa",
            "Tecumseh",
            "Tescott",
            "Thayer",
            "Tipton",
            "Tonganoxie",
            "Topeka",
            "Toronto",
            "Towanda",
            "Treece",
            "Tribune",
            "Troy",
            "Turon",
            "Tyro",
            "Udall",
            "Ulysses",
            "Union",
            "Uniontown",
            "Utica",
            "Valley Center",
            "Valley Falls",
            "Vassar",
            "Vermillion",
            "Victoria",
            "Viola",
            "Virgil",
            "Wa Keeney",
            "Wakarusa",
            "Wakefield",
            "Waldo",
            "Waldron",
            "Walker",
            "Wallace",
            "Walnut",
            "Walton",
            "Wamego",
            "Washington",
            "Waterville",
            "Wathena",
            "Waverly",
            "Webber",
            "Weir",
            "Welda",
            "Wellington",
            "Wellsville",
            "Weskan",
            "West Mineral",
            "Westmoreland",
            "Westphalia",
            "Wetmore",
            "Wheaton",
            "White City",
            "White Cloud",
            "Whitewater",
            "Whiting",
            "Wichita",
            "Williamsburg",
            "Wilmore",
            "Wilsey",
            "Wilson",
            "Winchester",
            "Windom",
            "Winfield",
            "Winona",
            "Wolf River",
            "Woodbine",
            "Woodston",
            "Wright",
            "Yates Center",
            "Yoder",
            "Zenda"
        ]
    },
    {
        "state": "Kentucky",
        "abbr": "KY",
        "cities": [
            "Aberdeen",
            "Adairville",
            "Adams",
            "Adolphus",
            "Ages Brookside",
            "Albany",
            "Alexandria",
            "Allegre",
            "Allen",
            "Allensville",
            "Almo",
            "Alpha",
            "Alvaton",
            "Annville",
            "Argillite",
            "Arjay",
            "Arlington",
            "Artemus",
            "Ary",
            "Ashcamp",
            "Asher",
            "Ashland",
            "Athol",
            "Auburn",
            "Augusta",
            "Austin",
            "Auxier",
            "Avawam",
            "Bagdad",
            "Bakerton",
            "Bandana",
            "Banner",
            "Barbourville",
            "Bardstown",
            "Bardwell",
            "Barlow",
            "Baskett",
            "Battletown",
            "Baxter",
            "Bays",
            "Bear Branch",
            "Beattyville",
            "Beaumont",
            "Beauty",
            "Beaver",
            "Beaver Dam",
            "Bedford",
            "Bee Spring",
            "Beech Creek",
            "Beech Grove",
            "Beechmont",
            "Belcher",
            "Belfry",
            "Bellevue",
            "Belton",
            "Benham",
            "Benton",
            "Berea",
            "Berry",
            "Bethany",
            "Bethelridge",
            "Bethlehem",
            "Betsy Layne",
            "Beverly",
            "Bevinsville",
            "Big Clifty",
            "Big Creek",
            "Big Laurel",
            "Big Spring",
            "Bighill",
            "Bimble",
            "Blackey",
            "Blackford",
            "Blaine",
            "Bledsoe",
            "Bloomfield",
            "Blue River",
            "Boaz",
            "Bonnieville",
            "Bonnyman",
            "Booneville",
            "Boons Camp",
            "Boston",
            "Bowling Green",
            "Bradfordsville",
            "Brandenburg",
            "Breeding",
            "Bremen",
            "Brodhead",
            "Bronston",
            "Brooklyn",
            "Brooks",
            "Brooksville",
            "Browder",
            "Brownsville",
            "Bryants Store",
            "Bryantsville",
            "Buckhorn",
            "Buckner",
            "Buffalo",
            "Bulan",
            "Burdine",
            "Burgin",
            "Burkesville",
            "Burlington",
            "Burna",
            "Burnside",
            "Bush",
            "Busy",
            "Butler",
            "Bypro",
            "Cadiz",
            "Calhoun",
            "California",
            "Calvert City",
            "Calvin",
            "Camp Dix",
            "Campbellsburg",
            "Campbellsville",
            "Campton",
            "Canada",
            "Cane Valley",
            "Caneyville",
            "Canmer",
            "Cannel City",
            "Cannon",
            "Carlisle",
            "Carrie",
            "Carrollton",
            "Carter",
            "Catlettsburg",
            "Cave City",
            "Cawood",
            "Cecilia",
            "Center",
            "Centertown",
            "Central City",
            "Cerulean",
            "Chaplin",
            "Chappell",
            "Chavies",
            "Cisco",
            "Clarkson",
            "Clay",
            "Clay City",
            "Clayhole",
            "Clearfield",
            "Cleaton",
            "Clermont",
            "Clifty",
            "Clinton",
            "Closplint",
            "Cloverport",
            "Coalgood",
            "Coldiron",
            "Columbia",
            "Columbus",
            "Combs",
            "Confluence",
            "Corbin",
            "Corinth",
            "Cornettsville",
            "Corydon",
            "Covington",
            "Coxs Creek",
            "Crab Orchard",
            "Cranks",
            "Crayne",
            "Crestwood",
            "Crittenden",
            "Crockett",
            "Crofton",
            "Cromona",
            "Cromwell",
            "Cub Run",
            "Cumberland",
            "Cunningham",
            "Curdsville",
            "Custer",
            "Cynthiana",
            "Dabolt",
            "Dana",
            "Danville",
            "David",
            "Dawson Springs",
            "Dayhoit",
            "Dayton",
            "De Mossville",
            "Deane",
            "Debord",
            "Delphia",
            "Dema",
            "Denniston",
            "Denton",
            "Denver",
            "Dewitt",
            "Dexter",
            "Dice",
            "Dixon",
            "Dorton",
            "Dover",
            "Drake",
            "Drakesboro",
            "Drift",
            "Dry Ridge",
            "Dubre",
            "Dunbar",
            "Dundee",
            "Dunmor",
            "Dunnville",
            "Dwale",
            "Dwarf",
            "Dycusburg",
            "Earlington",
            "East Bernstadt",
            "East Point",
            "Eastern",
            "Eastview",
            "Eastwood",
            "Eddyville",
            "Edmonton",
            "Edna",
            "Eighty Eight",
            "Ekron",
            "Elizabethtown",
            "Elizaville",
            "Elk Horn",
            "Elkfork",
            "Elkhorn City",
            "Elkton",
            "Elliottville",
            "Elsie",
            "Emerson",
            "Eminence",
            "Emlyn",
            "Emmalena",
            "Eolia",
            "Eriline",
            "Erlanger",
            "Ermine",
            "Essie",
            "Etoile",
            "Eubank",
            "Evarts",
            "Ewing",
            "Ezel",
            "Fairdale",
            "Fairfield",
            "Fairplay",
            "Fairview",
            "Falcon",
            "Fall Rock",
            "Falls Of Rough",
            "Falmouth",
            "Fancy Farm",
            "Farmers",
            "Farmington",
            "Fedscreek",
            "Ferguson",
            "Finchville",
            "Firebrick",
            "Fisherville",
            "Fisty",
            "Flat Lick",
            "Flatgap",
            "Flatwoods",
            "Flemingsburg",
            "Florence",
            "Ford",
            "Fords Branch",
            "Fordsville",
            "Forest Hills",
            "Fort Campbell",
            "Fort Knox",
            "Fort Mitchell",
            "Fort Thomas",
            "Foster",
            "Fountain Run",
            "Fourmile",
            "Frakes",
            "Frankfort",
            "Franklin",
            "Fredonia",
            "Freeburn",
            "Frenchburg",
            "Ft Mitchell",
            "Fulton",
            "Gamaliel",
            "Gapville",
            "Garfield",
            "Garner",
            "Garrard",
            "Garrett",
            "Garrison",
            "Gays Creek",
            "Georgetown",
            "Germantown",
            "Ghent",
            "Gilbertsville",
            "Girdler",
            "Glasgow",
            "Glencoe",
            "Glendale",
            "Glens Fork",
            "Glenview",
            "Goose Rock",
            "Gordon",
            "Goshen",
            "Gracey",
            "Gradyville",
            "Graham",
            "Grahn",
            "Grand Rivers",
            "Gravel Switch",
            "Gray",
            "Gray Hawk",
            "Grays Knob",
            "Grayson",
            "Green Road",
            "Greensburg",
            "Greenup",
            "Greenville",
            "Grethel",
            "Gulston",
            "Gunlock",
            "Guston",
            "Guthrie",
            "Hadley",
            "Hagerhill",
            "Haldeman",
            "Halfway",
            "Hallie",
            "Hamlin",
            "Hampton",
            "Hanson",
            "Happy",
            "Hardburly",
            "Hardin",
            "Hardinsburg",
            "Hardy",
            "Hardyville",
            "Harlan",
            "Harned",
            "Harold",
            "Harrods Creek",
            "Harrodsburg",
            "Hartford",
            "Hawesville",
            "Hazard",
            "Hazel",
            "Hazel Green",
            "Hebron",
            "Heidelberg",
            "Heidrick",
            "Hellier",
            "Helton",
            "Henderson",
            "Herndon",
            "Hestand",
            "Hi Hat",
            "Hickman",
            "Hickory",
            "Hillsboro",
            "Hima",
            "Hindman",
            "Hinkle",
            "Hiseville",
            "Hitchins",
            "Hodgenville",
            "Holland",
            "Holmes Mill",
            "Hope",
            "Hopkinsville",
            "Horse Branch",
            "Horse Cave",
            "Hoskinston",
            "Huddy",
            "Hudson",
            "Hueysville",
            "Hulen",
            "Huntsville",
            "Hustonville",
            "Hyden",
            "Independence",
            "Inez",
            "Ingram",
            "Irvine",
            "Irvington",
            "Island",
            "Island City",
            "Isom",
            "Isonville",
            "Ivel",
            "Ivyton",
            "Jackhorn",
            "Jackson",
            "Jacobs",
            "Jamestown",
            "Jeff",
            "Jeffersonville",
            "Jenkins",
            "Jeremiah",
            "Jetson",
            "Jonancy",
            "Jonesville",
            "Junction City",
            "Keaton",
            "Keavy",
            "Keene",
            "Kenton",
            "Kenvir",
            "Kettle Island",
            "Kevil",
            "Kimper",
            "Kings Mountain",
            "Kirksey",
            "Kite",
            "Knifley",
            "Knob Lick",
            "Krypton",
            "Kuttawa",
            "La Center",
            "La Fayette",
            "La Grange",
            "Lackey",
            "Lancaster",
            "Langley",
            "Latonia",
            "Lawrenceburg",
            "Leander",
            "Lebanon",
            "Lebanon Junction",
            "Leburn",
            "Ledbetter",
            "Lee City",
            "Leitchfield",
            "Lejunior",
            "Lerose",
            "Letcher",
            "Lewisburg",
            "Lewisport",
            "Lexington",
            "Liberty",
            "Lick Creek",
            "Lily",
            "Lindseyville",
            "Linefork",
            "Littcarr",
            "Livermore",
            "Livingston",
            "Lloyd",
            "Lockport",
            "London",
            "Lone",
            "Lookout",
            "Loretto",
            "Lost Creek",
            "Louisa",
            "Louisville",
            "Lovelaceville",
            "Lovely",
            "Lowes",
            "Lowmansville",
            "Loyall",
            "Lucas",
            "Lynch",
            "Lynnville",
            "Maceo",
            "Mackville",
            "Madisonville",
            "Magnolia",
            "Majestic",
            "Mallie",
            "Malone",
            "Mammoth Cave",
            "Manchester",
            "Manitou",
            "Mannsville",
            "Maple Mount",
            "Marion",
            "Marrowbone",
            "Marshes Siding",
            "Martha",
            "Martin",
            "Mary Alice",
            "Marydell",
            "Mason",
            "Masonic Home",
            "Mayfield",
            "Mayking",
            "Mayslick",
            "Maysville",
            "Mazie",
            "McAndrews",
            "McCarr",
            "McDaniels",
            "McDowell",
            "McHenry",
            "McKee",
            "McKinney",
            "McQuady",
            "McRoberts",
            "McVeigh",
            "Meally",
            "Means",
            "Melber",
            "Melbourne",
            "Melvin",
            "Middleburg",
            "Middlesboro",
            "Middlesborough",
            "Midway",
            "Milburn",
            "Milford",
            "Mill Springs",
            "Millersburg",
            "Millstone",
            "Milltown",
            "Millwood",
            "Milton",
            "Minerva",
            "Minnie",
            "Miracle",
            "Mistletoe",
            "Mitchellsburg",
            "Mize",
            "Monticello",
            "Moorefield",
            "Morehead",
            "Morganfield",
            "Morgantown",
            "Morning View",
            "Mortons Gap",
            "Mount Eden",
            "Mount Hermon",
            "Mount Olivet",
            "Mount Sherman",
            "Mount Sterling",
            "Mount Vernon",
            "Mount Washington",
            "Mousie",
            "Mouthcard",
            "Mozelle",
            "Muldraugh",
            "Munfordville",
            "Murray",
            "Muses Mills",
            "Myra",
            "Nancy",
            "Nazareth",
            "Nebo",
            "Neon",
            "Nerinx",
            "Nevisdale",
            "New Castle",
            "New Concord",
            "New Haven",
            "New Hope",
            "New Liberty",
            "Newport",
            "Nicholasville",
            "North Middletown",
            "Nortonville",
            "Oak Grove",
            "Oakland",
            "Oil Springs",
            "Olaton",
            "Olive Hill",
            "Olmstead",
            "Olympia",
            "Oneida",
            "Ophir",
            "Orlando",
            "Owensboro",
            "Owenton",
            "Owingsville",
            "Paducah",
            "Paint Lick",
            "Paintsville",
            "Paris",
            "Park City",
            "Parkers Lake",
            "Parksville",
            "Partridge",
            "Pathfork",
            "Payneville",
            "Pellville",
            "Pembroke",
            "Pendleton",
            "Penrod",
            "Peoples",
            "Perry Park",
            "Perryville",
            "Petersburg",
            "Pewee Valley",
            "Phelps",
            "Philpot",
            "Phyllis",
            "Pikeville",
            "Pilgrim",
            "Pine Knot",
            "Pine Ridge",
            "Pine Top",
            "Pineville",
            "Pinsonfork",
            "Pippa Passes",
            "Pittsburg",
            "Pleasureville",
            "Plummers Landing",
            "Poole",
            "Port Royal",
            "Powderly",
            "Premium",
            "Preston",
            "Prestonsburg",
            "Primrose",
            "Princeton",
            "Printer",
            "Prospect",
            "Providence",
            "Provo",
            "Putney",
            "Quincy",
            "Raccoon",
            "Radcliff",
            "Ransom",
            "Raven",
            "Ravenna",
            "Raywick",
            "Redfox",
            "Reed",
            "Regina",
            "Renfro Valley",
            "Revelo",
            "Reynolds Station",
            "Rhodelia",
            "Ricetown",
            "Richardsville",
            "Richmond",
            "Rineyville",
            "River",
            "Roark",
            "Robards",
            "Robinson Creek",
            "Rochester",
            "Rockfield",
            "Rockholds",
            "Rockhouse",
            "Rockport",
            "Rocky Hill",
            "Rogers",
            "Rosine",
            "Roundhill",
            "Rousseau",
            "Rowdy",
            "Roxana",
            "Royalton",
            "Rumsey",
            "Rush",
            "Russell",
            "Russell Springs",
            "Russellville",
            "Sacramento",
            "Sadieville",
            "Saint Catharine",
            "Saint Charles",
            "Saint Francis",
            "Saint Helens",
            "Saint Mary",
            "Saint Paul",
            "Salem",
            "Salt Lick",
            "Salvisa",
            "Salyersville",
            "Sanders",
            "Sandgap",
            "Sandy Hook",
            "Sassafras",
            "Saul",
            "Scalf",
            "Science Hill",
            "Scottsville",
            "Scuddy",
            "Se Ree",
            "Sebree",
            "Seco",
            "Sedalia",
            "Sextons Creek",
            "Sharon Grove",
            "Sharpsburg",
            "Shelbiana",
            "Shelby Gap",
            "Shelbyville",
            "Shepherdsville",
            "Sidney",
            "Siler",
            "Silver Grove",
            "Simpsonville",
            "Sitka",
            "Sizerock",
            "Slade",
            "Slaughters",
            "Slemp",
            "Smilax",
            "Smith",
            "Smith Mills",
            "Smithfield",
            "Smithland",
            "Smiths Grove",
            "Soldier",
            "Somerset",
            "Sonora",
            "South Carrollton",
            "South Portsmouth",
            "South Shore",
            "South Union",
            "South Williamson",
            "Sparta",
            "Spottsville",
            "Springfield",
            "Staffordsville",
            "Stambaugh",
            "Stamping Ground",
            "Stanford",
            "Stanley",
            "Stanton",
            "Stanville",
            "Stearns",
            "Steele",
            "Stephensport",
            "Stinnett",
            "Stone",
            "Stoney Fork",
            "Stopover",
            "Strunk",
            "Sturgis",
            "Sullivan",
            "Sulphur",
            "Summer Shade",
            "Summersville",
            "Summit",
            "Sweeden",
            "Symsonia",
            "Talbert",
            "Tateville",
            "Taylorsville",
            "Teaberry",
            "Thelma",
            "Thornton",
            "Thousandsticks",
            "Tiline",
            "Tiptonville",
            "Toler",
            "Tollesboro",
            "Tolu",
            "Tomahawk",
            "Tompkinsville",
            "Topmost",
            "Totz",
            "Tram",
            "Trenton",
            "Trosper",
            "Turners Station",
            "Tutor Key",
            "Tyner",
            "Ulysses",
            "Union",
            "Union Star",
            "Uniontown",
            "Upton",
            "Utica",
            "Van Lear",
            "Vanceburg",
            "Vancleve",
            "Varney",
            "Verona",
            "Versailles",
            "Vest",
            "Vicco",
            "Vincent",
            "Vine Grove",
            "Viper",
            "Virgie",
            "Waco",
            "Waddy",
            "Walker",
            "Wallingford",
            "Wallins Creek",
            "Walton",
            "Waneta",
            "Warbranch",
            "Warfield",
            "Warsaw",
            "Washington",
            "Water Valley",
            "Waterview",
            "Waverly",
            "Wayland",
            "Waynesburg",
            "Webbville",
            "Webster",
            "Weeksbury",
            "Welchs Creek",
            "Wellington",
            "Wendover",
            "West Liberty",
            "West Louisville",
            "West Paducah",
            "West Point",
            "West Prestonsburg",
            "West Somerset",
            "West Van Lear",
            "Westport",
            "Westview",
            "Wheatcroft",
            "Wheelwright",
            "Whick",
            "White Mills",
            "White Plains",
            "Whitesburg",
            "Whitesville",
            "Whitley City",
            "Wickliffe",
            "Wildie",
            "Willard",
            "Williamsburg",
            "Williamsport",
            "Williamstown",
            "Willisburg",
            "Wilmore",
            "Winchester",
            "Windsor",
            "Wingo",
            "Winston",
            "Wittensville",
            "Woodbine",
            "Woodburn",
            "Woodbury",
            "Woollum",
            "Wooton",
            "Worthington",
            "Worthville",
            "Wrigley",
            "Yeaddiss",
            "Yerkes",
            "Yosemite",
            "Zoe"
        ]
    },
    {
        "state": "Louisiana",
        "abbr": "IL",
        "cities": [
            "Abbeville, LA",
            "Abita Springs, LA",
            "Acme, LA",
            "Addis, LA",
            "Aimwell, LA",
            "Akers, LA",
            "Albany, LA",
            "Alexandria, LA",
            "Ama, LA",
            "Amelia, LA",
            "Amite, LA",
            "Anacoco, LA",
            "Angie, LA",
            "Angola, LA",
            "Arabi, LA",
            "Arcadia, LA",
            "Archibald, LA",
            "Arnaudville, LA",
            "Ashland, LA",
            "Athens, LA",
            "Atlanta, LA",
            "Avery Island, LA",
            "Baker, LA",
            "Baldwin, LA",
            "Ball, LA",
            "Barataria, LA",
            "Barksdale AFB, LA",
            "Basile, LA",
            "Baskin, LA",
            "Bastrop, LA",
            "Batchelor, LA",
            "Baton Rouge, LA",
            "Bayou Goula, LA",
            "Belcher, LA",
            "Bell City, LA",
            "Belle Chasse, LA",
            "Belle Rose, LA",
            "Belmont, LA",
            "Bentley, LA",
            "Benton, LA",
            "Bernice, LA",
            "Berwick, LA",
            "Bethany, LA",
            "Bienville, LA",
            "Blanchard, LA",
            "Blanks, LA",
            "Bogalusa, LA",
            "Bonita, LA",
            "Boothville, LA",
            "Bordelonville, LA",
            "Bossier City, LA",
            "Bourg, LA",
            "Boutte, LA",
            "Boyce, LA",
            "Braithwaite, LA",
            "Branch, LA",
            "Breaux Bridge, LA",
            "Brittany, LA",
            "Broussard, LA",
            "Brusly, LA",
            "Bueche, LA",
            "Bunkie, LA",
            "Buras, LA",
            "Burnside, LA",
            "Bush, LA",
            "Cade, LA",
            "Calhoun, LA",
            "Calvin, LA",
            "Cameron, LA",
            "Campti, LA",
            "Cankton, LA",
            "Carencro, LA",
            "Carlisle, LA",
            "Carville, LA",
            "Castor, LA",
            "Cecilia, LA",
            "Center Point, LA",
            "Centerville, LA",
            "Chalmette, LA",
            "Charenton, LA",
            "Chase, LA",
            "Chataignier, LA",
            "Chatham, LA",
            "Chauvin, LA",
            "Cheneyville, LA",
            "Choudrant, LA",
            "Church Point, LA",
            "Clarence, LA",
            "Clarks, LA",
            "Clayton, LA",
            "Clinton, LA",
            "Cloutierville, LA",
            "Colfax, LA",
            "Collinston, LA",
            "Columbia, LA",
            "Convent, LA",
            "Converse, LA",
            "Cotton Valley, LA",
            "Cottonport, LA",
            "Coushatta, LA",
            "Covington, LA",
            "Creole, LA",
            "Crowley, LA",
            "Crowville, LA",
            "Cullen, LA",
            "Cut Off, LA",
            "Darrow, LA",
            "Davant, LA",
            "Delcambre, LA",
            "Delhi, LA",
            "Delta, LA",
            "Denham Springs, LA",
            "Dequincy, LA",
            "Deridder, LA",
            "Des Allemands, LA",
            "Destrehan, LA",
            "Deville, LA",
            "Dodson, LA",
            "Donaldsonville, LA",
            "Donner, LA",
            "Downsville, LA",
            "Doyline, LA",
            "Dry Creek, LA",
            "Dry Prong, LA",
            "Dubach, LA",
            "Dubberly, LA",
            "Dulac, LA",
            "Duplessis, LA",
            "Dupont, LA",
            "Duson, LA",
            "East Point, LA",
            "Echo, LA",
            "Edgard, LA",
            "Effie, LA",
            "Egan, LA",
            "Elizabeth, LA",
            "Elm Grove, LA",
            "Elmer, LA",
            "Elton, LA",
            "Empire, LA",
            "Enterprise, LA",
            "Epps, LA",
            "Erath, LA",
            "Eros, LA",
            "Erwinville, LA",
            "Estherwood, LA",
            "Ethel, LA",
            "Eunice, LA",
            "Evangeline, LA",
            "Evans, LA",
            "Evergreen, LA",
            "Fairbanks, LA",
            "Farmerville, LA",
            "Fenton, LA",
            "Ferriday, LA",
            "Fisher, LA",
            "Flatwoods, LA",
            "Flora, LA",
            "Florien, LA",
            "Fluker, LA",
            "Folsom, LA",
            "Fordoche, LA",
            "Forest, LA",
            "Forest Hill, LA",
            "Fort Necessity, LA",
            "Franklin, LA",
            "Franklinton, LA",
            "French Settlement, LA",
            "Frierson, LA",
            "Fullerton, LA",
            "Galliano, LA",
            "Garden City, LA",
            "Gardner, LA",
            "Garyville, LA",
            "Geismar, LA",
            "Georgetown, LA",
            "Gheens, LA",
            "Gibsland, LA",
            "Gibson, LA",
            "Gilbert, LA",
            "Gilliam, LA",
            "Glenmora, LA",
            "Gloster, LA",
            "Glynn, LA",
            "Golden Meadow, LA",
            "Goldonna, LA",
            "Gonzales, LA",
            "Gorum, LA",
            "Grambling, LA",
            "Gramercy, LA",
            "Grand Cane, LA",
            "Grand Chenier, LA",
            "Grand Coteau, LA",
            "Grand Isle, LA",
            "Grant, LA",
            "Gray, LA",
            "Grayson, LA",
            "Greensburg, LA",
            "Greenwell Springs, LA",
            "Greenwood, LA",
            "Gretna, LA",
            "Grosse Tete, LA",
            "Gueydan, LA",
            "Hackberry, LA",
            "Hahnville, LA",
            "Hall Summit, LA",
            "Hamburg, LA",
            "Hammond, LA",
            "Harmon, LA",
            "Harrisonburg, LA",
            "Harvey, LA",
            "Haughton, LA",
            "Hayes, LA",
            "Haynesville, LA",
            "Heflin, LA",
            "Hessmer, LA",
            "Hester, LA",
            "Hineston, LA",
            "Hodge, LA",
            "Holden, LA",
            "Homer, LA",
            "Hornbeck, LA",
            "Hosston, LA",
            "Houma, LA",
            "Husser, LA",
            "Ida, LA",
            "Independence, LA",
            "Innis, LA",
            "Iota, LA",
            "Iowa, LA",
            "Jackson, LA",
            "Jamestown, LA",
            "Jarreau, LA",
            "Jeanerette, LA",
            "Jefferson, LA",
            "Jena, LA",
            "Jennings, LA",
            "Jigger, LA",
            "Jones, LA",
            "Jonesboro, LA",
            "Jonesville, LA",
            "Joyce, LA",
            "Kaplan, LA",
            "Keatchie, LA",
            "Keithville, LA",
            "Kelly, LA",
            "Kenner, LA",
            "Kentwood, LA",
            "Kilbourne, LA",
            "Killona, LA",
            "Kinder, LA",
            "Kraemer, LA",
            "Krotz Springs, LA",
            "Kurthwood, LA",
            "La Place, LA",
            "Labadieville, LA",
            "Labarre, LA",
            "Lacamp, LA",
            "Lacassine, LA",
            "Lacombe, LA",
            "Lafayette, LA",
            "Lafitte, LA",
            "Lake Arthur, LA",
            "Lake Charles, LA",
            "Lake Providence, LA",
            "Lakeland, LA",
            "Laplace, LA",
            "Larose, LA",
            "Lawtell, LA",
            "Lebeau, LA",
            "Leblanc, LA",
            "Lecompte, LA",
            "Leesville, LA",
            "Lena, LA",
            "Leonville, LA",
            "Lettsworth, LA",
            "Libuse, LA",
            "Lillie, LA",
            "Lisbon, LA",
            "Livingston, LA",
            "Livonia, LA",
            "Lockport, LA",
            "Logansport, LA",
            "Longleaf, LA",
            "Longstreet, LA",
            "Longville, LA",
            "Loranger, LA",
            "Loreauville, LA",
            "Lottie, LA",
            "Luling, LA",
            "Lutcher, LA",
            "Lydia, LA",
            "Madisonville, LA",
            "Mamou, LA",
            "Mandeville, LA",
            "Mangham, LA",
            "Mansfield, LA",
            "Mansura, LA",
            "Many, LA",
            "Maringouin, LA",
            "Marion, LA",
            "Marksville, LA",
            "Marrero, LA",
            "Marthaville, LA",
            "Mathews, LA",
            "Maurepas, LA",
            "Maurice, LA",
            "McNary, LA",
            "Melrose, LA",
            "Melville, LA",
            "Mer Rouge, LA",
            "Meraux, LA",
            "Mermentau, LA",
            "Merryville, LA",
            "Metairie, LA",
            "Milton, LA",
            "Minden, LA",
            "Mittie, LA",
            "Modeste, LA",
            "Monroe, LA",
            "Montegut, LA",
            "Monterey, LA",
            "Montgomery, LA",
            "Mooringsport, LA",
            "Mora, LA",
            "Moreauville, LA",
            "Morgan City, LA",
            "Morganza, LA",
            "Morrow, LA",
            "Morse, LA",
            "Mount Airy, LA",
            "Mount Hermon, LA",
            "Napoleonville, LA",
            "Natalbany, LA",
            "Natchez, LA",
            "Natchitoches, LA",
            "Negreet, LA",
            "New Iberia, LA",
            "New Orleans, LA",
            "New Roads, LA",
            "New Sarpy, LA",
            "Newellton, LA",
            "Newllano, LA",
            "Noble, LA",
            "Norco, LA",
            "Norwood, LA",
            "Oak Grove, LA",
            "Oak Ridge, LA",
            "Oakdale, LA",
            "Oberlin, LA",
            "Oil City, LA",
            "Olla, LA",
            "Opelousas, LA",
            "Oscar, LA",
            "Otis, LA",
            "Paincourtville, LA",
            "Palmetto, LA",
            "Paradis, LA",
            "Patterson, LA",
            "Paulina, LA",
            "Pearl River, LA",
            "Pelican, LA",
            "Perry, LA",
            "Pierre Part, LA",
            "Pilottown, LA",
            "Pine Grove, LA",
            "Pine Prairie, LA",
            "Pineville, LA",
            "Pioneer, LA",
            "Pitkin, LA",
            "Plain Dealing, LA",
            "Plaquemine, LA",
            "Plattenville, LA",
            "Plaucheville, LA",
            "Pleasant Hill, LA",
            "Pointe A La Hache, LA",
            "Pollock, LA",
            "Ponchatoula, LA",
            "Port Allen, LA",
            "Port Barre, LA",
            "Port Sulphur, LA",
            "Powhatan, LA",
            "Prairieville, LA",
            "Pride, LA",
            "Princeton, LA",
            "Provencal, LA",
            "Quitman, LA",
            "Raceland, LA",
            "Ragley, LA",
            "Rayne, LA",
            "Rayville, LA",
            "Reddell, LA",
            "Reeves, LA",
            "Reserve, LA",
            "Rhinehart, LA",
            "Ringgold, LA",
            "Roanoke, LA",
            "Robeline, LA",
            "Robert, LA",
            "Rodessa, LA",
            "Rosedale, LA",
            "Roseland, LA",
            "Rosepine, LA",
            "Rougon, LA",
            "Ruby, LA",
            "Ruston, LA",
            "Saint Amant, LA",
            "Saint Benedict, LA",
            "Saint Bernard, LA",
            "Saint Francisville, LA",
            "Saint Gabriel, LA",
            "Saint James, LA",
            "Saint Joseph, LA",
            "Saint Landry, LA",
            "Saint Martinville, LA",
            "Saint Maurice, LA",
            "Saint Rose, LA",
            "Saline, LA",
            "Sarepta, LA",
            "Schriever, LA",
            "Scott, LA",
            "Shongaloo, LA",
            "Shreveport, LA",
            "Sibley, LA",
            "Sicily Island, LA",
            "Sieper, LA",
            "Sikes, LA",
            "Simmesport, LA",
            "Simpson, LA",
            "Simsboro, LA",
            "Singer, LA",
            "Slagle, LA",
            "Slaughter, LA",
            "Slidell, LA",
            "Sondheimer, LA",
            "Sorrento, LA",
            "South Mansfield, LA",
            "Spearsville, LA",
            "Springfield, LA",
            "Springhill, LA",
            "Starks, LA",
            "Start, LA",
            "Sterlington, LA",
            "Stonewall, LA",
            "Sugartown, LA",
            "Sulphur, LA",
            "Summerfield, LA",
            "Sun, LA",
            "Sunset, LA",
            "Sunshine, LA",
            "Swartz, LA",
            "Talisheek, LA",
            "Tallulah, LA",
            "Tangipahoa, LA",
            "Taylor, LA",
            "Theriot, LA",
            "Thibodaux, LA",
            "Tickfaw, LA",
            "Tioga, LA",
            "Torbert, LA",
            "Transylvania, LA",
            "Trout, LA",
            "Tullos, LA",
            "Tunica, LA",
            "Turkey Creek, LA",
            "Uncle Sam, LA",
            "Urania, LA",
            "Vacherie, LA",
            "Venice, LA",
            "Ventress, LA",
            "Verda, LA",
            "Vidalia, LA",
            "Ville Platte, LA",
            "Vinton, LA",
            "Violet, LA",
            "Vivian, LA",
            "Wakefield, LA",
            "Walker, LA",
            "Washington, LA",
            "Waterproof, LA",
            "Watson, LA",
            "Welsh, LA",
            "West Monroe, LA",
            "Westlake, LA",
            "Westwego, LA",
            "Weyanoke, LA",
            "White Castle, LA",
            "Wildsville, LA",
            "Wilson, LA",
            "Winnfield, LA",
            "Winnsboro, LA",
            "Wisner, LA",
            "Woodworth, LA",
            "Youngsville, LA",
            "Zachary, LA",
            "Zwolle, LA"
        ]
    },
    {
        "state": "Maine",
        "abbr": "ME",
        "cities": [
            "Abbot",
            "Acton",
            "Addison",
            "Albion",
            "Alfred",
            "Alna",
            "Andover",
            "Anson",
            "Ashland",
            "Athens",
            "Auburn",
            "Augusta",
            "Aurora",
            "Bailey Island",
            "Baileyville",
            "Bangor",
            "Bar Harbor",
            "Bar Mills",
            "Bass Harbor",
            "Bath",
            "Bayville",
            "Beals",
            "Belfast",
            "Belgrade",
            "Belgrade Lakes",
            "Benedicta",
            "Bernard",
            "Berwick",
            "Bethel",
            "Biddeford",
            "Biddeford Pool",
            "Bingham",
            "Birch Harbor",
            "Blaine",
            "Blue Hill",
            "Blue Hill Falls",
            "Boothbay",
            "Boothbay Harbor",
            "Bowdoin",
            "Bowdoinham",
            "Bradford",
            "Bradley",
            "Bremen",
            "Brewer",
            "Bridgewater",
            "Bridgton",
            "Bristol",
            "Brooklin",
            "Brooks",
            "Brooksville",
            "Brookton",
            "Brownfield",
            "Brownville",
            "Brownville Junction",
            "Brunswick",
            "Bryant Pond",
            "Buckfield",
            "Bucksport",
            "Burlington",
            "Burnham",
            "Bustins Island",
            "Calais",
            "Cambridge",
            "Camden",
            "Canaan",
            "Canton",
            "Cape Elizabeth",
            "Cape Neddick",
            "Cape Porpoise",
            "Caratunk",
            "Cardville",
            "Caribou",
            "Carmel",
            "Cary",
            "Casco",
            "Castine",
            "Center Lovell",
            "Chamberlain",
            "Charleston",
            "Chebeague Island",
            "Cherryfield",
            "China",
            "Clayton Lake",
            "Cliff Island",
            "Clinton",
            "Columbia Falls",
            "Coopers Mills",
            "Corea",
            "Corinna",
            "Corinth",
            "Cornish",
            "Costigan",
            "Cranberry Isles",
            "Crouseville",
            "Cumberland Center",
            "Cumberland Foreside",
            "Cushing",
            "Cutler",
            "Damariscotta",
            "Danforth",
            "Danville",
            "Deer Isle",
            "Denmark",
            "Dennysville",
            "Detroit",
            "Dexter",
            "Dixfield",
            "Dixmont",
            "Dover Foxcroft",
            "Dresden",
            "Dryden",
            "Durham",
            "Eagle Lake",
            "East Andover",
            "East Baldwin",
            "East Blue Hill",
            "East Boothbay",
            "East Dixfield",
            "East Livermore",
            "East Machias",
            "East Millinocket",
            "East Newport",
            "East Orland",
            "East Parsonfield",
            "East Poland",
            "East Vassalboro",
            "East Waterboro",
            "East Wilton",
            "East Winthrop",
            "Easton",
            "Eastport",
            "Eddington",
            "Edgecomb",
            "Eliot",
            "Ellsworth",
            "Estcourt Station",
            "Etna",
            "Eustis",
            "Exeter",
            "Fairfield",
            "Falmouth",
            "Farmingdale",
            "Farmington",
            "Farmington Falls",
            "Fort Fairfield",
            "Fort Kent",
            "Fort Kent Mills",
            "Frankfort",
            "Franklin",
            "Freedom",
            "Freeport",
            "Frenchboro",
            "Frenchville",
            "Friendship",
            "Fryeburg",
            "Gardiner",
            "Garland",
            "Georgetown",
            "Glen Cove",
            "Gorham",
            "Gouldsboro",
            "Grand Isle",
            "Grand Lake Stream",
            "Gray",
            "Greene",
            "Greenville",
            "Greenville Junction",
            "Guilford",
            "Hallowell",
            "Hampden",
            "Hancock",
            "Hanover",
            "Harborside",
            "Harmony",
            "Harpswell",
            "Harrington",
            "Harrison",
            "Hartland",
            "Hebron",
            "Hinckley",
            "Hiram",
            "Holden",
            "Hollis Center",
            "Hope",
            "Houlton",
            "Howland",
            "Hudson",
            "Hulls Cove",
            "Island Falls",
            "Isle Au Haut",
            "Isle Of Springs",
            "Islesboro",
            "Islesford",
            "Jackman",
            "Jay",
            "Jefferson",
            "Jonesboro",
            "Jonesport",
            "Kenduskeag",
            "Kennebunk",
            "Kennebunkport",
            "Kents Hill",
            "Kingfield",
            "Kingman",
            "Kittery",
            "Kittery Point",
            "Lagrange",
            "Lambert Lake",
            "Lebanon",
            "Lee",
            "Leeds",
            "Levant",
            "Lewiston",
            "Liberty",
            "Limerick",
            "Limestone",
            "Limington",
            "Lincoln",
            "Lincolnville",
            "Lincolnville Center",
            "Lisbon",
            "Lisbon Falls",
            "Litchfield",
            "Little Deer Isle",
            "Livermore",
            "Livermore Falls",
            "Locke Mills",
            "Long Island",
            "Lovell",
            "Lubec",
            "Machias",
            "Machiasport",
            "Madawaska",
            "Madison",
            "Manchester",
            "Manset",
            "Mapleton",
            "Mars Hill",
            "Masardis",
            "Matinicus",
            "Mattawamkeag",
            "Mechanic Falls",
            "Meddybemps",
            "Medway",
            "Merepoint",
            "Mexico",
            "Milbridge",
            "Milford",
            "Millinocket",
            "Milo",
            "Minot",
            "Monhegan",
            "Monmouth",
            "Monroe",
            "Monson",
            "Monticello",
            "Moody",
            "Morrill",
            "Mount Desert",
            "Mount Vernon",
            "Naples",
            "New Gloucester",
            "New Harbor",
            "New Limerick",
            "New Portland",
            "New Sharon",
            "New Sweden",
            "New Vineyard",
            "Newagen",
            "Newcastle",
            "Newfield",
            "Newport",
            "Newry",
            "Nobleboro",
            "Norridgewock",
            "North Anson",
            "North Berwick",
            "North Bridgton",
            "North Haven",
            "North Jay",
            "North Monmouth",
            "North New Portland",
            "North Turner",
            "North Vassalboro",
            "North Waterboro",
            "North Waterford",
            "North Yarmouth",
            "Northeast Harbor",
            "Norway",
            "Oakfield",
            "Oakland",
            "Ocean Park",
            "Ogunquit",
            "Olamon",
            "Old Orchard Beach",
            "Old Town",
            "Oquossoc",
            "Orient",
            "Orland",
            "Orono",
            "Orrington",
            "Orrs Island",
            "Otter Creek",
            "Owls Head",
            "Oxbow",
            "Oxford",
            "Palermo",
            "Palmyra",
            "Paris",
            "Parsonsfield",
            "Passadumkeag",
            "Patten",
            "Peaks Island",
            "Pemaquid",
            "Pembroke",
            "Penobscot",
            "Perham",
            "Perry",
            "Peru",
            "Phillips",
            "Phippsburg",
            "Pittsfield",
            "Plymouth",
            "Poland",
            "Port Clyde",
            "Portage",
            "Porter",
            "Portland",
            "Pownal",
            "Presque Isle",
            "Princeton",
            "Prospect Harbor",
            "Quimby",
            "Randolph",
            "Rangeley",
            "Raymond",
            "Readfield",
            "Richmond",
            "Robbinston",
            "Rockland",
            "Rockport",
            "Rockwood",
            "Round Pond",
            "Roxbury",
            "Rumford",
            "Rumford Center",
            "Sabattus",
            "Saco",
            "Saint Agatha",
            "Saint Albans",
            "Saint David",
            "Saint Francis",
            "Saint George",
            "Salsbury Cove",
            "Sandy Point",
            "Sanford",
            "Sangerville",
            "Sargentville",
            "Scarborough",
            "Seal Cove",
            "Seal Harbor",
            "Searsmont",
            "Searsport",
            "Sebago",
            "Sebago Lake",
            "Sebasco Estates",
            "Sebec",
            "Sedgwick",
            "Shapleigh",
            "Shawmut",
            "Sheridan",
            "Sherman Mills",
            "Sherman Station",
            "Shirley Mills",
            "Sinclair",
            "Skowhegan",
            "Small Point",
            "Smithfield",
            "Smyrna Mills",
            "Soldier Pond",
            "Solon",
            "Sorrento",
            "South Berwick",
            "South Bristol",
            "South Casco",
            "South China",
            "South Freeport",
            "South Gardiner",
            "South Paris",
            "South Portland",
            "South Thomaston",
            "South Waterford",
            "South Windham",
            "Southport",
            "Southwest Harbor",
            "Springfield",
            "Springvale",
            "Spruce Head",
            "Squirrel Island",
            "Stacyville",
            "Standish",
            "Steep Falls",
            "Stetson",
            "Steuben",
            "Stillwater",
            "Stockholm",
            "Stockton Springs",
            "Stoneham",
            "Stonington",
            "Stratton",
            "Strong",
            "Sullivan",
            "Sumner",
            "Sunset",
            "Surry",
            "Swans Island",
            "Temple",
            "Tenants Harbor",
            "Thomaston",
            "Thorndike",
            "Topsfield",
            "Topsham",
            "Trevett",
            "Troy",
            "Turner",
            "Turner Center",
            "Union",
            "Unity",
            "Van Buren",
            "Vanceboro",
            "Vassalboro",
            "Vienna",
            "Vinalhaven",
            "Waite",
            "Waldoboro",
            "Walpole",
            "Warren",
            "Washburn",
            "Washington",
            "Waterboro",
            "Waterford",
            "Waterville",
            "Wayne",
            "Weld",
            "Wells",
            "Wesley",
            "West Baldwin",
            "West Bethel",
            "West Boothbay Harbor",
            "West Buxton",
            "West Enfield",
            "West Farmington",
            "West Forks",
            "West Kennebunk",
            "West Minot",
            "West Newfield",
            "West Paris",
            "West Poland",
            "West Rockport",
            "West Tremont",
            "Westbrook",
            "Westfield",
            "Whitefield",
            "Whiting",
            "Wilton",
            "Windham",
            "Windsor",
            "Winn",
            "Winter Harbor",
            "Winterport",
            "Winterville",
            "Winthrop",
            "Wiscasset",
            "Woolwich",
            "Wytopitlock",
            "Yarmouth",
            "York",
            "York Beach",
            "York Harbor"
        ]
    },
    {
        "state": "Maryland",
        "abbr": "MD",
        "cities": [
            "Abell",
            "Aberdeen",
            "Aberdeen Proving Ground",
            "Abingdon",
            "Accident",
            "Accokeek",
            "Adamstown",
            "Allen",
            "Andrews Air Force Base",
            "Annapolis",
            "Annapolis Junction",
            "Aquasco",
            "Arnold",
            "Ashton",
            "Avenue",
            "Baldwin",
            "Baltimore",
            "Barclay",
            "Barnesville",
            "Barstow",
            "Barton",
            "Beallsville",
            "Bel Air",
            "Bel Air South",
            "Bel Alton",
            "Belcamp",
            "Beltsville",
            "Benedict",
            "Benson",
            "Berlin",
            "Bethesda",
            "Bethlehem",
            "Betterton",
            "Big Pool",
            "Bishopville",
            "Bittinger",
            "Bivalve",
            "Bladensburg",
            "Bloomington",
            "Boonsboro",
            "Boring",
            "Bowie",
            "Boyds",
            "Bozman",
            "Braddock Heights",
            "Brandywine",
            "Brentwood",
            "Brinklow",
            "Brookeville",
            "Brooklandville",
            "Brooklyn",
            "Broomes Island",
            "Brownsville",
            "Brunswick",
            "Bryans Road",
            "Bryantown",
            "Buckeystown",
            "Burkittsville",
            "Burtonsville",
            "Bushwood",
            "Butler",
            "Cabin John",
            "California",
            "Callaway",
            "Cambridge",
            "Capitol Heights",
            "Cascade",
            "Catonsville",
            "Cavetown",
            "Cecilton",
            "Centreville",
            "Chaptico",
            "Charlestown",
            "Charlotte Hall",
            "Chase",
            "Cheltenham",
            "Chesapeake Beach",
            "Chesapeake City",
            "Chester",
            "Chestertown",
            "Chevy Chase",
            "Chewsville",
            "Childs",
            "Church Creek",
            "Church Hill",
            "Churchton",
            "Churchville",
            "Claiborne",
            "Clarksburg",
            "Clarksville",
            "Clear Spring",
            "Clements",
            "Clinton",
            "Cobb Island",
            "Cockeysville",
            "College Park",
            "Colora",
            "Coltons Point",
            "Columbia",
            "Compton",
            "Conowingo",
            "Cooksville",
            "Cordova",
            "Corriganville",
            "Crapo",
            "Crisfield",
            "Crocheron",
            "Crofton",
            "Crownsville",
            "Crumpton",
            "Cumberland",
            "Curtis Bay",
            "Damascus",
            "Dameron",
            "Darlington",
            "Davidsonville",
            "Dayton",
            "Deal Island",
            "Deale",
            "Delmar",
            "Denton",
            "Derwood",
            "Dickerson",
            "District Heights",
            "Dowell",
            "Drayden",
            "Dundalk",
            "Dunkirk",
            "Earleville",
            "East New Market",
            "Easton",
            "Eckhart Mines",
            "Eden",
            "Edgewater",
            "Edgewood",
            "Elk Mills",
            "Elkridge",
            "Elkton",
            "Ellerslie",
            "Ellicott City",
            "Emmitsburg",
            "Essex",
            "Ewell",
            "Fairmount",
            "Fairplay",
            "Fallston",
            "Faulkner",
            "Federalsburg",
            "Finksburg",
            "Fishing Creek",
            "Flintstone",
            "Forest Hill",
            "Fork",
            "Fort George G Meade",
            "Fort Howard",
            "Fort Washington",
            "Frederick",
            "Freeland",
            "Friendship",
            "Friendsville",
            "Frostburg",
            "Fruitland",
            "Fulton",
            "Funkstown",
            "Gaithersburg",
            "Galena",
            "Galesville",
            "Gambrills",
            "Gapland",
            "Garrett Park",
            "Garrison",
            "Georgetown",
            "Germantown",
            "Gibson Island",
            "Girdletree",
            "Glen Arm",
            "Glen Burnie",
            "Glen Echo",
            "Glenelg",
            "Glenn Dale",
            "Glenwood",
            "Glyndon",
            "Goldsboro",
            "Grantsville",
            "Grasonville",
            "Great Mills",
            "Greenbelt",
            "Greensboro",
            "Gunpowder",
            "Gwynn Oak",
            "Hagerstown",
            "Halethorpe",
            "Hampstead",
            "Hancock",
            "Hanover",
            "Harmans",
            "Harwood",
            "Havre De Grace",
            "Hebron",
            "Helen",
            "Henderson",
            "Henryton",
            "Highland",
            "Hillsboro",
            "Hollywood",
            "Hughesville",
            "Hunt Valley",
            "Huntingtown",
            "Hurlock",
            "Hyattsville",
            "Hydes",
            "Ijamsville",
            "Indian Head",
            "Ingleside",
            "Ironsides",
            "Issue",
            "Jarrettsville",
            "Jefferson",
            "Jessup",
            "Joppa",
            "Keedysville",
            "Kennedyville",
            "Kensington",
            "Keymar",
            "Kingsville",
            "Kitzmiller",
            "Knoxville",
            "La Plata",
            "Ladiesburg",
            "Lanham",
            "Laurel",
            "Leonardtown",
            "Lexington Park",
            "Libertytown",
            "Lineboro",
            "Linkwood",
            "Linthicum Heights",
            "Linwood",
            "Lisbon",
            "Little Orleans",
            "Lonaconing",
            "Long Green",
            "Lothian",
            "Loveville",
            "Luke",
            "Lusby",
            "Lutherville Timonium",
            "Madison",
            "Manchester",
            "Manokin",
            "Marbury",
            "Mardela Springs",
            "Marion Station",
            "Marriottsville",
            "Marydel",
            "Maryland Line",
            "Massey",
            "Maugansville",
            "Mayo",
            "Mcdaniel",
            "McHenry",
            "Mechanicsville",
            "Middle River",
            "Middletown",
            "Midland",
            "Midlothian",
            "Millersville",
            "Millington",
            "Monkton",
            "Monrovia",
            "Montgomery Village",
            "Morganza",
            "Mount Airy",
            "Mount Rainier",
            "Mount Savage",
            "Mount Victoria",
            "Myersville",
            "Nanjemoy",
            "Nanticoke",
            "Neavitt",
            "New Market",
            "New Midway",
            "New Windsor",
            "Newark",
            "Newburg",
            "Newcomb",
            "North Beach",
            "North East",
            "Nottingham",
            "Oakland",
            "Ocean City",
            "Odenton",
            "Oldtown",
            "Olney",
            "Owings",
            "Owings Mills",
            "Oxford",
            "Oxon Hill",
            "Park Hall",
            "Parkton",
            "Parkville",
            "Parsonsburg",
            "Pasadena",
            "Patuxent River",
            "Perry Hall",
            "Perry Point",
            "Perryman",
            "Perryville",
            "Phoenix",
            "Pikesville",
            "Piney Point",
            "Pinto",
            "Pittsville",
            "Pocomoke City",
            "Point Of Rocks",
            "Pomfret",
            "Poolesville",
            "Port Deposit",
            "Port Republic",
            "Port Tobacco",
            "Potomac",
            "Powellville",
            "Preston",
            "Price",
            "Prince Frederick",
            "Princess Anne",
            "Pylesville",
            "Quantico",
            "Queen Anne",
            "Queenstown",
            "Randallstown",
            "Rawlings",
            "Rehobeth",
            "Reisterstown",
            "Rhodesdale",
            "Riderwood",
            "Ridge",
            "Ridgely",
            "Rising Sun",
            "Riva",
            "Riverdale",
            "Rock Hall",
            "Rock Point",
            "Rockville",
            "Rocky Ridge",
            "Rohrersville",
            "Rosedale",
            "Royal Oak",
            "Sabillasville",
            "Saint Inigoes",
            "Saint James",
            "Saint Leonard",
            "Saint Marys City",
            "Saint Michaels",
            "Salisbury",
            "Sandy Spring",
            "Savage",
            "Scotland",
            "Secretary",
            "Severn",
            "Severna Park",
            "Shady Side",
            "Sharpsburg",
            "Sharptown",
            "Sherwood",
            "Showell",
            "Silver Spring",
            "Simpsonville",
            "Smithsburg",
            "Snow Hill",
            "Solomons",
            "Southern Md Facility",
            "Sparks Glencoe",
            "Sparrows Point",
            "Spencerville",
            "Spring Gap",
            "Stevenson",
            "Stevensville",
            "Still Pond",
            "Stockton",
            "Street",
            "Suburb Maryland Fac",
            "Sudlersville",
            "Suitland",
            "Sunderland",
            "Swanton",
            "Sykesville",
            "Takoma Park",
            "Tall Timbers",
            "Taneytown",
            "Taylors Island",
            "Temple Hills",
            "Templeville",
            "Thurmont",
            "Tilghman",
            "Toddville",
            "Towson",
            "Tracys Landing",
            "Trappe",
            "Tuscarora",
            "Tyaskin",
            "Tylerton",
            "Union Bridge",
            "Unionville",
            "Upper Fairmount",
            "Upper Falls",
            "Upper Marlboro",
            "Upperco",
            "Valley Lee",
            "Vienna",
            "Waldorf",
            "Walkersville",
            "Warwick",
            "Washington Grove",
            "Welcome",
            "Wenona",
            "West Friendship",
            "West River",
            "Westernport",
            "Westminster",
            "Westover",
            "Whaleyville",
            "White Hall",
            "White Marsh",
            "White Plains",
            "Whiteford",
            "Willards",
            "Williamsport",
            "Windsor Mill",
            "Wingate",
            "Wittman",
            "Woodbine",
            "Woodsboro",
            "Woodstock",
            "Woolford",
            "Worton",
            "Wye Mills"
        ]
    },
    {
        "state": "Massachusetts",
        "abbr": "MA",
        "cities": [
            "Abington",
            "Accord",
            "Acton",
            "Acushnet",
            "Adams",
            "Agawam",
            "Allston",
            "Amesbury",
            "Amherst",
            "Andover",
            "Arlington",
            "Arlington Heights",
            "Ashburnham",
            "Ashby",
            "Ashfield",
            "Ashland",
            "Ashley Falls",
            "Assonet",
            "Athol",
            "Attleboro",
            "Attleboro Falls",
            "Auburn",
            "Auburndale",
            "Avon",
            "Ayer",
            "Babson Park",
            "Baldwinville",
            "Barnstable",
            "Barnstable Town",
            "Barre",
            "Becket",
            "Bedford",
            "Belchertown",
            "Bellingham",
            "Belmont",
            "Berkley",
            "Berkshire",
            "Berlin",
            "Bernardston",
            "Beverly",
            "Billerica",
            "Blackstone",
            "Blandford",
            "Bolton",
            "Bondsville",
            "Boston",
            "Boxborough",
            "Boxford",
            "Boylston",
            "Braintree",
            "Brant Rock",
            "Brewster",
            "Bridgewater",
            "Brighton",
            "Brimfield",
            "Brockton",
            "Brookfield",
            "Brookline",
            "Brookline Village",
            "Bryantville",
            "Buckland",
            "Burlington",
            "Buzzards Bay",
            "Byfield",
            "Cambridge",
            "Canton",
            "Carlisle",
            "Carver",
            "Cataumet",
            "Centerville",
            "Charlemont",
            "Charlestown",
            "Charlton",
            "Charlton City",
            "Charlton Depot",
            "Chartley",
            "Chatham",
            "Chelmsford",
            "Chelsea",
            "Cherry Valley",
            "Cheshire",
            "Chester",
            "Chesterfield",
            "Chestnut Hill",
            "Chicopee",
            "Chilmark",
            "Clinton",
            "Cohasset",
            "Colrain",
            "Concord",
            "Conway",
            "Cotuit",
            "Cummaquid",
            "Cummington",
            "Cuttyhunk",
            "Dalton",
            "Danvers",
            "Dartmouth",
            "Dedham",
            "Deerfield",
            "Dennis",
            "Dennis Port",
            "Dighton",
            "Douglas",
            "Dover",
            "Dracut",
            "Drury",
            "Dudley",
            "Dunstable",
            "Duxbury",
            "East Bridgewater",
            "East Brookfield",
            "East Dennis",
            "East Falmouth",
            "East Freetown",
            "East Longmeadow",
            "East Mansfield",
            "East Orleans",
            "East Otis",
            "East Princeton",
            "East Sandwich",
            "East Taunton",
            "East Templeton",
            "East Walpole",
            "East Wareham",
            "Eastham",
            "Easthampton",
            "Easton",
            "Edgartown",
            "Elmwood",
            "Erving",
            "Essex",
            "Everett",
            "Fairhaven",
            "Fall River",
            "Falmouth",
            "Fayville",
            "Feeding Hills",
            "Fiskdale",
            "Fitchburg",
            "Florence",
            "Forestdale",
            "Foxboro",
            "Foxborough",
            "Framingham",
            "Franklin",
            "Gardner",
            "Georgetown",
            "Gilbertville",
            "Glendale",
            "Gloucester",
            "Goshen",
            "Grafton",
            "Granby",
            "Granville",
            "Great Barrington",
            "Green Harbor",
            "Greenbush",
            "Greenfield",
            "Groton",
            "Groveland",
            "Hadley",
            "Halifax",
            "Hamilton",
            "Hampden",
            "Hanover",
            "Hanscom AFB",
            "Hanson",
            "Hardwick",
            "Harvard",
            "Harwich",
            "Harwich Port",
            "Hatfield",
            "Hathorne",
            "Haverhill",
            "Haydenville",
            "Heath",
            "Hingham",
            "Hinsdale",
            "Holbrook",
            "Holden",
            "Holland",
            "Holliston",
            "Holyoke",
            "Hopedale",
            "Hopkinton",
            "Housatonic",
            "Hubbardston",
            "Hudson",
            "Hull",
            "Humarock",
            "Huntington",
            "Hyannis",
            "Hyannis Port",
            "Hyde Park",
            "Indian Orchard",
            "Ipswich",
            "Jamaica Plain",
            "Jefferson",
            "Kingston",
            "Lake Pleasant",
            "Lakeville",
            "Lancaster",
            "Lanesboro",
            "Lawrence",
            "Lee",
            "Leeds",
            "Leicester",
            "Lenox",
            "Lenox Dale",
            "Leominster",
            "Leverett",
            "Lexington",
            "Lincoln",
            "Linwood",
            "Littleton",
            "Longmeadow",
            "Lowell",
            "Ludlow",
            "Lunenburg",
            "Lynn",
            "Lynnfield",
            "Malden",
            "Manchaug",
            "Manchester",
            "Manomet",
            "Mansfield",
            "Marblehead",
            "Marion",
            "Marlborough",
            "Marshfield",
            "Marshfield Hills",
            "Marstons Mills",
            "Mashpee",
            "Mattapan",
            "Mattapoisett",
            "Maynard",
            "Medfield",
            "Medford",
            "Medway",
            "Melrose",
            "Mendon",
            "Menemsha",
            "Merrimac",
            "Methuen",
            "Middleboro",
            "Middlefield",
            "Middleton",
            "Milford",
            "Mill River",
            "Millbury",
            "Millis",
            "Millville",
            "Milton",
            "Milton Village",
            "Minot",
            "Monponsett",
            "Monroe Bridge",
            "Monson",
            "Montague",
            "Monterey",
            "Monument Beach",
            "Nahant",
            "Nantucket",
            "Natick",
            "Needham",
            "New Bedford",
            "New Braintree",
            "New Salem",
            "New Town",
            "Newbury",
            "Newburyport",
            "Newton",
            "Newton Center",
            "Newton Highlands",
            "Newton Lower Falls",
            "Newton Upper Falls",
            "Newtonville",
            "Nonantum",
            "Norfolk",
            "North Adams",
            "North Amherst",
            "North Andover",
            "North Attleboro",
            "North Billerica",
            "North Brookfield",
            "North Carver",
            "North Chatham",
            "North Chelmsford",
            "North Dartmouth",
            "North Dighton",
            "North Eastham",
            "North Easton",
            "North Egremont",
            "North Falmouth",
            "North Grafton",
            "North Hatfield",
            "North Marshfield",
            "North Oxford",
            "North Pembroke",
            "North Reading",
            "North Scituate",
            "North Truro",
            "North Uxbridge",
            "Northampton",
            "Northborough",
            "Northbridge",
            "Northfield",
            "Norton",
            "Norwell",
            "Norwood",
            "Nutting Lake",
            "Oak Bluffs",
            "Oakham",
            "Ocean Bluff",
            "Onset",
            "Orange",
            "Orleans",
            "Osterville",
            "Otis",
            "Oxford",
            "Palmer",
            "Paxton",
            "Peabody",
            "Pembroke",
            "Pepperell",
            "Petersham",
            "Pinehurst",
            "Pittsfield",
            "Plainfield",
            "Plainville",
            "Plymouth",
            "Plympton",
            "Pocasset",
            "Prides Crossing",
            "Princeton",
            "Provincetown",
            "Quincy",
            "Randolph",
            "Raynham",
            "Raynham Center",
            "Reading",
            "Readville",
            "Rehoboth",
            "Revere",
            "Richmond",
            "Rochdale",
            "Rochester",
            "Rockland",
            "Rockport",
            "Roslindale",
            "Rowe",
            "Rowley",
            "Royalston",
            "Russell",
            "Rutland",
            "Sagamore",
            "Sagamore Beach",
            "Salem",
            "Salisbury",
            "Sandisfield",
            "Sandwich",
            "Saugus",
            "Savoy",
            "Scituate",
            "Seekonk",
            "Sharon",
            "Shattuckville",
            "Sheffield",
            "Shelburne Falls",
            "Sheldonville",
            "Sherborn",
            "Shirley",
            "Shrewsbury",
            "Shutesbury",
            "Siasconset",
            "Silver Beach",
            "Somerset",
            "Somerville",
            "South Barre",
            "South Carver",
            "South Chatham",
            "South Dartmouth",
            "South Deerfield",
            "South Dennis",
            "South Easton",
            "South Egremont",
            "South Grafton",
            "South Hadley",
            "South Hamilton",
            "South Harwich",
            "South Lancaster",
            "South Lee",
            "South Orleans",
            "South Walpole",
            "South Wellfleet",
            "South Yarmouth",
            "Southampton",
            "Southborough",
            "Southbridge",
            "Southfield",
            "Southwick",
            "Spencer",
            "Springfield",
            "Sterling",
            "Still River",
            "Stockbridge",
            "Stoneham",
            "Stoughton",
            "Stow",
            "Sturbridge",
            "Sudbury",
            "Sunderland",
            "Sutton",
            "Swampscott",
            "Swansea",
            "Taunton",
            "Templeton",
            "Tewksbury",
            "Thorndike",
            "Three Rivers",
            "Tolland",
            "Topsfield",
            "Townsend",
            "Truro",
            "Turners Falls",
            "Tyngsboro",
            "Tyringham",
            "Upton",
            "Uxbridge",
            "Village Of Nagog Woods",
            "Vineyard Haven",
            "Waban",
            "Wakefield",
            "Wales",
            "Walpole",
            "Waltham",
            "Ware",
            "Wareham",
            "Warren",
            "Warwick",
            "Watertown",
            "Waverley",
            "Wayland",
            "Webster",
            "Wellesley",
            "Wellesley Hills",
            "Wellfleet",
            "Wendell",
            "Wendell Depot",
            "Wenham",
            "West Barnstable",
            "West Boxford",
            "West Boylston",
            "West Bridgewater",
            "West Brookfield",
            "West Chatham",
            "West Chesterfield",
            "West Dennis",
            "West Falmouth",
            "West Groton",
            "West Harwich",
            "West Hatfield",
            "West Hyannisport",
            "West Medford",
            "West Millbury",
            "West Newbury",
            "West Newton",
            "West Roxbury",
            "West Springfield",
            "West Stockbridge",
            "West Tisbury",
            "West Townsend",
            "West Wareham",
            "West Warren",
            "West Yarmouth",
            "Westborough",
            "Westfield",
            "Westford",
            "Westminster",
            "Weston",
            "Westport",
            "Westport Point",
            "Westwood",
            "Weymouth",
            "Whately",
            "Wheelwright",
            "White Horse Beach",
            "Whitinsville",
            "Whitman",
            "Wilbraham",
            "Williamsburg",
            "Williamstown",
            "Wilmington",
            "Winchendon",
            "Winchendon Springs",
            "Winchester",
            "Windsor",
            "Winthrop",
            "Woburn",
            "Woods Hole",
            "Woodville",
            "Worcester",
            "Woronoco",
            "Worthington",
            "Wrentham",
            "Yarmouth Port"
        ]
    },
    {
        "state": "Michigan",
        "abbr": "MI",
        "cities": [
            "Acme",
            "Ada",
            "Addison",
            "Adrian",
            "Afton",
            "Ahmeek",
            "Akron",
            "Alanson",
            "Alba",
            "Albion",
            "Alden",
            "Alger",
            "Algonac",
            "Allegan",
            "Allen",
            "Allen Park",
            "Allendale",
            "Allenton",
            "Allouez",
            "Alma",
            "Almont",
            "Alpena",
            "Alpha",
            "Alto",
            "Amasa",
            "Anchorville",
            "Ann Arbor",
            "Applegate",
            "Arcadia",
            "Argyle",
            "Armada",
            "Arnold",
            "Ashley",
            "Athens",
            "Atlanta",
            "Atlantic Mine",
            "Atlas",
            "Attica",
            "Au Gres",
            "Au Train",
            "Auburn",
            "Auburn Hills",
            "Augusta",
            "Avoca",
            "Azalia",
            "Bad Axe",
            "Bailey",
            "Baldwin",
            "Bancroft",
            "Bangor",
            "Bannister",
            "Baraga",
            "Barbeau",
            "Bark River",
            "Baroda",
            "Barryton",
            "Barton City",
            "Bath",
            "Battle Creek",
            "Bay City",
            "Bay Port",
            "Bay Shore",
            "Bear Lake",
            "Beaver Island",
            "Beaverton",
            "Bedford",
            "Belding",
            "Bellaire",
            "Belleville",
            "Bellevue",
            "Belmont",
            "Bentley",
            "Benton Harbor",
            "Benzonia",
            "Bergland",
            "Berkley",
            "Berrien Center",
            "Berrien Springs",
            "Bessemer",
            "Beulah",
            "Big Bay",
            "Big Rapids",
            "Birch Run",
            "Birmingham",
            "Bitely",
            "Black River",
            "Blanchard",
            "Blissfield",
            "Bloomfield Hills",
            "Bloomingdale",
            "Boon",
            "Boyne City",
            "Boyne Falls",
            "Bradley",
            "Branch",
            "Brant",
            "Breckenridge",
            "Breedsville",
            "Brethren",
            "Bridgeport",
            "Bridgewater",
            "Bridgman",
            "Brighton",
            "Brimley",
            "Britton",
            "Brohman",
            "Bronson",
            "Brooklyn",
            "Brown City",
            "Bruce Crossing",
            "Brutus",
            "Buchanan",
            "Buckley",
            "Burlington",
            "Burnips",
            "Burr Oak",
            "Burt",
            "Burt Lake",
            "Burton",
            "Byron",
            "Byron Center",
            "Cadillac",
            "Caledonia",
            "Calumet",
            "Camden",
            "Cannonsburg",
            "Canton",
            "Capac",
            "Carleton",
            "Carney",
            "Caro",
            "Carp Lake",
            "Carrollton",
            "Carson City",
            "Carsonville",
            "Casco",
            "Caseville",
            "Casnovia",
            "Caspian",
            "Cass City",
            "Cassopolis",
            "Cedar",
            "Cedar Lake",
            "Cedar River",
            "Cedar Springs",
            "Cedarville",
            "Cement City",
            "Center Line",
            "Central Lake",
            "Centreville",
            "Ceresco",
            "Champion",
            "Channing",
            "Charlevoix",
            "Charlotte",
            "Chase",
            "Chassell",
            "Chatham",
            "Cheboygan",
            "Chelsea",
            "Chesaning",
            "Chippewa Lake",
            "Clare",
            "Clarklake",
            "Clarkston",
            "Clarksville",
            "Clawson",
            "Clayton",
            "Clifford",
            "Climax",
            "Clinton",
            "Clinton Township",
            "Clio",
            "Cloverdale",
            "Cohoctah",
            "Coldwater",
            "Coleman",
            "Colfax",
            "Coloma",
            "Colon",
            "Columbiaville",
            "Columbus",
            "Comins",
            "Commerce Township",
            "Comstock",
            "Comstock Park",
            "Concord",
            "Conklin",
            "Constantine",
            "Conway",
            "Cooks",
            "Coopersville",
            "Copemish",
            "Copper City",
            "Copper Harbor",
            "Coral",
            "Cornell",
            "Corunna",
            "Covert",
            "Covington",
            "Cross Village",
            "Croswell",
            "Crystal",
            "Crystal Falls",
            "Curran",
            "Curtis",
            "Custer",
            "Dafter",
            "Daggett",
            "Dansville",
            "Davisburg",
            "Davison",
            "De Tour Village",
            "Dearborn",
            "Dearborn Heights",
            "Decatur",
            "Decker",
            "Deckerville",
            "Deerfield",
            "Deerton",
            "Deford",
            "Delton",
            "Detroit",
            "Dewitt",
            "Dexter",
            "Dickson",
            "Dimondale",
            "Dodgeville",
            "Dollar Bay",
            "Dorr",
            "Douglas",
            "Dowagiac",
            "Dowling",
            "Drayton Plains",
            "Drummond Island",
            "Dryden",
            "Dundee",
            "Durand",
            "Eagle",
            "East China",
            "East Jordan",
            "East Lansing",
            "East Leroy",
            "East Tawas",
            "Eastlake",
            "Eastpointe",
            "Eastport",
            "Eaton Rapids",
            "Eau Claire",
            "Eben Junction",
            "Eckerman",
            "Ecorse",
            "Edenville",
            "Edmore",
            "Edwardsburg",
            "Elberta",
            "Elk Rapids",
            "Elkton",
            "Ellsworth",
            "Elm Hall",
            "Elmira",
            "Elsie",
            "Elwell",
            "Emmett",
            "Empire",
            "Engadine",
            "Erie",
            "Escanaba",
            "Essexville",
            "Eureka",
            "Evart",
            "Ewen",
            "Fair Haven",
            "Fairgrove",
            "Fairview",
            "Falmouth",
            "Farmington",
            "Farwell",
            "Felch",
            "Fennville",
            "Fenton",
            "Fenwick",
            "Ferndale",
            "Ferrysburg",
            "Fife Lake",
            "Filer City",
            "Filion",
            "Flat Rock",
            "Flint",
            "Flushing",
            "Forest",
            "Forestville",
            "Fort Gratiot",
            "Foster City",
            "Fostoria",
            "Fountain",
            "Fowler",
            "Fowlerville",
            "Frankenmuth",
            "Frankfort",
            "Franklin",
            "Fraser",
            "Frederic",
            "Free Soil",
            "Freeland",
            "Freeport",
            "Fremont",
            "Frontier",
            "Fruitport",
            "Fulton",
            "Gaastra",
            "Gagetown",
            "Gaines",
            "Galesburg",
            "Galien",
            "Garden",
            "Garden City",
            "Gaylord",
            "Genesee",
            "Germfask",
            "Gilford",
            "Gladstone",
            "Gladwin",
            "Glen Arbor",
            "Glenn",
            "Glennie",
            "Gobles",
            "Goetzville",
            "Good Hart",
            "Goodells",
            "Goodrich",
            "Gould City",
            "Gowen",
            "Grand Blanc",
            "Grand Haven",
            "Grand Junction",
            "Grand Ledge",
            "Grand Marais",
            "Grand Rapids",
            "Grandville",
            "Grant",
            "Grass Lake",
            "Grawn",
            "Grayling",
            "Greenbush",
            "Greenland",
            "Greenville",
            "Greenwood",
            "Gregory",
            "Grosse Ile",
            "Grosse Pointe",
            "Gulliver",
            "Gwinn",
            "Hadley",
            "Hagar Shores",
            "Hale",
            "Hamburg",
            "Hamilton",
            "Hamtramck",
            "Hancock",
            "Hanover",
            "Harbert",
            "Harbor Beach",
            "Harbor Springs",
            "Harper Woods",
            "Harrietta",
            "Harris",
            "Harrison",
            "Harrison Township",
            "Harrisville",
            "Harsens Island",
            "Hart",
            "Hartford",
            "Hartland",
            "Haslett",
            "Hastings",
            "Hawks",
            "Hazel Park",
            "Hemlock",
            "Henderson",
            "Hermansville",
            "Herron",
            "Hersey",
            "Hesperia",
            "Hessel",
            "Hickory Corners",
            "Higgins Lake",
            "Highland",
            "Highland Park",
            "Hillman",
            "Hillsdale",
            "Holland",
            "Holly",
            "Holt",
            "Holton",
            "Homer",
            "Honor",
            "Hope",
            "Hopkins",
            "Horton",
            "Houghton",
            "Houghton Lake",
            "Houghton Lake Heights",
            "Howard City",
            "Howell",
            "Hubbard Lake",
            "Hubbardston",
            "Hubbell",
            "Hudson",
            "Hudsonville",
            "Hulbert",
            "Huntington Woods",
            "Ida",
            "Idlewild",
            "Imlay City",
            "Independence",
            "Indian River",
            "Ingalls",
            "Inkster",
            "Interlochen",
            "Ionia",
            "Iron Mountain",
            "Iron River",
            "Irons",
            "Ironwood",
            "Ishpeming",
            "Ithaca",
            "Jackson",
            "Jamestown",
            "Jasper",
            "Jeddo",
            "Jenison",
            "Jerome",
            "Johannesburg",
            "Jones",
            "Jonesville",
            "Kalamazoo",
            "Kaleva",
            "Kalkaska",
            "Kawkawlin",
            "Kearsarge",
            "Keego Harbor",
            "Kendall",
            "Kent City",
            "Kewadin",
            "Kincheloe",
            "Kinde",
            "Kingsford",
            "Kingsley",
            "Kingston",
            "Kinross",
            "La Salle",
            "Lachine",
            "Lacota",
            "Laingsburg",
            "Lake",
            "Lake Ann",
            "Lake City",
            "Lake George",
            "Lake Leelanau",
            "Lake Linden",
            "Lake Odessa",
            "Lake Orion",
            "Lakeland",
            "Lakeside",
            "Lakeview",
            "Lakeville",
            "Lambertville",
            "Lamont",
            "Lanse",
            "Lansing",
            "Lapeer",
            "Lawrence",
            "Lawton",
            "Leland",
            "Lennon",
            "Leonard",
            "Leonidas",
            "Leroy",
            "Leslie",
            "Levering",
            "Lewiston",
            "Lexington",
            "Lincoln",
            "Lincoln Park",
            "Linden",
            "Linwood",
            "Litchfield",
            "Little Lake",
            "Livonia",
            "Long Lake",
            "Loretto",
            "Lowell",
            "Ludington",
            "Luna Pier",
            "Lupton",
            "Luther",
            "Luzerne",
            "Lyndon",
            "Lyons",
            "Macatawa",
            "Mackinac Island",
            "Mackinaw City",
            "Macomb",
            "Madison Heights",
            "Mancelona",
            "Manchester",
            "Manistee",
            "Manistique",
            "Manitou Beach",
            "Manton",
            "Maple City",
            "Maple Rapids",
            "Marcellus",
            "Marenisco",
            "Marine City",
            "Marion",
            "Markey",
            "Marlette",
            "Marne",
            "Marquette",
            "Marshall",
            "Martin",
            "Marysville",
            "Mason",
            "Mass City",
            "Mattawan",
            "Maybee",
            "Mayfield",
            "Mayville",
            "McBain",
            "Mcbrides",
            "McMillan",
            "Mears",
            "Mecosta",
            "Melvin",
            "Melvindale",
            "Memphis",
            "Mendon",
            "Menominee",
            "Merrill",
            "Merritt",
            "Mesick",
            "Metamora",
            "Michigamme",
            "Michigan Center",
            "Middleton",
            "Middleville",
            "Midland",
            "Mikado",
            "Milan",
            "Milford",
            "Millersburg",
            "Millington",
            "Minden City",
            "Mio",
            "Mohawk",
            "Moline",
            "Monroe",
            "Montague",
            "Montgomery",
            "Montrose",
            "Moran",
            "Morenci",
            "Morley",
            "Morrice",
            "Moscow",
            "Mosherville",
            "Mount Clemens",
            "Mount Morris",
            "Mount Pleasant",
            "Muir",
            "Mullett Lake",
            "Mulliken",
            "Munger",
            "Munising",
            "Munith",
            "Muskegon",
            "Nadeau",
            "Nahma",
            "Napoleon",
            "Nashville",
            "National City",
            "National Mine",
            "Naubinway",
            "Nazareth",
            "Negaunee",
            "New Baltimore",
            "New Boston",
            "New Buffalo",
            "New Era",
            "New Haven",
            "New Hudson",
            "New Lothrop",
            "New Troy",
            "Newaygo",
            "Newberry",
            "Newkirk",
            "Newport",
            "Niles",
            "Nisula",
            "North Adams",
            "North Branch",
            "North Star",
            "North Street",
            "Northport",
            "Northville",
            "Norvell",
            "Norway",
            "Nottawa",
            "Novi",
            "Nunica",
            "Oak Grove",
            "Oak Park",
            "Oakland",
            "Oakley",
            "Oden",
            "Okemos",
            "Old Mission",
            "Olivet",
            "Omena",
            "Omer",
            "Onaway",
            "Onekama",
            "Onondaga",
            "Onsted",
            "Ontonagon",
            "Orleans",
            "Ortonville",
            "Oscoda",
            "Oshtemo",
            "Osseo",
            "Ossineke",
            "Otisville",
            "Otsego",
            "Ottawa Lake",
            "Otter Lake",
            "Ovid",
            "Owendale",
            "Owosso",
            "Oxford",
            "Painesdale",
            "Palmer",
            "Palms",
            "Palmyra",
            "Palo",
            "Paradise",
            "Paris",
            "Parma",
            "Paw Paw",
            "Peck",
            "Pelkie",
            "Pellston",
            "Pentwater",
            "Perkins",
            "Perrinton",
            "Perronville",
            "Perry",
            "Petersburg",
            "Petoskey",
            "Pewamo",
            "Pickford",
            "Pierson",
            "Pigeon",
            "Pinckney",
            "Pinconning",
            "Pittsford",
            "Plainwell",
            "Pleasant Lake",
            "Pleasant Ridge",
            "Plymouth",
            "Pointe Aux Pins",
            "Pompeii",
            "Pontiac",
            "Port Austin",
            "Port Hope",
            "Port Huron",
            "Port Sanilac",
            "Portage",
            "Portland",
            "Posen",
            "Potterville",
            "Powers",
            "Prescott",
            "Presque Isle",
            "Prudenville",
            "Pullman",
            "Quincy",
            "Quinnesec",
            "Ralph",
            "Ramsay",
            "Rapid City",
            "Rapid River",
            "Ravenna",
            "Ray",
            "Reading",
            "Redford",
            "Reed City",
            "Reese",
            "Remus",
            "Republic",
            "Rhodes",
            "Richland",
            "Richmond",
            "Richville",
            "Ridgeway",
            "Riga",
            "River Rouge",
            "Riverdale",
            "Riverside",
            "Rives Junction",
            "Rochester",
            "Rock",
            "Rockford",
            "Rockland",
            "Rockwood",
            "Rodney",
            "Rogers City",
            "Rollin",
            "Romeo",
            "Romulus",
            "Roscommon",
            "Rose",
            "Rose City",
            "Rosebush",
            "Roseville",
            "Rothbury",
            "Royal Oak",
            "Rudyard",
            "Rumely",
            "Ruth",
            "Saginaw",
            "Sagola",
            "Saint Charles",
            "Saint Clair",
            "Saint Clair Shores",
            "Saint Helen",
            "Saint Ignace",
            "Saint Johns",
            "Saint Joseph",
            "Saint Louis",
            "Salem",
            "Saline",
            "Samaria",
            "Sand Creek",
            "Sand Lake",
            "Sandusky",
            "Sanford",
            "Saranac",
            "Saugatuck",
            "Sault Sainte Marie",
            "Sawyer",
            "Schoolcraft",
            "Sciota",
            "Scotts",
            "Scottville",
            "Sears",
            "Sebewaing",
            "Seneca",
            "Seney",
            "Shaftsburg",
            "Shelby",
            "Shelbyville",
            "Shepherd",
            "Sheridan",
            "Sherwood",
            "Shingleton",
            "Sidnaw",
            "Sidney",
            "Silverwood",
            "Six Lakes",
            "Skandia",
            "Skanee",
            "Slagle",
            "Smiths Creek",
            "Smyrna",
            "Snover",
            "Sodus",
            "Somerset",
            "Somerset Center",
            "South Boardman",
            "South Branch",
            "South Haven",
            "South Lyon",
            "South Monroe",
            "South Range",
            "South Rockwood",
            "Southfield",
            "Southgate",
            "Spalding",
            "Sparta",
            "Spring Arbor",
            "Spring Lake",
            "Springport",
            "Spruce",
            "Stambaugh",
            "Standish",
            "Stanton",
            "Stanwood",
            "Stephenson",
            "Sterling",
            "Sterling Heights",
            "Stevensville",
            "Stockbridge",
            "Strongs",
            "Sturgis",
            "Sumner",
            "Sunfield",
            "Suttons Bay",
            "Swartz Creek",
            "Tawas City",
            "Taylor",
            "Tecumseh",
            "Tekonsha",
            "Temperance",
            "Thompsonville",
            "Three Oaks",
            "Three Rivers",
            "Tipton",
            "Toivola",
            "Topinabee",
            "Tower",
            "Traverse City",
            "Trenary",
            "Trenton",
            "Trout Creek",
            "Trout Lake",
            "Troy",
            "Trufant",
            "Turner",
            "Tuscola",
            "Tustin",
            "Twin Lake",
            "Twining",
            "Ubly",
            "Union",
            "Union City",
            "Union Lake",
            "Union Pier",
            "Unionville",
            "University Center",
            "Utica",
            "Vandalia",
            "Vanderbilt",
            "Vassar",
            "Vermontville",
            "Vernon",
            "Vestaburg",
            "Vicksburg",
            "Vulcan",
            "Wabaningo",
            "Wakefield",
            "Waldron",
            "Walhalla",
            "Walkerville",
            "Wallace",
            "Walled Lake",
            "Walloon Lake",
            "Warren",
            "Washington",
            "Waterford",
            "Waters",
            "Watersmeet",
            "Watervliet",
            "Watton",
            "Wayland",
            "Wayne",
            "Webberville",
            "Weidman",
            "Wells",
            "Wellston",
            "West Bloomfield",
            "West Branch",
            "West Olive",
            "Westland",
            "Weston",
            "Westphalia",
            "Wetmore",
            "Wheeler",
            "White Cloud",
            "White Lake",
            "White Pigeon",
            "White Pine",
            "Whitehall",
            "Whitewater",
            "Whitmore Lake",
            "Whittaker",
            "Whittemore",
            "Williamsburg",
            "Williamston",
            "Willis",
            "Wilson",
            "Winn",
            "Wixom",
            "Wolverine",
            "Woodland",
            "Wyandotte",
            "Yale",
            "Yates",
            "Ypsilanti",
            "Zeeland"
        ]
    },
    {
        "state": "Minnesota",
        "abbr": "MN",
        "cities": [
            "Acton",
            "Ada",
            "Adams",
            "Adolph",
            "Adrian",
            "Afton",
            "Ah Gwah Ching",
            "Aitkin",
            "Akeley",
            "Albany",
            "Albert Lea",
            "Alberta",
            "Albertville",
            "Alborn",
            "Alden",
            "Aldrich",
            "Alexandria",
            "Almelund",
            "Alpha",
            "Altura",
            "Alvarado",
            "Amboy",
            "Andover",
            "Angle Inlet",
            "Angora",
            "Angus",
            "Annandale",
            "Anoka",
            "Appleton",
            "Arco",
            "Argyle",
            "Arlington",
            "Ashby",
            "Askov",
            "Atwater",
            "Audubon",
            "Aurora",
            "Austin",
            "Avoca",
            "Avon",
            "Babbitt",
            "Backus",
            "Badger",
            "Bagley",
            "Baker",
            "Balaton",
            "Barnesville",
            "Barnum",
            "Barrett",
            "Barry",
            "Battle Lake",
            "Baudette",
            "Baxter",
            "Bayport",
            "Beardsley",
            "Beaver Bay",
            "Beaver Creek",
            "Becker",
            "Bejou",
            "Belgrade",
            "Belle Plaine",
            "Bellingham",
            "Beltrami",
            "Belview",
            "Bemidji",
            "Bena",
            "Benedict",
            "Benson",
            "Bertha",
            "Bethel",
            "Big Falls",
            "Big Lake",
            "Bigelow",
            "Bigfork",
            "Bingham Lake",
            "Birchdale",
            "Bird Island",
            "Biwabik",
            "Blackduck",
            "Blomkest",
            "Blooming Prairie",
            "Blue Earth",
            "Bluffton",
            "Bock",
            "Borup",
            "Bovey",
            "Bowlus",
            "Bowstring",
            "Boyd",
            "Braham",
            "Brainerd",
            "Brandon",
            "Breckenridge",
            "Brewster",
            "Bricelyn",
            "Brimson",
            "Britt",
            "Brook Park",
            "Brooks",
            "Brookston",
            "Brooten",
            "Browerville",
            "Browns Valley",
            "Brownsdale",
            "Brownsville",
            "Brownton",
            "Bruno",
            "Buckman",
            "Buffalo",
            "Buffalo Lake",
            "Buhl",
            "Burnsville",
            "Burtrum",
            "Butterfield",
            "Byron",
            "Caledonia",
            "Callaway",
            "Calumet",
            "Cambridge",
            "Campbell",
            "Canby",
            "Cannon Falls",
            "Canton",
            "Canyon",
            "Carlos",
            "Carlton",
            "Carver",
            "Cass Lake",
            "Castle Rock",
            "Cedar",
            "Center City",
            "Ceylon",
            "Champlin",
            "Chandler",
            "Chanhassen",
            "Chaska",
            "Chatfield",
            "Chisago City",
            "Chisholm",
            "Chokio",
            "Circle Pines",
            "Clara City",
            "Claremont",
            "Clarissa",
            "Clark",
            "Clarkfield",
            "Clarks Grove",
            "Clear Lake",
            "Clearbrook",
            "Clearwater",
            "Clements",
            "Cleveland",
            "Climax",
            "Clinton",
            "Clitherall",
            "Clontarf",
            "Cloquet",
            "Cohasset",
            "Cokato",
            "Cold Spring",
            "Coleraine",
            "Collegeville",
            "Cologne",
            "Comfrey",
            "Comstock",
            "Conger",
            "Cook",
            "Correll",
            "Cosmos",
            "Cottage Grove",
            "Cotton",
            "Cottonwood",
            "Courtland",
            "Crane Lake",
            "Cromwell",
            "Crookston",
            "Crosby",
            "Crosslake",
            "Crystal Bay",
            "Currie",
            "Cushing",
            "Cyrus",
            "Dakota",
            "Dalbo",
            "Dalton",
            "Danube",
            "Danvers",
            "Darfur",
            "Darwin",
            "Dassel",
            "Dawson",
            "Dayton",
            "Deer Creek",
            "Deer River",
            "Deerwood",
            "Delano",
            "Delavan",
            "Dennison",
            "Dent",
            "Detroit Lakes",
            "Dexter",
            "Dilworth",
            "Dodge Center",
            "Donaldson",
            "Donnelly",
            "Dover",
            "Dovray",
            "Duluth",
            "Dumont",
            "Dundas",
            "Dunnell",
            "Eagle Bend",
            "Eagle Lake",
            "East Grand Forks",
            "Easton",
            "Echo",
            "Eden Prairie",
            "Eden Valley",
            "Edgerton",
            "Effie",
            "Eitzen",
            "Elbow Lake",
            "Elgin",
            "Elizabeth",
            "Elk River",
            "Elko",
            "Elkton",
            "Ellendale",
            "Elrosa",
            "Ely",
            "Elysian",
            "Embarrass",
            "Emily",
            "Emmons",
            "Erhard",
            "Erskine",
            "Esko",
            "Essig",
            "Euclid",
            "Evansville",
            "Eveleth",
            "Excelsior",
            "Eyota",
            "Fairfax",
            "Fairmont",
            "Faribault",
            "Farmington",
            "Farwell",
            "Federal Dam",
            "Felton",
            "Fergus Falls",
            "Fertile",
            "Fifty Lakes",
            "Finland",
            "Finlayson",
            "Fisher",
            "Fleming",
            "Flensburg",
            "Flom",
            "Floodwood",
            "Florence",
            "Foley",
            "Forbes",
            "Forest Lake",
            "Foreston",
            "Fort Ripley",
            "Fosston",
            "Fountain",
            "Foxhome",
            "Franklin",
            "Frazee",
            "Freeborn",
            "Freeport",
            "Frontenac",
            "Frost",
            "Fulda",
            "Garden City",
            "Garfield",
            "Garrison",
            "Garvin",
            "Gary",
            "Gatzke",
            "Gaylord",
            "Geneva",
            "Georgetown",
            "Ghent",
            "Gibbon",
            "Gilbert",
            "Gilman",
            "Glencoe",
            "Glenville",
            "Glenwood",
            "Glyndon",
            "Gonvick",
            "Good Thunder",
            "Goodhue",
            "Goodland",
            "Goodridge",
            "Graceville",
            "Graham Lakes",
            "Granada",
            "Grand Marais",
            "Grand Meadow",
            "Grand Portage",
            "Grand Rapids",
            "Grandy",
            "Granite Falls",
            "Grasston",
            "Green Isle",
            "Greenbush",
            "Greenwald",
            "Grey Eagle",
            "Grove City",
            "Grygla",
            "Gully",
            "Hackensack",
            "Hallock",
            "Halma",
            "Halstad",
            "Hamburg",
            "Hamel",
            "Hampton",
            "Hancock",
            "Hanley Falls",
            "Hanover",
            "Hanska",
            "Hardwick",
            "Harmony",
            "Harris",
            "Hartland",
            "Hastings",
            "Hawick",
            "Hawley",
            "Hayfield",
            "Hayward",
            "Hector",
            "Henderson",
            "Hendricks",
            "Hendrum",
            "Henning",
            "Henriette",
            "Herman",
            "Heron Lake",
            "Hewitt",
            "Hibbing",
            "Hill City",
            "Hillman",
            "Hills",
            "Hinckley",
            "Hines",
            "Hitterdal",
            "Hoffman",
            "Hokah",
            "Holdingford",
            "Holland",
            "Hollandale",
            "Holloway",
            "Holmes City",
            "Holyoke",
            "Homer",
            "Hope",
            "Hopkins",
            "Houston",
            "Hovland",
            "Howard Lake",
            "Hoyt Lakes",
            "Hugo",
            "Humboldt",
            "Huntley",
            "Hutchinson",
            "Ihlen",
            "International Falls",
            "Inver Grove Heights",
            "Iona",
            "Iron",
            "Ironton",
            "Isabella",
            "Isanti",
            "Isle",
            "Itasca",
            "Ivanhoe",
            "Jackson",
            "Jacobson",
            "Janesville",
            "Jasper",
            "Jeffers",
            "Jenkins",
            "Jordan",
            "Kanaranzi",
            "Kandiyohi",
            "Karlstad",
            "Kasota",
            "Kasson",
            "Keewatin",
            "Kelliher",
            "Kellogg",
            "Kennedy",
            "Kenneth",
            "Kensington",
            "Kent",
            "Kenyon",
            "Kerkhoven",
            "Kerrick",
            "Kettle River",
            "Kiester",
            "Kilkenny",
            "Kimball",
            "Kinney",
            "Knife River",
            "Kroschel",
            "La Crescent",
            "La Salle",
            "Lafayette",
            "Lake Benton",
            "Lake Bronson",
            "Lake City",
            "Lake Crystal",
            "Lake Elmo",
            "Lake Eunice",
            "Lake George",
            "Lake Hubert",
            "Lake Lillian",
            "Lake Park",
            "Lake Wilson",
            "Lakefield",
            "Lakeland",
            "Lakeville",
            "Lamberton",
            "Lancaster",
            "Lanesboro",
            "Lansing",
            "Laporte",
            "Lastrup",
            "Le Center",
            "Le Roy",
            "Le Sueur",
            "Lengby",
            "Leonard",
            "Leota",
            "Lester Prairie",
            "Lewiston",
            "Lewisville",
            "Lindstrom",
            "Lismore",
            "Litchfield",
            "Little Falls",
            "Littlefork",
            "Loman",
            "Long Lake",
            "Long Prairie",
            "Longville",
            "Lonsdale",
            "Loretto",
            "Lowry",
            "Lucan",
            "Lutsen",
            "Luverne",
            "Lyle",
            "Lynd",
            "Madelia",
            "Madison",
            "Madison Lake",
            "Magnolia",
            "Mahnomen",
            "Makinen",
            "Manchester",
            "Mankato",
            "Mantorville",
            "Maple Lake",
            "Maple Plain",
            "Mapleton",
            "Marble",
            "Marcell",
            "Margie",
            "Marietta",
            "Marine On Saint Croix",
            "Marshall",
            "Max",
            "Mayer",
            "Maynard",
            "Mazeppa",
            "McGrath",
            "Mcgregor",
            "Mcintosh",
            "McKinley",
            "Meadowlands",
            "Medford",
            "Melrose",
            "Melrude",
            "Menahga",
            "Mendota",
            "Mentor",
            "Merrifield",
            "Middle River",
            "Milaca",
            "Milan",
            "Millville",
            "Milroy",
            "Miltona",
            "Minneapolis",
            "Minneota",
            "Minnesota City",
            "Minnesota Lake",
            "Minnetonka",
            "Minnetonka Beach",
            "Mizpah",
            "Montevideo",
            "Montgomery",
            "Monticello",
            "Montrose",
            "Moorhead",
            "Moose Lake",
            "Mora",
            "Morgan",
            "Morris",
            "Morristown",
            "Morton",
            "Motley",
            "Mound",
            "Mount Morris",
            "Mountain Iron",
            "Mountain Lake",
            "Murdock",
            "Nashua",
            "Nashwauk",
            "Navarre",
            "Naytahwaush",
            "Nelson",
            "Nerstrand",
            "Nett Lake",
            "Nevis",
            "New Auburn",
            "New Germany",
            "New London",
            "New Market",
            "New Munich",
            "New Prague",
            "New Richland",
            "New Ulm",
            "New York Mills",
            "Newfolden",
            "Newport",
            "Nicollet",
            "Nielsville",
            "Nimrod",
            "Nisswa",
            "Norcross",
            "North Branch",
            "Northfield",
            "Northome",
            "Northrop",
            "Norwood",
            "Noyes",
            "Oak Island",
            "Oak Park",
            "Oakland",
            "Odessa",
            "Odin",
            "Ogema",
            "Ogilvie",
            "Okabena",
            "Oklee",
            "Olivia",
            "Onamia",
            "Ormsby",
            "Oronoco",
            "Orr",
            "Ortonville",
            "Osage",
            "Osakis",
            "Oslo",
            "Osseo",
            "Ostrander",
            "Ottertail",
            "Outing",
            "Owatonna",
            "Palisade",
            "Park Rapids",
            "Parkers Prairie",
            "Paynesville",
            "Pease",
            "Pelican Rapids",
            "Pemberton",
            "Pengilly",
            "Pennington",
            "Pennock",
            "Pequot Lakes",
            "Perham",
            "Perley",
            "Peterson",
            "Pierz",
            "Pillager",
            "Pine City",
            "Pine Island",
            "Pine River",
            "Pipestone",
            "Plainview",
            "Plato",
            "Plummer",
            "Ponemah",
            "Ponsford",
            "Porter",
            "Powers",
            "Preston",
            "Princeton",
            "Prinsburg",
            "Prior Lake",
            "Puposky",
            "Racine",
            "Randall",
            "Randolph",
            "Ranier",
            "Ray",
            "Raymond",
            "Reading",
            "Reads Landing",
            "Red Lake Falls",
            "Red Wing",
            "Redby",
            "Redlake",
            "Redwood Falls",
            "Remer",
            "Renville",
            "Revere",
            "Rice",
            "Richmond",
            "Richville",
            "Richwood",
            "Rochert",
            "Rochester",
            "Rock Creek",
            "Rockford",
            "Rockville",
            "Rogers",
            "Rollingstone",
            "Roosevelt",
            "Roscoe",
            "Rose Creek",
            "Roseau",
            "Rosemount",
            "Rothsay",
            "Round Lake",
            "Royalton",
            "Rush City",
            "Rushford",
            "Rushmore",
            "Russell",
            "Ruthton",
            "Sabin",
            "Sacred Heart",
            "Saginaw",
            "Saint Bonifacius",
            "Saint Charles",
            "Saint Clair",
            "Saint Cloud",
            "Saint Francis",
            "Saint Hilaire",
            "Saint James",
            "Saint Joseph",
            "Saint Martin",
            "Saint Michael",
            "Saint Paul",
            "Saint Paul Park",
            "Saint Peter",
            "Saint Stephen",
            "Saint Vincent",
            "Salol",
            "Sanborn",
            "Sandstone",
            "Santiago",
            "Sargeant",
            "Sartell",
            "Sauk Centre",
            "Sauk Rapids",
            "Savage",
            "Sawyer",
            "Scandia",
            "Schroeder",
            "Seaforth",
            "Searles",
            "Sebeka",
            "Shafer",
            "Shakopee",
            "Shelly",
            "Sherburn",
            "Shevlin",
            "Side Lake",
            "Silver Bay",
            "Silver Creek",
            "Silver Lake",
            "Slayton",
            "Sleepy Eye",
            "Solway",
            "Soudan",
            "South Haven",
            "South International Falls",
            "South Saint Paul",
            "Spicer",
            "Spring Grove",
            "Spring Lake",
            "Spring Park",
            "Spring Valley",
            "Springfield",
            "Squaw Lake",
            "St. Leo",
            "Stacy",
            "Stanchfield",
            "Staples",
            "Starbuck",
            "Steen",
            "Stephen",
            "Stewart",
            "Stewartville",
            "Stillwater",
            "Stockton",
            "Storden",
            "Strandquist",
            "Strathcona",
            "Sturgeon Lake",
            "Sunburg",
            "Swan River",
            "Swanville",
            "Swatara",
            "Swift",
            "Taconite",
            "Talmoon",
            "Tamarack",
            "Taopi",
            "Taunton",
            "Taylors Falls",
            "Tenstrike",
            "Thief River Falls",
            "Tintah",
            "Tofte",
            "Tower",
            "Tracy",
            "Trail",
            "Trimont",
            "Trosky",
            "Truman",
            "Twig",
            "Twin Lakes",
            "Twin Valley",
            "Two Harbors",
            "Tyler",
            "Ulen",
            "Underwood",
            "Upsala",
            "Utica",
            "Vergas",
            "Vermillion",
            "Verndale",
            "Vernon Center",
            "Vesta",
            "Victoria",
            "Viking",
            "Villard",
            "Vining",
            "Virginia",
            "Wabasha",
            "Wabasso",
            "Waconia",
            "Wadena",
            "Wahkon",
            "Waite Park",
            "Waldorf",
            "Walker",
            "Walnut Grove",
            "Waltham",
            "Wanamingo",
            "Wanda",
            "Wannaska",
            "Warba",
            "Warren",
            "Warroad",
            "Warsaw",
            "Waseca",
            "Waskish",
            "Watertown",
            "Waterville",
            "Watkins",
            "Watson",
            "Waubun",
            "Waverly",
            "Wayzata",
            "Webster",
            "Welch",
            "Welcome",
            "Wells",
            "Wendell",
            "West Albany",
            "West Concord",
            "West Union",
            "Westbrook",
            "Wheaton",
            "White Earth",
            "Willernie",
            "Williams",
            "Willmar",
            "Willow River",
            "Wilmont",
            "Wilton",
            "Windom",
            "Winger",
            "Winnebago",
            "Winona",
            "Winsted",
            "Winthrop",
            "Winton",
            "Wirt",
            "Wolf Lake",
            "Wolverton",
            "Wood Lake",
            "Woodstock",
            "Worthington",
            "Wrenshall",
            "Wright",
            "Wykoff",
            "Wyoming",
            "Young America",
            "Zimmerman",
            "Zumbro Falls",
            "Zumbrota"
        ]
    },
    {
        "state": "Mississippi",
        "abbr": "MS",
        "cities": [
            "Abbeville",
            "Aberdeen",
            "Ackerman",
            "Algoma",
            "Alligator",
            "Amory",
            "Anguilla",
            "Arcola",
            "Arkabutla",
            "Artesia",
            "Ashland",
            "Avalon",
            "Avon",
            "Bailey",
            "Baldwyn",
            "Banner",
            "Bassfield",
            "Batesville",
            "Bay Saint Louis",
            "Bay Springs",
            "Beaumont",
            "Becker",
            "Belden",
            "Belen",
            "Bellefontaine",
            "Belmont",
            "Belzoni",
            "Benoit",
            "Benton",
            "Bentonia",
            "Beulah",
            "Big Creek",
            "Biloxi",
            "Blue Mountain",
            "Blue Springs",
            "Bogue Chitto",
            "Bolton",
            "Booneville",
            "Boyle",
            "Brandon",
            "Braxton",
            "Brookhaven",
            "Brooklyn",
            "Brooksville",
            "Bruce",
            "Buckatunna",
            "Bude",
            "Burnsville",
            "Byhalia",
            "Caledonia",
            "Calhoun City",
            "Camden",
            "Canton",
            "Carriere",
            "Carrollton",
            "Carson",
            "Carthage",
            "Cary",
            "Cascilla",
            "Cedarbluff",
            "Centreville",
            "Charleston",
            "Chatawa",
            "Chatham",
            "Chunky",
            "Clara",
            "Clarksdale",
            "Cleveland",
            "Clinton",
            "Coahoma",
            "Coffeeville",
            "Coila",
            "Coldwater",
            "Collins",
            "Collinsville",
            "Columbia",
            "Columbus",
            "Como",
            "Conehatta",
            "Corinth",
            "Courtland",
            "Crawford",
            "Crenshaw",
            "Crosby",
            "Crowder",
            "Cruger",
            "Crystal Springs",
            "D Iberville",
            "D Lo",
            "Daleville",
            "Darling",
            "De Kalb",
            "Decatur",
            "Delta City",
            "Dennis",
            "Derma",
            "Diamondhead",
            "Doddsville",
            "Drew",
            "Dublin",
            "Duck Hill",
            "Dumas",
            "Duncan",
            "Dundee",
            "Durant",
            "Eastabuchie",
            "Ecru",
            "Edwards",
            "Elliott",
            "Ellisville",
            "Enid",
            "Enterprise",
            "Escatawpa",
            "Ethel",
            "Etta",
            "Eupora",
            "Falcon",
            "Falkner",
            "Farrell",
            "Fayette",
            "Fernwood",
            "Flora",
            "Florence",
            "Forest",
            "Foxworth",
            "French Camp",
            "Friars Point",
            "Fulton",
            "Gallman",
            "Gattman",
            "Gautier",
            "Georgetown",
            "Glen",
            "Glen Allan",
            "Glendora",
            "Gloster",
            "Golden",
            "Goodman",
            "Gore Springs",
            "Grace",
            "Greenville",
            "Greenwood",
            "Greenwood Springs",
            "Grenada",
            "Gulfport",
            "Gunnison",
            "Guntown",
            "Hamilton",
            "Harperville",
            "Harriston",
            "Harrisville",
            "Hattiesburg",
            "Hazlehurst",
            "Heidelberg",
            "Hermanville",
            "Hernando",
            "Hickory",
            "Hickory Flat",
            "Hillsboro",
            "Holcomb",
            "Hollandale",
            "Holly Bluff",
            "Holly Ridge",
            "Holly Springs",
            "Horn Lake",
            "Houlka",
            "Houston",
            "Hurley",
            "Independence",
            "Indianola",
            "Inverness",
            "Isola",
            "Itta Bena",
            "Jackson",
            "Jayess",
            "Jonestown",
            "Kilmichael",
            "Kiln",
            "Kokomo",
            "Kosciusko",
            "Lake",
            "Lake Cormorant",
            "Lakeshore",
            "Lamar",
            "Lambert",
            "Lauderdale",
            "Laurel",
            "Lawrence",
            "Leakesville",
            "Leland",
            "Lena",
            "Lexington",
            "Liberty",
            "Little Rock",
            "Long Beach",
            "Lorman",
            "Louin",
            "Louise",
            "Louisville",
            "Lucedale",
            "Ludlow",
            "Lula",
            "Lumberton",
            "Lyon",
            "Maben",
            "Macon",
            "Madden",
            "Madison",
            "Magee",
            "Magnolia",
            "Mantachie",
            "Mantee",
            "Marietta",
            "Marion",
            "Marks",
            "Mathiston",
            "Mattson",
            "Mayersville",
            "Mayhew",
            "McAdams",
            "McCall Creek",
            "McCarley",
            "Mccomb",
            "McCondy",
            "McCool",
            "McHenry",
            "McLain",
            "McNeill",
            "Meadville",
            "Mendenhall",
            "Meridian",
            "Merigold",
            "Metcalfe",
            "Michigan City",
            "Midnight",
            "Minter City",
            "Mississippi State",
            "Mize",
            "Money",
            "Monticello",
            "Montpelier",
            "Mooreville",
            "Moorhead",
            "Morgan City",
            "Morton",
            "Moselle",
            "Moss",
            "Moss Point",
            "Mound Bayou",
            "Mount Olive",
            "Mount Pleasant",
            "Myrtle",
            "Natchez",
            "Neely",
            "Nesbit",
            "Nettleton",
            "New Albany",
            "New Augusta",
            "New Site",
            "Newhebron",
            "Newton",
            "Nicholson",
            "Nitta Yuma",
            "North Carrollton",
            "Noxapater",
            "Oak Vale",
            "Oakland",
            "Ocean Springs",
            "Okolona",
            "Olive Branch",
            "Osyka",
            "Ovett",
            "Oxford",
            "Pace",
            "Pachuta",
            "Panther Burn",
            "Parchman",
            "Paris",
            "Pascagoula",
            "Pass Christian",
            "Pattison",
            "Paulding",
            "Pearlington",
            "Pelahatchie",
            "Perkinston",
            "Petal",
            "Pheba",
            "Philadelphia",
            "Philipp",
            "Picayune",
            "Pickens",
            "Piney Woods",
            "Pinola",
            "Pittsboro",
            "Plantersville",
            "Pocahontas",
            "Pontotoc",
            "Pope",
            "Poplarville",
            "Port Gibson",
            "Porterville",
            "Potts Camp",
            "Prairie",
            "Prentiss",
            "Preston",
            "Puckett",
            "Pulaski",
            "Purvis",
            "Quitman",
            "Raleigh",
            "Randolph",
            "Raymond",
            "Red Banks",
            "Redwood",
            "Rena Lara",
            "Richton",
            "Ridgeland",
            "Rienzi",
            "Ripley",
            "Robinsonville",
            "Rolling Fork",
            "Rome",
            "Rose Hill",
            "Rosedale",
            "Roxie",
            "Ruleville",
            "Ruth",
            "Sallis",
            "Saltillo",
            "Sanatorium",
            "Sandersville",
            "Sandhill",
            "Sandy Hook",
            "Sarah",
            "Sardis",
            "Satartia",
            "Saucier",
            "Schlater",
            "Scobey",
            "Scooba",
            "Scott",
            "Sebastopol",
            "Seminary",
            "Senatobia",
            "Shannon",
            "Sharon",
            "Shaw",
            "Shelby",
            "Sherard",
            "Sherman",
            "Shubuta",
            "Shuqualak",
            "Sibley",
            "Sidon",
            "Silver City",
            "Silver Creek",
            "Slate Spring",
            "Sledge",
            "Smithdale",
            "Smithville",
            "Sontag",
            "Soso",
            "Southaven",
            "Star",
            "Starkville",
            "State Line",
            "Steens",
            "Stennis Space Center",
            "Stewart",
            "Stoneville",
            "Stonewall",
            "Stringer",
            "Sturgis",
            "Summit",
            "Sumner",
            "Sumrall",
            "Sunflower",
            "Swan Lake",
            "Swiftown",
            "Taylor",
            "Taylorsville",
            "Tchula",
            "Terry",
            "Thaxton",
            "Thomastown",
            "Tie Plant",
            "Tillatoba",
            "Tinsley",
            "Tiplersville",
            "Tippo",
            "Tishomingo",
            "Toccopola",
            "Toomsuba",
            "Tougaloo",
            "Trebloc",
            "Tremont",
            "Tula",
            "Tunica",
            "Tupelo",
            "Tutwiler",
            "Tylertown",
            "Union",
            "Union Church",
            "University",
            "Utica",
            "Vaiden",
            "Valley Park",
            "Van Vleet",
            "Vance",
            "Vardaman",
            "Vaughan",
            "Verona",
            "Vicksburg",
            "Victoria",
            "Vossburg",
            "Walls",
            "Walnut",
            "Walnut Grove",
            "Walthall",
            "Washington",
            "Water Valley",
            "Waterford",
            "Waveland",
            "Waynesboro",
            "Wayside",
            "Webb",
            "Weir",
            "Wesson",
            "West",
            "West Point",
            "Wheeler",
            "Whitfield",
            "Wiggins",
            "Winona",
            "Winstonville",
            "Winterville",
            "Woodland",
            "Woodville",
            "Yazoo City"
        ]
    },
    {
        "state": "Missouri",
        "abbr": "MO",
        "cities": [
            "Adrian",
            "Advance",
            "Agency",
            "Alba",
            "Albany",
            "Aldrich",
            "Alexandria",
            "Allendale",
            "Allenton",
            "Alma",
            "Altamont",
            "Altenburg",
            "Alton",
            "Amazonia",
            "Amity",
            "Amoret",
            "Amsterdam",
            "Anabel",
            "Anderson",
            "Annada",
            "Annapolis",
            "Anniston",
            "Appleton City",
            "Arbela",
            "Arbyrd",
            "Arcadia",
            "Archie",
            "Arcola",
            "Argyle",
            "Armstrong",
            "Arnold",
            "Arrow Rock",
            "Asbury",
            "Ash Grove",
            "Ashburn",
            "Ashland",
            "Atlanta",
            "Augusta",
            "Aurora",
            "Auxvasse",
            "Ava",
            "Avilla",
            "Bakersfield",
            "Ballwin",
            "Baring",
            "Barnard",
            "Barnett",
            "Barnhart",
            "Bates City",
            "Beaufort",
            "Belgrade",
            "Bell City",
            "Belle",
            "Belleview",
            "Bellflower",
            "Belton",
            "Bendavis",
            "Benton",
            "Benton City",
            "Berger",
            "Bernie",
            "Bertrand",
            "Bethany",
            "Bethel",
            "Beulah",
            "Bevier",
            "Billings",
            "Birch Tree",
            "Bismarck",
            "Bixby",
            "Black",
            "Blackburn",
            "Blackwater",
            "Blackwell",
            "Blairstown",
            "Bland",
            "Blodgett",
            "Bloomfield",
            "Bloomsdale",
            "Blue Eye",
            "Blue Mound",
            "Blue Springs",
            "Blythedale",
            "Bogard",
            "Bois D Arc",
            "Bolckow",
            "Bolivar",
            "Bonne Terre",
            "Bonnots Mill",
            "Boonville",
            "Boss",
            "Bosworth",
            "Bourbon",
            "Bowling Green",
            "Bradleyville",
            "Bragg City",
            "Braggadocio",
            "Brandsville",
            "Branson",
            "Brashear",
            "Braymer",
            "Brazeau",
            "Breckenridge",
            "Briar",
            "Bridgeton",
            "Brighton",
            "Brinktown",
            "Brixey",
            "Bronaugh",
            "Brookfield",
            "Brookline Station",
            "Broseley",
            "Browning",
            "Brownwood",
            "Brumley",
            "Bruner",
            "Brunswick",
            "Bucklin",
            "Buckner",
            "Bucyrus",
            "Buffalo",
            "Bunceton",
            "Bunker",
            "Burfordville",
            "Burlington Junction",
            "Butler",
            "Butterfield",
            "Cabool",
            "Cadet",
            "Cainsville",
            "Cairo",
            "Caledonia",
            "Calhoun",
            "California",
            "Callao",
            "Camden",
            "Camden Point",
            "Camdenton",
            "Cameron",
            "Campbell",
            "Canalou",
            "Canton",
            "Cape Fair",
            "Cape Girardeau",
            "Caplinger Mills",
            "Cardwell",
            "Carl Junction",
            "Carrollton",
            "Carterville",
            "Carthage",
            "Caruthersville",
            "Cascade",
            "Cassville",
            "Catawissa",
            "Catron",
            "Caulfield",
            "Cedar City",
            "Cedar Hill",
            "Cedarcreek",
            "Center",
            "Centertown",
            "Centerview",
            "Centerville",
            "Centralia",
            "Chadwick",
            "Chaffee",
            "Chamois",
            "Charleston",
            "Cherryville",
            "Chesterfield",
            "Chestnutridge",
            "Chilhowee",
            "Chillicothe",
            "Chula",
            "Clarence",
            "Clark",
            "Clarksburg",
            "Clarksdale",
            "Clarksville",
            "Clarkton",
            "Clay",
            "Clearmont",
            "Cleveland",
            "Clever",
            "Clifton Hill",
            "Climax Springs",
            "Clinton",
            "Clubb",
            "Clyde",
            "Coatsville",
            "Coffey",
            "Cole Camp",
            "Collins",
            "Columbia",
            "Commerce",
            "Conception",
            "Conception Junction",
            "Concordia",
            "Conran",
            "Conway",
            "Cook Station",
            "Cooter",
            "Corder",
            "Cosby",
            "Cottleville",
            "Couch",
            "Cowgill",
            "Craig",
            "Crane",
            "Creighton",
            "Crocker",
            "Cross Timbers",
            "Crystal City",
            "Cuba",
            "Curryville",
            "Dadeville",
            "Daisy",
            "Dalton",
            "Darlington",
            "Davisville",
            "Dawn",
            "De Kalb",
            "De Soto",
            "De Witt",
            "Dearborn",
            "Deepwater",
            "Deerfield",
            "Deering",
            "Defiance",
            "Delta",
            "Denver",
            "Des Arc",
            "Devils Elbow",
            "Dexter",
            "Diamond",
            "Diggins",
            "Dittmer",
            "Dixon",
            "Doe Run",
            "Doniphan",
            "Dora",
            "Dover",
            "Downing",
            "Drexel",
            "Drury",
            "Dudley",
            "Duenweg",
            "Duke",
            "Dunnegan",
            "Durham",
            "Dutchtown",
            "Dutzow",
            "Eagle Rock",
            "Eagleville",
            "Earth City",
            "East Lynne",
            "East Prairie",
            "Easton",
            "Edgar Springs",
            "Edgerton",
            "Edina",
            "Edwards",
            "El Dorado Springs",
            "Eldon",
            "Eldridge",
            "Elk Creek",
            "Elkland",
            "Ellington",
            "Ellsinore",
            "Elmer",
            "Elmo",
            "Elsberry",
            "Emden",
            "Eminence",
            "Emma",
            "Eolia",
            "Essex",
            "Ethel",
            "Etterville",
            "Eudora",
            "Eugene",
            "Eunice",
            "Eureka",
            "Everton",
            "Ewing",
            "Excello",
            "Excelsior Springs",
            "Exeter",
            "Fagus",
            "Fair Grove",
            "Fair Play",
            "Fairdealing",
            "Fairfax",
            "Fairport",
            "Fairview",
            "Falcon",
            "Farber",
            "Farley",
            "Farmington",
            "Farrar",
            "Faucett",
            "Fayette",
            "Fenton",
            "Festus",
            "Fillmore",
            "Fisk",
            "Flemington",
            "Fletcher",
            "Flinthill",
            "Florence",
            "Florissant",
            "Foley",
            "Fordland",
            "Forest City",
            "Foristell",
            "Forsyth",
            "Fort Leonard Wood",
            "Fortuna",
            "Foster",
            "Frankford",
            "Franklin",
            "Fredericktown",
            "Freeburg",
            "Freeman",
            "Freistatt",
            "Fremont",
            "French Village",
            "Friedheim",
            "Frohna",
            "Fulton",
            "Gainesville",
            "Galena",
            "Gallatin",
            "Galt",
            "Garden City",
            "Garrison",
            "Gasconade",
            "Gatewood",
            "Gentry",
            "Gerald",
            "Gibbs",
            "Gibson",
            "Gideon",
            "Gilliam",
            "Gilman City",
            "Gipsy",
            "Glasgow",
            "Glenallen",
            "Glencoe",
            "Glenwood",
            "Glover",
            "Gobler",
            "Golden",
            "Golden City",
            "Goodman",
            "Goodson",
            "Gordonville",
            "Gorin",
            "Gower",
            "Graff",
            "Graham",
            "Grain Valley",
            "Granby",
            "Grandin",
            "Grandview",
            "Granger",
            "Grant City",
            "Grassy",
            "Gravois Mills",
            "Gray Summit",
            "Grayridge",
            "Green Castle",
            "Green City",
            "Green Ridge",
            "Greenfield",
            "Greentop",
            "Greenville",
            "Greenwood",
            "Grover",
            "Grovespring",
            "Grubville",
            "Guilford",
            "Hale",
            "Half Way",
            "Hallsville",
            "Halltown",
            "Hamilton",
            "Hannibal",
            "Hardenville",
            "Hardin",
            "Harris",
            "Harrisburg",
            "Harrisonville",
            "Hartsburg",
            "Hartshorn",
            "Hartville",
            "Harviell",
            "Harwood",
            "Hatfield",
            "Hawk Point",
            "Hayti",
            "Hazelwood",
            "Helena",
            "Hematite",
            "Henley",
            "Henrietta",
            "Herculaneum",
            "Hermann",
            "Hermitage",
            "Higbee",
            "Higginsville",
            "High Hill",
            "High Point",
            "High Ridge",
            "Highlandville",
            "Hillsboro",
            "Hiram",
            "Holcomb",
            "Holden",
            "Holland",
            "Holliday",
            "Hollister",
            "Holt",
            "Holts Summit",
            "Hopkins",
            "Hornersville",
            "Horton",
            "House Springs",
            "Houston",
            "Houstonia",
            "Huggins",
            "Hughesville",
            "Humansville",
            "Hume",
            "Humphreys",
            "Hunnewell",
            "Huntsville",
            "Hurdland",
            "Hurley",
            "Iberia",
            "Imperial",
            "Independence",
            "Ionia",
            "Irondale",
            "Ironton",
            "Isabella",
            "Jackson",
            "Jacksonville",
            "Jadwin",
            "Jameson",
            "Jamesport",
            "Jamestown",
            "Jasper",
            "Jefferson City",
            "Jerico Springs",
            "Jerome",
            "Jonesburg",
            "Joplin",
            "Kahoka",
            "Kaiser",
            "Kansas City",
            "Kearney",
            "Kelso",
            "Kennett",
            "Kewanee",
            "Keytesville",
            "Kidder",
            "Kimberling City",
            "Kimmswick",
            "King City",
            "Kingdom City",
            "Kingston",
            "Kingsville",
            "Kirbyville",
            "Kirksville",
            "Kissee Mills",
            "Knob Lick",
            "Knob Noster",
            "Knox City",
            "Koeltztown",
            "Koshkonong",
            "La Belle",
            "La Grange",
            "La Monte",
            "La Plata",
            "La Russell",
            "Labadie",
            "Laclede",
            "Laddonia",
            "Lake Ozark",
            "Lake Saint Louis",
            "Lake Spring",
            "Lamar",
            "Lampe",
            "Lanagan",
            "Lancaster",
            "Laquey",
            "Laredo",
            "Latham",
            "Lathrop",
            "Laurie",
            "Lawson",
            "Leadwood",
            "Leasburg",
            "Lebanon",
            "Lecoma",
            "Lee's Summit",
            "Leeton",
            "Lenox",
            "Lentner",
            "Leonard",
            "Leopold",
            "Leslie",
            "Lesterville",
            "Levasy",
            "Lewistown",
            "Lexington",
            "Liberal",
            "Liberty",
            "Licking",
            "Liguori",
            "Lilbourn",
            "Lincoln",
            "Linn",
            "Linn Creek",
            "Linneus",
            "Livonia",
            "Lock Springs",
            "Lockwood",
            "Lodi",
            "Lohman",
            "Lone Jack",
            "Lonedell",
            "Long Lane",
            "Loose Creek",
            "Louisburg",
            "Louisiana",
            "Lowndes",
            "Lowry City",
            "Lucerne",
            "Ludlow",
            "Luebbering",
            "Luray",
            "Lynchburg",
            "Macks Creek",
            "Macomb",
            "Macon",
            "Madison",
            "Maitland",
            "Malden",
            "Malta Bend",
            "Mansfield",
            "Mapaville",
            "Marble Hill",
            "Marceline",
            "Marionville",
            "Marquand",
            "Marshall",
            "Marshfield",
            "Marston",
            "Marthasville",
            "Martinsburg",
            "Martinsville",
            "Maryland Heights",
            "Maryville",
            "Matthews",
            "Maysville",
            "Mayview",
            "Maywood",
            "McBride",
            "McClurg",
            "McFall",
            "McGee",
            "McGirk",
            "Meadville",
            "Memphis",
            "Mendon",
            "Mercer",
            "Meta",
            "Metz",
            "Mexico",
            "Miami",
            "Mid Missouri",
            "Middle Brook",
            "Middletown",
            "Milan",
            "Milford",
            "Mill Spring",
            "Miller",
            "Millersville",
            "Milo",
            "Mindenmines",
            "Mineral Point",
            "Missouri City",
            "Moberly",
            "Mokane",
            "Monett",
            "Monroe City",
            "Montgomery City",
            "Monticello",
            "Montier",
            "Montreal",
            "Montrose",
            "Moody",
            "Mooresville",
            "Mora",
            "Morehouse",
            "Morley",
            "Morris",
            "Morrison",
            "Morrisville",
            "Morse Mill",
            "Mosby",
            "Moscow Mills",
            "Mound City",
            "Moundville",
            "Mount Moriah",
            "Mount Sterling",
            "Mount Vernon",
            "Mountain Grove",
            "Mountain View",
            "Myrtle",
            "Napoleon",
            "Naylor",
            "Neck City",
            "Neelyville",
            "Nelson",
            "Neosho",
            "Nevada",
            "New Bloomfield",
            "New Boston",
            "New Cambria",
            "New Florence",
            "New Franklin",
            "New Hampton",
            "New Haven",
            "New London",
            "New Madrid",
            "New Melle",
            "New Offenburg",
            "Newark",
            "Newburg",
            "Newtonia",
            "Newtown",
            "Niangua",
            "Nixa",
            "Noble",
            "Noel",
            "Norborne",
            "Norwood",
            "Novelty",
            "Novinger",
            "O Fallon",
            "Oak Grove",
            "Oak Ridge",
            "Odessa",
            "Old Appleton",
            "Old Monroe",
            "Oldfield",
            "Olean",
            "Olney",
            "Oran",
            "Oregon",
            "Oronogo",
            "Orrick",
            "Osage Beach",
            "Osborn",
            "Osceola",
            "Otterville",
            "Owensville",
            "Oxly",
            "Ozark",
            "Pacific",
            "Painton",
            "Palmyra",
            "Paris",
            "Park Hills",
            "Parma",
            "Parnell",
            "Pascola",
            "Passaic",
            "Patterson",
            "Patton",
            "Pattonsburg",
            "Paynesville",
            "Peace Valley",
            "Peculiar",
            "Perkins",
            "Perry",
            "Perryville",
            "Pevely",
            "Philadelphia",
            "Phillipsburg",
            "Pickering",
            "Piedmont",
            "Pierce City",
            "Pilot Grove",
            "Pilot Knob",
            "Pineville",
            "Pittsburg",
            "Plato",
            "Platte City",
            "Plattsburg",
            "Pleasant Hill",
            "Pleasant Hope",
            "Plevna",
            "Pocahontas",
            "Point Lookout",
            "Polk",
            "Pollock",
            "Polo",
            "Pomona",
            "Ponce De Leon",
            "Pontiac",
            "Poplar Bluff",
            "Portage Des Sioux",
            "Portageville",
            "Portland",
            "Potosi",
            "Pottersville",
            "Powell",
            "Powersite",
            "Powersville",
            "Prairie Home",
            "Preston",
            "Princeton",
            "Purcell",
            "Purdin",
            "Purdy",
            "Puxico",
            "Queen City",
            "Quincy",
            "Quitman",
            "Qulin",
            "Racine",
            "Ravenwood",
            "Raymondville",
            "Raymore",
            "Rayville",
            "Rea",
            "Redford",
            "Reeds",
            "Reeds Spring",
            "Renick",
            "Republic",
            "Revere",
            "Reynolds",
            "Rhineland",
            "Rich Hill",
            "Richards",
            "Richland",
            "Richmond",
            "Richwoods",
            "Ridgedale",
            "Ridgeway",
            "Risco",
            "Riverside",
            "Rives",
            "Roach",
            "Robertsville",
            "Roby",
            "Rocheport",
            "Rock Port",
            "Rockaway Beach",
            "Rockbridge",
            "Rockville",
            "Rocky Comfort",
            "Rocky Mount",
            "Rogersville",
            "Rolla",
            "Rombauer",
            "Roscoe",
            "Rosebud",
            "Rosendale",
            "Rothville",
            "Rueter",
            "Rush Hill",
            "Rushville",
            "Russellville",
            "Rutledge",
            "Saginaw",
            "Saint Albans",
            "Saint Ann",
            "Saint Charles",
            "Saint Clair",
            "Saint Elizabeth",
            "Saint James",
            "Saint Joseph",
            "Saint Louis",
            "Saint Mary",
            "Saint Patrick",
            "Saint Peters",
            "Saint Thomas",
            "Sainte Genevieve",
            "Salem",
            "Salisbury",
            "Santa Fe",
            "Sarcoxie",
            "Savannah",
            "Saverton",
            "Schell City",
            "Scott City",
            "Sedalia",
            "Sedgewickville",
            "Seligman",
            "Senath",
            "Seneca",
            "Seymour",
            "Shelbina",
            "Shelbyville",
            "Sheldon",
            "Shell Knob",
            "Sheridan",
            "Shook",
            "Sibley",
            "Sikeston",
            "Silex",
            "Silva",
            "Skidmore",
            "Slater",
            "Smithton",
            "Smithville",
            "Solo",
            "South Fork",
            "South Greenfield",
            "South West City",
            "Sparta",
            "Spickard",
            "Spokane",
            "Springfield",
            "Squires",
            "St. Robert",
            "Stanberry",
            "Stanton",
            "Stark City",
            "Steedman",
            "Steele",
            "Steelville",
            "Stella",
            "Stet",
            "Stewartsville",
            "Stockton",
            "Stotts City",
            "Stoutland",
            "Stoutsville",
            "Stover",
            "Strafford",
            "Strasburg",
            "Sturdivant",
            "Sturgeon",
            "Success",
            "Sullivan",
            "Summersville",
            "Sumner",
            "Sunrise Beach",
            "Swedeborg",
            "Sweet Springs",
            "Syracuse",
            "Tallapoosa",
            "Taneyville",
            "Tarkio",
            "Taylor",
            "Tebbetts",
            "Tecumseh",
            "Teresita",
            "Thayer",
            "Thompson",
            "Thornfield",
            "Tiff",
            "Tiff City",
            "Tina",
            "Tipton",
            "Treloar",
            "Trenton",
            "Trimble",
            "Triplett",
            "Troy",
            "Truxton",
            "Tunas",
            "Turners",
            "Turney",
            "Tuscumbia",
            "Udall",
            "Ulman",
            "Union",
            "Union Star",
            "Uniontown",
            "Unionville",
            "Urbana",
            "Urich",
            "Utica",
            "Valles Mines",
            "Valley Park",
            "Van Buren",
            "Vandalia",
            "Vanduser",
            "Vanzant",
            "Verona",
            "Versailles",
            "Viburnum",
            "Vichy",
            "Vienna",
            "Villa Ridge",
            "Vista",
            "Vulcan",
            "Waco",
            "Wakenda",
            "Waldron",
            "Walker",
            "Walnut Grove",
            "Walnut Shade",
            "Wappapello",
            "Wardell",
            "Warrensburg",
            "Warrenton",
            "Warsaw",
            "Washburn",
            "Washington",
            "Wasola",
            "Watson",
            "Waverly",
            "Wayland",
            "Waynesville",
            "Weatherby",
            "Weaubleau",
            "Webb City",
            "Wellington",
            "Wellsville",
            "Wentworth",
            "Wentzville",
            "Wesco",
            "West Alton",
            "West Plains",
            "Westboro",
            "Weston",
            "Westphalia",
            "Wheatland",
            "Wheaton",
            "Wheeling",
            "Whiteman Air Force Base",
            "Whiteoak",
            "Whiteside",
            "Whitewater",
            "Willard",
            "Williamsburg",
            "Williamstown",
            "Williamsville",
            "Willow Springs",
            "Windsor",
            "Windyville",
            "Winfield",
            "Winigan",
            "Winona",
            "Winston",
            "Wolf Island",
            "Wooldridge",
            "Worth",
            "Worthington",
            "Wright City",
            "Wyaconda",
            "Wyatt",
            "Yukon",
            "Zalma",
            "Zanoni"
        ]
    },
    {
        "state": "Montana",
        "abbr": "MT",
        "cities": [
            "Absarokee",
            "Acton",
            "Alberton",
            "Alder",
            "Alzada",
            "Anaconda",
            "Angela",
            "Antelope",
            "Arlee",
            "Ashland",
            "Augusta",
            "Avon",
            "Babb",
            "Bainville",
            "Baker",
            "Ballantine",
            "Basin",
            "Bearcreek",
            "Belfry",
            "Belgrade",
            "Belt",
            "Biddle",
            "Big Arm",
            "Big Sandy",
            "Big Sky",
            "Big Timber",
            "Bigfork",
            "Bighorn",
            "Billings",
            "Birney",
            "Black Eagle",
            "Bloomfield",
            "Bonner",
            "Boulder",
            "Box Elder",
            "Boyd",
            "Boyes",
            "Bozeman",
            "Brady",
            "Bridger",
            "Broadus",
            "Broadview",
            "Brockton",
            "Brockway",
            "Browning",
            "Brusett",
            "Buffalo",
            "Busby",
            "Butte",
            "Bynum",
            "Cameron",
            "Canyon Creek",
            "Capitol",
            "Cardwell",
            "Carter",
            "Cascade",
            "Charlo",
            "Chester",
            "Chinook",
            "Choteau",
            "Circle",
            "Clancy",
            "Clinton",
            "Clyde Park",
            "Coffee Creek",
            "Cohagen",
            "Colstrip",
            "Columbia Falls",
            "Columbus",
            "Condon",
            "Conner",
            "Conrad",
            "Cooke City",
            "Coram",
            "Corvallis",
            "Crane",
            "Crow Agency",
            "Culbertson",
            "Custer",
            "Cut Bank",
            "Dagmar",
            "Darby",
            "Dayton",
            "De Borgia",
            "Decker",
            "Deer Lodge",
            "Dell",
            "Denton",
            "Dillon",
            "Divide",
            "Dixon",
            "Dodson",
            "Drummond",
            "Dupuyer",
            "Dutton",
            "East Glacier Park",
            "East Helena",
            "Edgar",
            "Ekalaka",
            "Elliston",
            "Elmo",
            "Emigrant",
            "Ennis",
            "Essex",
            "Ethridge",
            "Eureka",
            "Fairfield",
            "Fairview",
            "Fallon",
            "Fishtail",
            "Flaxville",
            "Florence",
            "Floweree",
            "Forestgrove",
            "Forsyth",
            "Fort Benton",
            "Fort Harrison",
            "Fort Peck",
            "Fort Shaw",
            "Fortine",
            "Four Corners",
            "Frazer",
            "Frenchtown",
            "Froid",
            "Fromberg",
            "Galata",
            "Gallatin Gateway",
            "Gardiner",
            "Garneill",
            "Garrison",
            "Garryowen",
            "Geraldine",
            "Geyser",
            "Gildford",
            "Glasgow",
            "Glen",
            "Glendive",
            "Glentana",
            "Gold Creek",
            "Grantsdale",
            "Grass Range",
            "Great Falls",
            "Greenough",
            "Greycliff",
            "Hall",
            "Hamilton",
            "Hammond",
            "Hardin",
            "Harlem",
            "Harlowton",
            "Harrison",
            "Hathaway",
            "Haugan",
            "Havre",
            "Hays",
            "Heart Butte",
            "Helena",
            "Helmville",
            "Heron",
            "Highwood",
            "Hilger",
            "Hingham",
            "Hinsdale",
            "Hobson",
            "Hogeland",
            "Homestead",
            "Hot Springs",
            "Hungry Horse",
            "Huntley",
            "Huson",
            "Hysham",
            "Ingomar",
            "Inverness",
            "Ismay",
            "Jackson",
            "Jefferson City",
            "Joliet",
            "Joplin",
            "Jordan",
            "Judith Gap",
            "Kalispell",
            "Kevin",
            "Kila",
            "Kinsey",
            "Kremlin",
            "Lake McDonald",
            "Lakeside",
            "Lambert",
            "Lame Deer",
            "Larslan",
            "Laurel",
            "Lavina",
            "Ledger",
            "Lewistown",
            "Libby",
            "Lima",
            "Lincoln",
            "Lindsay",
            "Livingston",
            "Lloyd",
            "Lodge Grass",
            "Lolo",
            "Loma",
            "Lonepine",
            "Loring",
            "Lothair",
            "Malmstrom A F B",
            "Malta",
            "Manhattan",
            "Marion",
            "Martin City",
            "Martinsdale",
            "Marysville",
            "McAllister",
            "McCabe",
            "McLeod",
            "Medicine Lake",
            "Melrose",
            "Melstone",
            "Melville",
            "Mildred",
            "Miles City",
            "Milltown",
            "Missoula",
            "Moccasin",
            "Molt",
            "Monarch",
            "Moore",
            "Mosby",
            "Musselshell",
            "Nashua",
            "Neihart",
            "Norris",
            "Noxon",
            "Nye",
            "Oilmont",
            "Olive",
            "Olney",
            "Opheim",
            "Otter",
            "Outlook",
            "Ovando",
            "Pablo",
            "Paradise",
            "Park City",
            "Peerless",
            "Pendroy",
            "Philipsburg",
            "Pinesdale",
            "Plains",
            "Plentywood",
            "Plevna",
            "Polaris",
            "Polebridge",
            "Polson",
            "Pompeys Pillar",
            "Pony",
            "Poplar",
            "Powderville",
            "Power",
            "Pray",
            "Proctor",
            "Pryor",
            "Radersburg",
            "Ramsay",
            "Rapelje",
            "Ravalli",
            "Raymond",
            "Raynesford",
            "Red Lodge",
            "Redstone",
            "Reed Point",
            "Reserve",
            "Rexford",
            "Richey",
            "Richland",
            "Ringling",
            "Roberts",
            "Rollins",
            "Ronan",
            "Roscoe",
            "Rosebud",
            "Roundup",
            "Roy",
            "Rudyard",
            "Ryegate",
            "Saco",
            "Saint Ignatius",
            "Saint Marie",
            "Saint Regis",
            "Saint Xavier",
            "Saltese",
            "Sand Coulee",
            "Sand Springs",
            "Sanders",
            "Santa Rita",
            "Savage",
            "Scobey",
            "Seeley Lake",
            "Shawmut",
            "Shelby",
            "Shepherd",
            "Sheridan",
            "Sidney",
            "Silver Gate",
            "Silver Star",
            "Simms",
            "Somers",
            "Sonnette",
            "Springdale",
            "Stanford",
            "Stevensville",
            "Stockett",
            "Stryker",
            "Sula",
            "Sumatra",
            "Sun River",
            "Sunburst",
            "Superior",
            "Sweet Grass",
            "Teigen",
            "Terry",
            "Thompson Falls",
            "Three Forks",
            "Toston",
            "Townsend",
            "Trego",
            "Trout Creek",
            "Troy",
            "Turner",
            "Twin Bridges",
            "Two Dot",
            "Ulm",
            "Valier",
            "Vandalia",
            "Vaughn",
            "Victor",
            "Vida",
            "Virginia City",
            "Volborg",
            "Warm Springs",
            "West Glacier",
            "West Yellowstone",
            "Westby",
            "White Sulphur Springs",
            "Whitefish",
            "Whitehall",
            "Whitetail",
            "Whitewater",
            "Whitlash",
            "Wibaux",
            "Willard",
            "Willow Creek",
            "Wilsall",
            "Winifred",
            "Winnett",
            "Winston",
            "Wisdom",
            "Wise River",
            "Wolf Creek",
            "Wolf Point",
            "Worden",
            "Wyola",
            "Yellowtail",
            "Zortman",
            "Zurich"
        ]
    },
    {
        "state": "Nebraska",
        "abbr": "NE",
        "cities": [
            "Abie",
            "Adams",
            "Ainsworth",
            "Albion",
            "Alda",
            "Alexandria",
            "Allen",
            "Alliance",
            "Alma",
            "Alvo",
            "Amelia",
            "Ames",
            "Amherst",
            "Angora",
            "Anselmo",
            "Ansley",
            "Arapahoe",
            "Arcadia",
            "Archer",
            "Arlington",
            "Arnold",
            "Arthur",
            "Ashby",
            "Ashland",
            "Ashton",
            "Atkinson",
            "Atlanta",
            "Auburn",
            "Aurora",
            "Avoca",
            "Axtell",
            "Ayr",
            "Bancroft",
            "Barneston",
            "Bartlett",
            "Bartley",
            "Bassett",
            "Battle Creek",
            "Bayard",
            "Beatrice",
            "Beaver City",
            "Beaver Crossing",
            "Bee",
            "Beemer",
            "Belden",
            "Belgrade",
            "Bellevue",
            "Bellwood",
            "Belvidere",
            "Benedict",
            "Benkelman",
            "Bennet",
            "Bennington",
            "Bertrand",
            "Berwyn",
            "Big Springs",
            "Bingham",
            "Bladen",
            "Blair",
            "Bloomfield",
            "Bloomington",
            "Blue Hill",
            "Blue Springs",
            "Boelus",
            "Boys Town",
            "Bradshaw",
            "Brady",
            "Brainard",
            "Brewster",
            "Bridgeport",
            "Bristow",
            "Broadwater",
            "Brock",
            "Broken Bow",
            "Brownville",
            "Brule",
            "Bruning",
            "Bruno",
            "Brunswick",
            "Burchard",
            "Burr",
            "Burwell",
            "Bushnell",
            "Butte",
            "Byron",
            "Cairo",
            "Callaway",
            "Cambridge",
            "Campbell",
            "Carleton",
            "Carroll",
            "Cedar Bluffs",
            "Cedar Creek",
            "Cedar Rapids",
            "Center",
            "Central City",
            "Ceresco",
            "Chadron",
            "Chambers",
            "Champion",
            "Chapman",
            "Chappell",
            "Chester",
            "Clarks",
            "Clarkson",
            "Clatonia",
            "Clay Center",
            "Clearwater",
            "Cody",
            "Coleridge",
            "Colon",
            "Columbus",
            "Comstock",
            "Concord",
            "Cook",
            "Cordova",
            "Cortland",
            "Cozad",
            "Crab Orchard",
            "Craig",
            "Crawford",
            "Creighton",
            "Creston",
            "Crete",
            "Crofton",
            "Crookston",
            "Culbertson",
            "Curtis",
            "Dakota City",
            "Dalton",
            "Danbury",
            "Dannebrog",
            "Davenport",
            "Davey",
            "David City",
            "Dawson",
            "Daykin",
            "De Witt",
            "Decatur",
            "Denton",
            "Deshler",
            "Deweese",
            "Dickens",
            "Diller",
            "Dix",
            "Dixon",
            "Dodge",
            "Doniphan",
            "Dorchester",
            "Douglas",
            "Du Bois",
            "Dunbar",
            "Duncan",
            "Dunning",
            "Dwight",
            "Eagle",
            "Eddyville",
            "Edgar",
            "Edison",
            "Elba",
            "Elgin",
            "Elk Creek",
            "Elkhorn",
            "Ellsworth",
            "Elm Creek",
            "Elmwood",
            "Elsie",
            "Elsmere",
            "Elwood",
            "Elyria",
            "Emerson",
            "Emmet",
            "Enders",
            "Endicott",
            "Ericson",
            "Eustis",
            "Ewing",
            "Exeter",
            "Fairbury",
            "Fairfield",
            "Fairmont",
            "Falls City",
            "Farnam",
            "Farwell",
            "Filley",
            "Firth",
            "Fordyce",
            "Fort Calhoun",
            "Foster",
            "Franklin",
            "Fremont",
            "Friend",
            "Fullerton",
            "Funk",
            "Garland",
            "Geneva",
            "Genoa",
            "Gering",
            "Gibbon",
            "Gilead",
            "Giltner",
            "Glenvil",
            "Goehner",
            "Gordon",
            "Gothenburg",
            "Grafton",
            "Grand Island",
            "Grant",
            "Greeley",
            "Greenwood",
            "Gresham",
            "Gretna",
            "Guide Rock",
            "Gurley",
            "Hadar",
            "Haigler",
            "Hallam",
            "Halsey",
            "Hamlet",
            "Hampton",
            "Hardy",
            "Harrisburg",
            "Harrison",
            "Hartington",
            "Harvard",
            "Hastings",
            "Hay Springs",
            "Hayes Center",
            "Hazard",
            "Heartwell",
            "Hebron",
            "Hemingford",
            "Henderson",
            "Hendley",
            "Henry",
            "Herman",
            "Hershey",
            "Hickman",
            "Hildreth",
            "Holbrook",
            "Holdrege",
            "Holmesville",
            "Holstein",
            "Homer",
            "Hooper",
            "Hordville",
            "Hoskins",
            "Howells",
            "Hubbard",
            "Hubbell",
            "Humboldt",
            "Humphrey",
            "Hyannis",
            "Imperial",
            "Inavale",
            "Indianola",
            "Inland",
            "Inman",
            "Ithaca",
            "Jackson",
            "Jansen",
            "Johnson",
            "Johnstown",
            "Juniata",
            "Kearney",
            "Kenesaw",
            "Kennard",
            "Keystone",
            "Kilgore",
            "Kimball",
            "La Vista",
            "Lakeside",
            "Laurel",
            "Lawrence",
            "Lebanon",
            "Leigh",
            "Lemoyne",
            "Leshara",
            "Lewellen",
            "Lewiston",
            "Lexington",
            "Liberty",
            "Lincoln",
            "Lindsay",
            "Linwood",
            "Lisco",
            "Litchfield",
            "Lodgepole",
            "Long Pine",
            "Loomis",
            "Lorton",
            "Louisville",
            "Loup City",
            "Lyman",
            "Lynch",
            "Lyons",
            "Macy",
            "Madison",
            "Madrid",
            "Magnet",
            "Malcolm",
            "Malmo",
            "Manley",
            "Marquette",
            "Marsland",
            "Martell",
            "Martin",
            "Maskell",
            "Mason City",
            "Max",
            "Maxwell",
            "Maywood",
            "McCook",
            "McCool Junction",
            "Mcgrew",
            "Mclean",
            "Mead",
            "Meadow Grove",
            "Melbeta",
            "Memphis",
            "Merna",
            "Merriman",
            "Milford",
            "Miller",
            "Milligan",
            "Mills",
            "Minatare",
            "Minden",
            "Mitchell",
            "Monroe",
            "Moorefield",
            "Morrill",
            "Morse Bluff",
            "Mullen",
            "Murdock",
            "Murray",
            "Naper",
            "Naponee",
            "Nebraska City",
            "Nehawka",
            "Neligh",
            "Nelson",
            "Nemaha",
            "Nenzel",
            "Newcastle",
            "Newman Grove",
            "Newport",
            "Nickerson",
            "Niobrara",
            "Norfolk",
            "Norman",
            "North Bend",
            "North Loup",
            "North Platte",
            "Oak",
            "Oakdale",
            "Oakland",
            "Oconto",
            "Odell",
            "Odessa",
            "Offutt A F B",
            "Ogallala",
            "Ohiowa",
            "Omaha",
            "Oneill",
            "Ong",
            "Orchard",
            "Ord",
            "Orleans",
            "Osceola",
            "Oshkosh",
            "Osmond",
            "Otoe",
            "Overton",
            "Oxford",
            "Page",
            "Palisade",
            "Palmer",
            "Palmyra",
            "Panama",
            "Papillion",
            "Parks",
            "Pawnee City",
            "Paxton",
            "Pender",
            "Peru",
            "Petersburg",
            "Phillips",
            "Pickrell",
            "Pierce",
            "Pilger",
            "Pine Bluffs",
            "Plainview",
            "Platte Center",
            "Plattsmouth",
            "Pleasant Dale",
            "Pleasanton",
            "Plymouth",
            "Polk",
            "Ponca",
            "Potter",
            "Prague",
            "Primrose",
            "Purdum",
            "Ragan",
            "Randolph",
            "Ravenna",
            "Raymond",
            "Red Cloud",
            "Republican City",
            "Reynolds",
            "Richfield",
            "Rising City",
            "Riverdale",
            "Riverton",
            "Roca",
            "Rockville",
            "Rogers",
            "Rosalie",
            "Rose",
            "Roseland",
            "Royal",
            "Rulo",
            "Rushville",
            "Ruskin",
            "Saint Edward",
            "Saint Helena",
            "Saint Libory",
            "Saint Paul",
            "Salem",
            "Sargent",
            "Saronville",
            "Schuyler",
            "Scotia",
            "Scottsbluff",
            "Scribner",
            "Seneca",
            "Seward",
            "Shelby",
            "Shelton",
            "Shickley",
            "Shubert",
            "Sidney",
            "Silver Creek",
            "Smithfield",
            "Snyder",
            "South Bend",
            "South Sioux City",
            "Spalding",
            "Sparks",
            "Spencer",
            "Sprague",
            "Springfield",
            "Springview",
            "St Columbans",
            "Stamford",
            "Stanton",
            "Staplehurst",
            "Stapleton",
            "Steele City",
            "Steinauer",
            "Stella",
            "Sterling",
            "Stockville",
            "Strang",
            "Stratton",
            "Stromsburg",
            "Stuart",
            "Sumner",
            "Superior",
            "Surprise",
            "Sutherland",
            "Sutton",
            "Swanton",
            "Syracuse",
            "Table Rock",
            "Talmage",
            "Taylor",
            "Tecumseh",
            "Tekamah",
            "Thedford",
            "Thurston",
            "Tilden",
            "Tobias",
            "Trenton",
            "Trumbull",
            "Tryon",
            "Uehling",
            "Ulysses",
            "Unadilla",
            "Union",
            "Upland",
            "Utica",
            "Valentine",
            "Valley",
            "Valparaiso",
            "Venango",
            "Verdel",
            "Verdigre",
            "Verdon",
            "Virginia",
            "Waco",
            "Wahoo",
            "Wakefield",
            "Wallace",
            "Walthill",
            "Walton",
            "Washington",
            "Waterbury",
            "Waterloo",
            "Wauneta",
            "Wausa",
            "Waverly",
            "Wayne",
            "Weeping Water",
            "Weissert",
            "Wellfleet",
            "West Point",
            "Western",
            "Westerville",
            "Weston",
            "Whiteclay",
            "Whitman",
            "Whitney",
            "Wilber",
            "Wilcox",
            "Willow Island",
            "Wilsonville",
            "Winnebago",
            "Winnetoon",
            "Winside",
            "Winslow",
            "Wisner",
            "Wolbach",
            "Wood Lake",
            "Wood River",
            "Wymore",
            "Wynot",
            "York",
            "Yutan"
        ]
    },
    {
        "state": "Nevada",
        "abbr": "NV",
        "cities": [
            "Alamo",
            "Amargosa Valley",
            "Austin",
            "Baker",
            "Battle Mountain",
            "Beatty",
            "Blue Diamond",
            "Boulder City",
            "Bunkerville",
            "Cal Nev Ari",
            "Caliente",
            "Carlin",
            "Carson City",
            "Crescent Valley",
            "Crystal Bay",
            "Dayton",
            "Deeth",
            "Denio",
            "Duckwater",
            "Dyer",
            "Elko",
            "Ely",
            "Empire",
            "Eureka",
            "Fallon",
            "Fernley",
            "Gabbs",
            "Gardnerville",
            "Gardnerville Ranchos",
            "Genoa",
            "Gerlach",
            "Gerlach-Empire",
            "Glenbrook",
            "Golconda",
            "Goldfield",
            "Halleck",
            "Hawthorne",
            "Henderson",
            "Hiko",
            "Imlay",
            "Incline Village",
            "Indian Springs",
            "Jackpot",
            "Jarbidge",
            "Jean",
            "Kingsbury",
            "Lamoille",
            "Las Vegas",
            "Laughlin",
            "Logandale",
            "Lovelock",
            "Lund",
            "Luning",
            "Manhattan",
            "McDermitt",
            "McGill",
            "Mercury",
            "Mesquite",
            "Mina",
            "Minden",
            "Moapa",
            "Montello",
            "Mountain City",
            "Nellis AFB",
            "Nixon",
            "North Las Vegas",
            "Orovada",
            "Overton",
            "Owyhee",
            "Pahrump",
            "Panaca",
            "Paradise Valley",
            "Pioche",
            "Reno",
            "Round Mountain",
            "Ruby Valley",
            "Ruth",
            "Schurz",
            "Searchlight",
            "Silver City",
            "Silver Springs",
            "Silverpeak",
            "Smith",
            "Sparks",
            "Spring Creek",
            "Stateline",
            "Summerlin South",
            "Sun Valley",
            "The Lakes",
            "Tonopah",
            "Tuscarora",
            "Valmy",
            "Virginia City",
            "Wadsworth",
            "Washoe Valley",
            "Wellington",
            "Wells",
            "West Wendover",
            "Winnemucca",
            "Yerington",
            "Zephyr Cove"
        ]
    },
    {
        "state": "New Hampshire",
        "abbr": "NH",
        "cities": [
            "Acworth",
            "Alstead",
            "Alton",
            "Alton Bay",
            "Amherst",
            "Andover",
            "Antrim",
            "Ashland",
            "Ashuelot",
            "Atkinson",
            "Auburn",
            "Barnstead",
            "Barrington",
            "Bartlett",
            "Bath",
            "Bedford",
            "Belmont",
            "Bennington",
            "Berlin",
            "Bethlehem",
            "Bow",
            "Bradford",
            "Bretton Woods",
            "Bristol",
            "Brookline",
            "Campton",
            "Canaan",
            "Candia",
            "Canterbury",
            "Center Barnstead",
            "Center Conway",
            "Center Harbor",
            "Center Ossipee",
            "Center Sandwich",
            "Center Strafford",
            "Center Tuftonboro",
            "Charlestown",
            "Chester",
            "Chesterfield",
            "Chichester",
            "Chocorua",
            "Claremont",
            "Colebrook",
            "Concord",
            "Contoocook",
            "Conway",
            "Cornish",
            "Cornish Flat",
            "Danbury",
            "Danville",
            "Deerfield",
            "Derry",
            "Dover",
            "Drewsville",
            "Dublin",
            "Dunbarton",
            "Durham",
            "East Andover",
            "East Candia",
            "East Derry",
            "East Hampstead",
            "East Hebron",
            "East Kingston",
            "East Wakefield",
            "Eaton Center",
            "Elkins",
            "Enfield",
            "Enfield Center",
            "Epping",
            "Epsom",
            "Errol",
            "Etna",
            "Exeter",
            "Farmington",
            "Fitzwilliam",
            "Francestown",
            "Franconia",
            "Franklin",
            "Freedom",
            "Fremont",
            "Georges Mills",
            "Gilmanton",
            "Gilmanton Iron Works",
            "Gilsum",
            "Glen",
            "Glencliff",
            "Goffstown",
            "Gorham",
            "Goshen",
            "Grafton",
            "Grantham",
            "Greenfield",
            "Greenland",
            "Greenville",
            "Groveton",
            "Guild",
            "Hampstead",
            "Hampton",
            "Hampton Falls",
            "Hancock",
            "Hanover",
            "Harrisville",
            "Haverhill",
            "Hebron",
            "Henniker",
            "Hill",
            "Hillsboro",
            "Hinsdale",
            "Holderness",
            "Hollis",
            "Hooksett",
            "Hudson",
            "Intervale",
            "Jackson",
            "Jaffrey",
            "Jefferson",
            "Kearsarge",
            "Keene",
            "Kingston",
            "Laconia",
            "Lancaster",
            "Landaff",
            "Lebanon",
            "Lempster",
            "Lincoln",
            "Lisbon",
            "Litchfield",
            "Littleton",
            "Lochmere",
            "Londonderry",
            "Loudon",
            "Lyme",
            "Lyme Center",
            "Lyndeborough",
            "Madison",
            "Manchester",
            "Marlborough",
            "Marlow",
            "Meadows",
            "Melvin Village",
            "Meredith",
            "Meriden",
            "Merrimack",
            "Milan",
            "Milford",
            "Milton",
            "Milton Mills",
            "Mirror Lake",
            "Monroe",
            "Mont Vernon",
            "Moultonborough",
            "Mount Washington",
            "Munsonville",
            "Nashua",
            "New Boston",
            "New Castle",
            "New Durham",
            "New Hampton",
            "New Ipswich",
            "New London",
            "Newbury",
            "Newfields",
            "Newmarket",
            "Newport",
            "Newton",
            "Newton Junction",
            "North Conway",
            "North Hampton",
            "North Haverhill",
            "North Salem",
            "North Sandwich",
            "North Stratford",
            "North Sutton",
            "North Walpole",
            "North Woodstock",
            "Northwood",
            "Nottingham",
            "Orford",
            "Ossipee",
            "Pelham",
            "Peterborough",
            "Piermont",
            "Pike",
            "Pittsburg",
            "Pittsfield",
            "Plainfield",
            "Plaistow",
            "Plymouth",
            "Portsmouth",
            "Raymond",
            "Rindge",
            "Rochester",
            "Rollinsford",
            "Rumney",
            "Rye",
            "Rye Beach",
            "Salem",
            "Salisbury",
            "Sanbornton",
            "Sanbornville",
            "Sandown",
            "Seabrook",
            "Sharon",
            "Silver Lake",
            "Somersworth",
            "South Acworth",
            "South Effingham",
            "South Newbury",
            "South Sutton",
            "South Tamworth",
            "Spofford",
            "Springfield",
            "Stinson Lake",
            "Stoddard",
            "Strafford",
            "Stratham",
            "Sullivan",
            "Sunapee",
            "Suncook",
            "Swanzey",
            "Tamworth",
            "Temple",
            "Tilton",
            "Troy",
            "Twin Mountain",
            "Union",
            "Walpole",
            "Warner",
            "Warren",
            "Washington",
            "Waterville Valley",
            "Weare",
            "Wentworth",
            "West Chesterfield",
            "West Lebanon",
            "West Nottingham",
            "West Ossipee",
            "West Peterborough",
            "West Stewartstown",
            "West Swanzey",
            "Westmoreland",
            "Whitefield",
            "Wilmot",
            "Wilton",
            "Winchester",
            "Windham",
            "Winnisquam",
            "Wolfeboro",
            "Wolfeboro Falls",
            "Wonalancet",
            "Woodstock",
            "Woodsville"
        ]
    },
    {
        "state": "New Jersey",
        "abbr": "NJ",
        "cities": [
            "Absecon",
            "Adelphia",
            "Allamuchy",
            "Allendale",
            "Allenhurst",
            "Allentown",
            "Allenwood",
            "Alloway",
            "Alpine",
            "Andover",
            "Annandale",
            "Asbury",
            "Asbury Park",
            "Atco",
            "Atlantic City",
            "Atlantic Highlands",
            "Audubon",
            "Augusta",
            "Avalon",
            "Avenel",
            "Avon By The Sea",
            "Baptistown",
            "Barnegat",
            "Barnegat Light",
            "Barrington",
            "Basking Ridge",
            "Bass River",
            "Bayonne",
            "Bayville",
            "Beach Haven",
            "Beachwood",
            "Bedminster",
            "Belford",
            "Belle Mead",
            "Belleville",
            "Bellmawr",
            "Belmar",
            "Belvidere",
            "Bergenfield",
            "Berkeley",
            "Berkeley Heights",
            "Berlin",
            "Bernards",
            "Bernardsville",
            "Beverly",
            "Birmingham",
            "Blackwood",
            "Blairstown",
            "Blawenburg",
            "Bloomfield",
            "Bloomingdale",
            "Bloomsbury",
            "Bogota",
            "Boonton",
            "Bordentown",
            "Bound Brook",
            "Bradley Beach",
            "Branchville",
            "Brick",
            "Bridgeport",
            "Bridgeton",
            "Bridgewater",
            "Brielle",
            "Brigantine",
            "Broadway",
            "Brookside",
            "Browns Mills",
            "Budd Lake",
            "Buena",
            "Burlington",
            "Butler",
            "Buttzville",
            "Caldwell",
            "Califon",
            "Camden",
            "Cape May",
            "Cape May Court House",
            "Cape May Point",
            "Carlstadt",
            "Carteret",
            "Cedar Brook",
            "Cedar Grove",
            "Cedar Knolls",
            "Cedarville",
            "Changewater",
            "Chatham",
            "Chatsworth",
            "Cherry Hill",
            "Chester",
            "Clark",
            "Clarksboro",
            "Clarksburg",
            "Clayton",
            "Clementon",
            "Cliffside Park",
            "Cliffwood",
            "Clifton",
            "Clinton",
            "Closter",
            "Collingswood",
            "Cologne",
            "Colonia",
            "Colts Neck",
            "Columbia",
            "Columbus",
            "Cookstown",
            "Cranbury",
            "Cranford",
            "Cream Ridge",
            "Cresskill",
            "Crosswicks",
            "Dayton",
            "Deal",
            "Deepwater",
            "Deerfield Street",
            "Delaware",
            "Delmont",
            "Demarest",
            "Dennisville",
            "Denville",
            "Dividing Creek",
            "Dorchester",
            "Dorothy",
            "Dover",
            "Downe",
            "Dumont",
            "Dunellen",
            "East Amwell",
            "East Brunswick",
            "East Hanover",
            "East Orange",
            "East Rutherford",
            "Eatontown",
            "Edgewater",
            "Edison",
            "Egg Harbor City",
            "Egg Harbor Township",
            "Elizabeth",
            "Elmer",
            "Elmwood Park",
            "Elwood",
            "Elwood-Magnolia",
            "Emerson",
            "Englewood",
            "Englewood Cliffs",
            "Englishtown",
            "Essex Fells",
            "Estell Manor",
            "Ewan",
            "Fair Haven",
            "Fair Lawn",
            "Fairfield",
            "Fairton",
            "Fairview",
            "Fanwood",
            "Far Hills",
            "Farmingdale",
            "Flagtown",
            "Flanders",
            "Flemington",
            "Florence",
            "Florham Park",
            "Fords",
            "Forked River",
            "Fort Lee",
            "Fort Monmouth",
            "Fortescue",
            "Franklin",
            "Franklin Lakes",
            "Franklin Park",
            "Franklinville",
            "Freehold",
            "Frenchtown",
            "Garfield",
            "Garwood",
            "Gibbsboro",
            "Gibbstown",
            "Gillette",
            "Gladstone",
            "Glassboro",
            "Glasser",
            "Glen Gardner",
            "Glen Ridge",
            "Glen Rock",
            "Glendora",
            "Glenwood",
            "Gloucester City",
            "Goshen",
            "Great Meadows",
            "Great Meadows-Vienna",
            "Green Creek",
            "Green Village",
            "Greendell",
            "Greenwich",
            "Grenloch",
            "Hackensack",
            "Hackettstown",
            "Haddon Heights",
            "Haddonfield",
            "Hainesport",
            "Haledon",
            "Hamburg",
            "Hammonton",
            "Hampton",
            "Hancocks Bridge",
            "Hardyston",
            "Harrington Park",
            "Harrison",
            "Harrisonville",
            "Hasbrouck Heights",
            "Haskell",
            "Haworth",
            "Hawthorne",
            "Hazlet",
            "Heislerville",
            "Helmetta",
            "Hewitt",
            "Hibernia",
            "High Bridge",
            "Highland Lakes",
            "Highland Park",
            "Highlands",
            "Hightstown",
            "Hillsdale",
            "Hillside",
            "Ho Ho Kus",
            "Ho-Ho-Kus",
            "Hoboken",
            "Holmdel",
            "Hopatcong",
            "Hope",
            "Hopewell",
            "Howell",
            "Imlaystown",
            "Ironia",
            "Irvington",
            "Iselin",
            "Island Heights",
            "Jackson",
            "Jamesburg",
            "Jersey City",
            "Jobstown",
            "Johnsonburg",
            "Juliustown",
            "Keansburg",
            "Kearny",
            "Keasbey",
            "Kendall Park",
            "Kenilworth",
            "Kenvil",
            "Keyport",
            "Kingston",
            "Lafayette",
            "Lake Hiawatha",
            "Lake Hopatcong",
            "Lakehurst",
            "Lakewood",
            "Lambertville",
            "Landing",
            "Landisville",
            "Lanoka Harbor",
            "Lavallette",
            "Lawnside",
            "Layton",
            "Lebanon",
            "Ledgewood",
            "Leeds Point",
            "Leesburg",
            "Leonardo",
            "Leonia",
            "Liberty Corner",
            "Lincoln Park",
            "Lincroft",
            "Linden",
            "Linwood",
            "Little Falls",
            "Little Ferry",
            "Little Silver",
            "Little York",
            "Livingston",
            "Lodi",
            "Long Branch",
            "Long Valley",
            "Longport",
            "Lumberton",
            "Lyndhurst",
            "Lyons",
            "Madison",
            "Magnolia",
            "Mahwah",
            "Malaga",
            "Manahawkin",
            "Manasquan",
            "Mantoloking",
            "Mantua",
            "Manville",
            "Maple Shade",
            "Maplewood",
            "Margate City",
            "Marlboro",
            "Marlton",
            "Marmora",
            "Martinsville",
            "Matawan",
            "Maurice River",
            "Mauricetown",
            "Mays Landing",
            "Maywood",
            "McAfee",
            "Medford",
            "Mendham",
            "Merchantville",
            "Metuchen",
            "Mickleton",
            "Middlesex",
            "Middletown",
            "Middleville",
            "Midland Park",
            "Milford",
            "Millburn",
            "Millington",
            "Millstone",
            "Milltown",
            "Millville",
            "Milmay",
            "Mine Hill",
            "Minotola",
            "Mizpah",
            "Monmouth Beach",
            "Monmouth Junction",
            "Monroeville",
            "Montague",
            "Montclair",
            "Montvale",
            "Montville",
            "Moonachie",
            "Moorestown",
            "Morganville",
            "Morris Plains",
            "Morristown",
            "Mount Arlington",
            "Mount Ephraim",
            "Mount Freedom",
            "Mount Holly",
            "Mount Laurel",
            "Mount Royal",
            "Mount Tabor",
            "Mountain Lakes",
            "Mountainside",
            "Mullica Hill",
            "National Park",
            "Navesink",
            "Neptune",
            "Neshanic Station",
            "Netcong",
            "New Brunswick",
            "New Egypt",
            "New Gretna",
            "New Lisbon",
            "New Milford",
            "New Providence",
            "New Vernon",
            "New York",
            "Newark",
            "Newfield",
            "Newfoundland",
            "Newport",
            "Newton",
            "Newtonville",
            "Norma",
            "Normandy Beach",
            "North Arlington",
            "North Bergen",
            "North Brunswick",
            "Northfield",
            "Northvale",
            "Norwood",
            "Nutley",
            "Oak Ridge",
            "Oakhurst",
            "Oakland",
            "Oaklyn",
            "Ocean City",
            "Ocean Gate",
            "Ocean Grove",
            "Ocean View",
            "Oceanport",
            "Oceanville",
            "Ogdensburg",
            "Old Bridge",
            "Oldwick",
            "Oradell",
            "Orange",
            "Oxford",
            "Palisades Park",
            "Palmyra",
            "Paramus",
            "Park Ridge",
            "Parlin",
            "Parsippany",
            "Passaic",
            "Paterson",
            "Paulsboro",
            "Peapack",
            "Peapack and Gladstone",
            "Pedricktown",
            "Pemberton",
            "Pennington",
            "Penns Grove",
            "Pennsauken",
            "Pennsville",
            "Pequannock",
            "Perrineville",
            "Perth Amboy",
            "Phillipsburg",
            "Picatinny Arsenal",
            "Pine Beach",
            "Pine Brook",
            "Piscataway",
            "Pitman",
            "Pittstown",
            "Plainfield",
            "Plainsboro",
            "Pleasantville",
            "Pluckemin",
            "Point Pleasant Beach",
            "Pomona",
            "Pompton Lakes",
            "Pompton Plains",
            "Port Elizabeth",
            "Port Monmouth",
            "Port Murray",
            "Port Norris",
            "Port Reading",
            "Port Republic",
            "Pottersville",
            "Princeton",
            "Princeton Junction",
            "Quakertown",
            "Quinton",
            "Rahway",
            "Ramsey",
            "Rancocas",
            "Randolph",
            "Raritan",
            "Readington",
            "Red Bank",
            "Richland",
            "Richwood",
            "Ridgefield",
            "Ridgefield Park",
            "Ridgewood",
            "Ringoes",
            "Ringwood",
            "Rio Grande",
            "River Edge",
            "Riverdale",
            "Riverside",
            "Riverton",
            "Rochelle Park",
            "Rockaway",
            "Rocky Hill",
            "Roebling",
            "Roosevelt",
            "Roseland",
            "Roselle",
            "Roselle Park",
            "Rosemont",
            "Rosenhayn",
            "Rumson",
            "Runnemede",
            "Rutherford",
            "Saddle Brook",
            "Saddle River",
            "Salem",
            "Sayreville",
            "Schooleys Mountain",
            "Scotch Plains",
            "Sea Girt",
            "Sea Isle City",
            "Seaside Heights",
            "Seaside Park",
            "Secaucus",
            "Sergeantsville",
            "Sewaren",
            "Sewell",
            "Shiloh",
            "Short Hills",
            "Shrewsbury",
            "Sicklerville",
            "Skillman",
            "Somerdale",
            "Somers Point",
            "Somerset",
            "Somerville",
            "South Amboy",
            "South Bound Brook",
            "South Dennis",
            "South Hackensack",
            "South Orange",
            "South Plainfield",
            "South River",
            "South Seaville",
            "Sparta",
            "Spotswood",
            "Spring Lake",
            "Springfield",
            "Stanhope",
            "Stanton",
            "Stewartsville",
            "Stillwater",
            "Stirling",
            "Stockholm",
            "Stockton",
            "Stone Harbor",
            "Stratford",
            "Strathmere",
            "Succasunna",
            "Summit",
            "Sussex",
            "Swartswood",
            "Swedesboro",
            "Teaneck",
            "Tenafly",
            "Tennent",
            "Teterboro",
            "Thorofare",
            "Three Bridges",
            "Titusville",
            "Toms River",
            "Totowa",
            "Towaco",
            "Tranquility",
            "Trenton",
            "Tuckahoe",
            "Tuckerton",
            "Union",
            "Union City",
            "Vauxhall",
            "Ventnor City",
            "Vernon",
            "Verona",
            "Vienna",
            "Villas",
            "Vincentown",
            "Vineland",
            "Voorhees",
            "Waldwick",
            "Wallington",
            "Wallpack Center",
            "Wanaque",
            "Waretown",
            "Warren",
            "Washington",
            "Watchung",
            "Waterford Works",
            "Wayne",
            "Wenonah",
            "West Berlin",
            "West Creek",
            "West Long Branch",
            "West Milford",
            "West New York",
            "West Orange",
            "West Paterson",
            "Westfield",
            "Westville",
            "Westwood",
            "Wharton",
            "Whippany",
            "Whitehouse",
            "Whitehouse Station",
            "Whitesboro",
            "Whiting",
            "Wickatunk",
            "Wildwood",
            "Williamstown",
            "Willingboro",
            "Windsor",
            "Winslow",
            "Wood Ridge",
            "Woodbine",
            "Woodbridge",
            "Woodbury",
            "Woodbury Heights",
            "Woodcliff Lake",
            "Woodstown",
            "Wrightstown",
            "Wyckoff",
            "Zarephath"
        ]
    },
    {
        "state": "New Mexico",
        "abbr": "NM",
        "cities": [
            "Abiquiu",
            "Alamogordo",
            "Albuquerque",
            "Alcalde",
            "Algodones",
            "Alto",
            "Amalia",
            "Amistad",
            "Angel Fire",
            "Animas",
            "Anthony",
            "Anton Chico",
            "Aragon",
            "Arenas Valley",
            "Arrey",
            "Arroyo Hondo",
            "Arroyo Seco",
            "Artesia",
            "Aztec",
            "Bard",
            "Bayard",
            "Belen",
            "Bell Ranch",
            "Bent",
            "Berino",
            "Bernalillo",
            "Blanco",
            "Bloomfield",
            "Bluewater",
            "Boles Acres",
            "Bosque",
            "Bosque Farms",
            "Brimhall",
            "Broadview",
            "Buckhorn",
            "Buena Vista",
            "Caballo",
            "Canjilon",
            "Cannon AFB",
            "Canones",
            "Capitan",
            "Caprock",
            "Capulin",
            "Carlsbad",
            "Carrizozo",
            "Carson",
            "Casa Blanca",
            "Causey",
            "Cebolla",
            "Cedar Crest",
            "Cedarvale",
            "Cerrillos",
            "Cerro",
            "Chacon",
            "Chama",
            "Chamberino",
            "Chamisal",
            "Chaparral",
            "Chimayo",
            "Church Rock",
            "Cimarron",
            "Claunch",
            "Clayton",
            "Cleveland",
            "Cliff",
            "Clines Corners",
            "Cloudcroft",
            "Clovis",
            "Cochiti Lake",
            "Cochiti Pueblo",
            "Columbus",
            "Conchas Dam",
            "Continental Divide",
            "Cordova",
            "Corona",
            "Corrales",
            "Costilla",
            "Counselor",
            "Coyote",
            "Crossroads",
            "Crownpoint",
            "Cuba",
            "Cubero",
            "Cuervo",
            "Datil",
            "Deming",
            "Derry",
            "Des Moines",
            "Dexter",
            "Dixon",
            "Dona Ana",
            "Dora",
            "Dulce",
            "Eagle Nest",
            "Edgewood",
            "El Paso",
            "El Prado",
            "El Rito",
            "Elephant Butte",
            "Elida",
            "Embudo",
            "Encino",
            "Espanola",
            "Estancia",
            "Eunice",
            "Fairacres",
            "Farmington",
            "Faywood",
            "Fence Lake",
            "Flora Vista",
            "Floyd",
            "Folsom",
            "Fort Bayard",
            "Fort Stanton",
            "Fort Sumner",
            "Fort Wingate",
            "Fruitland",
            "Gallina",
            "Gallup",
            "Gamerco",
            "Garfield",
            "Garita",
            "Gila",
            "Gladstone",
            "Glencoe",
            "Glenwood",
            "Glorieta",
            "Grady",
            "Grants",
            "Grenville",
            "Guadalupita",
            "Hachita",
            "Hagerman",
            "Hanover",
            "Hatch",
            "Hernandez",
            "High Rolls Mountain Park",
            "Hillsboro",
            "Hobbs",
            "Holloman Air Force Base",
            "Holman",
            "Hondo",
            "Hope",
            "House",
            "Hurley",
            "Ilfeld",
            "Isleta",
            "Jal",
            "Jamestown",
            "Jarales",
            "Jemez Pueblo",
            "Jemez Springs",
            "Kenna",
            "Kirtland",
            "Kirtland AFB",
            "La Jara",
            "La Joya",
            "La Loma",
            "La Luz",
            "La Madera",
            "La Mesa",
            "La Plata",
            "Laguna",
            "Lake Arthur",
            "Lakewood",
            "Lamy",
            "Las Cruces",
            "Las Vegas",
            "Lemitar",
            "Lincoln",
            "Lindrith",
            "Lingo",
            "Llano",
            "Loco Hills",
            "Logan",
            "Lordsburg",
            "Los Alamos",
            "Los Lunas",
            "Los Ojos",
            "Loving",
            "Lovington",
            "Luna",
            "Magdalena",
            "Malaga",
            "Maljamar",
            "Maxwell",
            "Mayhill",
            "McAlister",
            "McDonald",
            "McIntosh",
            "Medanales",
            "Melrose",
            "Mentmore",
            "Mescalero",
            "Mesilla",
            "Mesilla Park",
            "Mesquite",
            "Mexican Springs",
            "Miami",
            "Milan",
            "Mills",
            "Milnesand",
            "Mimbres",
            "Montezuma",
            "Monticello",
            "Monument",
            "Mora",
            "Moriarty",
            "Mosquero",
            "Mount Dora",
            "Mountainair",
            "Mule Creek",
            "Nageezi",
            "Nara Visa",
            "Navajo",
            "Navajo Dam",
            "New Laguna",
            "Newcomb",
            "Newkirk",
            "Nogal",
            "Ocate",
            "Ojo Caliente",
            "Ojo Feliz",
            "Organ",
            "Orogrande",
            "Paguate",
            "Pecos",
            "Pena Blanca",
            "Penasco",
            "Pep",
            "Peralta",
            "Petaca",
            "Picacho",
            "Pie Town",
            "Pinehill",
            "Pinon",
            "Pinos Altos",
            "Placitas",
            "Playas",
            "Polvadera",
            "Ponderosa",
            "Portales",
            "Prewitt",
            "Pueblo Of Acoma",
            "Quay",
            "Quemado",
            "Questa",
            "Radium Springs",
            "Rainsville",
            "Ramah",
            "Ranchos De Taos",
            "Raton",
            "Red River",
            "Redrock",
            "Regina",
            "Rehoboth",
            "Reserve",
            "Ribera",
            "Rincon",
            "Rio Rancho",
            "Rociada",
            "Rodeo",
            "Rogers",
            "Roswell",
            "Rowe",
            "Roy",
            "Ruidoso",
            "Ruidoso Downs",
            "Sacramento",
            "Saint Vrain",
            "Salem",
            "San Acacia",
            "San Antonio",
            "San Cristobal",
            "San Fidel",
            "San Jon",
            "San Jose",
            "San Juan Pueblo",
            "San Miguel",
            "San Patricio",
            "San Rafael",
            "San Ysidro",
            "Sandia Park",
            "Sanostee",
            "Santa Clara",
            "Santa Cruz",
            "Santa Fe",
            "Santa Rosa",
            "Santa Teresa",
            "Santo Domingo Pueblo",
            "Sapello",
            "Sedan",
            "Seneca",
            "Serafina",
            "Sheep Springs",
            "Shiprock",
            "Silver City",
            "Smith Lake",
            "Socorro",
            "Solano",
            "Springer",
            "Stanley",
            "Sunland Park",
            "Sunspot",
            "Taiban",
            "Tajique",
            "Taos",
            "Taos Ski Valley",
            "Tatum",
            "Tererro",
            "Tesuque",
            "Texico",
            "Thoreau",
            "Tierra Amarilla",
            "Tijeras",
            "Timberon",
            "Tinnie",
            "Tohatchi",
            "Tome",
            "Torreon",
            "Trampas",
            "Trementina",
            "Tres Piedras",
            "Truchas",
            "Truth Or Consequences",
            "Tucumcari",
            "Tularosa",
            "Tyrone",
            "Ute Park",
            "Vadito",
            "Vado",
            "Valdez",
            "Vallecitos",
            "Valmora",
            "Vanderwagen",
            "Vaughn",
            "Veguita",
            "Velarde",
            "Villanueva",
            "Wagon Mound",
            "Waterflow",
            "Watrous",
            "Weed",
            "White Sands Missile Range",
            "Whites City",
            "Willard",
            "Williamsburg",
            "Winston",
            "Yatahey",
            "Yeso",
            "Youngsville",
            "Zuni"
        ]
    },
    {
        "state": "New York",
        "abbr": "NY",
        "cities": [
            "Accord",
            "Acra",
            "Adams",
            "Adams Basin",
            "Adams Center",
            "Addison",
            "Adirondack",
            "Afton",
            "Akron",
            "Alabama",
            "Albany",
            "Albertson",
            "Albion",
            "Alcove",
            "Alden",
            "Alder Creek",
            "Alexander",
            "Alexandria Bay",
            "Alfred",
            "Alfred Station",
            "Allegany",
            "Allentown",
            "Alma",
            "Almond",
            "Alpine",
            "Alplaus",
            "Altamont",
            "Altmar",
            "Alton",
            "Altona",
            "Amagansett",
            "Amawalk",
            "Amenia",
            "Amityville",
            "Amsterdam",
            "Ancram",
            "Ancramdale",
            "Andes",
            "Andover",
            "Angelica",
            "Angola",
            "Annandale On Hudson",
            "Antwerp",
            "Apalachin",
            "Appleton",
            "Apulia Station",
            "Aquebogue",
            "Arcade",
            "Arden",
            "Ardsley",
            "Ardsley On Hudson",
            "Argyle",
            "Arkport",
            "Arkville",
            "Armonk",
            "Arverne",
            "Ashland",
            "Ashville",
            "Astoria",
            "Athens",
            "Athol",
            "Athol Springs",
            "Atlanta",
            "Atlantic Beach",
            "Attica",
            "Au Sable Forks",
            "Auburn",
            "Auriesville",
            "Aurora",
            "Austerlitz",
            "Ava",
            "Averill Park",
            "Avoca",
            "Avon",
            "Babylon",
            "Bainbridge",
            "Bakers Mills",
            "Baldwin",
            "Baldwin Place",
            "Baldwinsville",
            "Ballston Lake",
            "Ballston Spa",
            "Bangall",
            "Barker",
            "Barneveld",
            "Barrytown",
            "Barryville",
            "Barton",
            "Basom",
            "Batavia",
            "Bath",
            "Bay Shore",
            "Bayport",
            "Bayside",
            "Bayville",
            "Beacon",
            "Bear Mountain",
            "Bearsville",
            "Beaver Dams",
            "Beaver Falls",
            "Bedford",
            "Bedford Hills",
            "Belfast",
            "Bellerose",
            "Belleville",
            "Bellmore",
            "Bellona",
            "Bellport",
            "Bellvale",
            "Belmont",
            "Bemus Point",
            "Bergen",
            "Berkshire",
            "Berlin",
            "Berne",
            "Bernhards Bay",
            "Bethel",
            "Bethpage",
            "Bible School Park",
            "Big Flats",
            "Big Indian",
            "Billings",
            "Binghamton",
            "Black Creek",
            "Black River",
            "Blauvelt",
            "Bliss",
            "Blodgett Mills",
            "Bloomfield",
            "Blooming Grove",
            "Bloomingburg",
            "Bloomingdale",
            "Bloomington",
            "Bloomville",
            "Blossvale",
            "Blue Mountain Lake",
            "Blue Point",
            "Bohemia",
            "Boiceville",
            "Bolivar",
            "Bolton Landing",
            "Bombay",
            "Boonville",
            "Boston",
            "Bouckville",
            "Bovina Center",
            "Bowmansville",
            "Bradford",
            "Brainard",
            "Brainardsville",
            "Branchport",
            "Brant",
            "Brant Lake",
            "Brantingham",
            "Brasher Falls",
            "Breesport",
            "Breezy Point",
            "Brentwood",
            "Brewerton",
            "Brewster",
            "Briarcliff Manor",
            "Bridgehampton",
            "Bridgeport",
            "Bridgewater",
            "Brier Hill",
            "Brightwaters",
            "Broadalbin",
            "Brockport",
            "Brocton",
            "Bronx",
            "Bronxville",
            "Brookfield",
            "Brookhaven",
            "Brooklyn",
            "Brooktondale",
            "Brownville",
            "Brushton",
            "Buchanan",
            "Buffalo",
            "Bullville",
            "Burdett",
            "Burke",
            "Burlingham",
            "Burlington Flats",
            "Burnt Hills",
            "Burt",
            "Buskirk",
            "Byron",
            "Cadyville",
            "Cairo",
            "Calcium",
            "Caledonia",
            "Callicoon",
            "Callicoon Center",
            "Calverton",
            "Cambria Heights",
            "Cambridge",
            "Camden",
            "Cameron",
            "Cameron Mills",
            "Camillus",
            "Campbell",
            "Campbell Hall",
            "Canaan",
            "Canadice",
            "Canajoharie",
            "Canandaigua",
            "Canaseraga",
            "Canastota",
            "Candor",
            "Caneadea",
            "Canisteo",
            "Canton",
            "Cape Vincent",
            "Carle Place",
            "Carlisle",
            "Carmel",
            "Caroga Lake",
            "Carthage",
            "Cassadaga",
            "Cassville",
            "Castile",
            "Castle Creek",
            "Castle Point",
            "Castleton On Hudson",
            "Castorland",
            "Cato",
            "Catskill",
            "Cattaraugus",
            "Cayuga",
            "Cayuta",
            "Cazenovia",
            "Cedarhurst",
            "Celoron",
            "Center Moriches",
            "Centereach",
            "Centerport",
            "Centerville",
            "Central Bridge",
            "Central Islip",
            "Central Square",
            "Central Valley",
            "Ceres",
            "Chadwicks",
            "Chaffee",
            "Champlain",
            "Chappaqua",
            "Charlotteville",
            "Chase Mills",
            "Chateaugay",
            "Chatham",
            "Chaumont",
            "Chautauqua",
            "Chazy",
            "Chelsea",
            "Chemung",
            "Chenango Bridge",
            "Chenango Forks",
            "Cherry Creek",
            "Cherry Plain",
            "Cherry Valley",
            "Chester",
            "Chestertown",
            "Chichester",
            "Childwold",
            "Chippewa Bay",
            "Chittenango",
            "Churchville",
            "Churubusco",
            "Cicero",
            "Cincinnatus",
            "Circleville",
            "Clarence",
            "Clarence Center",
            "Clarendon",
            "Clark Mills",
            "Clarkson",
            "Clarksville",
            "Claryville",
            "Claverack",
            "Clay",
            "Clayton",
            "Clayville",
            "Clemons",
            "Cleveland",
            "Cleverdale",
            "Clifton Park",
            "Clifton Springs",
            "Climax",
            "Clinton",
            "Clinton Corners",
            "Clintondale",
            "Clockville",
            "Clyde",
            "Clymer",
            "Cobleskill",
            "Cochecton",
            "Cochecton Center",
            "Coeymans",
            "Coeymans Hollow",
            "Cohocton",
            "Cohoes",
            "Cold Brook",
            "Cold Spring",
            "Cold Spring Harbor",
            "Colden",
            "Colesville",
            "College Point",
            "Colliersville",
            "Collins",
            "Collins Center",
            "Colton",
            "Columbiaville",
            "Commack",
            "Comstock",
            "Conesus",
            "Conewango Valley",
            "Congers",
            "Conklin",
            "Connelly",
            "Constable",
            "Constableville",
            "Constantia",
            "Coopers Plains",
            "Cooperstown",
            "Copake",
            "Copake Falls",
            "Copenhagen",
            "Copiague",
            "Coram",
            "Corbettsville",
            "Corfu",
            "Corinth",
            "Corning",
            "Cornwall",
            "Cornwall On Hudson",
            "Cornwallville",
            "Corona",
            "Cortland",
            "Cortlandt Manor",
            "Cossayuna",
            "Cottekill",
            "Cowlesville",
            "Coxsackie",
            "Cragsmoor",
            "Cranberry Lake",
            "Craryville",
            "Crittenden",
            "Croghan",
            "Crompond",
            "Cropseyville",
            "Cross River",
            "Croton Falls",
            "Croton On Hudson",
            "Crown Point",
            "Cuba",
            "Cuddebackville",
            "Cutchogue",
            "Dale",
            "Dalton",
            "Dannemora",
            "Dansville",
            "Darien Center",
            "Davenport",
            "Davenport Center",
            "Dayton",
            "De Kalb Junction",
            "De Lancey",
            "De Peyster",
            "De Ruyter",
            "Deansboro",
            "Deer Park",
            "Deer River",
            "Deferiet",
            "Delanson",
            "Delevan",
            "Delhi",
            "Delmar",
            "Delphi Falls",
            "Denmark",
            "Denver",
            "Depauville",
            "Depew",
            "Deposit",
            "Derby",
            "Dewittville",
            "Dexter",
            "Diamond Point",
            "Dickinson Center",
            "Dobbs Ferry",
            "Dolgeville",
            "Dormansville",
            "Dover Plains",
            "Downsville",
            "Dresden",
            "Dryden",
            "Duanesburg",
            "Dundee",
            "Dunkirk",
            "Durham",
            "Durhamville",
            "Eagle Bay",
            "Eagle Bridge",
            "Earlton",
            "Earlville",
            "East Amherst",
            "East Aurora",
            "East Berne",
            "East Bethany",
            "East Bloomfield",
            "East Branch",
            "East Chatham",
            "East Concord",
            "East Durham",
            "East Elmhurst",
            "East Greenbush",
            "East Hampton",
            "East Homer",
            "East Islip",
            "East Jewett",
            "East Marion",
            "East Meadow",
            "East Meredith",
            "East Moriches",
            "East Nassau",
            "East Northport",
            "East Norwich",
            "East Otto",
            "East Pembroke",
            "East Pharsalia",
            "East Quogue",
            "East Randolph",
            "East Rochester",
            "East Rockaway",
            "East Schodack",
            "East Setauket",
            "East Springfield",
            "East Syracuse",
            "East Williamson",
            "East Worcester",
            "Eastchester",
            "Eastport",
            "Eaton",
            "Eden",
            "Edmeston",
            "Edwards",
            "Elba",
            "Elbridge",
            "Eldred",
            "Elizabethtown",
            "Elizaville",
            "Elka Park",
            "Ellenburg",
            "Ellenburg Center",
            "Ellenburg Depot",
            "Ellenville",
            "Ellicottville",
            "Ellington",
            "Ellisburg",
            "Elma",
            "Elmhurst",
            "Elmira",
            "Elmont",
            "Elmsford",
            "Endicott",
            "Endwell",
            "Erieville",
            "Erin",
            "Esopus",
            "Esperance",
            "Essex",
            "Etna",
            "Evans Mills",
            "Fabius",
            "Fair Haven",
            "Fairport",
            "Falconer",
            "Fallsburg",
            "Fancher",
            "Far Rockaway",
            "Farmersville Station",
            "Farmingdale",
            "Farmington",
            "Farmingville",
            "Farnham",
            "Fayette",
            "Fayetteville",
            "Felts Mills",
            "Ferndale",
            "Feura Bush",
            "Fillmore",
            "Findley Lake",
            "Fine",
            "Fishers",
            "Fishers Island",
            "Fishers Landing",
            "Fishkill",
            "Fishs Eddy",
            "Fleischmanns",
            "Floral Park",
            "Florida",
            "Flushing",
            "Fly Creek",
            "Fonda",
            "Forest Hills",
            "Forestburgh",
            "Forestport",
            "Forestville",
            "Fort Ann",
            "Fort Covington",
            "Fort Drum",
            "Fort Edward",
            "Fort Hunter",
            "Fort Johnson",
            "Fort Montgomery",
            "Fort Plain",
            "Frankfort",
            "Franklin",
            "Franklin Springs",
            "Franklin Square",
            "Franklinville",
            "Fredonia",
            "Freedom",
            "Freehold",
            "Freeport",
            "Freeville",
            "Fremont Center",
            "Fresh Meadows",
            "Frewsburg",
            "Friendship",
            "Fulton",
            "Fultonham",
            "Fultonville",
            "Gabriels",
            "Gainesville",
            "Gallupville",
            "Galway",
            "Gansevoort",
            "Garden City",
            "Gardiner",
            "Garnerville",
            "Garrattsville",
            "Garrison",
            "Gasport",
            "Geneseo",
            "Geneva",
            "Genoa",
            "Georgetown",
            "Germantown",
            "Gerry",
            "Getzville",
            "Ghent",
            "Gilbertsville",
            "Gilboa",
            "Glasco",
            "Glen Aubrey",
            "Glen Cove",
            "Glen Head",
            "Glen Oaks",
            "Glen Spey",
            "Glen Wild",
            "Glenfield",
            "Glenford",
            "Glenham",
            "Glenmont",
            "Glens Falls",
            "Glenwood",
            "Glenwood Landing",
            "Gloversville",
            "Godeffroy",
            "Goldens Bridge",
            "Gorham",
            "Goshen",
            "Gouverneur",
            "Gowanda",
            "Grafton",
            "Grahamsville",
            "Grand Gorge",
            "Grand Island",
            "Granite Springs",
            "Granville",
            "Great Bend",
            "Great Neck",
            "Great River",
            "Great Valley",
            "Greene",
            "Greenfield Center",
            "Greenfield Park",
            "Greenhurst",
            "Greenlawn",
            "Greenport",
            "Greenvale",
            "Greenville",
            "Greenwich",
            "Greenwood",
            "Greenwood Lake",
            "Greig",
            "Groton",
            "Groveland",
            "Guilderland",
            "Guilderland Center",
            "Guilford",
            "Hadley",
            "Hagaman",
            "Hague",
            "Hailesboro",
            "Haines Falls",
            "Halcottsville",
            "Hall",
            "Hamburg",
            "Hamden",
            "Hamilton",
            "Hamlin",
            "Hammond",
            "Hammondsport",
            "Hampton",
            "Hampton Bays",
            "Hancock",
            "Hankins",
            "Hannacroix",
            "Hannawa Falls",
            "Hannibal",
            "Harford",
            "Harpersfield",
            "Harpursville",
            "Harriman",
            "Harris",
            "Harrison",
            "Harrisville",
            "Hartford",
            "Hartsdale",
            "Hartwick",
            "Hastings",
            "Hastings On Hudson",
            "Hauppauge",
            "Haverstraw",
            "Hawthorne",
            "Hector",
            "Helena",
            "Hemlock",
            "Hempstead",
            "Henderson",
            "Henderson Harbor",
            "Henrietta",
            "Hensonville",
            "Herkimer",
            "Hermon",
            "Heuvelton",
            "Hewlett",
            "Hicksville",
            "High Falls",
            "Highland",
            "Highland Falls",
            "Highland Lake",
            "Highland Mills",
            "Highmount",
            "Hillburn",
            "Hillsdale",
            "Hilton",
            "Himrod",
            "Hinckley",
            "Hinsdale",
            "Hobart",
            "Hoffmeister",
            "Hogansburg",
            "Holbrook",
            "Holland",
            "Holland Patent",
            "Holley",
            "Hollis",
            "Hollowville",
            "Holmes",
            "Holtsville",
            "Homer",
            "Honeoye",
            "Honeoye Falls",
            "Hoosick",
            "Hoosick Falls",
            "Hopewell Junction",
            "Hornell",
            "Horseheads",
            "Hortonville",
            "Houghton",
            "Howard Beach",
            "Howells",
            "Howes Cave",
            "Hubbardsville",
            "Hudson",
            "Hudson Falls",
            "Hughsonville",
            "Huguenot",
            "Huletts Landing",
            "Hume",
            "Hunt",
            "Hunter",
            "Huntington",
            "Huntington Station",
            "Hurley",
            "Hurleyville",
            "Hyde Park",
            "Ilion",
            "Indian Lake",
            "Inlet",
            "Interlaken",
            "Inwood",
            "Ionia",
            "Irving",
            "Irvington",
            "Island Park",
            "Islandia",
            "Islip",
            "Islip Terrace",
            "Ithaca",
            "Jackson Heights",
            "Jacksonville",
            "Jamaica",
            "Jamesport",
            "Jamestown",
            "Jamesville",
            "Jasper",
            "Java Center",
            "Java Village",
            "Jay",
            "Jefferson",
            "Jefferson Valley",
            "Jeffersonville",
            "Jericho",
            "Jewett",
            "Johnsburg",
            "Johnson",
            "Johnson City",
            "Johnsonville",
            "Johnstown",
            "Jordan",
            "Jordanville",
            "Kanona",
            "Katonah",
            "Kattskill Bay",
            "Kauneonga Lake",
            "Keene",
            "Keene Valley",
            "Keeseville",
            "Kendall",
            "Kennedy",
            "Kenoza Lake",
            "Kent",
            "Kerhonkson",
            "Keuka Park",
            "Kew Gardens",
            "Kiamesha Lake",
            "Kill Buck",
            "Killawog",
            "Kinderhook",
            "King Ferry",
            "Kings Park",
            "Kingston",
            "Kirkville",
            "Kirkwood",
            "Knowlesville",
            "Knox",
            "Knoxboro",
            "La Fargeville",
            "La Fayette",
            "La Grange",
            "Lacona",
            "Lagrangeville",
            "Lake Clear",
            "Lake George",
            "Lake Grove",
            "Lake Hill",
            "Lake Huntington",
            "Lake Katrine",
            "Lake Luzerne",
            "Lake Peekskill",
            "Lake Placid",
            "Lake Pleasant",
            "Lake View",
            "Lakemont",
            "Lakeville",
            "Lakewood",
            "Lancaster",
            "Lanesville",
            "Lansing",
            "Larchmont",
            "Latham",
            "Laurel",
            "Laurens",
            "Lawrence",
            "Lawrenceville",
            "Lawtons",
            "Le Roy",
            "Lee Center",
            "Leeds",
            "Leicester",
            "Leon",
            "Leonardsville",
            "Levittown",
            "Lewis",
            "Lewisboro",
            "Lewiston",
            "Lexington",
            "Liberty",
            "Lily Dale",
            "Lima",
            "Limerick",
            "Limestone",
            "Lincolndale",
            "Lindenhurst",
            "Lindley",
            "Linwood",
            "Lisbon",
            "Lisle",
            "Little Falls",
            "Little Genesee",
            "Little Neck",
            "Little Valley",
            "Little York",
            "Liverpool",
            "Livingston",
            "Livingston Manor",
            "Livonia",
            "Livonia Center",
            "Loch Sheldrake",
            "Locke",
            "Lockport",
            "Lockwood",
            "Locust Valley",
            "Lodi",
            "Long Beach",
            "Long Eddy",
            "Long Island City",
            "Long Lake",
            "Lorraine",
            "Lowman",
            "Lowville",
            "Lycoming",
            "Lynbrook",
            "Lyndonville",
            "Lyon Mountain",
            "Lyons",
            "Lyons Falls",
            "Macedon",
            "Machias",
            "Madison",
            "Madrid",
            "Mahopac",
            "Mahopac Falls",
            "Maine",
            "Malden Bridge",
            "Malden On Hudson",
            "Mallory",
            "Malone",
            "Malverne",
            "Mamaroneck",
            "Manchester",
            "Manhasset",
            "Manlius",
            "Mannsville",
            "Manorville",
            "Maple Springs",
            "Maple View",
            "Maplecrest",
            "Marathon",
            "Marcellus",
            "Marcy",
            "Margaretville",
            "Marietta",
            "Marilla",
            "Marion",
            "Marlboro",
            "Martinsburg",
            "Martville",
            "Maryknoll",
            "Maryland",
            "Masonville",
            "Maspeth",
            "Massapequa",
            "Massapequa Park",
            "Massena",
            "Mastic",
            "Mastic Beach",
            "Mattituck",
            "Maybrook",
            "Mayfield",
            "Mayville",
            "McConnellsville",
            "McDonough",
            "McGraw",
            "McLean",
            "Mechanicville",
            "Mecklenburg",
            "Medford",
            "Medina",
            "Medusa",
            "Mellenville",
            "Melrose",
            "Melville",
            "Memphis",
            "Mendon",
            "Meridale",
            "Meridian",
            "Merrick",
            "Mexico",
            "Mid Hudson",
            "Mid Island",
            "Middle Falls",
            "Middle Granville",
            "Middle Grove",
            "Middle Island",
            "Middle Village",
            "Middleburgh",
            "Middleport",
            "Middlesex",
            "Middletown",
            "Middleville",
            "Milford",
            "Mill Neck",
            "Millbrook",
            "Miller Place",
            "Millerton",
            "Millport",
            "Millwood",
            "Milton",
            "Mineola",
            "Minerva",
            "Minetto",
            "Mineville",
            "Minoa",
            "Model City",
            "Modena",
            "Mohawk",
            "Mohegan Lake",
            "Moira",
            "Mongaup Valley",
            "Monroe",
            "Monsey",
            "Montauk",
            "Montezuma",
            "Montgomery",
            "Monticello",
            "Montour Falls",
            "Montrose",
            "Mooers",
            "Mooers Forks",
            "Moravia",
            "Moriah",
            "Moriah Center",
            "Moriches",
            "Morris",
            "Morrisonville",
            "Morristown",
            "Morrisville",
            "Morton",
            "Mottville",
            "Mount Kisco",
            "Mount Marion",
            "Mount Morris",
            "Mount Sinai",
            "Mount Tremper",
            "Mount Upton",
            "Mount Vernon",
            "Mount Vision",
            "Mountain Dale",
            "Mountainville",
            "Mumford",
            "Munnsville",
            "Nanuet",
            "Napanoch",
            "Naples",
            "Narrowsburg",
            "Nassau",
            "Natural Bridge",
            "Nedrow",
            "Nelliston",
            "Nesconset",
            "Neversink",
            "New Baltimore",
            "New Berlin",
            "New City",
            "New Hampton",
            "New Hartford",
            "New Haven",
            "New Hyde Park",
            "New Kingston",
            "New Lebanon",
            "New Lisbon",
            "New Milford",
            "New Paltz",
            "New Rochelle",
            "New Russia",
            "New Suffolk",
            "New Windsor",
            "New Woodstock",
            "New York",
            "New York Mills",
            "Newark",
            "Newark Valley",
            "Newburgh",
            "Newcomb",
            "Newfane",
            "Newfield",
            "Newport",
            "Newton Falls",
            "Newtonville",
            "Niagara Falls",
            "Niagara University",
            "Nichols",
            "Nicholville",
            "Nineveh",
            "Niobe",
            "Niverville",
            "Norfolk",
            "North Babylon",
            "North Bangor",
            "North Bay",
            "North Blenheim",
            "North Boston",
            "North Branch",
            "North Brookfield",
            "North Chatham",
            "North Chili",
            "North Collins",
            "North Creek",
            "North Evans",
            "North Granville",
            "North Greece",
            "North Hoosick",
            "North Hudson",
            "North Java",
            "North Lawrence",
            "North Norwich",
            "North Pitcher",
            "North River",
            "North Rose",
            "North Salem",
            "North Tonawanda",
            "Northport",
            "Northville",
            "Norwich",
            "Norwood",
            "Nunda",
            "Nyack",
            "Oak Hill",
            "Oakdale",
            "Oakfield",
            "Oakland Gardens",
            "Oaks Corners",
            "Obernburg",
            "Ocean Beach",
            "Oceanside",
            "Odessa",
            "Ogdensburg",
            "Olcott",
            "Old Bethpage",
            "Old Chatham",
            "Old Forge",
            "Old Westbury",
            "Olean",
            "Olivebridge",
            "Olmstedville",
            "Oneida",
            "Oneonta",
            "Ontario",
            "Ontario Center",
            "Orangeburg",
            "Orchard Park",
            "Orient",
            "Oriskany",
            "Oriskany Falls",
            "Orwell",
            "Ossining",
            "Oswegatchie",
            "Oswego",
            "Otego",
            "Otisville",
            "Otto",
            "Ouaquaga",
            "Ovid",
            "Owego",
            "Owls Head",
            "Oxbow",
            "Oxford",
            "Oyster Bay",
            "Ozone Park",
            "Painted Post",
            "Palatine Bridge",
            "Palenville",
            "Palisades",
            "Palmyra",
            "Panama",
            "Paradox",
            "Parish",
            "Parishville",
            "Parksville",
            "Patchogue",
            "Patterson",
            "Pattersonville",
            "Paul Smiths",
            "Pavilion",
            "Pawling",
            "Pearl River",
            "Peconic",
            "Peekskill",
            "Pelham",
            "Penfield",
            "Penn Yan",
            "Pennellville",
            "Perkinsville",
            "Perry",
            "Perrysburg",
            "Peru",
            "Peterboro",
            "Petersburg",
            "Pharsalia",
            "Phelps",
            "Philadelphia",
            "Phillipsport",
            "Philmont",
            "Phoenicia",
            "Phoenix",
            "Piercefield",
            "Piermont",
            "Pierrepont Manor",
            "Piffard",
            "Pike",
            "Pine Bush",
            "Pine City",
            "Pine Hill",
            "Pine Island",
            "Pine Plains",
            "Pine Valley",
            "Piseco",
            "Pitcher",
            "Pittsford",
            "Plainview",
            "Plainville",
            "Plattekill",
            "Plattsburgh",
            "Pleasant Valley",
            "Pleasantville",
            "Plessis",
            "Plymouth",
            "Poestenkill",
            "Point Lookout",
            "Poland",
            "Pomona",
            "Pompey",
            "Pond Eddy",
            "Poplar Ridge",
            "Port Byron",
            "Port Chester",
            "Port Crane",
            "Port Ewen",
            "Port Gibson",
            "Port Henry",
            "Port Jefferson",
            "Port Jefferson Station",
            "Port Jervis",
            "Port Kent",
            "Port Leyden",
            "Port Washington",
            "Portage",
            "Portageville",
            "Porter Corners",
            "Portland",
            "Portlandville",
            "Portville",
            "Potsdam",
            "Pottersville",
            "Poughkeepsie",
            "Poughquag",
            "Pound Ridge",
            "Prattsburgh",
            "Prattsville",
            "Preble",
            "Preston Hollow",
            "Prospect",
            "Pulaski",
            "Pulteney",
            "Pultneyville",
            "Purchase",
            "Purdys",
            "Purling",
            "Putnam Station",
            "Putnam Valley",
            "Pyrites",
            "Quaker Street",
            "Queens Village",
            "Queensbury",
            "Quogue",
            "Rainbow Lake",
            "Randolph",
            "Ransomville",
            "Raquette Lake",
            "Ravena",
            "Ray Brook",
            "Raymondville",
            "Reading Center",
            "Red Creek",
            "Red Hook",
            "Redfield",
            "Redford",
            "Redwood",
            "Rego Park",
            "Remsen",
            "Remsenburg",
            "Rensselaer",
            "Rensselaer Falls",
            "Rensselaerville",
            "Retsof",
            "Rexford",
            "Rexville",
            "Rhinebeck",
            "Rhinecliff",
            "Richburg",
            "Richfield Springs",
            "Richford",
            "Richland",
            "Richmond Hill",
            "Richmondville",
            "Richville",
            "Ridge",
            "Ridgewood",
            "Rifton",
            "Riparius",
            "Ripley",
            "Riverhead",
            "Rochester",
            "Rock City Falls",
            "Rock Hill",
            "Rock Stream",
            "Rock Tavern",
            "Rockaway Park",
            "Rockville Centre",
            "Rocky Point",
            "Rodman",
            "Rome",
            "Romulus",
            "Ronkonkoma",
            "Roosevelt",
            "Rooseveltown",
            "Roscoe",
            "Rose",
            "Roseboom",
            "Rosedale",
            "Rosendale",
            "Roslyn",
            "Roslyn Heights",
            "Rossburg",
            "Rotterdam Junction",
            "Round Lake",
            "Round Top",
            "Rouses Point",
            "Roxbury",
            "Ruby",
            "Rush",
            "Rushford",
            "Rushville",
            "Russell",
            "Rye",
            "Sabael",
            "Sackets Harbor",
            "Sag Harbor",
            "Sagaponack",
            "Saint Albans",
            "Saint Bonaventure",
            "Saint James",
            "Saint Johnsville",
            "Saint Regis Falls",
            "Salamanca",
            "Salem",
            "Salisbury Center",
            "Salisbury Mills",
            "Salt Point",
            "Sanborn",
            "Sand Lake",
            "Sandusky",
            "Sandy Creek",
            "Sangerfield",
            "Saranac",
            "Saranac Lake",
            "Saratoga Springs",
            "Sardinia",
            "Saugerties",
            "Sauquoit",
            "Savannah",
            "Savona",
            "Sayville",
            "Scarsdale",
            "Schaghticoke",
            "Schenectady",
            "Schenevus",
            "Schodack Landing",
            "Schoharie",
            "Schroon Lake",
            "Schuyler Falls",
            "Schuyler Lake",
            "Schuylerville",
            "Scio",
            "Scipio Center",
            "Scottsburg",
            "Scottsville",
            "Sea Cliff",
            "Seaford",
            "Selden",
            "Selkirk",
            "Seneca Castle",
            "Seneca Falls",
            "Severance",
            "Shandaken",
            "Sharon Springs",
            "Shelter Island",
            "Shelter Island Heights",
            "Shenorock",
            "Sherburne",
            "Sheridan",
            "Sherman",
            "Sherrill",
            "Shinhopple",
            "Shirley",
            "Shokan",
            "Shoreham",
            "Shortsville",
            "Shrub Oak",
            "Shushan",
            "Sidney",
            "Sidney Center",
            "Silver Bay",
            "Silver Creek",
            "Silver Lake",
            "Silver Springs",
            "Sinclairville",
            "Skaneateles",
            "Skaneateles Falls",
            "Slate Hill",
            "Slaterville Springs",
            "Slingerlands",
            "Sloansville",
            "Sloatsburg",
            "Smallwood",
            "Smithboro",
            "Smithtown",
            "Smithville Flats",
            "Smyrna",
            "Sodus",
            "Sodus Point",
            "Solsville",
            "Somers",
            "Sonyea",
            "Sound Beach",
            "South Bethlehem",
            "South Butler",
            "South Byron",
            "South Cairo",
            "South Colton",
            "South Dayton",
            "South Fallsburg",
            "South Glens Falls",
            "South Jamesport",
            "South Kortright",
            "South Lima",
            "South New Berlin",
            "South Otselic",
            "South Ozone Park",
            "South Plymouth",
            "South Richmond Hill",
            "South Rutland",
            "South Salem",
            "South Schodack",
            "South Wales",
            "Southampton",
            "Southfields",
            "Southold",
            "Sparkill",
            "Sparrow Bush",
            "Speculator",
            "Spencer",
            "Spencerport",
            "Spencertown",
            "Speonk",
            "Sprakers",
            "Spring Brook",
            "Spring Glen",
            "Spring Valley",
            "Springfield Center",
            "Springfield Gardens",
            "Springville",
            "Springwater",
            "Staatsburg",
            "Stafford",
            "Stamford",
            "Stanfordville",
            "Stanley",
            "Star Lake",
            "Staten Island",
            "Steamburg",
            "Stella Niagara",
            "Stephentown",
            "Sterling",
            "Sterling Forest",
            "Stillwater",
            "Stittville",
            "Stockton",
            "Stone Ridge",
            "Stony Brook",
            "Stony Creek",
            "Stony Point",
            "Stormville",
            "Stottville",
            "Stow",
            "Stratford",
            "Strykersville",
            "Stuyvesant",
            "Stuyvesant Falls",
            "Suffern",
            "Sugar Loaf",
            "Summit",
            "Summitville",
            "Sundown",
            "Sunnyside",
            "Surprise",
            "Swain",
            "Swan Lake",
            "Sylvan Beach",
            "Syosset",
            "Syracuse",
            "Taberg",
            "Tallman",
            "Tannersville",
            "Tappan",
            "Tarrytown",
            "Thendara",
            "Theresa",
            "Thiells",
            "Thompson Ridge",
            "Thompsonville",
            "Thornwood",
            "Thousand Island Park",
            "Three Mile Bay",
            "Ticonderoga",
            "Tillson",
            "Tioga Center",
            "Tivoli",
            "Tomkins Cove",
            "Tonawanda",
            "Treadwell",
            "Tribes Hill",
            "Troupsburg",
            "Trout Creek",
            "Troy",
            "Trumansburg",
            "Truxton",
            "Tuckahoe",
            "Tully",
            "Tunnel",
            "Tupper Lake",
            "Turin",
            "Tuxedo Park",
            "Tyrone",
            "Ulster Park",
            "Unadilla",
            "Union Hill",
            "Union Springs",
            "Uniondale",
            "Unionville",
            "Upper Jay",
            "Upton",
            "Utica",
            "Vails Gate",
            "Valatie",
            "Valhalla",
            "Valley Cottage",
            "Valley Falls",
            "Valley Stream",
            "Van Buren Point",
            "Van Etten",
            "Van Hornesville",
            "Varysburg",
            "Verbank",
            "Vermontville",
            "Vernon",
            "Vernon Center",
            "Verona",
            "Verona Beach",
            "Verplanck",
            "Versailles",
            "Vestal",
            "Victor",
            "Victory Mills",
            "Voorheesville",
            "Waccabuc",
            "Waddington",
            "Wading River",
            "Wainscott",
            "Walden",
            "Wales Center",
            "Walker Valley",
            "Wallkill",
            "Walton",
            "Walworth",
            "Wampsville",
            "Wanakena",
            "Wantagh",
            "Wappingers Falls",
            "Warners",
            "Warnerville",
            "Warrensburg",
            "Warsaw",
            "Warwick",
            "Washington Mills",
            "Washingtonville",
            "Wassaic",
            "Water Mill",
            "Waterford",
            "Waterloo",
            "Waterport",
            "Watertown",
            "Waterville",
            "Watervliet",
            "Watkins Glen",
            "Waverly",
            "Wawarsing",
            "Wayland",
            "Wayne",
            "Webb",
            "Webster",
            "Weedsport",
            "Wellesley Island",
            "Wells",
            "Wells Bridge",
            "Wellsburg",
            "Wellsville",
            "West Babylon",
            "West Bloomfield",
            "West Burlington",
            "West Camp",
            "West Chazy",
            "West Clarksville",
            "West Copake",
            "West Coxsackie",
            "West Davenport",
            "West Eaton",
            "West Edmeston",
            "West Falls",
            "West Fulton",
            "West Harrison",
            "West Haverstraw",
            "West Hempstead",
            "West Henrietta",
            "West Hurley",
            "West Islip",
            "West Kill",
            "West Lebanon",
            "West Leyden",
            "West Monroe",
            "West Nyack",
            "West Oneonta",
            "West Park",
            "West Point",
            "West Sand Lake",
            "West Sayville",
            "West Shokan",
            "West Stockholm",
            "West Valley",
            "West Winfield",
            "Westbrookville",
            "Westbury",
            "Westdale",
            "Westerlo",
            "Westernville",
            "Westfield",
            "Westford",
            "Westhampton",
            "Westhampton Beach",
            "Westmoreland",
            "Westons Mills",
            "Westport",
            "Westtown",
            "Wevertown",
            "Whippleville",
            "White Lake",
            "White Plains",
            "White Sulphur Springs",
            "Whitehall",
            "Whitesboro",
            "Whitestone",
            "Whitestown",
            "Whitesville",
            "Whitney Point",
            "Willard",
            "Willet",
            "Williamson",
            "Williamstown",
            "Williston Park",
            "Willow",
            "Willsboro",
            "Willseyville",
            "Wilmington",
            "Wilson",
            "Wilton",
            "Windham",
            "Windsor",
            "Wingdale",
            "Winthrop",
            "Witherbee",
            "Wolcott",
            "Woodbourne",
            "Woodbury",
            "Woodgate",
            "Woodhaven",
            "Woodhull",
            "Woodmere",
            "Woodridge",
            "Woodside",
            "Woodstock",
            "Worcester",
            "Wurtsboro",
            "Wyandanch",
            "Wykagyl",
            "Wynantskill",
            "Wyoming",
            "Yaphank",
            "Yonkers",
            "York",
            "Yorkshire",
            "Yorktown Heights",
            "Yorkville",
            "Youngstown",
            "Youngsville",
            "Yulan"
        ]
    },
    {
        "state": "North Carolina",
        "abbr": "NC",
        "cities": [
            "Aberdeen",
            "Advance",
            "Ahoskie",
            "Alamance",
            "Albemarle",
            "Albertson",
            "Alexander",
            "Alexis",
            "Alliance",
            "Almond",
            "Altamahaw",
            "Andrews",
            "Angier",
            "Ansonville",
            "Apex",
            "Arapahoe",
            "Ararat",
            "Arden",
            "Ash",
            "Asheboro",
            "Asheville",
            "Atkinson",
            "Atlantic",
            "Atlantic Beach",
            "Aulander",
            "Aurora",
            "Autryville",
            "Avon",
            "Ayden",
            "Aydlett",
            "Badin",
            "Bahama",
            "Bailey",
            "Bakersville",
            "Balsam",
            "Balsam Grove",
            "Banner Elk",
            "Barco",
            "Barium Springs",
            "Barnardsville",
            "Barnesville",
            "Bat Cave",
            "Bath",
            "Battleboro",
            "Bayboro",
            "Bear Creek",
            "Beaufort",
            "Belews Creek",
            "Belhaven",
            "Bellarthur",
            "Belmont",
            "Belvidere",
            "Bennett",
            "Benson",
            "Bessemer City",
            "Bethania",
            "Bethel",
            "Beulaville",
            "Biscoe",
            "Black Creek",
            "Black Mountain",
            "Bladenboro",
            "Blanch",
            "Blounts Creek",
            "Blowing Rock",
            "Boiling Springs",
            "Bolivia",
            "Bolton",
            "Bonlee",
            "Boomer",
            "Boone",
            "Boonville",
            "Bostic",
            "Brasstown",
            "Brevard",
            "Bridgeton",
            "Broadway",
            "Browns Summit",
            "Brunswick",
            "Bryson City",
            "Buies Creek",
            "Bullock",
            "Bunn",
            "Bunnlevel",
            "Burgaw",
            "Burlington",
            "Burnsville",
            "Butner",
            "Buxton",
            "Bynum",
            "Calabash",
            "Calypso",
            "Camden",
            "Cameron",
            "Camp Lejeune",
            "Candler",
            "Candor",
            "Canton",
            "Caroleen",
            "Carolina Beach",
            "Carrboro",
            "Carthage",
            "Cary",
            "Casar",
            "Cashiers",
            "Castalia",
            "Castle Hayne",
            "Catawba",
            "Cedar Falls",
            "Cedar Grove",
            "Cedar Island",
            "Cedar Mountain",
            "Cerro Gordo",
            "Chadbourn",
            "Chapel Hill",
            "Charlotte",
            "Cherokee",
            "Cherry Point",
            "Cherryville",
            "Chimney Rock",
            "China Grove",
            "Chinquapin",
            "Chocowinity",
            "Claremont",
            "Clarendon",
            "Clarkton",
            "Clayton",
            "Clemmons",
            "Cleveland",
            "Cliffside",
            "Climax",
            "Clinton",
            "Clyde",
            "Coats",
            "Cofield",
            "Coinjock",
            "Colerain",
            "Colfax",
            "Collettsville",
            "Columbia",
            "Columbus",
            "Comfort",
            "Como",
            "Concord",
            "Conetoe",
            "Connellys Springs",
            "Conover",
            "Conway",
            "Cooleemee",
            "Corapeake",
            "Cordova",
            "Cornelius",
            "Corolla",
            "Council",
            "Cove City",
            "Cramerton",
            "Creedmoor",
            "Creston",
            "Creswell",
            "Crossnore",
            "Crouse",
            "Crumpler",
            "Culberson",
            "Cullowhee",
            "Cumberland",
            "Cumnock",
            "Currie",
            "Currituck",
            "Dallas",
            "Dana",
            "Danbury",
            "Davidson",
            "Davis",
            "Deep Gap",
            "Deep Run",
            "Delco",
            "Denton",
            "Denver",
            "Dillsboro",
            "Dobson",
            "Dover",
            "Drexel",
            "Dublin",
            "Dudley",
            "Dunn",
            "Durants Neck",
            "Durham",
            "Eagle Rock",
            "Eagle Springs",
            "Earl",
            "East Bend",
            "East Flat Rock",
            "East Spencer",
            "Eden",
            "Edenton",
            "Edneyville",
            "Edward",
            "Efland",
            "Elizabeth City",
            "Elizabethtown",
            "Elk Park",
            "Elkin",
            "Ellenboro",
            "Ellerbe",
            "Elm City",
            "Elon College",
            "Emerald Isle",
            "Enfield",
            "Engelhard",
            "Enka",
            "Ennice",
            "Ernul",
            "Erwin",
            "Ether",
            "Etowah",
            "Eure",
            "Everetts",
            "Evergreen",
            "Fair Bluff",
            "Fairfield",
            "Fairmont",
            "Fairplains",
            "Fairview",
            "Faison",
            "Faith",
            "Falcon",
            "Falkland",
            "Fallston",
            "Farmville",
            "Fayetteville",
            "Ferguson",
            "Flat Rock",
            "Fleetwood",
            "Fletcher",
            "Fontana Dam",
            "Forest City",
            "Fort Bragg",
            "Fountain",
            "Four Oaks",
            "Franklin",
            "Franklinton",
            "Franklinville",
            "Fremont",
            "Frisco",
            "Fuquay Varina",
            "Garland",
            "Garner",
            "Garysburg",
            "Gaston",
            "Gastonia",
            "Gates",
            "Gatesville",
            "Germanton",
            "Gerton",
            "Gibson",
            "Gibsonville",
            "Glade Valley",
            "Glen Alpine",
            "Glendale Springs",
            "Glenville",
            "Glenwood",
            "Gloucester",
            "Godwin",
            "Gold Hill",
            "Goldsboro",
            "Goldston",
            "Graham",
            "Grandy",
            "Granite Falls",
            "Granite Quarry",
            "Grantsboro",
            "Grassy Creek",
            "Greenmountain",
            "Greensboro",
            "Greenville",
            "Grifton",
            "Grimesland",
            "Grover",
            "Gulf",
            "Gumberry",
            "Halifax",
            "Hallsboro",
            "Hamilton",
            "Hamlet",
            "Hampstead",
            "Hamptonville",
            "Harbinger",
            "Harkers Island",
            "Harmony",
            "Harrells",
            "Harrellsville",
            "Harris",
            "Harrisburg",
            "Hassell",
            "Hatteras",
            "Havelock",
            "Haw River",
            "Hayesville",
            "Hays",
            "Hazelwood",
            "Henderson",
            "Hendersonville",
            "Henrico",
            "Henrietta",
            "Hertford",
            "Hickory",
            "Hiddenite",
            "High Point",
            "High Shoals",
            "Highfalls",
            "Highlands",
            "Hildebran",
            "Hillsborough",
            "Hobbsville",
            "Hobgood",
            "Hobucken",
            "Hoffman",
            "Hollister",
            "Holly Ridge",
            "Holly Springs",
            "Hookerton",
            "Hope Mills",
            "Horse Shoe",
            "Hot Springs",
            "Hubert",
            "Hudson",
            "Huntersville",
            "Hurdle Mills",
            "Icard",
            "Indian Trail",
            "Ingold",
            "Iron Station",
            "Ivanhoe",
            "Jackson",
            "Jackson Springs",
            "Jacksonville",
            "Jamestown",
            "Jamesville",
            "Jarvisburg",
            "Jefferson",
            "Jonas Ridge",
            "Jonesville",
            "Julian",
            "Kannapolis",
            "Kelford",
            "Kelly",
            "Kenansville",
            "Kenly",
            "Kernersville",
            "Kill Devil Hills",
            "King",
            "Kings Mountain",
            "Kinston",
            "Kipling",
            "Kittrell",
            "Kitty Hawk",
            "Knightdale",
            "Knotts Island",
            "Kure Beach",
            "La Grange",
            "Lake Junaluska",
            "Lake Lure",
            "Lake Toxaway",
            "Lake Waccamaw",
            "Lakeview",
            "Landis",
            "Lansing",
            "Lattimore",
            "Laurel Hill",
            "Laurel Springs",
            "Laurinburg",
            "Lawndale",
            "Lawsonville",
            "Leasburg",
            "Leicester",
            "Leland",
            "Lemon Springs",
            "Lenoir",
            "Lewiston Woodville",
            "Lewisville",
            "Lexington",
            "Liberty",
            "Lilesville",
            "Lillington",
            "Lincolnton",
            "Linden",
            "Linville",
            "Linville Falls",
            "Linwood",
            "Little Switzerland",
            "Littleton",
            "Locust",
            "Longwood",
            "Louisburg",
            "Lowell",
            "Lowgap",
            "Lowland",
            "Lucama",
            "Lumber Bridge",
            "Lumberton",
            "Lynn",
            "Macclesfield",
            "Macon",
            "Madison",
            "Maggie Valley",
            "Magnolia",
            "Maiden",
            "Mamers",
            "Manns Harbor",
            "Manson",
            "Manteo",
            "Maple",
            "Maple Hill",
            "Marble",
            "Margarettsville",
            "Marietta",
            "Marion",
            "Mars Hill",
            "Marshall",
            "Marshallberg",
            "Marshville",
            "Marston",
            "Matthews",
            "Maury",
            "Maxton",
            "Mayodan",
            "Maysville",
            "McAdenville",
            "Mccain",
            "Mccutcheon Field",
            "McFarlan",
            "McGrady",
            "McLeansville",
            "Mebane",
            "Merritt",
            "Merry Hill",
            "Micaville",
            "Micro",
            "Middleburg",
            "Middlesex",
            "Midland",
            "Midway Park",
            "Mill Spring",
            "Millers Creek",
            "Milton",
            "Milwaukee",
            "Mineral Springs",
            "Minneapolis",
            "Misenheimer",
            "Mocksville",
            "Moncure",
            "Monroe",
            "Montezuma",
            "Montreat",
            "Mooresboro",
            "Mooresville",
            "Moravian Falls",
            "Morehead City",
            "Morganton",
            "Morrisville",
            "Morven",
            "Mount Airy",
            "Mount Gilead",
            "Mount Holly",
            "Mount Mourne",
            "Mount Olive",
            "Mount Pleasant",
            "Mount Ulla",
            "Mountain Home",
            "Moyock",
            "Murfreesboro",
            "Murphy",
            "Nags Head",
            "Nakina",
            "Naples",
            "Nashville",
            "Nebo",
            "New Bern",
            "New Hill",
            "New London",
            "Newell",
            "Newland",
            "Newport",
            "Newton",
            "Newton Grove",
            "Norlina",
            "Norman",
            "North Wilkesboro",
            "Norwood",
            "Oak City",
            "Oak Island",
            "Oak Ridge",
            "Oakboro",
            "Ocean Isle Beach",
            "Ocracoke",
            "Old Fort",
            "Olin",
            "Olivia",
            "Oriental",
            "Orrum",
            "Otto",
            "Oxford",
            "Palmyra",
            "Pantego",
            "Parkton",
            "Parmele",
            "Patterson",
            "Paw Creek",
            "Peachland",
            "Pelham",
            "Pembroke",
            "Pendleton",
            "Penland",
            "Penrose",
            "Pfafftown",
            "Pikeville",
            "Pilot Mountain",
            "Pine Hall",
            "Pine Level",
            "Pinebluff",
            "Pinehurst",
            "Pineola",
            "Pinetops",
            "Pinetown",
            "Pineville",
            "Piney Creek",
            "Pink Hill",
            "Pinnacle",
            "Pisgah Forest",
            "Pittsboro",
            "Pleasant Garden",
            "Pleasant Hill",
            "Plumtree",
            "Plymouth",
            "Point Harbor",
            "Polkton",
            "Polkville",
            "Pollocksville",
            "Pope A F B",
            "Poplar Branch",
            "Potecasi",
            "Powells Point",
            "Powellsville",
            "Princeton",
            "Proctorville",
            "Prospect Hill",
            "Providence",
            "Purlear",
            "Raeford",
            "Raleigh",
            "Ramseur",
            "Randleman",
            "Red Oak",
            "Red Springs",
            "Reidsville",
            "Rex",
            "Rhodhiss",
            "Rich Square",
            "Richfield",
            "Richlands",
            "Ridgecrest",
            "Ridgeway",
            "Riegelwood",
            "Roanoke Rapids",
            "Roaring Gap",
            "Roaring River",
            "Robbins",
            "Robbinsville",
            "Robersonville",
            "Rockingham",
            "Rockwell",
            "Rocky Mount",
            "Rocky Point",
            "Rodanthe",
            "Roduco",
            "Rolesville",
            "Ronda",
            "Roper",
            "Rose Hill",
            "Roseboro",
            "Rosman",
            "Rougemont",
            "Rowland",
            "Roxboro",
            "Roxobel",
            "Ruffin",
            "Rural Hall",
            "Rutherford College",
            "Rutherfordton",
            "Saint Pauls",
            "Salemburg",
            "Salisbury",
            "Salter Path",
            "Saluda",
            "Salvo",
            "Sandy Ridge",
            "Sanford",
            "Sapphire",
            "Saratoga",
            "Saxapahaw",
            "Scaly Mountain",
            "Scotland Neck",
            "Scotts",
            "Scottville",
            "Scranton",
            "Seaboard",
            "Seagrove",
            "Sealevel",
            "Sedalia",
            "Selma",
            "Semora",
            "Seven Springs",
            "Severn",
            "Shallotte",
            "Shannon",
            "Sharpsburg",
            "Shawboro",
            "Shelby",
            "Sherrills Ford",
            "Shiloh",
            "Siler City",
            "Siloam",
            "Simpson",
            "Sims",
            "Skyland",
            "Smithfield",
            "Smyrna",
            "Sneads Ferry",
            "Snow Camp",
            "Snow Hill",
            "Sophia",
            "South Brunswick",
            "South Mills",
            "Southern Pines",
            "Southmont",
            "Southport",
            "Sparta",
            "Speed",
            "Spencer",
            "Spindale",
            "Spring Hope",
            "Spring Lake",
            "Spruce Pine",
            "Stacy",
            "Staley",
            "Stanfield",
            "Stanley",
            "Stantonsburg",
            "Star",
            "State Road",
            "Statesville",
            "Stedman",
            "Stella",
            "Stem",
            "Stokes",
            "Stokesdale",
            "Stoneville",
            "Stonewall",
            "Stony Point",
            "Stovall",
            "Stumpy Point",
            "Sugar Grove",
            "Summerfield",
            "Sunbury",
            "Sunset Beach",
            "Supply",
            "Swannanoa",
            "Swanquarter",
            "Swansboro",
            "Swepsonville",
            "Sylva",
            "Tabor City",
            "Tar Heel",
            "Tarawa Terrace",
            "Tarboro",
            "Taylorsville",
            "Teachey",
            "Terrell",
            "Thomasville",
            "Thurmond",
            "Tillery",
            "Timberlake",
            "Toast",
            "Tobaccoville",
            "Todd",
            "Topton",
            "Townsville",
            "Traphill",
            "Trenton",
            "Trinity",
            "Troutman",
            "Troy",
            "Tryon",
            "Tuckasegee",
            "Turkey",
            "Turnersburg",
            "Tuxedo",
            "Tyner",
            "Union Grove",
            "Union Mills",
            "Valdese",
            "Vale",
            "Valle Crucis",
            "Vanceboro",
            "Vandemere",
            "Vass",
            "Vaughan",
            "Vilas",
            "Waco",
            "Wade",
            "Wadesboro",
            "Wagram",
            "Wake Forest",
            "Walkertown",
            "Wallace",
            "Wallburg",
            "Walnut Cove",
            "Walstonburg",
            "Wanchese",
            "Warne",
            "Warrensville",
            "Warrenton",
            "Warsaw",
            "Washington",
            "Watha",
            "Waves",
            "Waxhaw",
            "Waynesville",
            "Weaverville",
            "Webster",
            "Welcome",
            "Weldon",
            "Wendell",
            "Wentworth",
            "West End",
            "West Jefferson",
            "Westfield",
            "Whitakers",
            "White Oak",
            "White Plains",
            "Whiteville",
            "Whitsett",
            "Whittier",
            "Wilkesboro",
            "Willard",
            "Williamston",
            "Williston",
            "Willow Spring",
            "Wilmington",
            "Wilson",
            "Wilsons Mills",
            "Windsor",
            "Winfall",
            "Wingate",
            "Winnabow",
            "Winston Salem",
            "Winterville",
            "Winton",
            "Wise",
            "Woodland",
            "Woodleaf",
            "Wrightsboro",
            "Wrightsville Beach",
            "Yadkinville",
            "Yanceyville",
            "Youngsville",
            "Zebulon",
            "Zionville",
            "Zirconia"
        ]
    },
    {
        "state": "North Dakota",
        "abbr": "ND",
        "cities": [
            "Abercrombie",
            "Absaraka",
            "Adams",
            "Agate",
            "Alamo",
            "Alexander",
            "Almont",
            "Alsen",
            "Ambrose",
            "Amenia",
            "Amidon",
            "Anamoose",
            "Aneta",
            "Antler",
            "Ardoch",
            "Argusville",
            "Arnegard",
            "Arthur",
            "Arvilla",
            "Ashley",
            "Ayr",
            "Baldwin",
            "Balfour",
            "Balta",
            "Bantry",
            "Barney",
            "Bathgate",
            "Beach",
            "Belcourt",
            "Belfield",
            "Benedict",
            "Berlin",
            "Berthold",
            "Beulah",
            "Binford",
            "Bisbee",
            "Bismarck",
            "Blanchard",
            "Bottineau",
            "Bowbells",
            "Bowdon",
            "Bowman",
            "Braddock",
            "Bremen",
            "Brinsmade",
            "Brocket",
            "Buchanan",
            "Buffalo",
            "Burlington",
            "Butte",
            "Buxton",
            "Caledonia",
            "Calvin",
            "Cando",
            "Cannon Ball",
            "Carpio",
            "Carrington",
            "Carson",
            "Cartwright",
            "Casselton",
            "Cathay",
            "Cavalier",
            "Cayuga",
            "Center",
            "Chaffee",
            "Chaseley",
            "Christine",
            "Churchs Ferry",
            "Clay",
            "Cleveland",
            "Clifford",
            "Cogswell",
            "Coleharbor",
            "Colfax",
            "Colquhoun",
            "Columbus",
            "Cooperstown",
            "Courtenay",
            "Crary",
            "Crosby",
            "Crystal",
            "Cummings",
            "Dahlen",
            "Davenport",
            "Dawson",
            "Dazey",
            "Deering",
            "Denhoff",
            "Des Lacs",
            "Devils Lake",
            "Dickey",
            "Dickinson",
            "Dodge",
            "Donnybrook",
            "Douglas",
            "Drake",
            "Drayton",
            "Driscoll",
            "Dunn Center",
            "Dunseith",
            "Eckelson",
            "Edgeley",
            "Edinburg",
            "Edmore",
            "Egeland",
            "Elgin",
            "Ellendale",
            "Emerado",
            "Enderlin",
            "Epping",
            "Erie",
            "Esmond",
            "Fairdale",
            "Fairfield",
            "Fairmount",
            "Fargo",
            "Farmington",
            "Fessenden",
            "Fingal",
            "Finley",
            "Flasher",
            "Flaxton",
            "Forbes",
            "Fordville",
            "Forest River",
            "Forman",
            "Fort Ransom",
            "Fort Totten",
            "Fort Yates",
            "Fortuna",
            "Fredonia",
            "Fullerton",
            "Gackle",
            "Galesburg",
            "Gardner",
            "Garrison",
            "Gilby",
            "Gladstone",
            "Glasston",
            "Glen Ullin",
            "Glenburn",
            "Glenfield",
            "Golden Valley",
            "Golva",
            "Goodrich",
            "Grace City",
            "Grafton",
            "Grand Forks",
            "Grand Forks AFB",
            "Grandfield",
            "Grandin",
            "Granville",
            "Grassy Butte",
            "Great Bend",
            "Grenora",
            "Gwinner",
            "Hague",
            "Halliday",
            "Hamberg",
            "Hamilton",
            "Hampden",
            "Hankinson",
            "Hannaford",
            "Hannah",
            "Hansboro",
            "Harvey",
            "Harwood",
            "Hatton",
            "Havana",
            "Hazelton",
            "Hazen",
            "Hebron",
            "Hensel",
            "Hettinger",
            "Hillsboro",
            "Hoople",
            "Hope",
            "Horace",
            "Hunter",
            "Hurdsfield",
            "Inkster",
            "Jamestown",
            "Jessie",
            "Jud",
            "Karlsruhe",
            "Kathryn",
            "Keene",
            "Kenmare",
            "Kensal",
            "Kief",
            "Killdeer",
            "Kindred",
            "Kintyre",
            "Knox",
            "Kramer",
            "Kulm",
            "Lakota",
            "Lamoure",
            "Langdon",
            "Lankin",
            "Lansford",
            "Larimore",
            "Lawton",
            "Leeds",
            "Lefor",
            "Lehr",
            "Lemmon",
            "Leonard",
            "Lidgerwood",
            "Lignite",
            "Linton",
            "Lisbon",
            "Litchville",
            "Luverne",
            "Maddock",
            "Maida",
            "Makoti",
            "Mandan",
            "Mandaree",
            "Manning",
            "Mantador",
            "Manvel",
            "Mapleton",
            "Marion",
            "Marmarth",
            "Marshall",
            "Martin",
            "Max",
            "Maxbass",
            "Mayville",
            "Mcclusky",
            "Mcgregor",
            "Mchenry",
            "Mckenzie",
            "Mcleod",
            "Mcville",
            "Medina",
            "Medora",
            "Mekinock",
            "Menoken",
            "Mercer",
            "Michigan",
            "Milnor",
            "Milton",
            "Minnewaukan",
            "Minot",
            "Minot AFB",
            "Minto",
            "Moffit",
            "Mohall",
            "Montpelier",
            "Mooreton",
            "Mott",
            "Mountain",
            "Munich",
            "Mylo",
            "Napoleon",
            "Neche",
            "Nekoma",
            "New England",
            "New Leipzig",
            "New Rockford",
            "New Salem",
            "New Town",
            "Newburg",
            "Niagara",
            "Nome",
            "Noonan",
            "Northwood",
            "Norwich",
            "Oakes",
            "Oberon",
            "Orange",
            "Oriska",
            "Orrin",
            "Osnabrock",
            "Page",
            "Palermo",
            "Park River",
            "Parshall",
            "Pekin",
            "Pembina",
            "Penn",
            "Perth",
            "Petersburg",
            "Pettibone",
            "Pillsbury",
            "Pingree",
            "Pisek",
            "Plaza",
            "Poplar Grove",
            "Portal",
            "Portland",
            "Powers Lake",
            "Raleigh",
            "Ray",
            "Reeder",
            "Regan",
            "Regent",
            "Reynolds",
            "Rhame",
            "Richardton",
            "Riverdale",
            "Robinson",
            "Rocklake",
            "Rogers",
            "Rolette",
            "Rolla",
            "Roseglen",
            "Ross",
            "Rugby",
            "Ruso",
            "Rutland",
            "Ryder",
            "Saint Anthony",
            "Saint John",
            "Saint Michael",
            "Saint Thomas",
            "Sanborn",
            "Sarles",
            "Sawyer",
            "Scranton",
            "Selfridge",
            "Sentinel Butte",
            "Sharon",
            "Sheldon",
            "Sherwood",
            "Sheyenne",
            "Shields",
            "Solen",
            "Souris",
            "South Heart",
            "Spiritwood",
            "Stanley",
            "Stanton",
            "Starkweather",
            "Steele",
            "Sterling",
            "Stirum",
            "Strasburg",
            "Streeter",
            "Surrey",
            "Sutton",
            "Sykeston",
            "Tappen",
            "Taylor",
            "Thompson",
            "Tioga",
            "Tokio",
            "Tolley",
            "Tolna",
            "Tower City",
            "Towner",
            "Trenton",
            "Turtle Lake",
            "Tuttle",
            "Underwood",
            "Upham",
            "Valley City",
            "Velva",
            "Venturia",
            "Verona",
            "Voltaire",
            "Wahpeton",
            "Walcott",
            "Wales",
            "Walhalla",
            "Warwick",
            "Washburn",
            "Watford City",
            "Webster",
            "West Fargo",
            "Westby",
            "Westhope",
            "Wheatland",
            "White Earth",
            "Wildrose",
            "Williston",
            "Willow City",
            "Wilton",
            "Wimbledon",
            "Wing",
            "Wishek",
            "Wolford",
            "Woodworth",
            "Wyndmere",
            "York",
            "Ypsilanti",
            "Zahl",
            "Zap",
            "Zeeland"
        ]
    },
    {
        "state": "Ohio",
        "abbr": "OH",
        "cities": [
            "Aberdeen",
            "Ada",
            "Adamsville",
            "Addyston",
            "Adelphi",
            "Adena",
            "Adrian",
            "Akron",
            "Albany",
            "Alexandria",
            "Alger",
            "Alledonia",
            "Alliance",
            "Alpha",
            "Alvada",
            "Alvordton",
            "Amanda",
            "Amelia",
            "Amesville",
            "Amherst",
            "Amlin",
            "Amsden",
            "Amsterdam",
            "Andover",
            "Anna",
            "Ansonia",
            "Antwerp",
            "Apple Creek",
            "Arcadia",
            "Arcanum",
            "Archbold",
            "Arlington",
            "Ashland",
            "Ashley",
            "Ashtabula",
            "Ashville",
            "Athens",
            "Attica",
            "Atwater",
            "Augusta",
            "Aurora",
            "Austinburg",
            "Ava",
            "Avon",
            "Avon Lake",
            "Bainbridge",
            "Bakersville",
            "Baltic",
            "Baltimore",
            "Bannock",
            "Barberton",
            "Barlow",
            "Barnesville",
            "Bartlett",
            "Barton",
            "Bascom",
            "Batavia",
            "Bath",
            "Bay Village",
            "Beach City",
            "Beachwood",
            "Beallsville",
            "Beaver",
            "Beaverdam",
            "Bedford",
            "Bellaire",
            "Bellbrook",
            "Belle Center",
            "Belle Valley",
            "Bellefontaine",
            "Bellevue",
            "Bellville",
            "Belmont",
            "Belmore",
            "Beloit",
            "Belpre",
            "Benton Ridge",
            "Bentonville",
            "Berea",
            "Bergholz",
            "Berkey",
            "Berlin",
            "Berlin Center",
            "Berlin Heights",
            "Bethel",
            "Bethesda",
            "Bettsville",
            "Beverly",
            "Bidwell",
            "Big Prairie",
            "Birmingham",
            "Blacklick",
            "Bladensburg",
            "Blaine",
            "Blakeslee",
            "Blanchester",
            "Blissfield",
            "Bloomdale",
            "Bloomingburg",
            "Bloomingdale",
            "Bloomville",
            "Blue Creek",
            "Blue Rock",
            "Bluffton",
            "Bolivar",
            "Botkins",
            "Bourneville",
            "Bowerston",
            "Bowersville",
            "Bowling Green",
            "Bradford",
            "Bradner",
            "Brady Lake",
            "Brecksville",
            "Bremen",
            "Brewster",
            "Brice",
            "Bridgeport",
            "Brilliant",
            "Brinkhaven",
            "Bristolville",
            "Broadview Heights",
            "Broadway",
            "Brookfield",
            "Brookpark",
            "Brookville",
            "Brownsville",
            "Brunswick",
            "Bryan",
            "Buchtel",
            "Buckeye Lake",
            "Buckland",
            "Bucyrus",
            "Buffalo",
            "Buford",
            "Burbank",
            "Burghill",
            "Burgoon",
            "Burkettsville",
            "Burton",
            "Butler",
            "Byesville",
            "Cable",
            "Cadiz",
            "Cairo",
            "Caldwell",
            "Caledonia",
            "Cambridge",
            "Camden",
            "Cameron",
            "Camp Dennison",
            "Campbell",
            "Canal Fulton",
            "Canal Winchester",
            "Canfield",
            "Canton",
            "Carbon Hill",
            "Carbondale",
            "Cardington",
            "Carey",
            "Carroll",
            "Carrollton",
            "Casstown",
            "Castalia",
            "Catawba",
            "Cecil",
            "Cedarville",
            "Celina",
            "Center",
            "Centerburg",
            "Chagrin Falls",
            "Chandlersville",
            "Chardon",
            "Charm",
            "Chatfield",
            "Chauncey",
            "Cherry Fork",
            "Chesapeake",
            "Cheshire",
            "Chester",
            "Chesterhill",
            "Chesterland",
            "Chesterville",
            "Chickasaw",
            "Chillicothe",
            "Chilo",
            "Chippewa Lake",
            "Christiansburg",
            "Cincinnati",
            "Circleville",
            "Clarington",
            "Clarksburg",
            "Clarksville",
            "Clay Center",
            "Clayton",
            "Cleveland",
            "Cleves",
            "Clifton",
            "Clinton",
            "Cloverdale",
            "Clyde",
            "Coal Run",
            "Coalton",
            "Coldwater",
            "Colerain",
            "College Corner",
            "Collins",
            "Collinsville",
            "Colton",
            "Columbia",
            "Columbia Station",
            "Columbiana",
            "Columbus",
            "Columbus Grove",
            "Commercial Point",
            "Conesville",
            "Conneaut",
            "Conover",
            "Continental",
            "Convoy",
            "Coolville",
            "Corning",
            "Cortland",
            "Coshocton",
            "Covington",
            "Crane",
            "Creola",
            "Crestline",
            "Creston",
            "Crooksville",
            "Croton",
            "Crown City",
            "Cuba",
            "Cumberland",
            "Curtice",
            "Custar",
            "Cutler",
            "Cuyahoga Falls",
            "Cygnet",
            "Cynthiana",
            "Dalton",
            "Damascus",
            "Danbury",
            "Danville",
            "Dayton",
            "De Graff",
            "Decatur",
            "Deerfield",
            "Deersville",
            "Defiance",
            "Delaware",
            "Dellroy",
            "Delphos",
            "Delta",
            "Dennison",
            "Derby",
            "Derwent",
            "Deshler",
            "Dexter City",
            "Diamond",
            "Dillonvale",
            "Dola",
            "Donnelsville",
            "Dorset",
            "Dover",
            "Doylestown",
            "Dresden",
            "Dublin",
            "Dunbridge",
            "Duncan Falls",
            "Dundee",
            "Dunkirk",
            "Dupont",
            "East Claridon",
            "East Fultonham",
            "East Liberty",
            "East Liverpool",
            "East Palestine",
            "East Rochester",
            "East Sparta",
            "East Springfield",
            "Eastlake",
            "Eaton",
            "Edgerton",
            "Edison",
            "Edon",
            "Eldorado",
            "Elgin",
            "Elkton",
            "Ellsworth",
            "Elmore",
            "Elyria",
            "Empire",
            "Englewood",
            "Enon",
            "Etna",
            "Euclid",
            "Evansport",
            "Fairborn",
            "Fairfield",
            "Fairpoint",
            "Fairview",
            "Farmdale",
            "Farmer",
            "Farmersville",
            "Fayette",
            "Fayetteville",
            "Feesburg",
            "Felicity",
            "Findlay",
            "Flat Rock",
            "Fleming",
            "Fletcher",
            "Flushing",
            "Forest",
            "Fort Jennings",
            "Fort Loramie",
            "Fort Recovery",
            "Fostoria",
            "Fowler",
            "Frankfort",
            "Franklin",
            "Franklin Furnace",
            "Frazeysburg",
            "Fredericksburg",
            "Fredericktown",
            "Freeport",
            "Fremont",
            "Fresno",
            "Friendship",
            "Fulton",
            "Fultonham",
            "Galena",
            "Galion",
            "Gallipolis",
            "Galloway",
            "Gambier",
            "Garrettsville",
            "Gates Mills",
            "Geneva",
            "Genoa",
            "Georgetown",
            "Germantown",
            "Gettysburg",
            "Gibsonburg",
            "Girard",
            "Glandorf",
            "Glencoe",
            "Glenford",
            "Glenmont",
            "Glouster",
            "Gnadenhutten",
            "Gomer",
            "Gordon",
            "Goshen",
            "Grafton",
            "Grand Rapids",
            "Grand River",
            "Granville",
            "Gratiot",
            "Gratis",
            "Graysville",
            "Graytown",
            "Green",
            "Green Camp",
            "Green Springs",
            "Greenfield",
            "Greenford",
            "Greentown",
            "Greenville",
            "Greenwich",
            "Grelton",
            "Grove City",
            "Groveport",
            "Grover Hill",
            "Guysville",
            "Gypsum",
            "Hallsville",
            "Hamden",
            "Hamersville",
            "Hamilton",
            "Hamler",
            "Hammondsville",
            "Hannibal",
            "Hanoverton",
            "Harbor View",
            "Harlem Springs",
            "Harpster",
            "Harrisburg",
            "Harrison",
            "Harrisville",
            "Harrod",
            "Hartford",
            "Hartville",
            "Harveysburg",
            "Haskins",
            "Haverhill",
            "Haviland",
            "Haydenville",
            "Hayesville",
            "Heath",
            "Hebron",
            "Helena",
            "Hicksville",
            "Higginsport",
            "Highland",
            "Hilliard",
            "Hillsboro",
            "Hinckley",
            "Hiram",
            "Hockingport",
            "Holgate",
            "Holland",
            "Hollansburg",
            "Holloway",
            "Holmesville",
            "Homer",
            "Homerville",
            "Homeworth",
            "Hooven",
            "Hopedale",
            "Hopewell",
            "Houston",
            "Howard",
            "Hoytville",
            "Hubbard",
            "Hudson",
            "Huntsburg",
            "Huntsville",
            "Huron",
            "Iberia",
            "Independence",
            "Irondale",
            "Ironton",
            "Irwin",
            "Isle Saint George",
            "Jackson",
            "Jackson Center",
            "Jacksontown",
            "Jacksonville",
            "Jacobsburg",
            "Jamestown",
            "Jasper",
            "Jefferson",
            "Jeffersonville",
            "Jenera",
            "Jeromesville",
            "Jerry City",
            "Jerusalem",
            "Jewell",
            "Jewett",
            "Johnstown",
            "Junction City",
            "Kalida",
            "Kansas",
            "Keene",
            "Kelleys Island",
            "Kensington",
            "Kent",
            "Kenton",
            "Kerr",
            "Kettlersville",
            "Kidron",
            "Kilbourne",
            "Killbuck",
            "Kimbolton",
            "Kings Mills",
            "Kingston",
            "Kingsville",
            "Kinsman",
            "Kipling",
            "Kipton",
            "Kirby",
            "Kirkersville",
            "Kitts Hill",
            "Kunkle",
            "La Rue",
            "Lacarne",
            "Lafayette",
            "Lafferty",
            "Lagrange",
            "Laings",
            "Lake Milton",
            "Lakemore",
            "Lakeside Marblehead",
            "Lakeview",
            "Lakeville",
            "Lakewood",
            "Lancaster",
            "Langsville",
            "Lansing",
            "Latham",
            "Latty",
            "Laura",
            "Laurelville",
            "Leavittsburg",
            "Lebanon",
            "Lees Creek",
            "Leesburg",
            "Leesville",
            "Leetonia",
            "Leipsic",
            "Lemoyne",
            "Lewis Center",
            "Lewisburg",
            "Lewistown",
            "Lewisville",
            "Liberty Center",
            "Lima",
            "Limaville",
            "Lindsey",
            "Lisbon",
            "Litchfield",
            "Lithopolis",
            "Little Hocking",
            "Lockbourne",
            "Lodi",
            "Logan",
            "London",
            "Londonderry",
            "Long Bottom",
            "Lorain",
            "Lore City",
            "Loudonville",
            "Louisville",
            "Loveland",
            "Lowell",
            "Lowellville",
            "Lower Salem",
            "Lucas",
            "Lucasville",
            "Luckey",
            "Ludlow Falls",
            "Lynchburg",
            "Lynx",
            "Lyons",
            "Macedonia",
            "Macksburg",
            "Madison",
            "Magnetic Springs",
            "Magnolia",
            "Maineville",
            "Malaga",
            "Malinta",
            "Malta",
            "Malvern",
            "Manchester",
            "Mansfield",
            "Mantua",
            "Maple Heights",
            "Maplewood",
            "Marathon",
            "Marengo",
            "Maria Stein",
            "Marietta",
            "Marion",
            "Mark Center",
            "Marshallville",
            "Martel",
            "Martin",
            "Martins Ferry",
            "Martinsburg",
            "Martinsville",
            "Marysville",
            "Mason",
            "Massillon",
            "Masury",
            "Maumee",
            "Maximo",
            "Maynard",
            "McArthur",
            "McClure",
            "McComb",
            "McConnelsville",
            "McCutchenville",
            "McDermott",
            "McDonald",
            "McGuffey",
            "Mechanicsburg",
            "Mechanicstown",
            "Medina",
            "Medway",
            "Melmore",
            "Melrose",
            "Mendon",
            "Mentor",
            "Mesopotamia",
            "Metamora",
            "Miamisburg",
            "Miamitown",
            "Miamiville",
            "Middle Bass",
            "Middle Point",
            "Middlebranch",
            "Middleburg",
            "Middlefield",
            "Middleport",
            "Middletown",
            "Midland",
            "Midvale",
            "Milan",
            "Milford",
            "Milford Center",
            "Millbury",
            "Milledgeville",
            "Miller City",
            "Millersburg",
            "Millersport",
            "Millfield",
            "Milton Center",
            "Mineral City",
            "Mineral Ridge",
            "Minerva",
            "Minford",
            "Mingo",
            "Mingo Junction",
            "Minster",
            "Mogadore",
            "Monclova",
            "Monroe",
            "Monroeville",
            "Montezuma",
            "Montpelier",
            "Montville",
            "Morgan",
            "Morral",
            "Morristown",
            "Morrow",
            "Moscow",
            "Mount Blanchard",
            "Mount Cory",
            "Mount Eaton",
            "Mount Gilead",
            "Mount Hope",
            "Mount Liberty",
            "Mount Orab",
            "Mount Perry",
            "Mount Pleasant",
            "Mount Saint Joseph",
            "Mount Sterling",
            "Mount Vernon",
            "Mount Victory",
            "Mowrystown",
            "Moxahala",
            "Munroe Falls",
            "Murray City",
            "Nankin",
            "Napoleon",
            "Nashport",
            "Nashville",
            "Navarre",
            "Neapolis",
            "Neffs",
            "Negley",
            "Nelsonville",
            "Nevada",
            "Neville",
            "New Albany",
            "New Athens",
            "New Bavaria",
            "New Bloomington",
            "New Bremen",
            "New Carlisle",
            "New Concord",
            "New Hampshire",
            "New Haven",
            "New Holland",
            "New Knoxville",
            "New Lebanon",
            "New Lexington",
            "New London",
            "New Madison",
            "New Marshfield",
            "New Matamoras",
            "New Middletown",
            "New Paris",
            "New Philadelphia",
            "New Plymouth",
            "New Richmond",
            "New Riegel",
            "New Rumley",
            "New Springfield",
            "New Straitsville",
            "New Vienna",
            "New Washington",
            "New Waterford",
            "New Weston",
            "Newark",
            "Newbury",
            "Newcomerstown",
            "Newport",
            "Newton Falls",
            "Newtonsville",
            "Ney",
            "Niles",
            "Noble",
            "North Baltimore",
            "North Bend",
            "North Benton",
            "North Bloomfield",
            "North Fairfield",
            "North Georgetown",
            "North Hampton",
            "North Jackson",
            "North Kingsville",
            "North Lawrence",
            "North Lewisburg",
            "North Lima",
            "North Olmsted",
            "North Ridgeville",
            "North Robinson",
            "North Royalton",
            "North Star",
            "Northfield",
            "Northwood",
            "Norwalk",
            "Norwich",
            "Nova",
            "Novelty",
            "Oak Harbor",
            "Oak Hill",
            "Oakwood",
            "Oberlin",
            "Oceola",
            "Ohio City",
            "Okeana",
            "Okolona",
            "Old Fort",
            "Old Washington",
            "Olmsted Falls",
            "Ontario",
            "Orangeville",
            "Oregon",
            "Oregonia",
            "Orient",
            "Orrville",
            "Orwell",
            "Osgood",
            "Ostrander",
            "Ottawa",
            "Ottoville",
            "Otway",
            "Overpeck",
            "Owensville",
            "Oxford",
            "Painesville",
            "Paint",
            "Palestine",
            "Pandora",
            "Paris",
            "Parkman",
            "Pataskala",
            "Patriot",
            "Paulding",
            "Payne",
            "Pedro",
            "Peebles",
            "Pemberton",
            "Pemberville",
            "Peninsula",
            "Perry",
            "Perrysburg",
            "Perrysville",
            "Petersburg",
            "Pettisville",
            "Phillipsburg",
            "Philo",
            "Pickerington",
            "Piedmont",
            "Pierpont",
            "Piketon",
            "Piney Fork",
            "Pioneer",
            "Piqua",
            "Pitsburg",
            "Plain City",
            "Plainfield",
            "Pleasant City",
            "Pleasant Hill",
            "Pleasant Plain",
            "Pleasantville",
            "Plymouth",
            "Polk",
            "Pomeroy",
            "Port Clinton",
            "Port Jefferson",
            "Port Washington",
            "Port William",
            "Portage",
            "Portland",
            "Portsmouth",
            "Potsdam",
            "Powell",
            "Powhatan Point",
            "Proctorville",
            "Prospect",
            "Put In Bay",
            "Quaker City",
            "Quincy",
            "Racine",
            "Radnor",
            "Randolph",
            "Rarden",
            "Ravenna",
            "Rawson",
            "Ray",
            "Rayland",
            "Raymond",
            "Reedsville",
            "Reesville",
            "Reno",
            "Republic",
            "Reynoldsburg",
            "Richfield",
            "Richland",
            "Richmond",
            "Richmond Dale",
            "Richwood",
            "Ridgeville",
            "Ridgeville Corners",
            "Ridgeway",
            "Rio Grande",
            "Ripley",
            "Risingsun",
            "Rittman",
            "Robertsville",
            "Rock Camp",
            "Rock Creek",
            "Rockbridge",
            "Rockford",
            "Rocky Ridge",
            "Rocky River",
            "Rogers",
            "Rome",
            "Rootstown",
            "Roseville",
            "Rosewood",
            "Ross",
            "Rossburg",
            "Rossford",
            "Roundhead",
            "Rudolph",
            "Rushsylvania",
            "Rushville",
            "Russells Point",
            "Russellville",
            "Russia",
            "Rutland",
            "Sabina",
            "Saint Clairsville",
            "Saint Henry",
            "Saint Johns",
            "Saint Louisville",
            "Saint Marys",
            "Saint Paris",
            "Salem",
            "Salesville",
            "Salineville",
            "Sandusky",
            "Sandyville",
            "Sarahsville",
            "Sardinia",
            "Sardis",
            "Savannah",
            "Scio",
            "Scioto Furnace",
            "Scott",
            "Scottown",
            "Seaman",
            "Sebring",
            "Sedalia",
            "Senecaville",
            "Seven Mile",
            "Seville",
            "Shade",
            "Shadyside",
            "Shandon",
            "Sharon Center",
            "Sharpsburg",
            "Shauck",
            "Shawnee",
            "Sheffield Lake",
            "Shelby",
            "Sherrodsville",
            "Sherwood",
            "Shiloh",
            "Short Creek",
            "Shreve",
            "Sidney",
            "Sinking Spring",
            "Smithfield",
            "Smithville",
            "Solon",
            "Somerdale",
            "Somerset",
            "Somerville",
            "South Bloomingville",
            "South Charleston",
            "South Lebanon",
            "South Point",
            "South Salem",
            "South Solon",
            "South Vienna",
            "South Webster",
            "Southington",
            "Sparta",
            "Spencer",
            "Spencerville",
            "Spring Valley",
            "Springboro",
            "Springfield",
            "Stafford",
            "Sterling",
            "Steubenville",
            "Stewart",
            "Stillwater",
            "Stockdale",
            "Stockport",
            "Stokes",
            "Stone Creek",
            "Stony Ridge",
            "Stout",
            "Stoutsville",
            "Stow",
            "Strasburg",
            "Stratton",
            "Streetsboro",
            "Strongsville",
            "Struthers",
            "Stryker",
            "Sugar Grove",
            "Sugarcreek",
            "Sullivan",
            "Sulphur Springs",
            "Summerfield",
            "Summit Station",
            "Summitville",
            "Sunbury",
            "Swanton",
            "Sycamore",
            "Sycamore Valley",
            "Sylvania",
            "Syracuse",
            "Tallmadge",
            "Tarlton",
            "Terrace Park",
            "The Plains",
            "Thompson",
            "Thornville",
            "Thurman",
            "Thurston",
            "Tiffin",
            "Tiltonsville",
            "Tipp City",
            "Tippecanoe",
            "Tiro",
            "Toledo",
            "Tontogany",
            "Torch",
            "Toronto",
            "Tremont City",
            "Trenton",
            "Trimble",
            "Trinway",
            "Troy",
            "Tuppers Plains",
            "Tuscarawas",
            "Twinsburg",
            "Uhrichsville",
            "Union",
            "Union City",
            "Union Furnace",
            "Unionport",
            "Uniontown",
            "Unionville",
            "Unionville Center",
            "Uniopolis",
            "Upper Sandusky",
            "Urbana",
            "Utica",
            "Valley City",
            "Van Buren",
            "Van Wert",
            "Vandalia",
            "Vanlue",
            "Vaughnsville",
            "Venedocia",
            "Vermilion",
            "Verona",
            "Versailles",
            "Vickery",
            "Vienna",
            "Vincent",
            "Vinton",
            "Wadsworth",
            "Wakefield",
            "Wakeman",
            "Walbridge",
            "Waldo",
            "Walhonding",
            "Walnut Creek",
            "Wapakoneta",
            "Warnock",
            "Warren",
            "Warsaw",
            "Washington Court House",
            "Washingtonville",
            "Waterford",
            "Waterloo",
            "Watertown",
            "Waterville",
            "Wauseon",
            "Waverly",
            "Wayland",
            "Wayne",
            "Waynesburg",
            "Waynesfield",
            "Waynesville",
            "Wellington",
            "Wellston",
            "Wellsville",
            "West Alexandria",
            "West Chester",
            "West Elkton",
            "West Farmington",
            "West Jefferson",
            "West Lafayette",
            "West Liberty",
            "West Manchester",
            "West Mansfield",
            "West Millgrove",
            "West Milton",
            "West Point",
            "West Portsmouth",
            "West Rushville",
            "West Salem",
            "West Union",
            "West Unity",
            "Westerville",
            "Westfield Center",
            "Westlake",
            "Weston",
            "Westville",
            "Wharton",
            "Wheelersburg",
            "Whipple",
            "White Cottage",
            "Whitehouse",
            "Wickliffe",
            "Wilberforce",
            "Wilkesville",
            "Willard",
            "Williamsburg",
            "Williamsfield",
            "Williamsport",
            "Williamstown",
            "Williston",
            "Willoughby",
            "Willow Wood",
            "Willshire",
            "Wilmington",
            "Wilmot",
            "Winchester",
            "Windham",
            "Windsor",
            "Winesburg",
            "Wingett Run",
            "Winona",
            "Wolf Run",
            "Woodsfield",
            "Woodstock",
            "Woodville",
            "Wooster",
            "Wren",
            "Xenia",
            "Yellow Springs",
            "Yorkshire",
            "Yorkville",
            "Youngstown",
            "Zaleski",
            "Zanesfield",
            "Zanesville",
            "Zoar"
        ]
    },
    {
        "state": "Oklahoma",
        "abbr": "OK",
        "cities": [
            "Achille",
            "Ada",
            "Adair",
            "Adams",
            "Addington",
            "Afton",
            "Agra",
            "Albany",
            "Albert",
            "Albion",
            "Alderson",
            "Alex",
            "Aline",
            "Allen",
            "Altus",
            "Altus AFB",
            "Alva",
            "Amber",
            "Ames",
            "Amorita",
            "Anadarko",
            "Antlers",
            "Apache",
            "Arapaho",
            "Arcadia",
            "Ardmore",
            "Arkoma",
            "Arnett",
            "Asher",
            "Atoka",
            "Atwood",
            "Avant",
            "Balko",
            "Barnsdall",
            "Bartlesville",
            "Battiest",
            "Beaver",
            "Beggs",
            "Bennington",
            "Bessie",
            "Bethany",
            "Bethel",
            "Big Cabin",
            "Billings",
            "Binger",
            "Bison",
            "Bixby",
            "Blackwell",
            "Blair",
            "Blanchard",
            "Blanco",
            "Blocker",
            "Bluejacket",
            "Boise City",
            "Bokchito",
            "Bokoshe",
            "Boley",
            "Boswell",
            "Bowlegs",
            "Bowring",
            "Boynton",
            "Bradley",
            "Braggs",
            "Braman",
            "Bray",
            "Bristow",
            "Broken Arrow",
            "Broken Bow",
            "Bromide",
            "Buffalo",
            "Bunch",
            "Burbank",
            "Burlington",
            "Burneyville",
            "Burns Flat",
            "Butler",
            "Byars",
            "Cache",
            "Caddo",
            "Calera",
            "Calumet",
            "Calvin",
            "Camargo",
            "Cameron",
            "Canadian",
            "Caney",
            "Canton",
            "Canute",
            "Cardin",
            "Carmen",
            "Carnegie",
            "Carney",
            "Carrier",
            "Carter",
            "Cartwright",
            "Cashion",
            "Castle",
            "Catoosa",
            "Cement",
            "Centrahoma",
            "Chandler",
            "Chattanooga",
            "Checotah",
            "Chelsea",
            "Cherokee",
            "Chester",
            "Cheyenne",
            "Chickasha",
            "Choctaw",
            "Chouteau",
            "Claremore",
            "Clarita",
            "Clayton",
            "Cleo Springs",
            "Cleveland",
            "Clinton",
            "Coalgate",
            "Colbert",
            "Colcord",
            "Coleman",
            "Collinsville",
            "Colony",
            "Comanche",
            "Commerce",
            "Concho",
            "Connerville",
            "Cookson",
            "Copan",
            "Cordell",
            "Corn",
            "Council Hill",
            "Countyline",
            "Covington",
            "Coweta",
            "Coyle",
            "Crawford",
            "Crescent",
            "Cromwell",
            "Crowder",
            "Cushing",
            "Custer City",
            "Cyril",
            "Dacoma",
            "Daisy",
            "Davenport",
            "Davidson",
            "Davis",
            "Deer Creek",
            "Delaware",
            "Depew",
            "Devol",
            "Dewar",
            "Dewey",
            "Dibble",
            "Dill City",
            "Disney",
            "Dodge",
            "Dougherty",
            "Douglas",
            "Dover",
            "Drummond",
            "Drumright",
            "Duke",
            "Duncan",
            "Durant",
            "Durham",
            "Dustin",
            "Eagletown",
            "Eakly",
            "Earlsboro",
            "Edmond",
            "El Reno",
            "Eldorado",
            "Elgin",
            "Elk City",
            "Elmer",
            "Elmore City",
            "Enid",
            "Erick",
            "Eucha",
            "Eufaula",
            "Fairfax",
            "Fairland",
            "Fairmont",
            "Fairview",
            "Fanshawe",
            "Fargo",
            "Faxon",
            "Fay",
            "Felt",
            "Finley",
            "Fittstown",
            "Fitzhugh",
            "Fletcher",
            "Forgan",
            "Fort Cobb",
            "Fort Gibson",
            "Fort Sill",
            "Fort Supply",
            "Fort Towson",
            "Foss",
            "Foster",
            "Fox",
            "Foyil",
            "Francis",
            "Frederick",
            "Freedom",
            "Gage",
            "Gans",
            "Garber",
            "Garvin",
            "Gate",
            "Geary",
            "Gene Autry",
            "Geronimo",
            "Glencoe",
            "Glenpool",
            "Golden",
            "Goltry",
            "Goodwell",
            "Gore",
            "Gotebo",
            "Gould",
            "Gowen",
            "Gracemont",
            "Graham",
            "Grandfield",
            "Granite",
            "Grant",
            "Greenfield",
            "Grove",
            "Guthrie",
            "Guymon",
            "Haileyville",
            "Hallett",
            "Hammon",
            "Hanna",
            "Hardesty",
            "Harrah",
            "Hartshorne",
            "Haskell",
            "Hastings",
            "Haworth",
            "Headrick",
            "Healdton",
            "Heavener",
            "Helena",
            "Hendrix",
            "Hennepin",
            "Hennessey",
            "Henryetta",
            "Hillsdale",
            "Hinton",
            "Hitchcock",
            "Hitchita",
            "Hobart",
            "Hodgen",
            "Holdenville",
            "Hollis",
            "Hollister",
            "Hominy",
            "Honobia",
            "Hooker",
            "Hopeton",
            "Howe",
            "Hoyt",
            "Hugo",
            "Hulbert",
            "Hunter",
            "Hydro",
            "Idabel",
            "Indiahoma",
            "Indianola",
            "Inola",
            "Isabella",
            "Jay",
            "Jenks",
            "Jennings",
            "Jet",
            "Jones",
            "Kansas",
            "Kaw City",
            "Kellyville",
            "Kemp",
            "Kenefic",
            "Kenton",
            "Keota",
            "Kerrick",
            "Ketchum",
            "Keyes",
            "Kiefer",
            "Kingfisher",
            "Kingston",
            "Kinta",
            "Kiowa",
            "Knowles",
            "Konawa",
            "Krebs",
            "Kremlin",
            "Lahoma",
            "Lamar",
            "Lamont",
            "Lane",
            "Langley",
            "Langston",
            "Laverne",
            "Lawton",
            "Lebanon",
            "Leedey",
            "Leflore",
            "Lehigh",
            "Lenapah",
            "Leon",
            "Leonard",
            "Lequire",
            "Lexington",
            "Lindsay",
            "Loco",
            "Locust Grove",
            "Lone Grove",
            "Lone Wolf",
            "Longdale",
            "Lookeba",
            "Loveland",
            "Loyal",
            "Lucien",
            "Luther",
            "Macomb",
            "Madill",
            "Manchester",
            "Mangum",
            "Manitou",
            "Mannford",
            "Mannsville",
            "Maramec",
            "Marble City",
            "Marietta",
            "Marland",
            "Marlow",
            "Marshall",
            "Martha",
            "Maud",
            "May",
            "Mayfield",
            "Maysville",
            "Mazie",
            "Mcalester",
            "McCord",
            "Mccurtain",
            "Mcloud",
            "Mead",
            "Medford",
            "Medicine Park",
            "Meeker",
            "Meers",
            "Meno",
            "Meridian",
            "Miami",
            "Milburn",
            "Milfay",
            "Mill Creek",
            "Millerton",
            "Minco",
            "Moffett",
            "Monroe",
            "Moodys",
            "Mooreland",
            "Morris",
            "Morrison",
            "Mounds",
            "Mountain Park",
            "Mountain View",
            "Moyers",
            "Muldrow",
            "Mulhall",
            "Muse",
            "Muskogee",
            "Mustang",
            "Mutual",
            "Nardin",
            "Nash",
            "Nashoba",
            "Newalla",
            "Newcastle",
            "Newkirk",
            "Nicoma Park",
            "Ninnekah",
            "Noble",
            "Norman",
            "North Miami",
            "Nowata",
            "Oakhurst",
            "Oaks",
            "Oakwood",
            "Ochelata",
            "Oilton",
            "Okarche",
            "Okay",
            "Okeene",
            "Okemah",
            "Oklahoma City",
            "Okmulgee",
            "Oktaha",
            "Olustee",
            "Omega",
            "Oologah",
            "Orlando",
            "Osage",
            "Oscar",
            "Overbrook",
            "Owasso",
            "Paden",
            "Panama",
            "Panola",
            "Paoli",
            "Park Hill",
            "Pauls Valley",
            "Pawhuska",
            "Pawnee",
            "Peggs",
            "Perkins",
            "Pernell",
            "Perry",
            "Picher",
            "Pickens",
            "Piedmont",
            "Pittsburg",
            "Platter",
            "Pocasset",
            "Pocola",
            "Ponca City",
            "Pond Creek",
            "Porter",
            "Porum",
            "Poteau",
            "Prague",
            "Preston",
            "Proctor",
            "Prue",
            "Pryor",
            "Purcell",
            "Putnam",
            "Quapaw",
            "Quinton",
            "Ralston",
            "Ramona",
            "Randlett",
            "Ratliff City",
            "Rattan",
            "Ravia",
            "Red Oak",
            "Red Rock",
            "Redbird",
            "Rentiesville",
            "Reydon",
            "Ringling",
            "Ringold",
            "Ringwood",
            "Ripley",
            "Rocky",
            "Roff",
            "Roland",
            "Roosevelt",
            "Rose",
            "Rosston",
            "Rufe",
            "Rush Springs",
            "Ryan",
            "S Coffeyville",
            "Saint Louis",
            "Salina",
            "Sallisaw",
            "Sand Springs",
            "Sapulpa",
            "Sasakwa",
            "Savanna",
            "Sawyer",
            "Sayre",
            "Schulter",
            "Seiling",
            "Seminole",
            "Sentinel",
            "Shady Point",
            "Shamrock",
            "Sharon",
            "Shattuck",
            "Shawnee",
            "Shidler",
            "Skiatook",
            "Slick",
            "Smithville",
            "Snow",
            "Snyder",
            "Soper",
            "Southard",
            "Sparks",
            "Spavinaw",
            "Spencer",
            "Spencerville",
            "Sperry",
            "Spiro",
            "Springer",
            "Sterling",
            "Stidham",
            "Stigler",
            "Stillwater",
            "Stilwell",
            "Stonewall",
            "Strang",
            "Stratford",
            "Stringtown",
            "Stroud",
            "Stuart",
            "Sulphur",
            "Sweetwater",
            "Swink",
            "Taft",
            "Tahlequah",
            "Talala",
            "Talihina",
            "Taloga",
            "Tatums",
            "Tecumseh",
            "Temple",
            "Terlton",
            "Terral",
            "Texhoma",
            "Texola",
            "Thackerville",
            "Thomas",
            "Tipton",
            "Tishomingo",
            "Tonkawa",
            "Tryon",
            "Tullahassee",
            "Tulsa",
            "Tupelo",
            "Turpin",
            "Tuskahoma",
            "Tussy",
            "Tuttle",
            "Twin Oaks",
            "Tyrone",
            "Union City",
            "Valliant",
            "Velma",
            "Vera",
            "Verden",
            "Vian",
            "Vici",
            "Vinita",
            "Vinson",
            "Wagoner",
            "Wainwright",
            "Wakita",
            "Walters",
            "Wanette",
            "Wann",
            "Wapanucka",
            "Wardville",
            "Warner",
            "Washington",
            "Washita",
            "Watonga",
            "Watson",
            "Watts",
            "Waukomis",
            "Waurika",
            "Wayne",
            "Waynoka",
            "Weatherford",
            "Webbers Falls",
            "Welch",
            "Weleetka",
            "Welling",
            "Wellston",
            "Westville",
            "Wetumka",
            "Wewoka",
            "Wheatland",
            "Whitefield",
            "Whitesboro",
            "Wilburton",
            "Willow",
            "Wilson",
            "Wister",
            "Woodward",
            "Wright City",
            "Wyandotte",
            "Wynnewood",
            "Wynona",
            "Yale",
            "Yukon"
        ]
    },
    {
        "state": "Oregon",
        "abbr": "OR",
        "cities": [
            "Adams",
            "Adel",
            "Adrian",
            "Agness",
            "Albany",
            "Allegany",
            "Alsea",
            "Alvadore",
            "Amity",
            "Antelope",
            "Arch Cape",
            "Arlington",
            "Arock",
            "Ashland",
            "Ashwood",
            "Astoria",
            "Athena",
            "Aumsville",
            "Aurora",
            "Azalea",
            "Baker City",
            "Bandon",
            "Banks",
            "Bates",
            "Bay City",
            "Beatty",
            "Beaver",
            "Beavercreek",
            "Beaverton",
            "Bend",
            "Blachly",
            "Blodgett",
            "Blue River",
            "Bly",
            "Boardman",
            "Bonanza",
            "Boring",
            "Bridal Veil",
            "Bridgeport",
            "Brightwood",
            "Broadbent",
            "Brogan",
            "Brookings",
            "Brothers",
            "Brownsville",
            "Burns",
            "Butte Falls",
            "Buxton",
            "Camas Valley",
            "Camp Sherman",
            "Canby",
            "Cannon Beach",
            "Canyon City",
            "Canyonville",
            "Carlton",
            "Cascade Locks",
            "Cascadia",
            "Cave Junction",
            "Cayuse",
            "Central Point",
            "Chemult",
            "Cheshire",
            "Chiloquin",
            "Christmas Valley",
            "Clackamas",
            "Clatskanie",
            "Cloverdale",
            "Colton",
            "Columbia City",
            "Condon",
            "Coos Bay",
            "Coquille",
            "Corbett",
            "Cornelius",
            "Corvallis",
            "Cottage Grove",
            "Cove",
            "Crabtree",
            "Crane",
            "Crater Lake",
            "Crawfordsville",
            "Crescent",
            "Crescent Lake",
            "Creswell",
            "Culp Creek",
            "Culver",
            "Curtin",
            "Dairy",
            "Dallas",
            "Days Creek",
            "Dayton",
            "Dayville",
            "Deadwood",
            "Deer Island",
            "Depoe Bay",
            "Detroit",
            "Dexter",
            "Diamond",
            "Dillard",
            "Donald",
            "Dorena",
            "Drain",
            "Drewsey",
            "Dufur",
            "Dundee",
            "Durkee",
            "Eagle Creek",
            "Eagle Point",
            "Echo",
            "Eddyville",
            "Elgin",
            "Elkton",
            "Elmira",
            "Enterprise",
            "Estacada",
            "Eugene",
            "Fairview",
            "Fall Creek",
            "Falls City",
            "Fields",
            "Florence",
            "Forest Grove",
            "Fort Klamath",
            "Fort Rock",
            "Fossil",
            "Foster",
            "Fox",
            "Frenchglen",
            "Gales Creek",
            "Gardiner",
            "Garibaldi",
            "Gaston",
            "Gates",
            "Gervais",
            "Gilchrist",
            "Gladstone",
            "Glendale",
            "Gleneden Beach",
            "Glide",
            "Gold Beach",
            "Gold Hill",
            "Government Camp",
            "Grand Ronde",
            "Grants Pass",
            "Grass Valley",
            "Gresham",
            "Haines",
            "Halfway",
            "Halsey",
            "Hammond",
            "Harper",
            "Harrisburg",
            "Hebo",
            "Helix",
            "Heppner",
            "Hereford",
            "Hermiston",
            "Hillsboro",
            "Hines",
            "Hood River",
            "Hubbard",
            "Huntington",
            "Idanha",
            "Idleyld Park",
            "Imbler",
            "Imnaha",
            "Independence",
            "Ione",
            "Ironside",
            "Irrigon",
            "Jacksonville",
            "Jamieson",
            "Jefferson",
            "John Day",
            "Joseph",
            "Junction City",
            "Juntura",
            "Keizer",
            "Keno",
            "Kent",
            "Kerby",
            "Kimberly",
            "Klamath Falls",
            "La Grande",
            "La Pine",
            "Lafayette",
            "Lake Oswego",
            "Lakeside",
            "Lakeview",
            "Langlois",
            "Lawen",
            "Lebanon",
            "Lexington",
            "Lincoln City",
            "Logsden",
            "Long Creek",
            "Lorane",
            "Lostine",
            "Lowell",
            "Lyons",
            "Madras",
            "Malin",
            "Manning",
            "Manzanita",
            "Mapleton",
            "Marcola",
            "Marion",
            "Marylhurst",
            "Maupin",
            "Mcminnville",
            "Meacham",
            "Medford",
            "Mehama",
            "Merlin",
            "Merrill",
            "Midland",
            "Mikkalo",
            "Mill City",
            "Milton Freewater",
            "Mitchell",
            "Molalla",
            "Monmouth",
            "Monroe",
            "Monument",
            "Moro",
            "Mosier",
            "Mount Angel",
            "Mount Hood Parkdale",
            "Mount Vernon",
            "Mulino",
            "Murphy",
            "Myrtle Creek",
            "Myrtle Point",
            "Nehalem",
            "Neotsu",
            "Neskowin",
            "Netarts",
            "Newberg",
            "Newport",
            "North Bend",
            "North Plains",
            "North Powder",
            "Norway",
            "Noti",
            "O Brien",
            "Oakland",
            "Oakridge",
            "Oceanside",
            "Odell",
            "Ontario",
            "Ophir",
            "Oregon City",
            "Otis",
            "Otter Rock",
            "Oxbow",
            "Pacific City",
            "Paisley",
            "Paulina",
            "Pendleton",
            "Philomath",
            "Phoenix",
            "Pilot Rock",
            "Pleasant Hill",
            "Plush",
            "Port Orford",
            "Portland",
            "Post",
            "Powell Butte",
            "Powers",
            "Prairie City",
            "Princeton",
            "Prineville",
            "Prospect",
            "Rainier",
            "Raleigh Hills",
            "Redmond",
            "Reedsport",
            "Remote",
            "Rhododendron",
            "Richland",
            "Rickreall",
            "Riddle",
            "Riley",
            "Ritter",
            "Riverside",
            "Rockaway Beach",
            "Rogue River",
            "Rose Lodge",
            "Roseburg",
            "Roseburg North",
            "Rufus",
            "Saginaw",
            "Saint Benedict",
            "Saint Helens",
            "Saint Paul",
            "Salem",
            "Sandy",
            "Scappoose",
            "Scio",
            "Scotts Mills",
            "Scottsburg",
            "Seal Rock",
            "Seaside",
            "Selma",
            "Seneca",
            "Shady Cove",
            "Shaniko",
            "Shedd",
            "Sheridan",
            "Sherwood",
            "Siletz",
            "Silver Lake",
            "Silverton",
            "Sisters",
            "Sixes",
            "South Beach",
            "Sprague River",
            "Spray",
            "Springfield",
            "Stanfield",
            "Stayton",
            "Sublimity",
            "Summer Lake",
            "Summerville",
            "Sumpter",
            "Sutherlin",
            "Sweet Home",
            "Swisshome",
            "Talent",
            "Tangent",
            "Tenmile",
            "Terrebonne",
            "The Dalles",
            "Thurston",
            "Tidewater",
            "Tillamook",
            "Tiller",
            "Timber",
            "Toledo",
            "Tolovana Park",
            "Trail",
            "Troutdale",
            "Tualatin",
            "Turner",
            "Tygh Valley",
            "Ukiah",
            "Umatilla",
            "Umpqua",
            "Union",
            "Unity",
            "Vale",
            "Veneta",
            "Vernonia",
            "Vida",
            "Waldport",
            "Wallowa",
            "Walterville",
            "Walton",
            "Warm Springs",
            "Warren",
            "Warrenton",
            "Wasco",
            "Wedderburn",
            "Welches",
            "West Linn",
            "Westfall",
            "Westfir",
            "Westlake",
            "Weston",
            "Wheeler",
            "White City",
            "Wilbur",
            "Wilderville",
            "Willamina",
            "Williams",
            "Wilsonville",
            "Winchester",
            "Winston",
            "Wolf Creek",
            "Woodburn",
            "Yachats",
            "Yamhill",
            "Yoncalla"
        ]
    },
    {
        "state": "Pennsylvania",
        "abbr": "PA",
        "cities": [
            "Aaronsburg",
            "Abbottstown",
            "Abington",
            "Ackermanville",
            "Acme",
            "Acosta",
            "Adah",
            "Adamsburg",
            "Adamstown",
            "Adamsville",
            "Addison",
            "Adrian",
            "Airville",
            "Akron",
            "Alba",
            "Albion",
            "Albrightsville",
            "Alburtis",
            "Aldenville",
            "Aleppo",
            "Alexandria",
            "Aliquippa",
            "Allenport",
            "Allensville",
            "Allentown",
            "Allenwood",
            "Allison",
            "Allison Park",
            "Allport",
            "Almedia",
            "Alsace",
            "Altoona",
            "Alum Bank",
            "Alverda",
            "Alverton",
            "Amberson",
            "Ambler",
            "Ambridge",
            "Amity",
            "Analomink",
            "Andreas",
            "Anita",
            "Annville",
            "Antes Fort",
            "Apollo",
            "Aquashicola",
            "Arcadia",
            "Archbald",
            "Arcola",
            "Ardara",
            "Ardmore",
            "Arendtsville",
            "Aristes",
            "Armagh",
            "Armbrust",
            "Arnot",
            "Arona",
            "Artemas",
            "Ashfield",
            "Ashland",
            "Ashville",
            "Aspers",
            "Aston",
            "Atglen",
            "Athens",
            "Atlantic",
            "Atlasburg",
            "Auburn",
            "Audubon",
            "Aultman",
            "Austin",
            "Avella",
            "Avis",
            "Avondale",
            "Avonmore",
            "Baden",
            "Bainbridge",
            "Bairdford",
            "Bakers Summit",
            "Bakerstown",
            "Bala Cynwyd",
            "Bally",
            "Bangor",
            "Barnesboro",
            "Barnesville",
            "Bart",
            "Barto",
            "Bartonsville",
            "Bath",
            "Bausman",
            "Beach Haven",
            "Beach Lake",
            "Beallsville",
            "Bear Creek",
            "Bear Lake",
            "Beaver",
            "Beaver Falls",
            "Beaver Meadows",
            "Beaver Springs",
            "Beaverdale",
            "Beavertown",
            "Beccaria",
            "Bechtelsville",
            "Bedford",
            "Bedminster",
            "Beech Creek",
            "Belle Vernon",
            "Bellefonte",
            "Belleville",
            "Bellwood",
            "Belsano",
            "Bendersville",
            "Benezett",
            "Bensalem",
            "Bentleyville",
            "Benton",
            "Berlin",
            "Bernville",
            "Berrysburg",
            "Berwick",
            "Berwyn",
            "Bessemer",
            "Bethel",
            "Bethel Park",
            "Bethlehem",
            "Beyer",
            "Big Cove Tannery",
            "Big Run",
            "Bigler",
            "Biglerville",
            "Birchrunville",
            "Bird In Hand",
            "Birdsboro",
            "Black Lick",
            "Blain",
            "Blairs Mills",
            "Blairsville",
            "Blakeslee",
            "Blanchard",
            "Blandburg",
            "Blandon",
            "Bloomfield",
            "Blooming Glen",
            "Bloomsburg",
            "Blossburg",
            "Blue Ball",
            "Blue Bell",
            "Blue Ridge Summit",
            "Boalsburg",
            "Bobtown",
            "Bodines",
            "Boiling Springs",
            "Bolivar",
            "Boswell",
            "Bovard",
            "Bowers",
            "Bowmansdale",
            "Bowmanstown",
            "Bowmansville",
            "Boyers",
            "Boyertown",
            "Boynton",
            "Brackenridge",
            "Brackney",
            "Braddock",
            "Bradenville",
            "Bradford",
            "Bradfordwoods",
            "Branchdale",
            "Branchton",
            "Brandamore",
            "Brandy Camp",
            "Brave",
            "Breezewood",
            "Breinigsville",
            "Bridgeport",
            "Bridgeton",
            "Bridgeville",
            "Brier Hill",
            "Brisbin",
            "Bristol",
            "Broad Top",
            "Brockport",
            "Brockton",
            "Brockway",
            "Brodheadsville",
            "Brogue",
            "Brookhaven",
            "Brooklyn",
            "Brookville",
            "Broomall",
            "Brownfield",
            "Brownstown",
            "Brownsville",
            "Bruin",
            "Brush Creek",
            "Brush Valley",
            "Bryn Athyn",
            "Bryn Mawr",
            "Buck Hill Falls",
            "Buckingham",
            "Buena Vista",
            "Buffalo Mills",
            "Bulger",
            "Bunola",
            "Burgettstown",
            "Burlington",
            "Burnham",
            "Burnside",
            "Burnt Cabins",
            "Bushkill",
            "Butler",
            "Byrnedale",
            "Cabot",
            "Cadogan",
            "Cairnbrook",
            "California",
            "Callensburg",
            "Callery",
            "Calumet",
            "Calvin",
            "Cambra",
            "Cambridge Springs",
            "Camp Hill",
            "Campbelltown",
            "Camptown",
            "Canadensis",
            "Canonsburg",
            "Canton",
            "Carbondale",
            "Cardale",
            "Carlisle",
            "Carlton",
            "Carmichaels",
            "Carnegie",
            "Carrolltown",
            "Carversville",
            "Cashtown",
            "Cassandra",
            "Cassville",
            "Castanea",
            "Catasauqua",
            "Catawissa",
            "Cecil",
            "Cedar Run",
            "Cedars",
            "Center Valley",
            "Centerport",
            "Centerville",
            "Central City",
            "Centralia",
            "Centre Hall",
            "Chadds Ford",
            "Chalfont",
            "Chalk Hill",
            "Chambersburg",
            "Chambersville",
            "Champion",
            "Chandlers Valley",
            "Charleroi",
            "Chatham",
            "Cheltenham",
            "Cherry Tree",
            "Cherryville",
            "Chest Springs",
            "Chester",
            "Chester Heights",
            "Chester Springs",
            "Chestnut Ridge",
            "Cheswick",
            "Cheyney",
            "Chicora",
            "Chinchilla",
            "Christiana",
            "Clairton",
            "Clarence",
            "Clarendon",
            "Claridge",
            "Clarington",
            "Clarion",
            "Clark",
            "Clarks Mills",
            "Clarks Summit",
            "Clarksburg",
            "Clarksville",
            "Claysburg",
            "Claysville",
            "Clearfield",
            "Clearville",
            "Clifford",
            "Climax",
            "Clinton",
            "Clintonville",
            "Clune",
            "Clymer",
            "Coal Center",
            "Coal Township",
            "Coaldale",
            "Coalport",
            "Coatesville",
            "Coburn",
            "Cochranton",
            "Cochranville",
            "Cocolamus",
            "Codorus",
            "Cogan Station",
            "Cokeburg",
            "Collegeville",
            "Colmar",
            "Columbia",
            "Columbia Cross Roads",
            "Columbus",
            "Colver",
            "Commodore",
            "Concord",
            "Concordville",
            "Conestoga",
            "Confluence",
            "Conneaut Lake",
            "Conneautville",
            "Connellsville",
            "Connoquenessing",
            "Conshohocken",
            "Conway",
            "Conyngham",
            "Cooksburg",
            "Coolspring",
            "Coopersburg",
            "Cooperstown",
            "Coplay",
            "Coral",
            "Coraopolis",
            "Cornwall",
            "Corry",
            "Corsica",
            "Coudersport",
            "Coulters",
            "Coupon",
            "Covington",
            "Cowanesque",
            "Cowansville",
            "Crabtree",
            "Craley",
            "Cranberry",
            "Cranberry Twp",
            "Cranesville",
            "Creamery",
            "Creekside",
            "Creighton",
            "Crescent",
            "Cresco",
            "Cresson",
            "Cressona",
            "Crosby",
            "Cross Fork",
            "Crown",
            "Croydon",
            "Crucible",
            "Crum Lynne",
            "Crystal Spring",
            "Cuddy",
            "Cumbola",
            "Cumru",
            "Curllsville",
            "Curryville",
            "Curtisville",
            "Curwensville",
            "Custer City",
            "Cyclone",
            "Dagus Mines",
            "Daisytown",
            "Dallas",
            "Dallastown",
            "Dalmatia",
            "Dalton",
            "Damascus",
            "Danboro",
            "Danielsville",
            "Danville",
            "Darby",
            "Darlington",
            "Darragh",
            "Dauberville",
            "Dauphin",
            "Davidsville",
            "Dawson",
            "Dayton",
            "De Lancey",
            "De Young",
            "Defiance",
            "Delano",
            "Delaware Water Gap",
            "Delmont",
            "Delta",
            "Denbo",
            "Denver",
            "Derrick City",
            "Derry",
            "Devault",
            "Devon",
            "Dewart",
            "Dickerson Run",
            "Dickson City",
            "Dilliner",
            "Dillsburg",
            "Dilltown",
            "Dimock",
            "Dingman",
            "Dingmans Ferry",
            "Distant",
            "Dixonville",
            "Donegal",
            "Donora",
            "Dornsife",
            "Douglassville",
            "Dover",
            "Downingtown",
            "Doylesburg",
            "Doylestown",
            "Dravosburg",
            "Dresher",
            "Drexel Hill",
            "Drifting",
            "Drifton",
            "Driftwood",
            "Drumore",
            "Drums",
            "Dry Run",
            "Du Bois",
            "Dublin",
            "Dudley",
            "Duke Center",
            "Dunbar",
            "Duncannon",
            "Duncansville",
            "Dunlevy",
            "Dunlo",
            "Duquesne",
            "Durham",
            "Duryea",
            "Dushore",
            "Dysart",
            "Eagles Mere",
            "Eagleville",
            "Earlington",
            "Earlville",
            "East Berlin",
            "East Brady",
            "East Butler",
            "East Earl",
            "East Fairfield",
            "East Freedom",
            "East Greenville",
            "East Hickory",
            "East McKeesport",
            "East Millsboro",
            "East Petersburg",
            "East Pittsburgh",
            "East Prospect",
            "East Smethport",
            "East Smithfield",
            "East Springfield",
            "East Stroudsburg",
            "East Texas",
            "East Vandergrift",
            "East Waterford",
            "Easton",
            "Eau Claire",
            "Ebensburg",
            "Ebervale",
            "Edgemont",
            "Edinboro",
            "Edinburg",
            "Edmon",
            "Effort",
            "Eighty Four",
            "Elco",
            "Eldersville",
            "Elderton",
            "Eldred",
            "Elgin",
            "Elizabeth",
            "Elizabethtown",
            "Elizabethville",
            "Elkins Park",
            "Elkland",
            "Elliottsburg",
            "Ellsworth",
            "Ellwood City",
            "Elm",
            "Elmhurst",
            "Elmora",
            "Elrama",
            "Elton",
            "Elverson",
            "Elysburg",
            "Emeigh",
            "Emigsville",
            "Emlenton",
            "Emmaus",
            "Emporium",
            "Endeavor",
            "Enola",
            "Enon Valley",
            "Entriken",
            "Ephrata",
            "Equinunk",
            "Erie",
            "Ernest",
            "Erwinna",
            "Essington",
            "Etters",
            "Evans City",
            "Everett",
            "Everson",
            "Excelsior",
            "Export",
            "Exton",
            "Factoryville",
            "Fairbank",
            "Fairchance",
            "Fairfield",
            "Fairhope",
            "Fairless Hills",
            "Fairmount City",
            "Fairview",
            "Fairview Village",
            "Fallentimber",
            "Falls",
            "Falls Creek",
            "Fannettsburg",
            "Farmington",
            "Farrell",
            "Fawn Grove",
            "Fayette City",
            "Fayetteville",
            "Feasterville Trevose",
            "Felton",
            "Fenelton",
            "Ferndale",
            "Finleyville",
            "Fisher",
            "Fishertown",
            "Fleetville",
            "Fleetwood",
            "Fleming",
            "Flicksville",
            "Flinton",
            "Flourtown",
            "Fogelsville",
            "Folcroft",
            "Folsom",
            "Fombell",
            "Forbes Road",
            "Force",
            "Ford City",
            "Ford Cliff",
            "Forest City",
            "Forest Grove",
            "Forestville",
            "Forksville",
            "Fort Hill",
            "Fort Littleton",
            "Fort Loudon",
            "Fort Washington",
            "Fountainville",
            "Foxburg",
            "Frackville",
            "Franconia",
            "Franklin",
            "Franklintown",
            "Frederick",
            "Fredericksburg",
            "Fredericktown",
            "Fredonia",
            "Freeburg",
            "Freedom",
            "Freeland",
            "Freeport",
            "Frenchville",
            "Friedens",
            "Friedensburg",
            "Friendsville",
            "Frostburg",
            "Fryburg",
            "Furlong",
            "Gaines",
            "Galeton",
            "Gallitzin",
            "Gans",
            "Gap",
            "Garards Fort",
            "Gardenville",
            "Gardners",
            "Garland",
            "Garrett",
            "Gastonville",
            "Geigertown",
            "Genesee",
            "Georgetown",
            "German",
            "Germansville",
            "Gettysburg",
            "Gibbon Glade",
            "Gibson",
            "Gibsonia",
            "Gifford",
            "Gilbert",
            "Gilberton",
            "Gilbertsville",
            "Gillett",
            "Gipsy",
            "Girard",
            "Girardville",
            "Gladwyne",
            "Glasgow",
            "Glassport",
            "Glen Campbell",
            "Glen Hope",
            "Glen Lyon",
            "Glen Mills",
            "Glen Richey",
            "Glen Riddle Lima",
            "Glen Rock",
            "Glenmoore",
            "Glenolden",
            "Glenshaw",
            "Glenside",
            "Glenville",
            "Goodville",
            "Gordon",
            "Gordonville",
            "Gouldsboro",
            "Gowen City",
            "Gradyville",
            "Grampian",
            "Grand Valley",
            "Grantham",
            "Grantville",
            "Granville",
            "Granville Summit",
            "Grapeville",
            "Grassflat",
            "Gratz",
            "Gray",
            "Graysville",
            "Great Bend",
            "Greeley",
            "Green Lane",
            "Green Park",
            "Greencastle",
            "Greenock",
            "Greensboro",
            "Greensburg",
            "Greentown",
            "Greenville",
            "Grindstone",
            "Grove City",
            "Grover",
            "Guys Mills",
            "Gwynedd",
            "Gwynedd Valley",
            "Hadley",
            "Halifax",
            "Hallstead",
            "Hamburg",
            "Hamilton",
            "Hamlin",
            "Hannastown",
            "Hanover",
            "Harborcreek",
            "Harford",
            "Harleigh",
            "Harleysville",
            "Harmonsburg",
            "Harmony",
            "Harrisburg",
            "Harrison City",
            "Harrison Valley",
            "Harrisonville",
            "Harrisville",
            "Hartleton",
            "Hartstown",
            "Harveys Lake",
            "Harwick",
            "Hastings",
            "Hatboro",
            "Hatfield",
            "Haverford",
            "Havertown",
            "Hawk Run",
            "Hawley",
            "Hawthorn",
            "Hazel Hurst",
            "Hazleton",
            "Hegins",
            "Heilwood",
            "Hellertown",
            "Hempfield",
            "Hendersonville",
            "Henryville",
            "Hereford",
            "Herman",
            "Herminie",
            "Hermitage",
            "Herndon",
            "Herrick Center",
            "Hershey",
            "Hesston",
            "Hibbs",
            "Hickory",
            "Hidden Valley",
            "Highspire",
            "Hiller",
            "Hilliards",
            "Hillsdale",
            "Hillsgrove",
            "Hillsville",
            "Hilltown",
            "Holbrook",
            "Holicong",
            "Hollidaysburg",
            "Hollsopple",
            "Holmes",
            "Holtwood",
            "Home",
            "Homer City",
            "Homestead",
            "Honesdale",
            "Honey Brook",
            "Honey Grove",
            "Hookstown",
            "Hooversville",
            "Hop Bottom",
            "Hopeland",
            "Hopewell",
            "Hopwood",
            "Horsham",
            "Hostetter",
            "Houston",
            "Houtzdale",
            "Howard",
            "Hughesville",
            "Hummels Wharf",
            "Hummelstown",
            "Hunker",
            "Hunlock Creek",
            "Huntingdon",
            "Huntingdon Valley",
            "Huntington Mills",
            "Hustontown",
            "Hutchinson",
            "Hyde",
            "Hyde Park",
            "Hydetown",
            "Hyndman",
            "Hyner",
            "Ickesburg",
            "Idaville",
            "Imler",
            "Immaculata",
            "Imperial",
            "Indian Head",
            "Indiana",
            "Indianola",
            "Industry",
            "Ingomar",
            "Intercourse",
            "Irvine",
            "Irvona",
            "Irwin",
            "Isabella",
            "Jackson",
            "Jackson Center",
            "Jacobs Creek",
            "James City",
            "James Creek",
            "Jamestown",
            "Jamison",
            "Jeannette",
            "Jefferson",
            "Jenkintown",
            "Jenners",
            "Jennerstown",
            "Jermyn",
            "Jerome",
            "Jersey Mills",
            "Jersey Shore",
            "Jessup",
            "Jim Thorpe",
            "Joffre",
            "Johnsonburg",
            "Johnstown",
            "Jones Mills",
            "Jonestown",
            "Josephine",
            "Julian",
            "Juneau",
            "Junedale",
            "Kane",
            "Kantner",
            "Karns City",
            "Karthaus",
            "Keisterville",
            "Kelayres",
            "Kelton",
            "Kemblesville",
            "Kempton",
            "Kennerdell",
            "Kennett Square",
            "Kent",
            "Kersey",
            "Kimberton",
            "King Of Prussia",
            "Kingsley",
            "Kingston",
            "Kintnersville",
            "Kinzers",
            "Kirkwood",
            "Kittanning",
            "Kleinfeltersville",
            "Klingerstown",
            "Knox",
            "Knox Dale",
            "Knoxville",
            "Koppel",
            "Kossuth",
            "Kreamer",
            "Kresgeville",
            "Kulpmont",
            "Kulpsville",
            "Kunkletown",
            "Kutztown",
            "Kylertown",
            "La Belle",
            "La Jose",
            "La Plume",
            "Laceyville",
            "Lackawaxen",
            "Lafayette Hill",
            "Lahaska",
            "Lairdsville",
            "Lake Ariel",
            "Lake City",
            "Lake Como",
            "Lake Harmony",
            "Lake Lynn",
            "Lake Winola",
            "Lakeville",
            "Lakewood",
            "Lamar",
            "Lamartine",
            "Lampeter",
            "Lancaster",
            "Landenberg",
            "Landingville",
            "Landisburg",
            "Landisville",
            "Lanesboro",
            "Langeloth",
            "Langhorne",
            "Lansdale",
            "Lansdowne",
            "Lanse",
            "Lansford",
            "Laporte",
            "Larimer",
            "Latrobe",
            "Lattimer Mines",
            "Laughlintown",
            "Laurelton",
            "Laurys Station",
            "Lavelle",
            "Lawn",
            "Lawrence",
            "Lawrenceville",
            "Lawton",
            "Le Raysville",
            "Lebanon",
            "Leck Kill",
            "Leckrone",
            "Lecontes Mills",
            "Lederach",
            "Leechburg",
            "Leeper",
            "Leesport",
            "Leetsdale",
            "Lehigh Valley",
            "Lehighton",
            "Lehman",
            "Leisenring",
            "Lemasters",
            "Lemont",
            "Lemont Furnace",
            "Lemoyne",
            "Lenhartsville",
            "Lenni",
            "Lenoxville",
            "Leola",
            "Leroy",
            "Levittown",
            "Lewis Run",
            "Lewisberry",
            "Lewisburg",
            "Lewistown",
            "Lewisville",
            "Liberty",
            "Library",
            "Lickingville",
            "Light Street",
            "Ligonier",
            "Lilly",
            "Limekiln",
            "Limeport",
            "Limestone",
            "Lincoln University",
            "Linden",
            "Line Lexington",
            "Linesville",
            "Lionville",
            "Listie",
            "Lititz",
            "Little Meadows",
            "Littlestown",
            "Liverpool",
            "Llewellyn",
            "Lock Haven",
            "Locust Gap",
            "Locustdale",
            "Loganton",
            "Loganville",
            "Long Pond",
            "Lopez",
            "Loretto",
            "Lost Creek",
            "Lowber",
            "Loyalhanna",
            "Loysburg",
            "Loysville",
            "Lucernemines",
            "Lucinda",
            "Ludlow",
            "Lumberville",
            "Lurgan",
            "Luthersburg",
            "Luxor",
            "Luzerne",
            "Lykens",
            "Lyndell",
            "Lyndora",
            "Lyon Station",
            "Mackeyville",
            "Macungie",
            "Madera",
            "Madison",
            "Madisonburg",
            "Mahaffey",
            "Mahanoy City",
            "Mahanoy Plane",
            "Mainesburg",
            "Mainland",
            "Malvern",
            "Mammoth",
            "Manchester",
            "Manheim",
            "Manns Choice",
            "Manor",
            "Manorville",
            "Mansfield",
            "Mapleton Depot",
            "Mar Lin",
            "Marble",
            "Marchand",
            "Marcus Hook",
            "Marianna",
            "Marienville",
            "Marietta",
            "Marion",
            "Marion Center",
            "Marion Heights",
            "Markleton",
            "Markleysburg",
            "Mars",
            "Marshalls Creek",
            "Marsteller",
            "Martin",
            "Martindale",
            "Martins Creek",
            "Martinsburg",
            "Mary D",
            "Marysville",
            "Masontown",
            "Matamoras",
            "Mather",
            "Mattawana",
            "Maxatawny",
            "Mayport",
            "Maytown",
            "Mcadoo",
            "McAlisterville",
            "McClellandtown",
            "McClure",
            "McConnellsburg",
            "McConnellstown",
            "McDonald",
            "McElhattan",
            "McEwensville",
            "McGrann",
            "McIntyre",
            "McKean",
            "McKees Rocks",
            "McKeesport",
            "McKnightstown",
            "McSherrystown",
            "McVeytown",
            "Meadow Lands",
            "Meadville",
            "Mechanicsburg",
            "Mechanicsville",
            "Media",
            "Mehoopany",
            "Melcroft",
            "Mendenhall",
            "Menges Mills",
            "Mentcle",
            "Mercer",
            "Mercersburg",
            "Merion Station",
            "Merrittstown",
            "Mertztown",
            "Meshoppen",
            "Mexico",
            "Meyersdale",
            "Middleburg",
            "Middlebury Center",
            "Middleport",
            "Middletown",
            "Midland",
            "Midway",
            "Mifflin",
            "Mifflinburg",
            "Mifflintown",
            "Mifflinville",
            "Milan",
            "Milanville",
            "Mildred",
            "Milesburg",
            "Milford",
            "Milford Square",
            "Mill Creek",
            "Mill Hall",
            "Mill Run",
            "Mill Village",
            "Millersburg",
            "Millerstown",
            "Millersville",
            "Millerton",
            "Millheim",
            "Millmont",
            "Millrift",
            "Mills",
            "Millsboro",
            "Millville",
            "Milnesville",
            "Milroy",
            "Milton",
            "Mineral Point",
            "Mineral Springs",
            "Minersville",
            "Mingoville",
            "Minisink Hills",
            "Miquon",
            "Modena",
            "Mohnton",
            "Mohrsville",
            "Monaca",
            "Monessen",
            "Monocacy Station",
            "Monongahela",
            "Monroeton",
            "Monroeville",
            "Mont Alto",
            "Mont Clare",
            "Montandon",
            "Montgomery",
            "Montgomeryville",
            "Montoursville",
            "Montrose",
            "Moosic",
            "Morann",
            "Morgan",
            "Morgantown",
            "Morris",
            "Morris Run",
            "Morrisdale",
            "Morrisville",
            "Morton",
            "Moscow",
            "Moshannon",
            "Mount Aetna",
            "Mount Bethel",
            "Mount Braddock",
            "Mount Carmel",
            "Mount Gretna",
            "Mount Holly Springs",
            "Mount Jewett",
            "Mount Joy",
            "Mount Morris",
            "Mount Pleasant",
            "Mount Pleasant Mills",
            "Mount Pocono",
            "Mount Union",
            "Mount Wolf",
            "Mountain Top",
            "Mountainhome",
            "Mountville",
            "Muhlenberg",
            "Muir",
            "Muncy",
            "Muncy Valley",
            "Munson",
            "Murrysville",
            "Muse",
            "Myerstown",
            "Nanticoke",
            "Nanty Glo",
            "Narberth",
            "Narvon",
            "Natrona Heights",
            "Nazareth",
            "Needmore",
            "Neelyton",
            "Neffs",
            "Nelson",
            "Nemacolin",
            "Nescopeck",
            "Nesquehoning",
            "New Albany",
            "New Alexandria",
            "New Baltimore",
            "New Bedford",
            "New Berlin",
            "New Berlinville",
            "New Bethlehem",
            "New Bloomfield",
            "New Brighton",
            "New Buffalo",
            "New Castle",
            "New Columbia",
            "New Cumberland",
            "New Derry",
            "New Eagle",
            "New Enterprise",
            "New Florence",
            "New Freedom",
            "New Freeport",
            "New Galilee",
            "New Geneva",
            "New Germantown",
            "New Holland",
            "New Hope",
            "New Kensington",
            "New Kingstown",
            "New London",
            "New Milford",
            "New Millport",
            "New Oxford",
            "New Paris",
            "New Park",
            "New Philadelphia",
            "New Providence",
            "New Ringgold",
            "New Salem",
            "New Stanton",
            "New Tripoli",
            "New Wilmington",
            "Newburg",
            "Newell",
            "Newfoundland",
            "Newmanstown",
            "Newport",
            "Newry",
            "Newton Hamilton",
            "Newtown",
            "Newtown Square",
            "Newville",
            "Nicholson",
            "Nicktown",
            "Nineveh",
            "Nisbet",
            "Normalville",
            "Norristown",
            "North Apollo",
            "North Bend",
            "North East",
            "North Springfield",
            "North Versailles",
            "North Wales",
            "North Washington",
            "Northampton",
            "Northpoint",
            "Northumberland",
            "Norvelt",
            "Norwood",
            "Nottingham",
            "Noxen",
            "Nu Mine",
            "Numidia",
            "Nuremberg",
            "Oak Ridge",
            "Oakdale",
            "Oakland Mills",
            "Oakmont",
            "Oaks",
            "Ohiopyle",
            "Oil City",
            "Olanta",
            "Old Forge",
            "Old Zionsville",
            "Oley",
            "Oliveburg",
            "Oliver",
            "Olyphant",
            "Oneida",
            "Ono",
            "Orangeville",
            "Orbisonia",
            "Orefield",
            "Oreland",
            "Orrstown",
            "Orrtanna",
            "Orson",
            "Orviston",
            "Orwigsburg",
            "Osceola",
            "Osceola Mills",
            "Osterburg",
            "Ottsville",
            "Oxford",
            "Palm",
            "Palmerton",
            "Palmyra",
            "Paoli",
            "Paradise",
            "Pardeesville",
            "Parker",
            "Parker Ford",
            "Parkesburg",
            "Parkhill",
            "Parryville",
            "Patton",
            "Paupack",
            "Paxinos",
            "Paxtonville",
            "Peach Bottom",
            "Peach Glen",
            "Peckville",
            "Pen Argyl",
            "Penfield",
            "Penn",
            "Penn Run",
            "Penns Creek",
            "Penns Park",
            "Pennsburg",
            "Pennsylvania Furnace",
            "Penryn",
            "Pequea",
            "Perkasie",
            "Perkiomenville",
            "Perry",
            "Perryopolis",
            "Petersburg",
            "Petrolia",
            "Philadelphia",
            "Philipsburg",
            "Phoenixville",
            "Picture Rocks",
            "Pillow",
            "Pine Bank",
            "Pine Forge",
            "Pine Grove",
            "Pine Grove Mills",
            "Pineville",
            "Pipersville",
            "Pitcairn",
            "Pitman",
            "Pittsburgh",
            "Pittsfield",
            "Pittston",
            "Plainfield",
            "Pleasant Hall",
            "Pleasant Mount",
            "Pleasant Unity",
            "Pleasantville",
            "Plumstead",
            "Plumsteadville",
            "Plumville",
            "Plymouth",
            "Plymouth Meeting",
            "Pocono Lake",
            "Pocono Lake Preserve",
            "Pocono Manor",
            "Pocono Pines",
            "Pocono Summit",
            "Pocopson",
            "Point Marion",
            "Point Pleasant",
            "Polk",
            "Pomeroy",
            "Port Allegany",
            "Port Carbon",
            "Port Clinton",
            "Port Matilda",
            "Port Royal",
            "Port Trevorton",
            "Portage",
            "Porters Sideling",
            "Portersville",
            "Portland",
            "Potter",
            "Pottersdale",
            "Potts Grove",
            "Pottstown",
            "Pottsville",
            "Poyntelle",
            "Presto",
            "Preston Park",
            "Pricedale",
            "Primos",
            "Prompton",
            "Prospect",
            "Prospect Park",
            "Prosperity",
            "Pulaski",
            "Punxsutawney",
            "Quakake",
            "Quakertown",
            "Quarryville",
            "Quecreek",
            "Queen",
            "Quentin",
            "Quincy",
            "Railroad",
            "Ralston",
            "Ramey",
            "Ransom",
            "Ravine",
            "Reading",
            "Reamstown",
            "Rebersburg",
            "Rebuck",
            "Rector",
            "Red Hill",
            "Red Lion",
            "Reeders",
            "Reedsville",
            "Refton",
            "Rehrersburg",
            "Reinholds",
            "Renfrew",
            "Reno",
            "Renovo",
            "Republic",
            "Revere",
            "Revloc",
            "Rew",
            "Rexmont",
            "Reynoldsville",
            "Rheems",
            "Rices Landing",
            "Riceville",
            "Richboro",
            "Richeyville",
            "Richfield",
            "Richland",
            "Richlandtown",
            "Riddlesburg",
            "Ridgway",
            "Ridley Park",
            "Riegelsville",
            "Rillton",
            "Rimersburg",
            "Ringgold",
            "Ringtown",
            "Riverside",
            "Rixford",
            "Roaring Branch",
            "Roaring Spring",
            "Robertsdale",
            "Robeson",
            "Robesonia",
            "Robinson",
            "Rochester",
            "Rochester Mills",
            "Rock Glen",
            "Rockhill Furnace",
            "Rockton",
            "Rockwood",
            "Rogersville",
            "Rome",
            "Ronco",
            "Ronks",
            "Roscoe",
            "Rossiter",
            "Rossville",
            "Roulette",
            "Rouseville",
            "Rouzerville",
            "Rowland",
            "Roxbury",
            "Royersford",
            "Ruffs Dale",
            "Rural Ridge",
            "Rural Valley",
            "Rushland",
            "Rushville",
            "Russell",
            "Russellton",
            "Sabinsville",
            "Sacramento",
            "Sadsburyville",
            "Saegertown",
            "Sagamore",
            "Saint Benedict",
            "Saint Boniface",
            "Saint Clair",
            "Saint Johns",
            "Saint Marys",
            "Saint Michael",
            "Saint Peters",
            "Saint Petersburg",
            "Saint Thomas",
            "Salford",
            "Salfordville",
            "Salina",
            "Salisbury",
            "Salix",
            "Salona",
            "Saltillo",
            "Saltsburg",
            "Sandy Lake",
            "Sandy Ridge",
            "Sarver",
            "Sassamansville",
            "Saxonburg",
            "Saxton",
            "Saylorsburg",
            "Sayre",
            "Scenery Hill",
            "Schaefferstown",
            "Schellsburg",
            "Schenley",
            "Schnecksville",
            "Schuylkill",
            "Schuylkill Haven",
            "Schwenksville",
            "Sciota",
            "Scotland",
            "Scotrun",
            "Scottdale",
            "Scranton",
            "Seanor",
            "Selinsgrove",
            "Sellersville",
            "Seltzer",
            "Seminole",
            "Seneca",
            "Seven Valleys",
            "Seward",
            "Sewickley",
            "Shade Gap",
            "Shady Grove",
            "Shamokin",
            "Shamokin Dam",
            "Shanksville",
            "Sharon",
            "Sharon Hill",
            "Sharpsville",
            "Shartlesville",
            "Shavertown",
            "Shawanese",
            "Shawnee On Delaware",
            "Shawville",
            "Sheakleyville",
            "Sheffield",
            "Shelocta",
            "Shenandoah",
            "Sheppton",
            "Shermans Dale",
            "Shickshinny",
            "Shinglehouse",
            "Shippensburg",
            "Shippenville",
            "Shippingport",
            "Shirleysburg",
            "Shoemakersville",
            "Shohola",
            "Shrewsbury",
            "Shunk",
            "Sidman",
            "Sigel",
            "Silver Spring",
            "Silverdale",
            "Sinnamahoning",
            "Sipesville",
            "Six Mile Run",
            "Skippack",
            "Skytop",
            "Slate Run",
            "Slatedale",
            "Slatington",
            "Slickville",
            "Sligo",
            "Slippery Rock",
            "Slovan",
            "Smethport",
            "Smicksburg",
            "Smithfield",
            "Smithmill",
            "Smithton",
            "Smock",
            "Smokerun",
            "Smoketown",
            "Snow Shoe",
            "Snydersburg",
            "Snydertown",
            "Solebury",
            "Somerset",
            "Soudersburg",
            "Souderton",
            "South Buffalo",
            "South Canaan",
            "South Fayette",
            "South Fork",
            "South Gibson",
            "South Heights",
            "South Londonderry",
            "South Montrose",
            "South Mountain",
            "South Sterling",
            "South Whitehall",
            "Southampton",
            "Southeastern",
            "Southview",
            "Southwest",
            "Spangler",
            "Spartansburg",
            "Spinnerstown",
            "Spraggs",
            "Sprankle Mills",
            "Spring Church",
            "Spring City",
            "Spring Creek",
            "Spring Glen",
            "Spring Grove",
            "Spring House",
            "Spring Mills",
            "Spring Mount",
            "Spring Run",
            "Springboro",
            "Springdale",
            "Springfield",
            "Springs",
            "Springtown",
            "Springville",
            "Sproul",
            "Spruce Creek",
            "Stahlstown",
            "Star Junction",
            "Starford",
            "Starlight",
            "Starrucca",
            "State College",
            "State Line",
            "Steelville",
            "Sterling",
            "Stevens",
            "Stevensville",
            "Stewartstown",
            "Stillwater",
            "Stockdale",
            "Stockertown",
            "Stoneboro",
            "Stony Run",
            "Stoystown",
            "Strabane",
            "Strasburg",
            "Strattanville",
            "Strausstown",
            "Strongstown",
            "Stroudsburg",
            "Stump Creek",
            "Sturgeon",
            "Sugar Grove",
            "Sugar Run",
            "Sugarloaf",
            "Summerdale",
            "Summerhill",
            "Summerville",
            "Summit Hill",
            "Summit Station",
            "Sumneytown",
            "Sunbury",
            "Suplee",
            "Susquehanna",
            "Sutersville",
            "Swarthmore",
            "Sweet Valley",
            "Swengel",
            "Swiftwater",
            "Sybertsville",
            "Sycamore",
            "Sykesville",
            "Sylvania",
            "Tafton",
            "Talmage",
            "Tamaqua",
            "Tamiment",
            "Tannersville",
            "Tarentum",
            "Tarrs",
            "Tatamy",
            "Taylor",
            "Taylorstown",
            "Telford",
            "Temple",
            "Templeton",
            "Terre Hill",
            "Thomasville",
            "Thompson",
            "Thompsontown",
            "Thorndale",
            "Thornton",
            "Three Springs",
            "Tidioute",
            "Timblin",
            "Tioga",
            "Tiona",
            "Tionesta",
            "Tipton",
            "Tire Hill",
            "Titusville",
            "Tobyhanna",
            "Todd",
            "Topton",
            "Torrance",
            "Toughkenamon",
            "Towanda",
            "Tower City",
            "Townville",
            "Trafford",
            "Transfer",
            "Treichlers",
            "Tremont",
            "Tresckow",
            "Trevorton",
            "Trexlertown",
            "Trout Run",
            "Troutville",
            "Troxelville",
            "Troy",
            "Trumbauersville",
            "Tunkhannock",
            "Turbotville",
            "Turkey City",
            "Turtle Creek",
            "Turtlepoint",
            "Tuscarora",
            "Twin Rocks",
            "Tyler Hill",
            "Tylersburg",
            "Tylersport",
            "Tylersville",
            "Tyrone",
            "Uledi",
            "Ulster",
            "Ulysses",
            "Union City",
            "Union Dale",
            "Uniontown",
            "Unionville",
            "United",
            "Unity House",
            "Unityville",
            "University Park",
            "Upper Black Eddy",
            "Upper Darby",
            "Upper Uwchlan",
            "Upperstrasburg",
            "Ursina",
            "Utica",
            "Uwchland",
            "Valencia",
            "Valier",
            "Valley Forge",
            "Valley View",
            "Van Voorhis",
            "Vanderbilt",
            "Vandergrift",
            "Venango",
            "Venetia",
            "Venus",
            "Verona",
            "Vestaburg",
            "Vicksburg",
            "Villa Maria",
            "Villanova",
            "Vintondale",
            "Virginville",
            "Volant",
            "Vowinckel",
            "Wagontown",
            "Wallaceton",
            "Wallingford",
            "Walnut Bottom",
            "Walnutport",
            "Walston",
            "Waltersburg",
            "Wampum",
            "Wapwallopen",
            "Warfordsburg",
            "Warminster",
            "Warren",
            "Warren Center",
            "Warrendale",
            "Warrington",
            "Warriors Mark",
            "Washington",
            "Washington Boro",
            "Washington Crossing",
            "Washingtonville",
            "Waterfall",
            "Waterford",
            "Waterville",
            "Watson",
            "Watsontown",
            "Wattsburg",
            "Waverly",
            "Waymart",
            "Wayne",
            "Waynesboro",
            "Waynesburg",
            "Weatherly",
            "Webster",
            "Weedville",
            "Weikert",
            "Wellersburg",
            "Wells Tannery",
            "Wellsboro",
            "Wellsville",
            "Wendel",
            "Wernersville",
            "West Alexander",
            "West Chester",
            "West Decatur",
            "West Elizabeth",
            "West Finley",
            "West Grove",
            "West Hickory",
            "West Lebanon",
            "West Leisenring",
            "West Middlesex",
            "West Middletown",
            "West Mifflin",
            "West Milton",
            "West Newton",
            "West Pittsburg",
            "West Point",
            "West Salisbury",
            "West Springfield",
            "West Sunbury",
            "West Willow",
            "Westfield",
            "Westland",
            "Westline",
            "Westmoreland City",
            "Weston",
            "Westover",
            "Westport",
            "Westtown",
            "Wexford",
            "Wheatland",
            "White",
            "White Deer",
            "White Haven",
            "White Mills",
            "Whitehall",
            "Whitney",
            "Wickhaven",
            "Wiconisco",
            "Widnoon",
            "Wilburton",
            "Wilcox",
            "Wildwood",
            "Wilkes Barre",
            "Williamsburg",
            "Williamson",
            "Williamsport",
            "Williamstown",
            "Willow Grove",
            "Willow Hill",
            "Willow Street",
            "Wilmerding",
            "Wilmore",
            "Winburne",
            "Wind Gap",
            "Wind Ridge",
            "Windber",
            "Windsor",
            "Winfield",
            "Witmer",
            "Wolf",
            "Womelsdorf",
            "Wood",
            "Woodbury",
            "Woodland",
            "Woodlyn",
            "Woodward",
            "Woolrich",
            "Worcester",
            "Worthington",
            "Worthville",
            "Woxall",
            "Wrightsville",
            "Wyalusing",
            "Wyano",
            "Wycombe",
            "Wyncote",
            "Wynnewood",
            "Wyoming",
            "Wysox",
            "Yatesboro",
            "Yeagertown",
            "York",
            "York Haven",
            "York New Salem",
            "York Springs",
            "Youngstown",
            "Youngsville",
            "Youngwood",
            "Yukon",
            "Zelienople",
            "Zieglerville",
            "Zion Grove",
            "Zionhill",
            "Zionsville",
            "Zullinger"
        ]
    },
    {
        "state": "Rhode Island",
        "abbr": "RI",
        "cities": [
            "Adamsville",
            "Albion",
            "Ashaway",
            "Barrington",
            "Block Island",
            "Bradford",
            "Bristol",
            "Carolina",
            "Central Falls",
            "Charlestown",
            "Chepachet",
            "Clayville",
            "Coventry",
            "Cranston",
            "Cumberland",
            "East Greenwich",
            "East Providence",
            "Exeter",
            "Fiskeville",
            "Forestdale",
            "Foster",
            "Glendale",
            "Greene",
            "Greenville",
            "Harmony",
            "Harrisville",
            "Hope",
            "Hope Valley",
            "Hopkinton",
            "Jamestown",
            "Johnston",
            "Kenyon",
            "Kingston",
            "Lincoln",
            "Little Compton",
            "Manville",
            "Mapleville",
            "Middletown",
            "Narragansett",
            "Newport",
            "North Kingstown",
            "North Providence",
            "North Scituate",
            "North Smithfield",
            "Oakland",
            "Pascoag",
            "Pawtucket",
            "Peace Dale",
            "Portsmouth",
            "Providence",
            "Prudence Island",
            "Riverside",
            "Rockville",
            "Rumford",
            "Saunderstown",
            "Shannock",
            "Slatersville",
            "Slocum",
            "Smithfield",
            "South Kingstown",
            "Tiverton",
            "Wakefield",
            "Warren",
            "Warwick",
            "West Greenwich",
            "West Kingston",
            "West Warwick",
            "Westerly",
            "Wood River Junction",
            "Woonsocket",
            "Wyoming"
        ]
    },
    {
        "state": "South Carolina",
        "abbr": "SC",
        "cities": [
            "Abbeville",
            "Adams Run",
            "Aiken",
            "Alcolu",
            "Allendale",
            "Anderson",
            "Andrews",
            "Arcadia",
            "Awendaw",
            "Aynor",
            "Ballentine",
            "Bamberg",
            "Barnwell",
            "Batesburg",
            "Batesburg-Leesville",
            "Bath",
            "Beaufort",
            "Beech Island",
            "Belton",
            "Bennettsville",
            "Bethera",
            "Bethune",
            "Bishopville",
            "Blacksburg",
            "Blackstock",
            "Blackville",
            "Blair",
            "Blenheim",
            "Bluffton",
            "Blythewood",
            "Bonneau",
            "Bowling Green",
            "Bowman",
            "Bradley",
            "Branchville",
            "Brunson",
            "Buffalo",
            "Cades",
            "Calhoun Falls",
            "Camden",
            "Cameron",
            "Campobello",
            "Canadys",
            "Carlisle",
            "Cassatt",
            "Catawba",
            "Cayce",
            "Centenary",
            "Central",
            "Chapin",
            "Chappells",
            "Charleston",
            "Charleston AFB",
            "Cheraw",
            "Chesnee",
            "Chester",
            "Chesterfield",
            "Clarks Hill",
            "Clearwater",
            "Clemson",
            "Cleveland",
            "Clifton",
            "Clinton",
            "Clio",
            "Clover",
            "Columbia",
            "Conestee",
            "Converse",
            "Conway",
            "Coosawatchie",
            "Cope",
            "Cordesville",
            "Cordova",
            "Cottageville",
            "Coward",
            "Cowpens",
            "Crocketville",
            "Cross",
            "Cross Anchor",
            "Cross Hill",
            "Dale",
            "Dalzell",
            "Darlington",
            "Daufuskie Island",
            "Davis Station",
            "Denmark",
            "Dillon",
            "Donalds",
            "Dorchester",
            "Drayton",
            "Due West",
            "Duncan",
            "Early Branch",
            "Easley",
            "Eastover",
            "Edgefield",
            "Edgemoor",
            "Edisto Island",
            "Effingham",
            "Ehrhardt",
            "Elgin",
            "Elko",
            "Elliott",
            "Elloree",
            "Enoree",
            "Estill",
            "Eutawville",
            "Fair Play",
            "Fairfax",
            "Fairforest",
            "Fingerville",
            "Florence",
            "Floyd Dale",
            "Folly Beach",
            "Fork",
            "Fort Lawn",
            "Fort Mill",
            "Fountain Inn",
            "Furman",
            "Gable",
            "Gadsden",
            "Gaffney",
            "Galivants Ferry",
            "Garden City",
            "Garnett",
            "Gaston",
            "Georgetown",
            "Gifford",
            "Gilbert",
            "Glendale",
            "Gloverville",
            "Goose Creek",
            "Gramling",
            "Graniteville",
            "Gray Court",
            "Great Falls",
            "Greeleyville",
            "Green Pond",
            "Green Sea",
            "Greenville",
            "Greenwood",
            "Greer",
            "Gresham",
            "Grover",
            "Hamer",
            "Hampton",
            "Hardeeville",
            "Harleyville",
            "Hartsville",
            "Heath Springs",
            "Hemingway",
            "Hickory Grove",
            "Hilda",
            "Hilton Head Island",
            "Hodges",
            "Holly Hill",
            "Hollywood",
            "Honea Path",
            "Hopkins",
            "Horatio",
            "Huger",
            "Inman",
            "Irmo",
            "Islandton",
            "Isle Of Palms",
            "Iva",
            "Jackson",
            "Jacksonboro",
            "Jamestown",
            "Jefferson",
            "Jenkinsville",
            "Joanna",
            "Johns Island",
            "Johnsonville",
            "Johnston",
            "Jonesville",
            "Kershaw",
            "Kinards",
            "Kingstree",
            "La France",
            "Ladson",
            "Lake City",
            "Lake View",
            "Lamar",
            "Lancaster",
            "Lando",
            "Landrum",
            "Lane",
            "Langley",
            "Latta",
            "Laurens",
            "Leesville",
            "Lexington",
            "Liberty",
            "Liberty Hill",
            "Little Mountain",
            "Little River",
            "Little Rock",
            "Lobeco",
            "Lockhart",
            "Lodge",
            "Long Creek",
            "Longs",
            "Loris",
            "Lowndesville",
            "Lugoff",
            "Luray",
            "Lydia",
            "Lyman",
            "Lynchburg",
            "Manning",
            "Marietta",
            "Marion",
            "Martin",
            "Mauldin",
            "Mayesville",
            "Mayo",
            "McBee",
            "McClellanville",
            "McColl",
            "McConnells",
            "McCormick",
            "Miley",
            "Minturn",
            "Modoc",
            "Moncks Corner",
            "Monetta",
            "Monticello",
            "Montmorenci",
            "Moore",
            "Mount Carmel",
            "Mount Croghan",
            "Mount Pleasant",
            "Mountain Rest",
            "Mountville",
            "Mullins",
            "Murrells Inlet",
            "Myrtle Beach",
            "Neeses",
            "Nesmith",
            "New Ellenton",
            "New Zion",
            "Newberry",
            "Newry",
            "Nichols",
            "Ninety Six",
            "Norris",
            "North",
            "North Augusta",
            "North Charleston",
            "North Myrtle Beach",
            "Norway",
            "Olanta",
            "Olar",
            "Orangeburg",
            "Pacolet",
            "Pacolet Mills",
            "Pageland",
            "Pamplico",
            "Parksville",
            "Patrick",
            "Pauline",
            "Pawleys Island",
            "Peak",
            "Pelion",
            "Pelzer",
            "Pendleton",
            "Perry",
            "Pickens",
            "Piedmont",
            "Pineland",
            "Pineville",
            "Pinewood",
            "Pinopolis",
            "Plum Branch",
            "Pomaria",
            "Port Royal",
            "Prosperity",
            "Rains",
            "Ravenel",
            "Reevesville",
            "Reidville",
            "Rembert",
            "Richburg",
            "Richland",
            "Ridge Spring",
            "Ridgeland",
            "Ridgeville",
            "Ridgeway",
            "Rion",
            "Rock Hill",
            "Roebuck",
            "Round O",
            "Rowesville",
            "Ruby",
            "Ruffin",
            "Russellville",
            "Saint George",
            "Saint Helena Island",
            "Saint Matthews",
            "Saint Stephen",
            "Salem",
            "Salley",
            "Salters",
            "Saluda",
            "Sandy Springs",
            "Santee",
            "Sardinia",
            "Scotia",
            "Scranton",
            "Seabrook",
            "Sellers",
            "Seneca",
            "Sharon",
            "Shaw A F B",
            "Sheldon",
            "Silverstreet",
            "Simpsonville",
            "Six Mile",
            "Slater",
            "Smoaks",
            "Smyrna",
            "Socastee",
            "Society Hill",
            "Spartanburg",
            "Springfield",
            "Starr",
            "Startex",
            "State Park",
            "Sullivans Island",
            "Summerton",
            "Summerville",
            "Sumter",
            "Sunset",
            "Swansea",
            "Sycamore",
            "Tamassee",
            "Tatum",
            "Taylors",
            "Tigerville",
            "Tillman",
            "Timmonsville",
            "Townville",
            "Travelers Rest",
            "Trenton",
            "Troy",
            "Turbeville",
            "Ulmer",
            "Una",
            "Union",
            "Van Wyck",
            "Vance",
            "Varnville",
            "Vaucluse",
            "Wadmalaw Island",
            "Wagener",
            "Walhalla",
            "Wallace",
            "Walterboro",
            "Ward",
            "Ware Shoals",
            "Warrenville",
            "Waterloo",
            "Wedgefield",
            "Wellford",
            "West Columbia",
            "West Union",
            "Westminster",
            "Westville",
            "White Oak",
            "White Rock",
            "White Stone",
            "Whitmire",
            "Williams",
            "Williamston",
            "Williston",
            "Windsor",
            "Winnsboro",
            "Woodruff",
            "Yemassee",
            "York"
        ]
    },
    {
        "state": "South Dakota",
        "abbr": "SD",
        "cities": [
            "Aberdeen",
            "Agar",
            "Akaska",
            "Alcester",
            "Alexandria",
            "Allen",
            "Alpena",
            "Amherst",
            "Andover",
            "Arlington",
            "Armour",
            "Artesian",
            "Ashton",
            "Astoria",
            "Aurora",
            "Avon",
            "Badger",
            "Baltic",
            "Barnard",
            "Batesland",
            "Bath",
            "Belle Fourche",
            "Belvidere",
            "Benton",
            "Beresford",
            "Bethlehem",
            "Big Sioux",
            "Big Stone City",
            "Bison",
            "Black Hawk",
            "Blunt",
            "Bonesteel",
            "Bowdle",
            "Box Elder",
            "Bradley",
            "Brandon",
            "Brandt",
            "Brantford",
            "Brentford",
            "Bridgewater",
            "Bristol",
            "Britton",
            "Brookings",
            "Bruce",
            "Bryant",
            "Buffalo",
            "Buffalo Gap",
            "Buffalo Ridge",
            "Bullhead",
            "Burbank",
            "Burke",
            "Cambria",
            "Camp Crook",
            "Canistota",
            "Canova",
            "Canton",
            "Caputa",
            "Carlisle",
            "Carpenter",
            "Carter",
            "Carthage",
            "Castlewood",
            "Cavour",
            "Centerville",
            "Chamberlain",
            "Chancellor",
            "Cherry Creek",
            "Chester",
            "Claire City",
            "Claremont",
            "Clark",
            "Clear Lake",
            "Cleveland",
            "Colman",
            "Colome",
            "Colton",
            "Columbia",
            "Conde",
            "Corona",
            "Corsica",
            "Creighton",
            "Cresbard",
            "Crooks",
            "Custer",
            "Dallas",
            "Dante",
            "Davis",
            "De Smet",
            "Deadwood",
            "Dell Rapids",
            "Delmont",
            "Dimock",
            "Doland",
            "Draper",
            "Dupree",
            "Eagle Butte",
            "Eden",
            "Edgemont",
            "Egan",
            "Elk Point",
            "Elkton",
            "Ellsworth AFB",
            "Elm Springs",
            "Emery",
            "Enning",
            "Erwin",
            "Estelline",
            "Ethan",
            "Eureka",
            "Fairburn",
            "Fairfax",
            "Fairview",
            "Faith",
            "Faulkton",
            "Fedora",
            "Ferney",
            "Firesteel",
            "Flandreau",
            "Florence",
            "Fort Meade",
            "Fort Pierre",
            "Fort Thompson",
            "Frankfort",
            "Frederick",
            "Freeman",
            "Fruitdale",
            "Fulton",
            "Gann Valley",
            "Garden City",
            "Garretson",
            "Gary",
            "Gayville",
            "Geddes",
            "Gettysburg",
            "Glad Valley",
            "Glencross",
            "Glenham",
            "Goodwin",
            "Gregory",
            "Grenville",
            "Groton",
            "Hamill",
            "Harrisburg",
            "Harrison",
            "Harrold",
            "Hartford",
            "Hayes",
            "Hayti",
            "Hazel",
            "Hecla",
            "Henry",
            "Hermosa",
            "Herreid",
            "Herrick",
            "Hetland",
            "Highmore",
            "Hill City",
            "Hitchcock",
            "Holabird",
            "Hosmer",
            "Hot Springs",
            "Houghton",
            "Hoven",
            "Howard",
            "Howes",
            "Hudson",
            "Humboldt",
            "Hurley",
            "Huron",
            "Ideal",
            "Interior",
            "Iona",
            "Ipswich",
            "Irene",
            "Iroquois",
            "Isabel",
            "Java",
            "Jefferson",
            "Kadoka",
            "Kaylor",
            "Keldron",
            "Kennebec",
            "Keystone",
            "Kimball",
            "Kranzburg",
            "Kyle",
            "Labolt",
            "Lake Andes",
            "Lake City",
            "Lake Norden",
            "Lake Preston",
            "Lane",
            "Langford",
            "Lantry",
            "Lead",
            "Lebanon",
            "Lennox",
            "Leola",
            "Lesterville",
            "Letcher",
            "Little Eagle",
            "Lodgepole",
            "Long Valley",
            "Longlake",
            "Lower Brule",
            "Ludlow",
            "Lyons",
            "Madison",
            "Mahto",
            "Manderson",
            "Mansfield",
            "Marion",
            "Martin",
            "Marty",
            "Marvin",
            "McIntosh",
            "McLaughlin",
            "Meadow",
            "Meckling",
            "Mellette",
            "Menno",
            "Midland",
            "Milbank",
            "Milesville",
            "Miller",
            "Mina",
            "Mission",
            "Mission Hill",
            "Mission Ridge",
            "Mitchell",
            "Mobridge",
            "Monroe",
            "Montrose",
            "Morristown",
            "Mound City",
            "Mount Vernon",
            "Mud Butte",
            "Murdo",
            "Nemo",
            "New Effington",
            "New Holland",
            "New Underwood",
            "Newell",
            "Nisland",
            "Norris",
            "North Sioux City",
            "Northville",
            "Nunda",
            "Oacoma",
            "Oelrichs",
            "Oglala",
            "Okaton",
            "Okreek",
            "Oldham",
            "Olivet",
            "Onaka",
            "Onida",
            "Opal",
            "Oral",
            "Orient",
            "Ortley",
            "Owanka",
            "Parade",
            "Parker",
            "Parkston",
            "Parmelee",
            "Peever",
            "Perry",
            "Philip",
            "Pickstown",
            "Piedmont",
            "Pierpont",
            "Pierre",
            "Pine Ridge",
            "Plankinton",
            "Platte",
            "Pollock",
            "Porcupine",
            "Prairie City",
            "Presho",
            "Pringle",
            "Provo",
            "Pukwana",
            "Quinn",
            "Ralph",
            "Ramona",
            "Rapid City",
            "Ravinia",
            "Raymond",
            "Red Owl",
            "Redfield",
            "Redig",
            "Ree Heights",
            "Reliance",
            "Renner",
            "Reva",
            "Revillo",
            "Ridgeview",
            "Rochford",
            "Rockham",
            "Roscoe",
            "Rosebud",
            "Rosholt",
            "Roslyn",
            "Rowena",
            "Rutland",
            "Saint Charles",
            "Saint Francis",
            "Saint Lawrence",
            "Saint Onge",
            "Salem",
            "Scenic",
            "Scotland",
            "Selby",
            "Seneca",
            "Shadehill",
            "Sinai",
            "Sioux Falls",
            "Sisseton",
            "Smithwick",
            "South Shore",
            "Spearfish",
            "Spencer",
            "Springfield",
            "Stephan",
            "Stickney",
            "Stockholm",
            "Strandburg",
            "Stratford",
            "Sturgis",
            "Summit",
            "Tabor",
            "Tea",
            "Timber Lake",
            "Tolstoy",
            "Toronto",
            "Trail City",
            "Trent",
            "Tripp",
            "Tulare",
            "Turton",
            "Tuthill",
            "Twin Brooks",
            "Tyndall",
            "Union Center",
            "Utica",
            "Vale",
            "Valley Springs",
            "Veblen",
            "Vermillion",
            "Viborg",
            "Vienna",
            "Virgil",
            "Vivian",
            "Volga",
            "Volin",
            "Wagner",
            "Wakonda",
            "Wakpala",
            "Walker",
            "Wall",
            "Wallace",
            "Wanblee",
            "Ward",
            "Warner",
            "Wasta",
            "Watauga",
            "Watertown",
            "Waubay",
            "Waverly",
            "Webster",
            "Wentworth",
            "Wessington",
            "Wessington Springs",
            "Westport",
            "Wewela",
            "White",
            "White Lake",
            "White Owl",
            "White River",
            "Whitehorse",
            "Whitewood",
            "Willow Lake",
            "Wilmot",
            "Winfred",
            "Winner",
            "Witten",
            "Wolsey",
            "Wood",
            "Woonsocket",
            "Worthing",
            "Wounded Knee",
            "Yale",
            "Yankton",
            "York"
        ]
    },
    {
        "state": "Tennessee",
        "abbr": "TN",
        "cities": [
            "Adams",
            "Adamsville",
            "Afton",
            "Alamo",
            "Alcoa",
            "Alexandria",
            "Allardt",
            "Allons",
            "Allred",
            "Alpine",
            "Altamont",
            "Andersonville",
            "Antioch",
            "Apison",
            "Ardmore",
            "Arlington",
            "Arnold AFB",
            "Arrington",
            "Arthur",
            "Ashland City",
            "Athens",
            "Atoka",
            "Atwood",
            "Auburntown",
            "Bakewell",
            "Bath Springs",
            "Baxter",
            "Bean Station",
            "Beech Bluff",
            "Beechgrove",
            "Beersheba Springs",
            "Belfast",
            "Bell Buckle",
            "Bells",
            "Belvidere",
            "Benton",
            "Bethel Springs",
            "Bethpage",
            "Big Rock",
            "Big Sandy",
            "Birchwood",
            "Blaine",
            "Bloomington Springs",
            "Blountville",
            "Bluff City",
            "Bogota",
            "Bolivar",
            "Bon Aqua",
            "Braden",
            "Bradford",
            "Bradyville",
            "Brentwood",
            "Briceville",
            "Brighton",
            "Bristol",
            "Brownsville",
            "Bruceton",
            "Brunswick",
            "Brush Creek",
            "Buchanan",
            "Buena Vista",
            "Buffalo Valley",
            "Bulls Gap",
            "Bumpus Mills",
            "Burlison",
            "Burns",
            "Butler",
            "Bybee",
            "Byrdstown",
            "Calhoun",
            "Camden",
            "Campaign",
            "Carthage",
            "Caryville",
            "Castalian Springs",
            "Cedar Grove",
            "Cedar Hill",
            "Celina",
            "Centerville",
            "Chapel Hill",
            "Chapmansboro",
            "Charleston",
            "Charlotte",
            "Chattanooga",
            "Chestnut Mound",
            "Chewalla",
            "Christiana",
            "Chuckey",
            "Church Hill",
            "Clairfield",
            "Clarkrange",
            "Clarksburg",
            "Clarksville",
            "Cleveland",
            "Clifton",
            "Clinton",
            "Coalfield",
            "Coalmont",
            "Cokercreek",
            "College Grove",
            "Collegedale",
            "Collierville",
            "Collinwood",
            "Columbia",
            "Como",
            "Conasauga",
            "Cookeville",
            "Copperhill",
            "Cordova",
            "Cornersville",
            "Corryton",
            "Cosby",
            "Cottage Grove",
            "Cottontown",
            "Counce",
            "Covington",
            "Cowan",
            "Crab Orchard",
            "Crawford",
            "Crockett Mills",
            "Cross Plains",
            "Crossville",
            "Crump",
            "Culleoka",
            "Cumberland City",
            "Cumberland Furnace",
            "Cumberland Gap",
            "Cunningham",
            "Cypress Inn",
            "Dandridge",
            "Darden",
            "Dayton",
            "Decatur",
            "Decaturville",
            "Decherd",
            "Deer Lodge",
            "Del Rio",
            "Delano",
            "Dellrose",
            "Denmark",
            "Dickson",
            "Dixon Springs",
            "Dover",
            "Dowelltown",
            "Doyle",
            "Dresden",
            "Drummonds",
            "Duck River",
            "Ducktown",
            "Duff",
            "Dukedom",
            "Dunlap",
            "Dyer",
            "Dyersburg",
            "Eads",
            "Eagan",
            "Eagleville",
            "Eaton",
            "Eidson",
            "Elgin",
            "Elizabethton",
            "Elkton",
            "Ellendale",
            "Elmwood",
            "Elora",
            "Englewood",
            "Enville",
            "Erin",
            "Erwin",
            "Estill Springs",
            "Ethridge",
            "Etowah",
            "Eva",
            "Evensville",
            "Fairview",
            "Fall Branch",
            "Farner",
            "Fayetteville",
            "Finger",
            "Finley",
            "Five Points",
            "Flag Pond",
            "Flintville",
            "Fosterville",
            "Frankewing",
            "Franklin",
            "Friendship",
            "Friendsville",
            "Fruitvale",
            "Gadsden",
            "Gainesboro",
            "Gallatin",
            "Gallaway",
            "Gates",
            "Gatlinburg",
            "Georgetown",
            "Germantown",
            "Gibson",
            "Gladeville",
            "Gleason",
            "Goodlettsville",
            "Goodspring",
            "Gordonsville",
            "Grand Junction",
            "Grandview",
            "Granville",
            "Graysville",
            "Greenback",
            "Greenbrier",
            "Greeneville",
            "Greenfield",
            "Grimsley",
            "Gruetli Laager",
            "Guild",
            "Guys",
            "Halls",
            "Hampshire",
            "Hampton",
            "Harriman",
            "Harrison",
            "Harrogate",
            "Hartford",
            "Hartsville",
            "Heiskell",
            "Helenwood",
            "Henderson",
            "Hendersonville",
            "Henry",
            "Hermitage",
            "Hickman",
            "Hickory Valley",
            "Hickory Withe",
            "Hilham",
            "Hillsboro",
            "Hixson",
            "Hohenwald",
            "Holladay",
            "Hollow Rock",
            "Hornbeak",
            "Hornsby",
            "Humboldt",
            "Huntingdon",
            "Huntland",
            "Huntsville",
            "Huron",
            "Hurricane Mills",
            "Idlewild",
            "Indian Mound",
            "Iron City",
            "Jacks Creek",
            "Jacksboro",
            "Jackson",
            "Jamestown",
            "Jasper",
            "Jefferson City",
            "Jellico",
            "Joelton",
            "Johnson City",
            "Jonesborough",
            "Kelso",
            "Kenton",
            "Kingsport",
            "Kingston",
            "Kingston Springs",
            "Knoxville",
            "Kodak",
            "Kyles Ford",
            "La Follette",
            "La Grange",
            "La Vergne",
            "Laconia",
            "Lafayette",
            "Lake City",
            "Lancaster",
            "Lancing",
            "Lascassas",
            "Laurel Bloomery",
            "Lavinia",
            "Lawrenceburg",
            "Lebanon",
            "Lenoir City",
            "Lenox",
            "Leoma",
            "Lewisburg",
            "Lexington",
            "Liberty",
            "Limestone",
            "Linden",
            "Livingston",
            "Lobelville",
            "Lone Mountain",
            "Lookout Mountain",
            "Loretto",
            "Loudon",
            "Louisville",
            "Lowland",
            "Lupton City",
            "Luray",
            "Luttrell",
            "Lutts",
            "Lyles",
            "Lynchburg",
            "Lynnville",
            "Macon",
            "Madison",
            "Madisonville",
            "Manchester",
            "Mansfield",
            "Martin",
            "Maryville",
            "Mascot",
            "Mason",
            "Maury City",
            "Maynardville",
            "McDonald",
            "McEwen",
            "McKenzie",
            "McLemoresville",
            "McMinnville",
            "Medina",
            "Medon",
            "Memphis",
            "Mercer",
            "Michie",
            "Middleton",
            "Midway",
            "Milan",
            "Milledgeville",
            "Milligan College",
            "Millington",
            "Milton",
            "Minor Hill",
            "Miston",
            "Mitchellville",
            "Mohawk",
            "Monroe",
            "Monteagle",
            "Monterey",
            "Mooresburg",
            "Morris Chapel",
            "Morrison",
            "Morristown",
            "Moscow",
            "Mosheim",
            "Moss",
            "Mount Carmel",
            "Mount Juliet",
            "Mount Pleasant",
            "Mountain City",
            "Mountain Home",
            "Mulberry",
            "Munford",
            "Murfreesboro",
            "Nashville",
            "New Johnsonville",
            "New Market",
            "New Tazewell",
            "Newbern",
            "Newcomb",
            "Newport",
            "Niota",
            "Nolensville",
            "Norene",
            "Normandy",
            "Norris",
            "Nunnelly",
            "Oak Ridge",
            "Oakdale",
            "Oakfield",
            "Oakland",
            "Obion",
            "Ocoee",
            "Old Hickory",
            "Oldfort",
            "Olivehill",
            "Oliver Springs",
            "Oneida",
            "Only",
            "Ooltewah",
            "Orlinda",
            "Ozone",
            "Pall Mall",
            "Palmer",
            "Palmersville",
            "Palmyra",
            "Paris",
            "Parrottsville",
            "Parsons",
            "Pegram",
            "Pelham",
            "Petersburg",
            "Petros",
            "Philadelphia",
            "Pickwick Dam",
            "Pigeon Forge",
            "Pikeville",
            "Piney Flats",
            "Pinson",
            "Pioneer",
            "Pleasant Hill",
            "Pleasant Shade",
            "Pleasant View",
            "Pleasantville",
            "Pocahontas",
            "Portland",
            "Powder Springs",
            "Powell",
            "Powells Crossroads",
            "Primm Springs",
            "Prospect",
            "Pruden",
            "Pulaski",
            "Puryear",
            "Quebeck",
            "Ramer",
            "Readyville",
            "Reagan",
            "Red Boiling Springs",
            "Reliance",
            "Riceville",
            "Rickman",
            "Riddleton",
            "Ridgely",
            "Ridgetop",
            "Rives",
            "Roan Mountain",
            "Robbins",
            "Rock Island",
            "Rockford",
            "Rockvale",
            "Rockwood",
            "Rogersville",
            "Rossville",
            "Rugby",
            "Russellville",
            "Rutherford",
            "Rutledge",
            "Saint Andrews",
            "Saint Bethlehem",
            "Saint Joseph",
            "Sale Creek",
            "Saltillo",
            "Samburg",
            "Santa Fe",
            "Sardis",
            "Saulsbury",
            "Savannah",
            "Scotts Hill",
            "Selmer",
            "Sequatchie",
            "Sevierville",
            "Sewanee",
            "Seymour",
            "Shady Valley",
            "Sharon",
            "Sharps Chapel",
            "Shawanee",
            "Shelbyville",
            "Sherwood",
            "Shiloh",
            "Signal Mountain",
            "Silerton",
            "Silver Point",
            "Slayden",
            "Smartt",
            "Smithville",
            "Smyrna",
            "Sneedville",
            "Soddy Daisy",
            "Somerville",
            "South Fulton",
            "South Pittsburg",
            "Southside",
            "Sparta",
            "Speedwell",
            "Spencer",
            "Spring City",
            "Spring Creek",
            "Spring Hill",
            "Springfield",
            "Springville",
            "Stanton",
            "Stantonville",
            "Stewart",
            "Strawberry Plains",
            "Sugar Tree",
            "Summertown",
            "Summitville",
            "Sunbright",
            "Surgoinsville",
            "Sweetwater",
            "Taft",
            "Talbott",
            "Tallassee",
            "Tazewell",
            "Telford",
            "Tellico Plains",
            "Ten Mile",
            "Tennessee Ridge",
            "Thompsons Station",
            "Thorn Hill",
            "Tigrett",
            "Tipton",
            "Toone",
            "Townsend",
            "Tracy City",
            "Trade",
            "Trenton",
            "Trezevant",
            "Trimble",
            "Troy",
            "Tullahoma",
            "Turtletown",
            "Unicoi",
            "Union City",
            "Unionville",
            "Vanleer",
            "Viola",
            "Vonore",
            "Walland",
            "Walling",
            "Wartburg",
            "Wartrace",
            "Washburn",
            "Watauga",
            "Watertown",
            "Watts Bar Dam",
            "Waverly",
            "Waynesboro",
            "Westmoreland",
            "Westpoint",
            "Westport",
            "White Bluff",
            "White House",
            "White Pine",
            "Whites Creek",
            "Whitesburg",
            "Whiteside",
            "Whiteville",
            "Whitleyville",
            "Whitwell",
            "Wilder",
            "Wildersville",
            "Williamsport",
            "Williston",
            "Winchester",
            "Winfield",
            "Winona",
            "Woodbury",
            "Woodland Mills",
            "Woodlawn",
            "Wynnburg",
            "Yorkville",
            "Yuma"
        ]
    },
    {
        "state": "Texas",
        "abbr": "TX",
        "cities": [
            "Abbott",
            "Abernathy",
            "Abilene",
            "Ace",
            "Ackerly",
            "Addison",
            "Adkins",
            "Adrian",
            "Afton",
            "Agua Dulce",
            "Aiken",
            "Alamo",
            "Alanreed",
            "Alba",
            "Albany",
            "Aledo",
            "Alice",
            "Alief",
            "Allen",
            "Alleyton",
            "Allison",
            "Alpine",
            "Altair",
            "Alto",
            "Alvarado",
            "Alvin",
            "Alvord",
            "Amarillo",
            "Amherst",
            "Anahuac",
            "Anderson",
            "Andrews",
            "Angleton",
            "Angus",
            "Anna",
            "Annona",
            "Anson",
            "Anthony",
            "Anton",
            "Apple Springs",
            "Aquilla",
            "Aransas Pass",
            "Archer City",
            "Argyle",
            "Arlington",
            "Armstrong",
            "Arp",
            "Art",
            "Artesia Wells",
            "Arthur City",
            "Asherton",
            "Aspermont",
            "Atascosa",
            "Athens",
            "Atlanta",
            "Aubrey",
            "Austin",
            "Austwell",
            "Avalon",
            "Avery",
            "Avinger",
            "Avoca",
            "Axtell",
            "Azle",
            "Bacliff",
            "Bagwell",
            "Bailey",
            "Baird",
            "Ballinger",
            "Balmorhea",
            "Bandera",
            "Bangs",
            "Banquete",
            "Bardwell",
            "Barker",
            "Barksdale",
            "Barnhart",
            "Barry",
            "Barstow",
            "Bartlett",
            "Bastrop",
            "Batesville",
            "Batson",
            "Bay City",
            "Bayside",
            "Baytown",
            "Beasley",
            "Beaumont",
            "Bebe",
            "Beckville",
            "Bedford",
            "Bedias",
            "Beeville",
            "Bellaire",
            "Bellevue",
            "Bells",
            "Bellville",
            "Belmont",
            "Belton",
            "Ben Bolt",
            "Ben Franklin",
            "Ben Wheeler",
            "Benavides",
            "Bend",
            "Benjamin",
            "Berclair",
            "Bergheim",
            "Bertram",
            "Big Bend National Park",
            "Big Lake",
            "Big Sandy",
            "Big Spring",
            "Big Wells",
            "Bigfoot",
            "Bishop",
            "Bivins",
            "Blackwell",
            "Blanco",
            "Blanket",
            "Bledsoe",
            "Bleiblerville",
            "Blessing",
            "Bloomburg",
            "Blooming Grove",
            "Bloomington",
            "Blossom",
            "Blue Ridge",
            "Bluegrove",
            "Bluff Dale",
            "Bluffton",
            "Blum",
            "Boerne",
            "Bogata",
            "Boling",
            "Bon Wier",
            "Bonham",
            "Booker",
            "Borger",
            "Bovina",
            "Bowie",
            "Boyd",
            "Boys Ranch",
            "Brackettville",
            "Brady",
            "Brandon",
            "Brashear",
            "Brazoria",
            "Breckenridge",
            "Bremond",
            "Brenham",
            "Bridge City",
            "Bridgeport",
            "Briggs",
            "Briscoe",
            "Broaddus",
            "Bronson",
            "Bronte",
            "Brookeland",
            "Brookesmith",
            "Brookshire",
            "Brookston",
            "Brownfield",
            "Brownsboro",
            "Brownsville",
            "Brownwood",
            "Bruceville",
            "Bruni",
            "Bryan",
            "Bryson",
            "Buchanan Dam",
            "Buckholts",
            "Buda",
            "Buffalo",
            "Buffalo Gap",
            "Bula",
            "Bullard",
            "Bulverde",
            "Buna",
            "Burkburnett",
            "Burkett",
            "Burkeville",
            "Burleson",
            "Burlington",
            "Burnet",
            "Burton",
            "Bushland",
            "Byers",
            "Bynum",
            "Cactus",
            "Caddo",
            "Caddo Mills",
            "Caldwell",
            "Call",
            "Calliham",
            "Calvert",
            "Camden",
            "Cameron",
            "Camp Wood",
            "Campbell",
            "Campbellton",
            "Canadian",
            "Canton",
            "Canutillo",
            "Canyon",
            "Canyon Lake",
            "Carbon",
            "Carey",
            "Carlsbad",
            "Carlton",
            "Carmine",
            "Carrizo Springs",
            "Carrollton",
            "Carthage",
            "Cason",
            "Castell",
            "Castroville",
            "Cat Spring",
            "Catarina",
            "Cayuga",
            "Cedar Creek",
            "Cedar Hill",
            "Cedar Lane",
            "Cedar Park",
            "Cee Vee",
            "Celeste",
            "Celina",
            "Center",
            "Center Point",
            "Centerville",
            "Centralia",
            "Chalk",
            "Chandler",
            "Channelview",
            "Channing",
            "Chapman Ranch",
            "Chappell Hill",
            "Charlotte",
            "Chatfield",
            "Cherokee",
            "Chester",
            "Chico",
            "Chicota",
            "Childress",
            "Chillicothe",
            "Chilton",
            "China",
            "China Spring",
            "Chireno",
            "Chriesman",
            "Christine",
            "Christoval",
            "Cibolo",
            "Cisco",
            "Clarendon",
            "Clarksville",
            "Claude",
            "Clay",
            "Clayton",
            "Cleburne",
            "Cleveland",
            "Clifton",
            "Clint",
            "Clute",
            "Clyde",
            "Coahoma",
            "Coldspring",
            "Coleman",
            "College Station",
            "Collegeport",
            "Colleyville",
            "Collinsville",
            "Colmesneil",
            "Colorado City",
            "Columbus",
            "Comanche",
            "Combes",
            "Comfort",
            "Commerce",
            "Como",
            "Comstock",
            "Concan",
            "Concepcion",
            "Concord",
            "Conroe",
            "Converse",
            "Cookville",
            "Coolidge",
            "Cooper",
            "Copeville",
            "Coppell",
            "Copperas Cove",
            "Corinth",
            "Corpus Christi",
            "Corrigan",
            "Corsicana",
            "Cost",
            "Cotton Center",
            "Cotulla",
            "Coupland",
            "Covington",
            "Coyanosa",
            "Crandall",
            "Crane",
            "Cranfills Gap",
            "Crawford",
            "Cresson",
            "Crockett",
            "Crosby",
            "Crosbyton",
            "Cross Plains",
            "Crowell",
            "Crowley",
            "Crystal City",
            "Cuero",
            "Cumby",
            "Cuney",
            "Cunningham",
            "Cushing",
            "Cypress",
            "D Hanis",
            "Daingerfield",
            "Daisetta",
            "Dale",
            "Dalhart",
            "Dallardsville",
            "Dallas",
            "Damon",
            "Danbury",
            "Danciger",
            "Danevang",
            "Darrouzett",
            "Davilla",
            "Dawn",
            "Dawson",
            "Dayton",
            "De Berry",
            "De Kalb",
            "De Leon",
            "Deanville",
            "Decatur",
            "Deer Park",
            "Del Rio",
            "Del Valle",
            "Dell City",
            "Delmita",
            "Denison",
            "Dennis",
            "Denton",
            "Denver City",
            "Deport",
            "Desdemona",
            "Desoto",
            "Detroit",
            "Devers",
            "Devine",
            "Deweyville",
            "Diana",
            "Diboll",
            "Dickens",
            "Dickinson",
            "Dike",
            "Dilley",
            "Dime Box",
            "Dimmitt",
            "Dinero",
            "Dobbin",
            "Dodd City",
            "Dodge",
            "Dodson",
            "Donie",
            "Donna",
            "Doole",
            "Doss",
            "Doucette",
            "Dougherty",
            "Douglass",
            "Douglassville",
            "Driftwood",
            "Dripping Springs",
            "Driscoll",
            "Dryden",
            "Dublin",
            "Dumas",
            "Dumont",
            "Duncanville",
            "Dunn",
            "Dyess AFB",
            "Eagle Lake",
            "Eagle Pass",
            "Early",
            "Earth",
            "East Bernard",
            "Eastland",
            "Easton",
            "Ecleto",
            "Ector",
            "Edcouch",
            "Eddy",
            "Eden",
            "Edgewood",
            "Edinburg",
            "Edmonson",
            "Edna",
            "Edroy",
            "Egypt",
            "El Campo",
            "El Indio",
            "El Paso",
            "Eldorado",
            "Electra",
            "Elgin",
            "Elkhart",
            "Ellinger",
            "Elm Mott",
            "Elmaton",
            "Elmendorf",
            "Elmo",
            "Elsa",
            "Elysian Fields",
            "Emory",
            "Encinal",
            "Encino",
            "Energy",
            "Enloe",
            "Ennis",
            "Enochs",
            "Eola",
            "Era",
            "Estelline",
            "Etoile",
            "Euless",
            "Eustace",
            "Evadale",
            "Evant",
            "Fabens",
            "Fairfield",
            "Falcon Heights",
            "Falfurrias",
            "Falls City",
            "Fannin",
            "Farmersville",
            "Farnsworth",
            "Farwell",
            "Fate",
            "Fayetteville",
            "Fentress",
            "Ferris",
            "Fieldton",
            "Fischer",
            "Flat",
            "Flatonia",
            "Flint",
            "Flomot",
            "Florence",
            "Floresville",
            "Flower Mound",
            "Floydada",
            "Fluvanna",
            "Flynn",
            "Follett",
            "Forestburg",
            "Forney",
            "Forreston",
            "Forsan",
            "Fort Davis",
            "Fort Hancock",
            "Fort McKavett",
            "Fort Stockton",
            "Fort Worth",
            "Fowlerton",
            "Francitas",
            "Franklin",
            "Frankston",
            "Fred",
            "Fredericksburg",
            "Fredonia",
            "Freeport",
            "Freer",
            "Fresno",
            "Friendswood",
            "Friona",
            "Frisco",
            "Fritch",
            "Frost",
            "Fruitvale",
            "Fulshear",
            "Fulton",
            "Gail",
            "Gainesville",
            "Galena Park",
            "Gallatin",
            "Galveston",
            "Ganado",
            "Garciasville",
            "Garden City",
            "Gardendale",
            "Garland",
            "Garrison",
            "Garwood",
            "Gary",
            "Gatesville",
            "Gause",
            "Geneva",
            "George West",
            "Georgetown",
            "Geronimo",
            "Giddings",
            "Gilchrist",
            "Gillett",
            "Gilmer",
            "Girard",
            "Girvin",
            "Gladewater",
            "Glen Flora",
            "Glen Rose",
            "Glidden",
            "Gober",
            "Godley",
            "Golden",
            "Goldsboro",
            "Goldsmith",
            "Goldthwaite",
            "Goliad",
            "Gonzales",
            "Goodfellow AFB",
            "Goodrich",
            "Gordon",
            "Gordonville",
            "Goree",
            "Gorman",
            "Gouldbusk",
            "Graford",
            "Graham",
            "Granbury",
            "Grand Prairie",
            "Grand Saline",
            "Grandfalls",
            "Grandview",
            "Granger",
            "Grapeland",
            "Grapevine",
            "Greenville",
            "Greenwood",
            "Gregory",
            "Groesbeck",
            "Groom",
            "Groves",
            "Groveton",
            "Grulla",
            "Gruver",
            "Guerra",
            "Gun Barrel City",
            "Gunter",
            "Gustine",
            "Guthrie",
            "Guy",
            "Hale Center",
            "Hallettsville",
            "Hallsville",
            "Haltom City",
            "Hamilton",
            "Hamlin",
            "Hamshire",
            "Hankamer",
            "Happy",
            "Hardin",
            "Hargill",
            "Harker Heights",
            "Harleton",
            "Harlingen",
            "Harper",
            "Harrold",
            "Hart",
            "Hartley",
            "Harwood",
            "Haskell",
            "Haslet",
            "Hawkins",
            "Hawley",
            "Hearne",
            "Hebbronville",
            "Hedley",
            "Heidenheimer",
            "Helotes",
            "Hemphill",
            "Hempstead",
            "Henderson",
            "Henrietta",
            "Hereford",
            "Hermleigh",
            "Hewitt",
            "Hext",
            "Hico",
            "Hidalgo",
            "Higgins",
            "High Island",
            "Highlands",
            "Hillister",
            "Hillsboro",
            "Hitchcock",
            "Hobson",
            "Hochheim",
            "Hockley",
            "Holland",
            "Holliday",
            "Hondo",
            "Honey Grove",
            "Hooks",
            "Houston",
            "Howe",
            "Hubbard",
            "Huffman",
            "Hufsmith",
            "Hughes Springs",
            "Hull",
            "Humble",
            "Hungerford",
            "Hunt",
            "Huntington",
            "Huntsville",
            "Hurst",
            "Hutchins",
            "Hutto",
            "Hye",
            "Idalou",
            "Imperial",
            "Industry",
            "Inez",
            "Ingleside",
            "Ingram",
            "Iola",
            "Iowa Park",
            "Ira",
            "Iraan",
            "Iredell",
            "Irene",
            "Irving",
            "Italy",
            "Itasca",
            "Ivanhoe",
            "Jacksboro",
            "Jacksonville",
            "Jarrell",
            "Jasper",
            "Jayton",
            "Jefferson",
            "Jermyn",
            "Jewett",
            "Joaquin",
            "Johnson City",
            "Joinerville",
            "Jonesboro",
            "Jonesville",
            "Josephine",
            "Joshua",
            "Jourdanton",
            "Judson",
            "Junction",
            "Justiceburg",
            "Justin",
            "Kamay",
            "Karnack",
            "Karnes City",
            "Katy",
            "Kaufman",
            "Keene",
            "Keller",
            "Kemah",
            "Kemp",
            "Kempner",
            "Kendalia",
            "Kendleton",
            "Kenedy",
            "Kennard",
            "Kennedale",
            "Kenney",
            "Kerens",
            "Kermit",
            "Kerrville",
            "Kildare",
            "Kilgore",
            "Killeen",
            "Kingsbury",
            "Kingsland",
            "Kingsville",
            "Kirbyville",
            "Kirkland",
            "Kirvin",
            "Klondike",
            "Knickerbocker",
            "Knippa",
            "Knott",
            "Knox City",
            "Kopperl",
            "Kosse",
            "Kountze",
            "Kress",
            "Krum",
            "Kurten",
            "Kyle",
            "La Blanca",
            "La Coste",
            "La Feria",
            "La Grange",
            "La Joya",
            "La Marque",
            "La Porte",
            "La Pryor",
            "La Salle",
            "La Vernia",
            "La Victoria",
            "La Villa",
            "La Ward",
            "Ladonia",
            "Laguna Park",
            "Laird Hill",
            "Lake Creek",
            "Lake Dallas",
            "Lake Jackson",
            "Lakeview",
            "Lamesa",
            "Lampasas",
            "Lancaster",
            "Lane City",
            "Laneville",
            "Langtry",
            "Laredo",
            "Larue",
            "Lasara",
            "Latexo",
            "Laughlin A F B",
            "Lavon",
            "Lawn",
            "Lazbuddie",
            "League City",
            "Leakey",
            "Leander",
            "Ledbetter",
            "Leesburg",
            "Leesville",
            "Lefors",
            "Leggett",
            "Lelia Lake",
            "Leming",
            "Lenorah",
            "Leon Junction",
            "Leona",
            "Leonard",
            "Leroy",
            "Levelland",
            "Lewisville",
            "Lexington",
            "Liberty",
            "Liberty Hill",
            "Lillian",
            "Lincoln",
            "Lindale",
            "Linden",
            "Lindsay",
            "Lingleville",
            "Linn",
            "Lipan",
            "Lipscomb",
            "Lissie",
            "Little Elm",
            "Little River",
            "Littlefield",
            "Liverpool",
            "Livingston",
            "Llano",
            "Lockhart",
            "Lockney",
            "Lodi",
            "Lohn",
            "Lolita",
            "Lometa",
            "London",
            "Lone Oak",
            "Lone Star",
            "Long Branch",
            "Long Mott",
            "Longview",
            "Loop",
            "Lopeno",
            "Loraine",
            "Lorena",
            "Lorenzo",
            "Los Ebanos",
            "Los Fresnos",
            "Los Indios",
            "Lott",
            "Louise",
            "Lovelady",
            "Loving",
            "Lowake",
            "Lozano",
            "Lubbock",
            "Lueders",
            "Lufkin",
            "Luling",
            "Lumberton",
            "Lyford",
            "Lyons",
            "Lytle",
            "Mabank",
            "Macdona",
            "Madisonville",
            "Magnolia",
            "Malakoff",
            "Malone",
            "Manchaca",
            "Manor",
            "Mansfield",
            "Manvel",
            "Maple",
            "Marathon",
            "Marble Falls",
            "Marfa",
            "Marietta",
            "Marion",
            "Markham",
            "Marlin",
            "Marquez",
            "Marshall",
            "Mart",
            "Martindale",
            "Martinsville",
            "Maryneal",
            "Mason",
            "Masterson",
            "Matador",
            "Matagorda",
            "Mathis",
            "Maud",
            "Mauriceville",
            "Maxwell",
            "May",
            "Maydelle",
            "Maypearl",
            "Maysfield",
            "Mcadoo",
            "McAllen",
            "McCamey",
            "McCaulley",
            "McCoy",
            "McDade",
            "Mcfaddin",
            "McGregor",
            "McKinney",
            "Mclean",
            "McLeod",
            "McNeil",
            "McQueeney",
            "Meadow",
            "Medina",
            "Megargel",
            "Melissa",
            "Melvin",
            "Memphis",
            "Menard",
            "Mentone",
            "Mercedes",
            "Mereta",
            "Meridian",
            "Merit",
            "Merkel",
            "Mertens",
            "Mertzon",
            "Mesquite",
            "Mexia",
            "Meyersville",
            "Miami",
            "Mico",
            "Midfield",
            "Midkiff",
            "Midland",
            "Midlothian",
            "Midway",
            "Milam",
            "Milano",
            "Miles",
            "Milford",
            "Millersview",
            "Millican",
            "Millsap",
            "Minden",
            "Mineola",
            "Mineral",
            "Mineral Wells",
            "Mingus",
            "Mirando City",
            "Mission",
            "Missouri City",
            "Mobeetie",
            "Monahans",
            "Mont Belvieu",
            "Montague",
            "Montalba",
            "Montgomery",
            "Moody",
            "Moore",
            "Moran",
            "Morgan",
            "Morgan Mill",
            "Morse",
            "Morton",
            "Moscow",
            "Moulton",
            "Mound",
            "Mount Calm",
            "Mount Enterprise",
            "Mount Pleasant",
            "Mount Vernon",
            "Mountain Home",
            "Muenster",
            "Muldoon",
            "Muleshoe",
            "Mullin",
            "Mumford",
            "Munday",
            "Murchison",
            "Myra",
            "Nacogdoches",
            "Nada",
            "Naples",
            "Nash",
            "Natalia",
            "Naval Air Station/ Jrb",
            "Navasota",
            "Nazareth",
            "Neches",
            "Nederland",
            "Needville",
            "Nemo",
            "Nevada",
            "New Baden",
            "New Boston",
            "New Braunfels",
            "New Caney",
            "New Deal",
            "New Home",
            "New London",
            "New Summerfield",
            "New Ulm",
            "New Waverly",
            "Newark",
            "Newcastle",
            "Newgulf",
            "Newton",
            "Nixon",
            "Nocona",
            "Nolan",
            "Nolanville",
            "Nome",
            "Nordheim",
            "Normangee",
            "Normanna",
            "North Houston",
            "North Richland Hills",
            "North Zulch",
            "Norton",
            "Notrees",
            "Novice",
            "Nursery",
            "O Brien",
            "Oakhurst",
            "Oakland",
            "Oakville",
            "Oakwood",
            "Odell",
            "Odem",
            "Odessa",
            "Odonnell",
            "Oglesby",
            "Oilton",
            "Oklaunion",
            "Old Glory",
            "Old Ocean",
            "Olden",
            "Olmito",
            "Olney",
            "Olton",
            "Omaha",
            "Onalaska",
            "Orange",
            "Orange Grove",
            "Orangefield",
            "Orchard",
            "Ore City",
            "Orla",
            "Ottine",
            "Otto",
            "Ovalo",
            "Overton",
            "Ozona",
            "Paducah",
            "Paige",
            "Paint Rock",
            "Palacios",
            "Palestine",
            "Palmer",
            "Palo Pinto",
            "Paluxy",
            "Pampa",
            "Pandora",
            "Panhandle",
            "Panna Maria",
            "Panola",
            "Paradise",
            "Paris",
            "Pasadena",
            "Pattison",
            "Pattonville",
            "Pawnee",
            "Pear Valley",
            "Pearland",
            "Pearsall",
            "Peaster",
            "Pecan Gap",
            "Pecos",
            "Peggy",
            "Pendleton",
            "Penelope",
            "Penitas",
            "Pennington",
            "Penwell",
            "Pep",
            "Perrin",
            "Perry",
            "Perryton",
            "Petersburg",
            "Petrolia",
            "Pettus",
            "Petty",
            "Pflugerville",
            "Pharr",
            "Pickton",
            "Pierce",
            "Pilot Point",
            "Pinehurst",
            "Pineland",
            "Pipe Creek",
            "Pittsburg",
            "Placedo",
            "Plains",
            "Plainview",
            "Plano",
            "Plantersville",
            "Pleasanton",
            "Pledger",
            "Plum",
            "Point",
            "Point Comfort",
            "Pointblank",
            "Pollok",
            "Ponder",
            "Pontotoc",
            "Poolville",
            "Port Aransas",
            "Port Arthur",
            "Port Bolivar",
            "Port Isabel",
            "Port Lavaca",
            "Port Mansfield",
            "Port Neches",
            "Port O Connor",
            "Porter",
            "Portland",
            "Post",
            "Poteet",
            "Poth",
            "Pottsboro",
            "Pottsville",
            "Powderly",
            "Powell",
            "Poynor",
            "Prairie Hill",
            "Prairie Lea",
            "Prairie View",
            "Premont",
            "Presidio",
            "Price",
            "Priddy",
            "Princeton",
            "Proctor",
            "Progreso",
            "Prosper",
            "Purdon",
            "Purmela",
            "Putnam",
            "Pyote",
            "Quail",
            "Quanah",
            "Queen City",
            "Quemado",
            "Quinlan",
            "Quitaque",
            "Quitman",
            "Rainbow",
            "Ralls",
            "Rancho Alegre",
            "Randolph",
            "Ranger",
            "Rankin",
            "Ransom Canyon",
            "Ratcliff",
            "Ravenna",
            "Raymondville",
            "Raywood",
            "Reagan",
            "Realitos",
            "Red Oak",
            "Red Rock",
            "Redford",
            "Redwater",
            "Refugio",
            "Reklaw",
            "Rhome",
            "Rice",
            "Richards",
            "Richardson",
            "Richland",
            "Richland Springs",
            "Richmond",
            "Riesel",
            "Ringgold",
            "Rio Frio",
            "Rio Grande City",
            "Rio Hondo",
            "Rio Medina",
            "Rio Vista",
            "Rising Star",
            "Riverside",
            "Riviera",
            "Roanoke",
            "Roans Prairie",
            "Roaring Springs",
            "Robert Lee",
            "Robstown",
            "Roby",
            "Rochelle",
            "Rochester",
            "Rock Island",
            "Rockdale",
            "Rockport",
            "Rocksprings",
            "Rockwall",
            "Rockwood",
            "Rogers",
            "Roma",
            "Romayor",
            "Roosevelt",
            "Ropesville",
            "Rosanky",
            "Roscoe",
            "Rosebud",
            "Rosenberg",
            "Rosharon",
            "Ross",
            "Rosser",
            "Rosston",
            "Rotan",
            "Round Mountain",
            "Round Rock",
            "Round Top",
            "Rowena",
            "Rowlett",
            "Roxton",
            "Royalty",
            "Royse City",
            "Rule",
            "Runge",
            "Rusk",
            "Rye",
            "Sabinal",
            "Sabine Pass",
            "Sacul",
            "Sadler",
            "Saint Hedwig",
            "Saint Jo",
            "Salado",
            "Salineno",
            "Salt Flat",
            "Saltillo",
            "Samnorwood",
            "San Angelo",
            "San Antonio",
            "San Augustine",
            "San Benito",
            "San Diego",
            "San Elizario",
            "San Felipe",
            "San Isidro",
            "San Juan",
            "San Leon",
            "San Marcos",
            "San Perlita",
            "San Saba",
            "San Ygnacio",
            "Sanderson",
            "Sandia",
            "Sandy",
            "Sanford",
            "Sanger",
            "Santa Anna",
            "Santa Elena",
            "Santa Fe",
            "Santa Maria",
            "Santa Rosa",
            "Santo",
            "Saragosa",
            "Saratoga",
            "Sarita",
            "Satin",
            "Savoy",
            "Schertz",
            "Schulenburg",
            "Schwertner",
            "Scotland",
            "Scottsville",
            "Scroggins",
            "Scurry",
            "Seabrook",
            "Seadrift",
            "Seagoville",
            "Seagraves",
            "Sealy",
            "Sebastian",
            "Seguin",
            "Selman City",
            "Seminole",
            "Seymour",
            "Shafter",
            "Shallowater",
            "Shamrock",
            "Sheffield",
            "Shelbyville",
            "Shepherd",
            "Sheppard AFB",
            "Sheridan",
            "Sherman",
            "Shiner",
            "Shiro",
            "Sidney",
            "Sienna Plantation",
            "Sierra Blanca",
            "Silsbee",
            "Silver",
            "Silverton",
            "Simms",
            "Simonton",
            "Sinton",
            "Skellytown",
            "Skidmore",
            "Slaton",
            "Slidell",
            "Smiley",
            "Smithville",
            "Smyer",
            "Snook",
            "Snyder",
            "Somerset",
            "Somerville",
            "Sonora",
            "Sour Lake",
            "South Bend",
            "South Houston",
            "South Padre Island",
            "South Plains",
            "Southlake",
            "Southmayd",
            "Spade",
            "Speaks",
            "Spearman",
            "Spicewood",
            "Splendora",
            "Spring",
            "Spring Branch",
            "Springlake",
            "Springtown",
            "Spur",
            "Spurger",
            "Stafford",
            "Stamford",
            "Stanton",
            "Staples",
            "Star",
            "Stephenville",
            "Sterling City",
            "Stinnett",
            "Stockdale",
            "Stonewall",
            "Stowell",
            "Stratford",
            "Strawn",
            "Streetman",
            "Sublime",
            "Sudan",
            "Sugar Land",
            "Sullivan City",
            "Sulphur Bluff",
            "Sulphur Springs",
            "Summerfield",
            "Sumner",
            "Sundown",
            "Sunnyvale",
            "Sunray",
            "Sunset",
            "Sutherland Springs",
            "Sweeny",
            "Sweet Home",
            "Sweetwater",
            "Sylvester",
            "Taft",
            "Tahoka",
            "Talco",
            "Talpa",
            "Tarpley",
            "Tarzan",
            "Tatum",
            "Taylor",
            "Teague",
            "Tehuacana",
            "Telegraph",
            "Telephone",
            "Telferner",
            "Tell",
            "Temple",
            "Tenaha",
            "Tennessee Colony",
            "Tennyson",
            "Terlingua",
            "Terrell",
            "Texarkana",
            "Texas City",
            "Texline",
            "The Colony",
            "Thicket",
            "Thomaston",
            "Thompsons",
            "Thorndale",
            "Thornton",
            "Thrall",
            "Three Rivers",
            "Throckmorton",
            "Tilden",
            "Timpson",
            "Tioga",
            "Tivoli",
            "Tokio",
            "Tolar",
            "Tom Bean",
            "Tomball",
            "Tornillo",
            "Tow",
            "Toyah",
            "Toyahvale",
            "Trent",
            "Trenton",
            "Trinidad",
            "Trinity",
            "Troup",
            "Troy",
            "Tuleta",
            "Tulia",
            "Turkey",
            "Tuscola",
            "Tye",
            "Tyler",
            "Tynan",
            "Umbarger",
            "Universal City",
            "Utopia",
            "Uvalde",
            "Valentine",
            "Valera",
            "Valley Mills",
            "Valley Spring",
            "Valley View",
            "Van",
            "Van Alstyne",
            "Van Horn",
            "Van Vleck",
            "Vancourt",
            "Vanderbilt",
            "Vanderpool",
            "Vega",
            "Venus",
            "Veribest",
            "Vernon",
            "Victoria",
            "Vidor",
            "Village Mills",
            "Voca",
            "Von Ormy",
            "Voss",
            "Votaw",
            "Voth",
            "Waco",
            "Wadsworth",
            "Waelder",
            "Waka",
            "Walburg",
            "Wall",
            "Waller",
            "Wallis",
            "Wallisville",
            "Walnut Springs",
            "Warda",
            "Waring",
            "Warren",
            "Washington",
            "Waskom",
            "Water Valley",
            "Waxahachie",
            "Wayside",
            "Weatherford",
            "Webster",
            "Weesatche",
            "Weimar",
            "Weinert",
            "Weir",
            "Welch",
            "Wellborn",
            "Wellington",
            "Wellman",
            "Wells",
            "Weslaco",
            "West",
            "West Columbia",
            "West Point",
            "Westbrook",
            "Westhoff",
            "Westminster",
            "Weston",
            "Wharton",
            "Wheeler",
            "Wheelock",
            "White Deer",
            "White Oak",
            "Whiteface",
            "Whitehouse",
            "Whitesboro",
            "Whitewright",
            "Whitharral",
            "Whitney",
            "Whitsett",
            "Whitt",
            "Wichita Falls",
            "Wickett",
            "Wiergate",
            "Wildorado",
            "Willis",
            "Willow City",
            "Wills Point",
            "Wilmer",
            "Wilson",
            "Wimberley",
            "Windom",
            "Windthorst",
            "Winfield",
            "Wingate",
            "Wink",
            "Winnie",
            "Winnsboro",
            "Winona",
            "Winters",
            "Woden",
            "Wolfe City",
            "Wolfforth",
            "Woodlake",
            "Woodlawn",
            "Woodsboro",
            "Woodson",
            "Woodville",
            "Woodway",
            "Wortham",
            "Wrightsboro",
            "Wylie",
            "Yancey",
            "Yantis",
            "Yoakum",
            "Yorktown",
            "Zapata",
            "Zavalla",
            "Zephyr"
        ]
    },
    {
        "state": "Utah",
        "abbr": "UT",
        "cities": [
            "Alpine",
            "Altamont",
            "Alton",
            "Altonah",
            "American Fork",
            "Aneth",
            "Annabella",
            "Antimony",
            "Aurora",
            "Axtell",
            "Bear River City",
            "Beaver",
            "Beryl",
            "Bicknell",
            "Bingham Canyon",
            "Blanding",
            "Bluebell",
            "Bluff",
            "Bonanza",
            "Boulder",
            "Bountiful",
            "Brian Head",
            "Brigham City",
            "Bryce",
            "Bryce Canyon",
            "Cache Junction",
            "Cannonville",
            "Castle Dale",
            "Cedar City",
            "Cedar Valley",
            "Centerfield",
            "Centerville",
            "Central",
            "Chester",
            "Circleville",
            "Cisco",
            "Clarkston",
            "Clawson",
            "Clearfield",
            "Cleveland",
            "Clinton",
            "Coalville",
            "Collinston",
            "Corinne",
            "Cornish",
            "Croydon",
            "Dammeron Valley",
            "Delta",
            "Deweyville",
            "Draper",
            "Duchesne",
            "Duck Creek Village",
            "Dugway",
            "Dutch John",
            "East Carbon",
            "Echo",
            "Eden",
            "Elberta",
            "Elmo",
            "Elsinore",
            "Emery",
            "Enterprise",
            "Ephraim",
            "Escalante",
            "Eureka",
            "Fairview",
            "Farmington",
            "Fayette",
            "Ferron",
            "Fielding",
            "Fillmore",
            "Fort Duchesne",
            "Fountain Green",
            "Fruitland",
            "Garden City",
            "Garland",
            "Garrison",
            "Glendale",
            "Glenwood",
            "Goshen",
            "Grantsville",
            "Green River",
            "Greenville",
            "Greenwich",
            "Grouse Creek",
            "Gunlock",
            "Gunnison",
            "Gusher",
            "Hanksville",
            "Hanna",
            "Hatch",
            "Heber City",
            "Helper",
            "Henefer",
            "Henrieville",
            "Hiawatha",
            "Hildale",
            "Hill AFB",
            "Hinckley",
            "Holden",
            "Honeyville",
            "Hooper",
            "Howell",
            "Huntington",
            "Huntsville",
            "Hurricane",
            "Hyde Park",
            "Hyrum",
            "Ibapah",
            "Ivins",
            "Jensen",
            "Joseph",
            "Junction",
            "Kamas",
            "Kanab",
            "Kanarraville",
            "Kanosh",
            "Kaysville",
            "Kenilworth",
            "Kingston",
            "Koosharem",
            "La Sal",
            "La Verkin",
            "Lake Powell",
            "Laketown",
            "Lapoint",
            "Layton",
            "Leamington",
            "Leeds",
            "Lehi",
            "Levan",
            "Lewiston",
            "Lindon",
            "Loa",
            "Logan",
            "Lyman",
            "Lynndyl",
            "Magna",
            "Manila",
            "Manti",
            "Mantua",
            "Mapleton",
            "Marysvale",
            "Mayfield",
            "Meadow",
            "Mendon",
            "Mexican Hat",
            "Midvale",
            "Midway",
            "Milford",
            "Millville",
            "Minersville",
            "Moab",
            "Modena",
            "Mona",
            "Monroe",
            "Montezuma Creek",
            "Monticello",
            "Morgan",
            "Moroni",
            "Mount Carmel",
            "Mount Pleasant",
            "Mountain Home",
            "Myton",
            "Neola",
            "Nephi",
            "New Harmony",
            "Newcastle",
            "Newton",
            "North Salt Lake",
            "Oak City",
            "Oakley",
            "Oasis",
            "Ogden",
            "Orangeville",
            "Orderville",
            "Orem",
            "Panguitch",
            "Paradise",
            "Paragonah",
            "Park City",
            "Park Valley",
            "Parowan",
            "Payson",
            "Peoa",
            "Pine Valley",
            "Pleasant Grove",
            "Plymouth",
            "Portage",
            "Price",
            "Providence",
            "Provo",
            "Randlett",
            "Randolph",
            "Redmond",
            "Richfield",
            "Richmond",
            "Riverside",
            "Riverton",
            "Rockville",
            "Roosevelt",
            "Roy",
            "Rush Valley",
            "Saint George",
            "Salem",
            "Salina",
            "Salt Lake City",
            "Sandy",
            "Santa Clara",
            "Santaquin",
            "Scipio",
            "Sevier",
            "Sigurd",
            "Smithfield",
            "Snowville",
            "South Jordan",
            "South Willard",
            "Spanish Fork",
            "Spring City",
            "Springdale",
            "Springville",
            "Sterling",
            "Stockton",
            "Summit",
            "Sunnyside",
            "Syracuse",
            "Tabiona",
            "Talmage",
            "Teasdale",
            "Thompson",
            "Tooele",
            "Toquerville",
            "Torrey",
            "Tremonton",
            "Trenton",
            "Tridell",
            "Tropic",
            "Vernal",
            "Vernon",
            "Veyo",
            "Virgin",
            "Wales",
            "Wallsburg",
            "Washington",
            "Wellington",
            "Wellsville",
            "Wendover",
            "West Jordan",
            "Whiterocks",
            "Willard",
            "Woodruff",
            "Woods Cross"
        ]
    },
    {
        "state": "Vermont",
        "abbr": "VT",
        "cities": [
            "Adamant",
            "Albany",
            "Alburg",
            "Arlington",
            "Ascutney",
            "Averill",
            "Bakersfield",
            "Barnard",
            "Barnet",
            "Barre",
            "Barton",
            "Beebe Plain",
            "Beecher Falls",
            "Bellows Falls",
            "Belmont",
            "Belvidere Center",
            "Bennington",
            "Benson",
            "Bethel",
            "Bomoseen",
            "Bondville",
            "Bradford",
            "Brandon",
            "Brattleboro",
            "Bridgewater",
            "Bridgewater Corners",
            "Bridport",
            "Bristol",
            "Brookfield",
            "Brownsville",
            "Burlington",
            "Cabot",
            "Calais",
            "Cambridge",
            "Cambridgeport",
            "Canaan",
            "Castleton",
            "Cavendish",
            "Center Rutland",
            "Charlotte",
            "Chelsea",
            "Chester",
            "Chester Depot",
            "Chittenden",
            "Colchester",
            "Concord",
            "Corinth",
            "Coventry",
            "Craftsbury",
            "Craftsbury Common",
            "Cuttingsville",
            "Danby",
            "Danville",
            "Derby",
            "Derby Center",
            "Derby Line",
            "Dorset",
            "East Arlington",
            "East Barre",
            "East Berkshire",
            "East Burke",
            "East Calais",
            "East Charleston",
            "East Corinth",
            "East Dorset",
            "East Dover",
            "East Fairfield",
            "East Hardwick",
            "East Haven",
            "East Middlebury",
            "East Montpelier",
            "East Poultney",
            "East Randolph",
            "East Ryegate",
            "East Saint Johnsbury",
            "East Thetford",
            "East Wallingford",
            "Eden",
            "Eden Mills",
            "Enosburg Falls",
            "Essex",
            "Essex Junction",
            "Fair Haven",
            "Fairfax",
            "Fairfield",
            "Fairlee",
            "Ferrisburg",
            "Fletcher",
            "Florence",
            "Forest Dale",
            "Franklin",
            "Gaysville",
            "Gilman",
            "Glover",
            "Grafton",
            "Granby",
            "Grand Isle",
            "Graniteville",
            "Granville",
            "Greensboro",
            "Greensboro Bend",
            "Groton",
            "Guildhall",
            "Hancock",
            "Hardwick",
            "Hartford",
            "Hartland",
            "Hartland Four Corners",
            "Highgate Center",
            "Highgate Springs",
            "Hinesburg",
            "Huntington",
            "Hyde Park",
            "Hydeville",
            "Irasburg",
            "Island Pond",
            "Isle La Motte",
            "Jacksonville",
            "Jamaica",
            "Jeffersonville",
            "Jericho",
            "Johnson",
            "Jonesville",
            "Killington",
            "Lake Elmore",
            "Lincoln",
            "Londonderry",
            "Lowell",
            "Lower Waterford",
            "Ludlow",
            "Lunenburg",
            "Lyndon",
            "Lyndon Center",
            "Lyndonville",
            "Manchester",
            "Manchester Center",
            "Marlboro",
            "Marshfield",
            "McIndoe Falls",
            "Middlebury",
            "Middletown Springs",
            "Milton",
            "Monkton",
            "Montgomery",
            "Montgomery Center",
            "Montpelier",
            "Moretown",
            "Morgan",
            "Morrisville",
            "Moscow",
            "Mount Holly",
            "New Haven",
            "Newbury",
            "Newfane",
            "Newport",
            "Newport Center",
            "North Bennington",
            "North Clarendon",
            "North Concord",
            "North Ferrisburg",
            "North Hartland",
            "North Hero",
            "North Hyde Park",
            "North Montpelier",
            "North Pomfret",
            "North Pownal",
            "North Springfield",
            "North Thetford",
            "North Troy",
            "Northfield",
            "Northfield Falls",
            "Norton",
            "Norwich",
            "Orleans",
            "Orwell",
            "Passumpsic",
            "Pawlet",
            "Peacham",
            "Perkinsville",
            "Peru",
            "Pittsfield",
            "Pittsford",
            "Plainfield",
            "Plymouth",
            "Post Mills",
            "Poultney",
            "Pownal",
            "Proctor",
            "Proctorsville",
            "Putney",
            "Quechee",
            "Randolph",
            "Randolph Center",
            "Reading",
            "Readsboro",
            "Richford",
            "Richmond",
            "Ripton",
            "Rochester",
            "Roxbury",
            "Rupert",
            "Rutland",
            "Saint Albans",
            "Saint Albans Bay",
            "Saint Johnsbury",
            "Saint Johnsbury Center",
            "Salisbury",
            "Saxtons River",
            "Shaftsbury",
            "Sharon",
            "Sheffield",
            "Shelburne",
            "Sheldon",
            "Sheldon Springs",
            "Shoreham",
            "South Barre",
            "South Burlington",
            "South Hero",
            "South Londonderry",
            "South Newfane",
            "South Pomfret",
            "South Royalton",
            "South Ryegate",
            "South Strafford",
            "South Woodstock",
            "Springfield",
            "Stannard",
            "Starksboro",
            "Stockbridge",
            "Stowe",
            "Strafford",
            "Sudbury",
            "Sutton",
            "Swanton",
            "Taftsville",
            "Thetford",
            "Thetford Center",
            "Townshend",
            "Troy",
            "Tunbridge",
            "Underhill",
            "Underhill Center",
            "Vergennes",
            "Vernon",
            "Vershire",
            "Waitsfield",
            "Wallingford",
            "Wardsboro",
            "Warren",
            "Washington",
            "Waterbury",
            "Waterbury Center",
            "Waterville",
            "Websterville",
            "Wells",
            "Wells River",
            "West Burke",
            "West Charleston",
            "West Danville",
            "West Dover",
            "West Dummerston",
            "West Fairlee",
            "West Glover",
            "West Halifax",
            "West Hartford",
            "West Newbury",
            "West Pawlet",
            "West Rupert",
            "West Rutland",
            "West Topsham",
            "West Townshend",
            "West Wardsboro",
            "Westfield",
            "Westford",
            "Westminster",
            "Westminster Station",
            "Weston",
            "White River Junction",
            "Whiting",
            "Whitingham",
            "Wilder",
            "Williamstown",
            "Williamsville",
            "Williston",
            "Wilmington",
            "Windsor",
            "Winooski",
            "Wolcott",
            "Woodbury",
            "Woodford",
            "Woodstock",
            "Worcester"
        ]
    },
    {
        "state": "Virginia",
        "abbr": "VA",
        "cities": [
            "Abingdon",
            "Accomac",
            "Achilles",
            "Afton",
            "Alberta",
            "Aldie",
            "Alexandria",
            "Altavista",
            "Alton",
            "Amelia Court House",
            "Amherst",
            "Amissville",
            "Ammon",
            "Amonate",
            "Andover",
            "Annandale",
            "Appalachia",
            "Appomattox",
            "Ararat",
            "Arcola",
            "Ark",
            "Arlington",
            "Aroda",
            "Arrington",
            "Arvonia",
            "Ashburn",
            "Ashland",
            "Assawoman",
            "Atkins",
            "Atlantic",
            "Augusta Springs",
            "Austinville",
            "Axton",
            "Aylett",
            "Bacova",
            "Banco",
            "Bandy",
            "Barboursville",
            "Barhamsville",
            "Barren Springs",
            "Baskerville",
            "Bassett",
            "Bastian",
            "Basye",
            "Batesville",
            "Battery Park",
            "Bealeton",
            "Beaumont",
            "Beaverdam",
            "Bedford",
            "Bee",
            "Bellamy",
            "Belle Haven",
            "Belspring",
            "Ben Hur",
            "Bena",
            "Bent Mountain",
            "Bentonville",
            "Bergton",
            "Berryville",
            "Big Island",
            "Big Rock",
            "Big Stone Gap",
            "Birchleaf",
            "Birdsnest",
            "Bishop",
            "Blacksburg",
            "Blackstone",
            "Blackwater",
            "Blairs",
            "Bland",
            "Bloxom",
            "Blue Grass",
            "Blue Ridge",
            "Bluefield",
            "Bluemont",
            "Bohannon",
            "Boissevain",
            "Boones Mill",
            "Boston",
            "Bowling Green",
            "Boyce",
            "Boydton",
            "Boykins",
            "Bracey",
            "Branchville",
            "Brandy Station",
            "Breaks",
            "Bremo Bluff",
            "Bridgewater",
            "Brightwood",
            "Bristol",
            "Bristow",
            "Broad Run",
            "Broadford",
            "Broadway",
            "Brodnax",
            "Brooke",
            "Brookneal",
            "Brownsburg",
            "Brucetown",
            "Bruington",
            "Buchanan",
            "Buckingham",
            "Buena Vista",
            "Buffalo Junction",
            "Bumpass",
            "Burgess",
            "Burke",
            "Burkes Garden",
            "Burkeville",
            "Burr Hill",
            "Callands",
            "Callao",
            "Callaway",
            "Calverton",
            "Cana",
            "Cape Charles",
            "Capeville",
            "Capron",
            "Cardinal",
            "Caret",
            "Carrollton",
            "Carrsville",
            "Carson",
            "Cartersville",
            "Casanova",
            "Cascade",
            "Castleton",
            "Castlewood",
            "Catawba",
            "Catharpin",
            "Catlett",
            "Cedar Bluff",
            "Center Cross",
            "Centreville",
            "Ceres",
            "Champlain",
            "Chantilly",
            "Charles City",
            "Charlotte Court House",
            "Charlottesville",
            "Chase City",
            "Chatham",
            "Check",
            "Cheriton",
            "Chesapeake",
            "Chester",
            "Chester Gap",
            "Chesterfield",
            "Chilhowie",
            "Chincoteague Island",
            "Christchurch",
            "Christiansburg",
            "Church Road",
            "Church View",
            "Churchville",
            "Claremont",
            "Clarksville",
            "Claudville",
            "Clear Brook",
            "Cleveland",
            "Clifford",
            "Clifton",
            "Clifton Forge",
            "Clinchco",
            "Clintwood",
            "Clover",
            "Cloverdale",
            "Cluster Springs",
            "Cobbs Creek",
            "Coeburn",
            "Coleman Falls",
            "Coles Point",
            "Collinsville",
            "Colonial Beach",
            "Colonial Heights",
            "Columbia",
            "Concord",
            "Copper Hill",
            "Corbin",
            "Courtland",
            "Covesville",
            "Covington",
            "Craddockville",
            "Craigsville",
            "Crewe",
            "Criders",
            "Crimora",
            "Cripple Creek",
            "Critz",
            "Crockett",
            "Cross Junction",
            "Crozet",
            "Crozier",
            "Crystal Hill",
            "Cullen",
            "Culpeper",
            "Cumberland",
            "Dahlgren",
            "Daleville",
            "Damascus",
            "Dante",
            "Danville",
            "Davenport",
            "Davis Wharf",
            "Dayton",
            "Deerfield",
            "Delaplane",
            "Deltaville",
            "Dendron",
            "Dewitt",
            "Diggs",
            "Dillwyn",
            "Dinwiddie",
            "Disputanta",
            "Doe Hill",
            "Dogue",
            "Dolphin",
            "Doran",
            "Doswell",
            "Drakes Branch",
            "Draper",
            "Drewryville",
            "Dry Fork",
            "Dryden",
            "Dublin",
            "Duffield",
            "Dugspur",
            "Dulles",
            "Dumfries",
            "Dundas",
            "Dungannon",
            "Dunn Loring",
            "Dunnsville",
            "Dutton",
            "Dyke",
            "Eagle Rock",
            "Earlysville",
            "East Stone Gap",
            "Eastville",
            "Ebony",
            "Edinburg",
            "Edwardsville",
            "Eggleston",
            "Elberon",
            "Elk Creek",
            "Elkton",
            "Elkwood",
            "Elliston",
            "Emory",
            "Emporia",
            "Esmont",
            "Etlan",
            "Evergreen",
            "Evington",
            "Ewing",
            "Exmore",
            "Faber",
            "Fairfax",
            "Fairfax Station",
            "Fairfield",
            "Falls Church",
            "Falls Mills",
            "Fancy Gap",
            "Farmville",
            "Farnham",
            "Ferrum",
            "Fieldale",
            "Fife",
            "Fincastle",
            "Fishers Hill",
            "Fishersville",
            "Flint Hill",
            "Floyd",
            "Ford",
            "Forest",
            "Fork Union",
            "Fort Belvoir",
            "Fort Blackmore",
            "Fort Defiance",
            "Fort Eustis",
            "Fort Lee",
            "Fort Mitchell",
            "Fort Monroe",
            "Fort Valley",
            "Foster",
            "Franklin",
            "Franktown",
            "Fredericksburg",
            "Free Union",
            "Freeman",
            "Fries",
            "Front Royal",
            "Ft Myer",
            "Fulks Run",
            "Gainesville",
            "Galax",
            "Garrisonville",
            "Gasburg",
            "Gate City",
            "Glade Hill",
            "Glade Spring",
            "Gladstone",
            "Gladys",
            "Glasgow",
            "Glen Allen",
            "Glen Lyn",
            "Glen Wilton",
            "Gloucester",
            "Gloucester Point",
            "Goldbond",
            "Goldvein",
            "Goochland",
            "Goode",
            "Goodview",
            "Gordonsville",
            "Gore",
            "Goshen",
            "Graves Mill",
            "Great Falls",
            "Green Bay",
            "Greenbackville",
            "Greenbush",
            "Greenville",
            "Greenway",
            "Greenwood",
            "Gretna",
            "Grimstead",
            "Grottoes",
            "Grundy",
            "Gum Spring",
            "Gwynn",
            "Hacksneck",
            "Hadensville",
            "Hague",
            "Halifax",
            "Hallieford",
            "Hallwood",
            "Hamilton",
            "Hampden Sydney",
            "Hampton",
            "Hanover",
            "Harborton",
            "Hardy",
            "Hardyville",
            "Harman",
            "Harrisonburg",
            "Hartfield",
            "Hartwood",
            "Hayes",
            "Haymarket",
            "Haynesville",
            "Haysi",
            "Haywood",
            "Head Waters",
            "Heathsville",
            "Henry",
            "Herndon",
            "Highland Springs",
            "Hillsville",
            "Hiltons",
            "Hinton",
            "Hiwassee",
            "Honaker",
            "Hood",
            "Hopewell",
            "Horntown",
            "Horsepen",
            "Hot Springs",
            "Howardsville",
            "Huddleston",
            "Hudgins",
            "Hume",
            "Huntly",
            "Hurley",
            "Hurt",
            "Hustle",
            "Independence",
            "Indian Valley",
            "Iron Gate",
            "Irvington",
            "Isle Of Wight",
            "Ivanhoe",
            "Ivor",
            "Ivy",
            "Jamaica",
            "Jamestown",
            "Jamesville",
            "Jarratt",
            "Java",
            "Jeffersonton",
            "Jenkins Bridge",
            "Jersey",
            "Jetersville",
            "Jewell Ridge",
            "Jonesville",
            "Keeling",
            "Keen Mountain",
            "Keene",
            "Keezletown",
            "Keller",
            "Kenbridge",
            "Kents Store",
            "Keokee",
            "Keswick",
            "Keysville",
            "Kilmarnock",
            "King And Queen Court Hous",
            "King George",
            "King William",
            "Kinsale",
            "La Crosse",
            "Lacey Spring",
            "Lackey",
            "Ladysmith",
            "Lambsburg",
            "Lancaster",
            "Laneview",
            "Lanexa",
            "Laurel Fork",
            "Lawrenceville",
            "Lebanon",
            "Leesburg",
            "Leon",
            "Lexington",
            "Lightfoot",
            "Lignum",
            "Lincoln",
            "Linden",
            "Linville",
            "Little Plymouth",
            "Lively",
            "Locust Dale",
            "Locust Grove",
            "Locust Hill",
            "Locustville",
            "Long Island",
            "Loretto",
            "Lorton",
            "Lottsburg",
            "Louisa",
            "Lovettsville",
            "Lovingston",
            "Low Moor",
            "Lowry",
            "Lunenburg",
            "Luray",
            "Lynch Station",
            "Lynchburg",
            "Lyndhurst",
            "Machipongo",
            "Macon",
            "Madison",
            "Madison Heights",
            "Madison Mills",
            "Maidens",
            "Manakin Sabot",
            "Manassas",
            "Mannboro",
            "Manquin",
            "Mappsville",
            "Marion",
            "Marionville",
            "Markham",
            "Marshall",
            "Martinsville",
            "Maryus",
            "Mascot",
            "Massies Mill",
            "Mathews",
            "Mattaponi",
            "Maurertown",
            "Mavisdale",
            "Max Meadows",
            "Maxie",
            "McClure",
            "McCoy",
            "McDowell",
            "McGaheysville",
            "McKenney",
            "McLean",
            "Meadows Of Dan",
            "Meadowview",
            "Mears",
            "Mechanicsville",
            "Meherrin",
            "Melfa",
            "Mendota",
            "Meredithville",
            "Merrifield",
            "Merry Point",
            "Middlebrook",
            "Middleburg",
            "Middletown",
            "Midland",
            "Midlothian",
            "Milford",
            "Millboro",
            "Millers Tavern",
            "Millwood",
            "Mineral",
            "Mint Spring",
            "Mitchells",
            "Modest Town",
            "Mollusk",
            "Moneta",
            "Monroe",
            "Montebello",
            "Monterey",
            "Montpelier",
            "Montpelier Station",
            "Montross",
            "Montvale",
            "Moon",
            "Morattico",
            "Moseley",
            "Mount Crawford",
            "Mount Holly",
            "Mount Jackson",
            "Mount Sidney",
            "Mount Solon",
            "Mount Vernon",
            "Mouth Of Wilson",
            "Mustoe",
            "Narrows",
            "Naruna",
            "Nassawadox",
            "Nathalie",
            "Natural Bridge",
            "Natural Bridge Station",
            "Nellysford",
            "Nelson",
            "Nelsonia",
            "New Canton",
            "New Castle",
            "New Church",
            "New Hope",
            "New Kent",
            "New Market",
            "New Point",
            "New River",
            "Newbern",
            "Newington",
            "Newport",
            "Newport News",
            "Newsoms",
            "Newtown",
            "Nickelsville",
            "Ninde",
            "Nokesville",
            "Nora",
            "Norfolk",
            "Norge",
            "North",
            "North Garden",
            "North Tazewell",
            "Norton",
            "Norwood",
            "Nottoway",
            "Nuttsville",
            "Oak Hall",
            "Oakpark",
            "Oakton",
            "Oakwood",
            "Occoquan",
            "Oilville",
            "Oldhams",
            "Onancock",
            "Onemo",
            "Onley",
            "Ophelia",
            "Orange",
            "Ordinary",
            "Oriskany",
            "Orkney Springs",
            "Orlean",
            "Oyster",
            "Paeonian Springs",
            "Paint Bank",
            "Painter",
            "Palmyra",
            "Pamplin",
            "Paris",
            "Parksley",
            "Parrott",
            "Partlow",
            "Patrick Springs",
            "Pearisburg",
            "Pembroke",
            "Penhook",
            "Penn Laird",
            "Pennington Gap",
            "Petersburg",
            "Phenix",
            "Philomont",
            "Pilgrims Knob",
            "Pilot",
            "Piney River",
            "Pittsville",
            "Pleasant Valley",
            "Pocahontas",
            "Poquoson",
            "Port Haywood",
            "Port Republic",
            "Port Royal",
            "Portsmouth",
            "Pound",
            "Pounding Mill",
            "Powhatan",
            "Pratts",
            "Prince George",
            "Prospect",
            "Providence Forge",
            "Pulaski",
            "Pungoteague",
            "Purcellville",
            "Quantico",
            "Quicksburg",
            "Quinby",
            "Quinque",
            "Quinton",
            "Radford",
            "Radiant",
            "Randolph",
            "Raphine",
            "Rapidan",
            "Rappahannock Academy",
            "Raven",
            "Rawlings",
            "Rectortown",
            "Red Ash",
            "Red House",
            "Red Oak",
            "Redwood",
            "Reedville",
            "Remington",
            "Republican Grove",
            "Rescue",
            "Reston",
            "Reva",
            "Rhoadesville",
            "Rice",
            "Rich Creek",
            "Richardsville",
            "Richlands",
            "Richmond",
            "Ridgeway",
            "Rileyville",
            "Riner",
            "Ringgold",
            "Ripplemead",
            "Rixeyville",
            "Roanoke",
            "Rochelle",
            "Rockbridge Baths",
            "Rockville",
            "Rocky Gap",
            "Rocky Mount",
            "Rollins Fork",
            "Rose Hill",
            "Rosedale",
            "Roseland",
            "Round Hill",
            "Rowe",
            "Ruby",
            "Ruckersville",
            "Rural Retreat",
            "Rustburg",
            "Ruther Glen",
            "Ruthville",
            "Saint Charles",
            "Saint Paul",
            "Saint Stephens Church",
            "Salem",
            "Saltville",
            "Saluda",
            "Sandston",
            "Sandy Hook",
            "Sandy Level",
            "Sandy Point",
            "Sanford",
            "Saxe",
            "Saxis",
            "Schley",
            "Schuyler",
            "Scottsburg",
            "Scottsville",
            "Seaford",
            "Sealston",
            "Seaview",
            "Sedley",
            "Selma",
            "Seven Mile Ford",
            "Severn",
            "Shacklefords",
            "Sharps",
            "Shawsville",
            "Shenandoah",
            "Shipman",
            "Shortt Gap",
            "Singers Glen",
            "Skippers",
            "Skipwith",
            "Smithfield",
            "Somerset",
            "Somerville",
            "South Boston",
            "South Hill",
            "Sparta",
            "Speedwell",
            "Spencer",
            "Sperryville",
            "Spotsylvania",
            "Spottswood",
            "Spout Spring",
            "Spring Grove",
            "Springfield",
            "Stafford",
            "Staffordsville",
            "Stanardsville",
            "Stanley",
            "Stanleytown",
            "Star Tannery",
            "State Farm",
            "Staunton",
            "Steeles Tavern",
            "Stephens City",
            "Stephenson",
            "Sterling",
            "Stevensburg",
            "Stevensville",
            "Stonega",
            "Stony Creek",
            "Strasburg",
            "Stratford",
            "Stuart",
            "Stuarts Draft",
            "Studley",
            "Suffolk",
            "Sugar Grove",
            "Sumerduck",
            "Surry",
            "Susan",
            "Sussex",
            "Sutherland",
            "Sutherlin",
            "Sweet Briar",
            "Swoope",
            "Swords Creek",
            "Syria",
            "Tangier",
            "Tannersville",
            "Tappahannock",
            "Tasley",
            "Tazewell",
            "Temperanceville",
            "Thaxton",
            "The Plains",
            "Thornburg",
            "Timberville",
            "Toano",
            "Toms Brook",
            "Topping",
            "Townsend",
            "Trammel",
            "Trevilians",
            "Triangle",
            "Trout Dale",
            "Troutville",
            "Troy",
            "Tyro",
            "Union Hall",
            "Unionville",
            "University Of Richmond",
            "Upperville",
            "Urbanna",
            "Valentines",
            "Vansant",
            "Vernon Hill",
            "Verona",
            "Vesta",
            "Vesuvius",
            "Victoria",
            "Vienna",
            "Viewtown",
            "Village",
            "Villamont",
            "Vinton",
            "Virgilina",
            "Virginia Beach",
            "Volney",
            "Wachapreague",
            "Wake",
            "Wakefield",
            "Walkerton",
            "Wallops Island",
            "Wardtown",
            "Ware Neck",
            "Warfield",
            "Warm Springs",
            "Warrenton",
            "Warsaw",
            "Washington",
            "Water View",
            "Waterford",
            "Wattsville",
            "Waverly",
            "Waynesboro",
            "Weber City",
            "Weems",
            "West Augusta",
            "West Mclean",
            "West Point",
            "Weyers Cave",
            "White Hall",
            "White Marsh",
            "White Plains",
            "White Post",
            "White Stone",
            "Whitetop",
            "Whitewood",
            "Wicomico",
            "Wicomico Church",
            "Williamsburg",
            "Williamsville",
            "Willis",
            "Willis Wharf",
            "Wilsons",
            "Winchester",
            "Windsor",
            "Wingina",
            "Wirtz",
            "Wise",
            "Withams",
            "Wolford",
            "Wolftown",
            "Woodberry Forest",
            "Woodbridge",
            "Woodford",
            "Woodlawn",
            "Woods Cross Roads",
            "Woodstock",
            "Woodville",
            "Woolwine",
            "Wylliesburg",
            "Wytheville",
            "Yale",
            "Yorktown",
            "Zacata",
            "Zanoni",
            "Zuni"
        ]
    },
    {
        "state": "Washington",
        "abbr": "WA",
        "cities": [
            "Aberdeen",
            "Acme",
            "Addy",
            "Adna",
            "Airway Heights",
            "Albion",
            "Allyn",
            "Almira",
            "Amanda Park",
            "Amboy",
            "Anacortes",
            "Anatone",
            "Anderson Island",
            "Appleton",
            "Ardenvoir",
            "Ariel",
            "Arlington",
            "Ashford",
            "Asotin",
            "Auburn",
            "Bainbridge Island",
            "Baring",
            "Battle Ground",
            "Bay Center",
            "Beaver",
            "Belfair",
            "Bellevue",
            "Bellingham",
            "Belmont",
            "Benge",
            "Benton City",
            "Beverly",
            "Bickleton",
            "Bingen",
            "Black Diamond",
            "Blaine",
            "Blakely Island",
            "Bothell",
            "Bow",
            "Boyds",
            "Bremerton",
            "Brewster",
            "Bridgeport",
            "Brinnon",
            "Brownstown",
            "Brush Prairie",
            "Buckley",
            "Bucoda",
            "Buena",
            "Burbank",
            "Burley",
            "Burlington",
            "Burton",
            "Camano",
            "Camas",
            "Camp Murray",
            "Carbonado",
            "Carlsborg",
            "Carlton",
            "Carnation",
            "Carrolls",
            "Carson",
            "Cashmere",
            "Castle Rock",
            "Cathlamet",
            "Centerville",
            "Centralia",
            "Chattaroy",
            "Chehalis",
            "Chelan",
            "Chelan Falls",
            "Cheney",
            "Chewelah",
            "Chimacum",
            "Chinook",
            "Cinebar",
            "Clallam Bay",
            "Clarkston",
            "Clayton",
            "Cle Elum",
            "Clearlake",
            "Clinton",
            "Colbert",
            "Colfax",
            "College Place",
            "Colton",
            "Colville",
            "Conconully",
            "Concrete",
            "Connell",
            "Conway",
            "Copalis Beach",
            "Copalis Crossing",
            "Cosmopolis",
            "Cougar",
            "Coulee City",
            "Coulee Dam",
            "Coupeville",
            "Cowiche",
            "Creston",
            "Cunningham",
            "Curlew",
            "Curtis",
            "Cusick",
            "Custer",
            "Dallesport",
            "Danville",
            "Darrington",
            "Davenport",
            "Dayton",
            "Deer Harbor",
            "Deer Park",
            "Deming",
            "Desert Aire",
            "Dixie",
            "Doty",
            "Dryden",
            "Dupont",
            "Duvall",
            "East Olympia",
            "East Wenatchee",
            "Easton",
            "Eastsound",
            "Eatonville",
            "Edmonds",
            "Edwall",
            "Elbe",
            "Electric City",
            "Elk",
            "Ellensburg",
            "Elma",
            "Elmer City",
            "Eltopia",
            "Endicott",
            "Entiat",
            "Enumclaw",
            "Ephrata",
            "Ethel",
            "Evans",
            "Everett",
            "Everson",
            "Fairchild Air Force Base",
            "Fairfield",
            "Fall City",
            "Federal Way",
            "Ferndale",
            "Ford",
            "Forks",
            "Four Lakes",
            "Fox Island",
            "Freeland",
            "Freeman",
            "Friday Harbor",
            "Fruitland",
            "Galvin",
            "Garfield",
            "George",
            "Gifford",
            "Gig Harbor",
            "Glenoma",
            "Glenwood",
            "Gold Bar",
            "Goldendale",
            "Goose Prairie",
            "Graham",
            "Grand Coulee",
            "Grandview",
            "Granger",
            "Granite Falls",
            "Grapeview",
            "Grayland",
            "Grays River",
            "Greenacres",
            "Greenbank",
            "Hamilton",
            "Hansville",
            "Harrah",
            "Harrington",
            "Hartline",
            "Hatton",
            "Hay",
            "Hazel Dell North",
            "Heisson",
            "Hobart",
            "Hoodsport",
            "Hooper",
            "Hoquiam",
            "Humptulips",
            "Hunters",
            "Husum",
            "Ilwaco",
            "Inchelium",
            "Index",
            "Indianola",
            "Ione",
            "Issaquah",
            "Joyce",
            "Kahlotus",
            "Kalama",
            "Kapowsin",
            "Keller",
            "Kelso",
            "Kenmore",
            "Kennewick",
            "Kent",
            "Kettle Falls",
            "Keyport",
            "Kingston",
            "Kirkland",
            "Kittitas",
            "Klickitat",
            "La Center",
            "La Conner",
            "La Grande",
            "La Push",
            "Lacey",
            "Lacrosse",
            "Lake Stevens",
            "Lakebay",
            "Lakewood",
            "Lamona",
            "Lamont",
            "Langley",
            "Latah",
            "Laurier",
            "Leavenworth",
            "Lebam",
            "Liberty Lake",
            "Lilliwaup",
            "Lincoln",
            "Lind",
            "Littlerock",
            "Long Beach",
            "Longbranch",
            "Longmire",
            "Longview",
            "Loomis",
            "Loon Lake",
            "Lopez Island",
            "Lummi Island",
            "Lyle",
            "Lyman",
            "Lynden",
            "Lynnwood",
            "Mabton",
            "Malaga",
            "Malden",
            "Malo",
            "Malone",
            "Malott",
            "Manchester",
            "Mansfield",
            "Manson",
            "Maple Falls",
            "Maple Valley",
            "Marblemount",
            "Marcus",
            "Marlin",
            "Marshall",
            "Marysville",
            "Matlock",
            "Mattawa",
            "Mazama",
            "Mccleary",
            "Mckenna",
            "Mead",
            "Medical Lake",
            "Medina",
            "Menlo",
            "Mercer Island",
            "Mesa",
            "Metaline",
            "Metaline Falls",
            "Methow",
            "Mica",
            "Milton",
            "Mineral",
            "Moclips",
            "Mohler",
            "Monitor",
            "Monroe",
            "Montesano",
            "Morton",
            "Moses Lake",
            "Mossyrock",
            "Mount Vernon",
            "Mountlake Terrace",
            "Moxee",
            "Mukilteo",
            "Naches",
            "Nahcotta",
            "Napavine",
            "Naselle",
            "Neah Bay",
            "Neilton",
            "Nespelem",
            "Newman Lake",
            "Newport",
            "Nine Mile Falls",
            "Nooksack",
            "Nordland",
            "North Bend",
            "North Bonneville",
            "North Lakewood",
            "Northport",
            "Oak Harbor",
            "Oakesdale",
            "Oakville",
            "Ocean Park",
            "Ocean Shores",
            "Odessa",
            "Okanogan",
            "Olalla",
            "Olga",
            "Olympia",
            "Omak",
            "Onalaska",
            "Orcas",
            "Orient",
            "Orondo",
            "Oroville",
            "Orting",
            "Othello",
            "Otis Orchards",
            "Outlook",
            "Oysterville",
            "Pacific",
            "Pacific Beach",
            "Packwood",
            "Palisades",
            "Palouse",
            "Paradise Inn",
            "Parker",
            "Parkland",
            "Pasco",
            "Pateros",
            "Paterson",
            "Pe Ell",
            "Peshastin",
            "Plymouth",
            "Point Roberts",
            "Pomeroy",
            "Port Angeles",
            "Port Gamble",
            "Port Hadlock",
            "Port Ludlow",
            "Port Orchard",
            "Port Townsend",
            "Poulsbo",
            "Prescott",
            "Preston",
            "Prosser",
            "Pullman",
            "Puyallup",
            "Quilcene",
            "Quinault",
            "Quincy",
            "Rainier",
            "Randle",
            "Ravensdale",
            "Raymond",
            "Reardan",
            "Redmond",
            "Redondo",
            "Renton",
            "Republic",
            "Retsil",
            "Rice",
            "Richland",
            "Ridgefield",
            "Ritzville",
            "Riverside",
            "Rochester",
            "Rock Island",
            "Rockford",
            "Rockport",
            "Rollingbay",
            "Ronald",
            "Roosevelt",
            "Rosalia",
            "Rosburg",
            "Roslyn",
            "Roy",
            "Royal City",
            "Ryderwood",
            "Saint John",
            "Salkum",
            "Sammamish",
            "Satsop",
            "Seabeck",
            "Seahurst",
            "Seattle",
            "Seaview",
            "Sedro Woolley",
            "Sekiu",
            "Selah",
            "Sequim",
            "Shaw Island",
            "Shelton",
            "Shoreline",
            "Silvana",
            "Silver Creek",
            "Silverdale",
            "Silverlake",
            "Skamokawa",
            "Skykomish",
            "Snohomish",
            "Snoqualmie",
            "Snoqualmie Pass",
            "Soap Lake",
            "South Bend",
            "South Cle Elum",
            "South Colby",
            "South Prairie",
            "Southworth",
            "Spanaway",
            "Spangle",
            "Spokane",
            "Sprague",
            "Springdale",
            "Stanwood",
            "Starbuck",
            "Startup",
            "Stehekin",
            "Steilacoom",
            "Steptoe",
            "Stevenson",
            "Stratford",
            "Sultan",
            "Sumas",
            "Sumner",
            "Sunnyside",
            "Suquamish",
            "Tacoma",
            "Taholah",
            "Tahuya",
            "Tekoa",
            "Tenino",
            "Thornton",
            "Thorp",
            "Tieton",
            "Tokeland",
            "Toledo",
            "Tonasket",
            "Toppenish",
            "Touchet",
            "Toutle",
            "Tracyton",
            "Trout Lake",
            "Tumtum",
            "Tumwater",
            "Twisp",
            "Underwood",
            "Union",
            "Uniontown",
            "University Place",
            "Usk",
            "Vader",
            "Valley",
            "Valleyford",
            "Vancouver",
            "Vantage",
            "Vashon",
            "Vaughn",
            "Veradale",
            "Wahkiacus",
            "Waitsburg",
            "Waldron",
            "Walla Walla",
            "Waller",
            "Wallula",
            "Wapato",
            "Warden",
            "Washougal",
            "Washtucna",
            "Waterville",
            "Wauconda",
            "Wauna",
            "Waverly",
            "Wellpinit",
            "Wenatchee",
            "West Richland",
            "Westport",
            "White Salmon",
            "White Swan",
            "Wilbur",
            "Wilkeson",
            "Wilson Creek",
            "Winlock",
            "Winthrop",
            "Wishram",
            "Woodinville",
            "Woodland",
            "Yacolt",
            "Yakima",
            "Yelm",
            "Zillah"
        ]
    },
    {
        "state": "West Virginia",
        "abbr": "WV",
        "cities": [
            "Accoville",
            "Adrian",
            "Advent",
            "Albright",
            "Alderson",
            "Alkol",
            "Allen Junction",
            "Alloy",
            "Alma",
            "Alum Bridge",
            "Alum Creek",
            "Ameagle",
            "Amherstdale",
            "Amherstdale-Robinette",
            "Amigo",
            "Amma",
            "Anawalt",
            "Anmoore",
            "Ansted",
            "Apple Grove",
            "Arbovale",
            "Arnett",
            "Arnoldsburg",
            "Arthurdale",
            "Artie",
            "Asbury",
            "Ashford",
            "Ashton",
            "Athens",
            "Auburn",
            "Augusta",
            "Aurora",
            "Auto",
            "Avondale",
            "Baisden",
            "Baker",
            "Bakerton",
            "Bald Knob",
            "Ballard",
            "Ballengee",
            "Bancroft",
            "Barboursville",
            "Barrackville",
            "Bartley",
            "Bartow",
            "Baxter",
            "Bayard",
            "Beaver",
            "Beckley",
            "Beech Bottom",
            "Beeson",
            "Belington",
            "Belle",
            "Belleville",
            "Belmont",
            "Belva",
            "Bens Run",
            "Bentree",
            "Benwood",
            "Berea",
            "Bergoo",
            "Berkeley Springs",
            "Berwind",
            "Bethany",
            "Beverly",
            "Bickmore",
            "Big Bend",
            "Big Creek",
            "Big Run",
            "Big Sandy",
            "Big Springs",
            "Bim",
            "Birch River",
            "Blacksville",
            "Blair",
            "Blandville",
            "Bloomery",
            "Bloomingrose",
            "Blount",
            "Blue Creek",
            "Blue Jay",
            "Bluefield",
            "Bob White",
            "Bolt",
            "Bomont",
            "Boomer",
            "Booth",
            "Borderland",
            "Bowden",
            "Bradley",
            "Bradshaw",
            "Bramwell",
            "Branchland",
            "Brandywine",
            "Breeden",
            "Brenton",
            "Bretz",
            "Bridgeport",
            "Bristol",
            "Brohard",
            "Brownton",
            "Bruceton Mills",
            "Bruno",
            "Buckeye",
            "Buckhannon",
            "Bud",
            "Buffalo",
            "Bunker Hill",
            "Burlington",
            "Burnsville",
            "Burton",
            "Cabin Creek",
            "Cabins",
            "Cairo",
            "Caldwell",
            "Calvin",
            "Camden",
            "Camden On Gauley",
            "Cameron",
            "Camp Creek",
            "Cannelton",
            "Canvas",
            "Capels",
            "Capon Bridge",
            "Capon Springs",
            "Caretta",
            "Carolina",
            "Cass",
            "Cassville",
            "Cedar Grove",
            "Cedarville",
            "Center Point",
            "Centralia",
            "Ceredo",
            "Chapmanville",
            "Charles Town",
            "Charleston",
            "Charlton Heights",
            "Charmco",
            "Chattaroy",
            "Chauncey",
            "Chester",
            "Chloe",
            "Circleville",
            "Clarksburg",
            "Clay",
            "Clear Creek",
            "Clear Fork",
            "Clendenin",
            "Cleveland",
            "Clio",
            "Clothier",
            "Coal City",
            "Coal Mountain",
            "Coalton",
            "Coalwood",
            "Colcord",
            "Colfax",
            "Colliers",
            "Comfort",
            "Cool Ridge",
            "Copen",
            "Cora",
            "Core",
            "Corinne",
            "Costa",
            "Cottageville",
            "Covel",
            "Cowen",
            "Coxs Mills",
            "Crab Orchard",
            "Craigsville",
            "Crawford",
            "Crawley",
            "Creston",
            "Crichton",
            "Crum",
            "Crumpler",
            "Cucumber",
            "Culloden",
            "Cyclone",
            "Dailey",
            "Dallas",
            "Danese",
            "Daniels",
            "Danville",
            "Davin",
            "Davis",
            "Davisville",
            "Davy",
            "Dawes",
            "Deep Water",
            "Delbarton",
            "Dellslow",
            "Delray",
            "Diana",
            "Dille",
            "Dingess",
            "Dixie",
            "Dorothy",
            "Dothan",
            "Drennen",
            "Dry Creek",
            "Drybranch",
            "Dryfork",
            "Duck",
            "Dunbar",
            "Dunlow",
            "Dunmore",
            "Durbin",
            "East Bank",
            "East Lynn",
            "Eccles",
            "Eckman",
            "Edgarton",
            "Edmond",
            "Eglon",
            "Elbert",
            "Eleanor",
            "Elizabeth",
            "Elk Garden",
            "Elkhorn",
            "Elkins",
            "Elkview",
            "Ellamore",
            "Ellenboro",
            "Elmira",
            "Elton",
            "English",
            "Enterprise",
            "Erbacon",
            "Eskdale",
            "Ethel",
            "Evans",
            "Everettville",
            "Exchange",
            "Fairdale",
            "Fairlea",
            "Fairmont",
            "Fairview",
            "Falling Rock",
            "Falling Waters",
            "Fanrock",
            "Farmington",
            "Fayetteville",
            "Fenwick",
            "Fisher",
            "Flat Top",
            "Flatwoods",
            "Flemington",
            "Follansbee",
            "Folsom",
            "Forest Hill",
            "Fort Ashby",
            "Fort Gay",
            "Fort Spring",
            "Foster",
            "Four States",
            "Frametown",
            "Frankford",
            "Franklin",
            "Fraziers Bottom",
            "Freeman",
            "French Creek",
            "Frenchton",
            "Friendly",
            "Gallagher",
            "Gallipolis Ferry",
            "Galloway",
            "Gandeeville",
            "Gap Mills",
            "Gary",
            "Gassaway",
            "Gauley Bridge",
            "Gay",
            "Genoa",
            "Gerrardstown",
            "Ghent",
            "Gilbert",
            "Gilboa",
            "Gilmer",
            "Given",
            "Glace",
            "Glady",
            "Glasgow",
            "Glen",
            "Glen Dale",
            "Glen Daniel",
            "Glen Easton",
            "Glen Ferris",
            "Glen Fork",
            "Glen Jean",
            "Glen Morgan",
            "Glen Rogers",
            "Glen White",
            "Glengary",
            "Glenhayes",
            "Glenville",
            "Glenwood",
            "Gordon",
            "Gormania",
            "Grafton",
            "Grant Town",
            "Grantsville",
            "Granville",
            "Grassy Meadows",
            "Great Cacapon",
            "Green Bank",
            "Green Spring",
            "Green Sulphur Springs",
            "Greenville",
            "Griffithsville",
            "Grimms Landing",
            "Gypsy",
            "Hacker Valley",
            "Halltown",
            "Hambleton",
            "Hamlin",
            "Hampden",
            "Handley",
            "Hanover",
            "Hansford",
            "Harman",
            "Harper",
            "Harpers Ferry",
            "Harrisville",
            "Hartford",
            "Harts",
            "Havaco",
            "Haywood",
            "Hazelton",
            "Heaters",
            "Hedgesville",
            "Helen",
            "Helvetia",
            "Hemphill",
            "Henderson",
            "Hendricks",
            "Henlawson",
            "Hensley",
            "Hepzibah",
            "Herndon",
            "Hernshaw",
            "Hewett",
            "Hiawatha",
            "Hico",
            "High View",
            "Hillsboro",
            "Hilltop",
            "Hines",
            "Hinton",
            "Holden",
            "Hometown",
            "Horner",
            "Hugheston",
            "Hundred",
            "Huntington",
            "Hurricane",
            "Huttonsville",
            "Iaeger",
            "Idamay",
            "Ikes Fork",
            "Independence",
            "Indore",
            "Industrial",
            "Institute",
            "Inwood",
            "Ireland",
            "Isaban",
            "Itmann",
            "Ivydale",
            "Jacksonburg",
            "Jane Lew",
            "Jeffrey",
            "Jenkinjones",
            "Jesse",
            "Jodie",
            "Jolo",
            "Jonben",
            "Josephine",
            "Julian",
            "Jumping Branch",
            "Junction",
            "Junior",
            "Justice",
            "Kanawha Falls",
            "Kanawha Head",
            "Kearneysville",
            "Kegley",
            "Kellysville",
            "Kenna",
            "Kenova",
            "Kerens",
            "Kermit",
            "Keslers Cross Lanes",
            "Keyser",
            "Keystone",
            "Kiahsville",
            "Kieffer",
            "Kilsyth",
            "Kimball",
            "Kimberly",
            "Kincaid",
            "Kingmont",
            "Kingwood",
            "Kistler",
            "Kopperston",
            "Kyle",
            "Lahmansville",
            "Lake",
            "Lakin",
            "Lanark",
            "Lansing",
            "Lashmeet",
            "Lavalette",
            "Layland",
            "Le Roy",
            "Leckie",
            "Leewood",
            "Left Hand",
            "Leivasy",
            "Lenore",
            "Leon",
            "Lerona",
            "Lesage",
            "Leslie",
            "Lester",
            "Letart",
            "Levels",
            "Lewisburg",
            "Liberty",
            "Linden",
            "Lindside",
            "Linn",
            "Little Birch",
            "Littleton",
            "Lizemores",
            "Lochgelly",
            "Lockney",
            "Logan",
            "London",
            "Lookout",
            "Looneyville",
            "Lorado",
            "Lorentz",
            "Lost City",
            "Lost Creek",
            "Lumberport",
            "Lyburn",
            "Lynco",
            "Maben",
            "Mabie",
            "Mabscott",
            "Mac Arthur",
            "Macfarlan",
            "Madison",
            "Maidsville",
            "Mallory",
            "Mammoth",
            "Man",
            "Mannington",
            "Marianna",
            "Marlinton",
            "Martinsburg",
            "Mason",
            "Masontown",
            "Matewan",
            "Matheny",
            "Mathias",
            "Matoaka",
            "Maxwelton",
            "Maybeury",
            "Maysel",
            "Maysville",
            "McGraws",
            "McMechen",
            "Meador",
            "Meadow Bluff",
            "Meadow Bridge",
            "Meadow Creek",
            "Meadowbrook",
            "Medley",
            "Metz",
            "Miami",
            "Middlebourne",
            "Midkiff",
            "Midway",
            "Milam",
            "Mill Creek",
            "Millstone",
            "Millville",
            "Millwood",
            "Milton",
            "Minden",
            "Mineral Wells",
            "Moatsville",
            "Mohawk",
            "Monaville",
            "Montana Mines",
            "Montcalm",
            "Monterville",
            "Montgomery",
            "Montrose",
            "Moorefield",
            "Morgantown",
            "Moundsville",
            "Mount Alto",
            "Mount Carbon",
            "Mount Clare",
            "Mount Gay",
            "Mount Hope",
            "Mount Lookout",
            "Mount Nebo",
            "Mount Olive",
            "Mount Storm",
            "Mount Zion",
            "Mountain",
            "Mullens",
            "Munday",
            "Myra",
            "Nallen",
            "Naoma",
            "Napier",
            "Naugatuck",
            "Nebo",
            "Nellis",
            "Nemours",
            "Neola",
            "Nettie",
            "New Creek",
            "New Cumberland",
            "New Haven",
            "New Manchester",
            "New Martinsville",
            "New Milton",
            "New Richmond",
            "Newburg",
            "Newell",
            "Newhall",
            "Newton",
            "Newtown",
            "Nimitz",
            "Nitro",
            "Nolan",
            "Normantown",
            "North Matewan",
            "North Spring",
            "Northfork",
            "Norton",
            "Oak Hill",
            "Oakvale",
            "Oceana",
            "Odd",
            "Ohley",
            "Old Fields",
            "Omar",
            "Ona",
            "Onego",
            "Orgas",
            "Orlando",
            "Orma",
            "Osage",
            "Ottawa",
            "Ovapa",
            "Paden City",
            "Page",
            "Pageton",
            "Palestine",
            "Panther",
            "Parkersburg",
            "Parsons",
            "Paw Paw",
            "Pax",
            "Paynesville",
            "Peach Creek",
            "Pecks Mill",
            "Pence Springs",
            "Pennsboro",
            "Pentress",
            "Perkins",
            "Petersburg",
            "Peterstown",
            "Petroleum",
            "Peytona",
            "Philippi",
            "Pickens",
            "Piedmont",
            "Pinch",
            "Pine Grove",
            "Pineville",
            "Piney View",
            "Pipestem",
            "Poca",
            "Point Pleasant",
            "Points",
            "Pond Gap",
            "Pool",
            "Porters Falls",
            "Powellton",
            "Powhatan",
            "Pratt",
            "Premier",
            "Prichard",
            "Prince",
            "Princeton",
            "Princewick",
            "Procious",
            "Proctor",
            "Prosperity",
            "Pullman",
            "Purgitsville",
            "Pursglove",
            "Quinwood",
            "Rachel",
            "Racine",
            "Ragland",
            "Rainelle",
            "Raleigh",
            "Ramsey",
            "Ranger",
            "Ranson",
            "Ravencliff",
            "Ravenswood",
            "Rawl",
            "Raysal",
            "Reader",
            "Red Creek",
            "Red House",
            "Red Jacket",
            "Redstar",
            "Reedsville",
            "Reedy",
            "Renick",
            "Reynoldsville",
            "Rhodell",
            "Richwood",
            "Ridgeley",
            "Ridgeview",
            "Ridgeway",
            "Rio",
            "Ripley",
            "Rippon",
            "Riverton",
            "Rivesville",
            "Robson",
            "Rock",
            "Rock Cave",
            "Rock Creek",
            "Rock View",
            "Rockport",
            "Roderfield",
            "Romney",
            "Ronceverte",
            "Rosedale",
            "Rosemont",
            "Rowlesburg",
            "Rupert",
            "Sabine",
            "Saint Albans",
            "Saint Marys",
            "Salem",
            "Salt Rock",
            "Sand Fork",
            "Sandstone",
            "Sandyville",
            "Sarah Ann",
            "Saulsville",
            "Saxon",
            "Scarbro",
            "Scott Depot",
            "Secondcreek",
            "Selbyville",
            "Seneca Rocks",
            "Seth",
            "Shady Spring",
            "Shanks",
            "Sharon",
            "Sharples",
            "Shenandoah Junction",
            "Shepherdstown",
            "Sherman",
            "Shinnston",
            "Shirley",
            "Shoals",
            "Shock",
            "Short Creek",
            "Simon",
            "Simpson",
            "Sinks Grove",
            "Sistersville",
            "Skelton",
            "Skygusty",
            "Slab Fork",
            "Slanesville",
            "Slatyfork",
            "Smithburg",
            "Smithers",
            "Smithfield",
            "Smithville",
            "Smoot",
            "Snowshoe",
            "Sod",
            "Sophia",
            "Southside",
            "Spanishburg",
            "Spelter",
            "Spencer",
            "Sprague",
            "Spring Dale",
            "Springfield",
            "Spurlockville",
            "Squire",
            "Stanaford",
            "Statts Mills",
            "Stephenson",
            "Stirrat",
            "Stollings",
            "Strange Creek",
            "Sugar Grove",
            "Sumerco",
            "Summerlee",
            "Summersville",
            "Summit Point",
            "Surveyor",
            "Sutton",
            "Swiss",
            "Switchback",
            "Switzer",
            "Sylvester",
            "Tad",
            "Talcott",
            "Tallmansville",
            "Tariff",
            "Teays",
            "Terra Alta",
            "Terry",
            "Thacker",
            "Thomas",
            "Thornton",
            "Thorpe",
            "Thurmond",
            "Tioga",
            "Tornado",
            "Triadelphia",
            "Troy",
            "True",
            "Tunnelton",
            "Turtle Creek",
            "Twilight",
            "Twin Branch",
            "Uneeda",
            "Union",
            "Upper Tract",
            "Upperglade",
            "Valley Bend",
            "Valley Fork",
            "Valley Grove",
            "Valley Head",
            "Van",
            "Varney",
            "Verdunville",
            "Verner",
            "Victor",
            "Vienna",
            "Volga",
            "Vulcan",
            "Wadestown",
            "Waiteville",
            "Walker",
            "Walkersville",
            "Wallace",
            "Wallback",
            "Walton",
            "Wana",
            "War",
            "Wardensville",
            "Warriormine",
            "Washington",
            "Waverly",
            "Wayne",
            "Wayside",
            "Webster Springs",
            "Weirton",
            "Welch",
            "Wellsburg",
            "West Columbia",
            "West Hamlin",
            "West Liberty",
            "West Milford",
            "West Union",
            "Weston",
            "Wharncliffe",
            "Wharton",
            "Wheeling",
            "White Oak",
            "White Sulphur Springs",
            "Whitesville",
            "Whitman",
            "Whitmer",
            "Widen",
            "Wilcoe",
            "Wiley Ford",
            "Wileyville",
            "Wilkinson",
            "Williamsburg",
            "Williamson",
            "Williamstown",
            "Wilsie",
            "Wilsonburg",
            "Wilsondale",
            "Windsor Heights",
            "Winfield",
            "Winifrede",
            "Winona",
            "Wolf Pen",
            "Wolfcreek",
            "Wolfe",
            "Woodville",
            "Worth",
            "Worthington",
            "Wyatt",
            "Wyco",
            "Wyoming",
            "Yawkey",
            "Yellow Spring",
            "Yolyn",
            "Yukon"
        ]
    },
    {
        "state": "Wisconsin",
        "abbr": "WI",
        "cities": [
            "Abbotsford",
            "Abrams",
            "Adams",
            "Adell",
            "Afton",
            "Albany",
            "Algoma",
            "Allenton",
            "Alma",
            "Alma Center",
            "Almena",
            "Almond",
            "Altoona",
            "Amberg",
            "Amery",
            "Amherst",
            "Amherst Junction",
            "Aniwa",
            "Antigo",
            "Appleton",
            "Arcadia",
            "Arena",
            "Argonne",
            "Argyle",
            "Arkansaw",
            "Arkdale",
            "Arlington",
            "Armstrong Creek",
            "Arpin",
            "Ashippun",
            "Ashland",
            "Athelstane",
            "Athens",
            "Auburndale",
            "Augusta",
            "Avalon",
            "Avoca",
            "Babcock",
            "Bagley",
            "Baileys Harbor",
            "Baldwin",
            "Balsam Lake",
            "Bancroft",
            "Bangor",
            "Baraboo",
            "Barneveld",
            "Barron",
            "Barronett",
            "Bassett",
            "Bay City",
            "Bayfield",
            "Bear Creek",
            "Beaver Dam",
            "Beetown",
            "Beldenville",
            "Belgium",
            "Belleville",
            "Belmont",
            "Beloit",
            "Benet Lake",
            "Benoit",
            "Benton",
            "Berlin",
            "Big Bend",
            "Big Falls",
            "Birchwood",
            "Birnamwood",
            "Black Creek",
            "Black Earth",
            "Black River Falls",
            "Blair",
            "Blanchardville",
            "Blenker",
            "Bloomer",
            "Bloomington",
            "Blue Mounds",
            "Blue River",
            "Bonduel",
            "Bone Lake",
            "Boscobel",
            "Boulder Junction",
            "Bowler",
            "Boyceville",
            "Boyd",
            "Branch",
            "Brandon",
            "Brantwood",
            "Briggsville",
            "Brill",
            "Brillion",
            "Bristol",
            "Brodhead",
            "Brokaw",
            "Brookfield",
            "Brooklyn",
            "Brownsville",
            "Browntown",
            "Bruce",
            "Brule",
            "Brussels",
            "Bryant",
            "Burlington",
            "Burnett",
            "Butler",
            "Butte Des Morts",
            "Butternut",
            "Byron",
            "Cable",
            "Cadott",
            "Caledonia",
            "Cambria",
            "Cambridge",
            "Cameron",
            "Camp Douglas",
            "Camp Lake",
            "Campbellsport",
            "Caroline",
            "Cascade",
            "Casco",
            "Cashton",
            "Cassville",
            "Cataract",
            "Catawba",
            "Cazenovia",
            "Cecil",
            "Cedar Grove",
            "Cedarburg",
            "Centuria",
            "Chaseburg",
            "Chelsea",
            "Chetek",
            "Chili",
            "Chilton",
            "Chippewa Falls",
            "Clam Lake",
            "Clayton",
            "Clear Lake",
            "Cleveland",
            "Clinton",
            "Clintonville",
            "Clyman",
            "Cobb",
            "Cochrane",
            "Colby",
            "Coleman",
            "Colfax",
            "Colgate",
            "Collins",
            "Coloma",
            "Columbus",
            "Combined Locks",
            "Comstock",
            "Conover",
            "Conrath",
            "Coon Valley",
            "Cornell",
            "Cornucopia",
            "Cottage Grove",
            "Couderay",
            "Crandon",
            "Crivitz",
            "Cross Plains",
            "Cuba City",
            "Cudahy",
            "Cumberland",
            "Curtiss",
            "Cushing",
            "Custer",
            "Dale",
            "Dallas",
            "Dalton",
            "Danbury",
            "Dane",
            "Darien",
            "Darlington",
            "De Forest",
            "De Pere",
            "De Soto",
            "Deer Park",
            "Deerbrook",
            "Deerfield",
            "Delafield",
            "Delavan",
            "Dellwood",
            "Denmark",
            "Dickeyville",
            "Dodge",
            "Dodgeville",
            "Dorchester",
            "Dousman",
            "Downing",
            "Downsville",
            "Doylestown",
            "Dresser",
            "Drummond",
            "Dunbar",
            "Durand",
            "Eagle",
            "Eagle River",
            "East Ellsworth",
            "East Troy",
            "Eastman",
            "Eaton",
            "Eau Claire",
            "Eau Galle",
            "Eden",
            "Edgar",
            "Edgerton",
            "Edgewater",
            "Edmund",
            "Egg Harbor",
            "Eland",
            "Elcho",
            "Elderon",
            "Eldorado",
            "Eleva",
            "Elk Mound",
            "Elkhart Lake",
            "Elkhorn",
            "Ellison Bay",
            "Ellsworth",
            "Elm Grove",
            "Elmwood",
            "Elroy",
            "Elton",
            "Embarrass",
            "Emerald",
            "Endeavor",
            "Ephraim",
            "Ettrick",
            "Eureka",
            "Evansville",
            "Exeland",
            "Fairchild",
            "Fairwater",
            "Fall Creek",
            "Fall River",
            "Fence",
            "Fennimore",
            "Ferryville",
            "Fifield",
            "Fish Creek",
            "Florence",
            "Fond du Lac",
            "Fontana",
            "Footville",
            "Forest",
            "Forest Junction",
            "Forestville",
            "Fort Atkinson",
            "Fountain City",
            "Fox Lake",
            "Foxboro",
            "Francis Creek",
            "Franklin",
            "Franksville",
            "Frederic",
            "Fredonia",
            "Freedom",
            "Fremont",
            "Friendship",
            "Friesland",
            "Galesville",
            "Galloway",
            "Gays Mills",
            "Genesee Depot",
            "Genoa",
            "Genoa City",
            "Georgetown",
            "Germantown",
            "Gile",
            "Gillett",
            "Gilman",
            "Gilmanton",
            "Gleason",
            "Glen Flora",
            "Glen Haven",
            "Glenbeulah",
            "Glenwood City",
            "Glidden",
            "Goodman",
            "Gordon",
            "Gotham",
            "Grafton",
            "Grand Marsh",
            "Grand View",
            "Granton",
            "Grantsburg",
            "Gratiot",
            "Green Bay",
            "Green Lake",
            "Green Valley",
            "Greenbush",
            "Greendale",
            "Greenleaf",
            "Greenville",
            "Greenwood",
            "Gresham",
            "Hager City",
            "Hales Corners",
            "Hammond",
            "Hancock",
            "Hannibal",
            "Hanover",
            "Harshaw",
            "Hartford",
            "Hartland",
            "Hatley",
            "Haugen",
            "Hawkins",
            "Hawthorne",
            "Hayward",
            "Hazel Green",
            "Hazelhurst",
            "Heafford Junction",
            "Helenville",
            "Herbster",
            "Hertel",
            "Hewitt",
            "High Bridge",
            "Highland",
            "Hilbert",
            "Hillpoint",
            "Hillsboro",
            "Hillsdale",
            "Hingham",
            "Hixton",
            "Holcombe",
            "Hollandale",
            "Holmen",
            "Honey Creek",
            "Horicon",
            "Hortonville",
            "Hubertus",
            "Hudson",
            "Humbird",
            "Hurley",
            "Hustisford",
            "Hustler",
            "Independence",
            "Iola",
            "Irma",
            "Iron Belt",
            "Iron Ridge",
            "Iron River",
            "Ixonia",
            "Jackson",
            "Janesville",
            "Jefferson",
            "Jim Falls",
            "Johnson Creek",
            "Juda",
            "Jump River",
            "Junction City",
            "Juneau",
            "Kansasville",
            "Kaukauna",
            "Kellnersville",
            "Kempster",
            "Kendall",
            "Kennan",
            "Kenosha",
            "Keshena",
            "Kewaskum",
            "Kewaunee",
            "Kickapoo",
            "Kiel",
            "Kieler",
            "Kimberly",
            "King",
            "Kingston",
            "Knapp",
            "Kohler",
            "Kossuth",
            "Krakow",
            "La Crosse",
            "La Farge",
            "La Pointe",
            "La Valle",
            "Lac Du Flambeau",
            "Ladysmith",
            "Lake Delton",
            "Lake Geneva",
            "Lake Mills",
            "Lake Nebagamon",
            "Lake Tomahawk",
            "Lakewood",
            "Lancaster",
            "Land O Lakes",
            "Lannon",
            "Laona",
            "Larsen",
            "Lebanon",
            "Lena",
            "Leopolis",
            "Lewis",
            "Liberty Grove",
            "Lime Ridge",
            "Linden",
            "Little Black",
            "Little Chute",
            "Little Suamico",
            "Livingston",
            "Lodi",
            "Loganville",
            "Lomira",
            "Lone Rock",
            "Long Lake",
            "Lowell",
            "Loyal",
            "Lublin",
            "Luck",
            "Ludington",
            "Luxemburg",
            "Lyndon Station",
            "Lynxville",
            "Lyons",
            "Madison",
            "Maiden Rock",
            "Malone",
            "Manawa",
            "Manitowish Waters",
            "Manitowoc",
            "Maple",
            "Maplewood",
            "Marathon",
            "Marengo",
            "Maribel",
            "Marinette",
            "Marion",
            "Markesan",
            "Marquette",
            "Marshall",
            "Marshfield",
            "Mason",
            "Mather",
            "Mattoon",
            "Mauston",
            "Mayville",
            "Mazomanie",
            "McFarland",
            "McNaughton",
            "Medford",
            "Medina",
            "Mellen",
            "Melrose",
            "Menasha",
            "Menomonee Falls",
            "Menomonie",
            "Mequon",
            "Mercer",
            "Merrill",
            "Merrillan",
            "Merrimac",
            "Merton",
            "Middleton",
            "Mikana",
            "Milladore",
            "Millston",
            "Milltown",
            "Milton",
            "Milwaukee",
            "Mindoro",
            "Mineral Point",
            "Minocqua",
            "Minong",
            "Mishicot",
            "Mondovi",
            "Monroe",
            "Montello",
            "Montfort",
            "Monticello",
            "Montreal",
            "Morrisonville",
            "Mosinee",
            "Mount Calvary",
            "Mount Hope",
            "Mount Horeb",
            "Mount Sterling",
            "Mountain",
            "Mukwonago",
            "Muscoda",
            "Muskego",
            "Nashotah",
            "Necedah",
            "Neenah",
            "Neillsville",
            "Nekoosa",
            "Nelson",
            "Nelsonville",
            "Neopit",
            "Neosho",
            "Neshkoro",
            "New Auburn",
            "New Berlin",
            "New Diggings",
            "New Franken",
            "New Glarus",
            "New Holstein",
            "New Lisbon",
            "New London",
            "New Munster",
            "New Richmond",
            "Newburg",
            "Newton",
            "Niagara",
            "Nichols",
            "North Freedom",
            "North Lake",
            "North Prairie",
            "Norwalk",
            "Oak Creek",
            "Oakdale",
            "Oakfield",
            "Oconomowoc",
            "Oconto",
            "Oconto Falls",
            "Odanah",
            "Ogdensburg",
            "Ogema",
            "Ojibwa",
            "Okauchee",
            "Omro",
            "Onalaska",
            "Oneida",
            "Ontario",
            "Oostburg",
            "Oregon",
            "Orfordville",
            "Osceola",
            "Oshkosh",
            "Osseo",
            "Owen",
            "Oxford",
            "Packwaukee",
            "Palmyra",
            "Pardeeville",
            "Park Falls",
            "Patch Grove",
            "Pearson",
            "Pelican Lake",
            "Pell Lake",
            "Pembine",
            "Pepin",
            "Peshtigo",
            "Pewaukee",
            "Phelps",
            "Phillips",
            "Phlox",
            "Pickerel",
            "Pickett",
            "Pigeon Falls",
            "Pine River",
            "Pittsville",
            "Plain",
            "Plainfield",
            "Platteville",
            "Pleasant Prairie",
            "Plover",
            "Plum City",
            "Plymouth",
            "Poplar",
            "Port Edwards",
            "Port Washington",
            "Port Wing",
            "Portage",
            "Porterfield",
            "Potosi",
            "Potter",
            "Pound",
            "Powers Lake",
            "Poy Sippi",
            "Poynette",
            "Prairie Du Chien",
            "Prairie Du Sac",
            "Prairie Farm",
            "Prentice",
            "Prescott",
            "Presque Isle",
            "Princeton",
            "Pulaski",
            "Racine",
            "Radisson",
            "Randolph",
            "Random Lake",
            "Readfield",
            "Readstown",
            "Redgranite",
            "Reedsburg",
            "Reedsville",
            "Reeseville",
            "Rewey",
            "Rhinelander",
            "Rib Lake",
            "Rice Lake",
            "Richfield",
            "Richland Center",
            "Ridgeland",
            "Ridgeway",
            "Ringle",
            "Rio",
            "Ripon",
            "River Falls",
            "Roberts",
            "Rochester",
            "Rock Falls",
            "Rock Springs",
            "Rockland",
            "Rosendale",
            "Rosholt",
            "Rothschild",
            "Royalton",
            "Rubicon",
            "Rudolph",
            "Saint Cloud",
            "Saint Croix Falls",
            "Saint Francis",
            "Saint Germain",
            "Saint Joseph",
            "Saint Nazianz",
            "Salem",
            "Sand Creek",
            "Sarona",
            "Sauk City",
            "Saukville",
            "Saxeville",
            "Saxon",
            "Sayner",
            "Scandinavia",
            "Schofield",
            "Seneca",
            "Sextonville",
            "Seymour",
            "Sharon",
            "Shawano",
            "Sheboygan",
            "Sheboygan Falls",
            "Sheldon",
            "Shell Lake",
            "Sherwood",
            "Shiocton",
            "Shullsburg",
            "Silver Lake",
            "Sinsinawa",
            "Siren",
            "Sister Bay",
            "Slinger",
            "Sobieski",
            "Soldiers Grove",
            "Solon Springs",
            "Somers",
            "Somerset",
            "South Milwaukee",
            "South Range",
            "South Wayne",
            "Sparta",
            "Spencer",
            "Spooner",
            "Spring Green",
            "Spring Valley",
            "Springbrook",
            "Springfield",
            "Stanley",
            "Star Lake",
            "Star Prairie",
            "Stetsonville",
            "Steuben",
            "Stevens Point",
            "Stitzer",
            "Stockbridge",
            "Stockholm",
            "Stoddard",
            "Stone Lake",
            "Stoughton",
            "Stratford",
            "Strum",
            "Sturgeon Bay",
            "Sturtevant",
            "Suamico",
            "Sullivan",
            "Summit Lake",
            "Sun Prairie",
            "Superior",
            "Suring",
            "Sussex",
            "Taylor",
            "Tennyson",
            "Theresa",
            "Thiensville",
            "Thorp",
            "Three Lakes",
            "Tigerton",
            "Tilleda",
            "Tisch Mills",
            "Tomah",
            "Tomahawk",
            "Tony",
            "Townsend",
            "Trego",
            "Trempealeau",
            "Trevor",
            "Tripoli",
            "Tunnel City",
            "Turtle Lake",
            "Twin Lakes",
            "Two Rivers",
            "Union Center",
            "Union Grove",
            "Unity",
            "Upson",
            "Valders",
            "Van Dyne",
            "Verona",
            "Vesper",
            "Viola",
            "Viroqua",
            "Wabeno",
            "Waldo",
            "Wales",
            "Walworth",
            "Warrens",
            "Wascott",
            "Washburn",
            "Washington Island",
            "Waterford",
            "Waterloo",
            "Watertown",
            "Waukau",
            "Waukesha",
            "Waunakee",
            "Waupaca",
            "Waupun",
            "Wausau",
            "Wausaukee",
            "Wautoma",
            "Wauzeka",
            "Webster",
            "West Bend",
            "West Salem",
            "Westboro",
            "Westby",
            "Westfield",
            "Weyauwega",
            "Weyerhaeuser",
            "Wheeler",
            "White Lake",
            "Whitehall",
            "Whitelaw",
            "Whitewater",
            "Wild Rose",
            "Willard",
            "Williams Bay",
            "Willow",
            "Wilmot",
            "Wilson",
            "Wilton",
            "Windsor",
            "Winnebago",
            "Winneconne",
            "Winter",
            "Wisconsin Dells",
            "Wisconsin Rapids",
            "Withee",
            "Wittenberg",
            "Wonewoc",
            "Woodford",
            "Woodland",
            "Woodman",
            "Woodruff",
            "Woodville",
            "Woodworth",
            "Wrightstown",
            "Wyocena",
            "Zachow",
            "Zenda"
        ]
    },
    {
        "state": "Wyoming",
        "abbr": "WY",
        "cities": [
            "Afton",
            "Aladdin",
            "Albin",
            "Alcova",
            "Alpine",
            "Alva",
            "Arapahoe",
            "Arminto",
            "Arvada",
            "Auburn",
            "Baggs",
            "Bairoil",
            "Banner",
            "Basin",
            "Bedford",
            "Beulah",
            "Big Horn",
            "Big Piney",
            "Bill",
            "Bondurant",
            "Bosler",
            "Boulder",
            "Buffalo",
            "Buford",
            "Burlington",
            "Burns",
            "Byron",
            "Carlile",
            "Carpenter",
            "Casper",
            "Centennial",
            "Cheyenne",
            "Chugwater",
            "Clearmont",
            "Cody",
            "Cokeville",
            "Cora",
            "Cowley",
            "Crowheart",
            "Daniel",
            "Dayton",
            "Deaver",
            "Devils Tower",
            "Diamondville",
            "Dixon",
            "Douglas",
            "Dubois",
            "Edgerton",
            "Elk Mountain",
            "Emblem",
            "Encampment",
            "Etna",
            "Evanston",
            "Evansville",
            "Fairview",
            "Farson",
            "Fe Warren AFB",
            "Fort Bridger",
            "Fort Laramie",
            "Fort Washakie",
            "Four Corners",
            "Frannie",
            "Frontier",
            "Garrett",
            "Gillette",
            "Glendo",
            "Glenrock",
            "Granger",
            "Granite Canon",
            "Green River",
            "Greybull",
            "Grover",
            "Guernsey",
            "Hamilton Dome",
            "Hanna",
            "Hartville",
            "Hawk Springs",
            "Hiland",
            "Hillsdale",
            "Horse Creek",
            "Hudson",
            "Hulett",
            "Huntley",
            "Hyattville",
            "Jackson",
            "Jay Em",
            "Jeffrey City",
            "Kaycee",
            "Kelly",
            "Kemmerer",
            "Kinnear",
            "Kirby",
            "La Barge",
            "Lagrange",
            "Lance Creek",
            "Lander",
            "Laramie",
            "Leiter",
            "Linch",
            "Lingle",
            "Little America",
            "Lontetree",
            "Lost Springs",
            "Lovell",
            "Lusk",
            "Lyman",
            "Lysite",
            "Manderson",
            "Manville",
            "McKinnon",
            "Medicine Bow",
            "Meeteetse",
            "Meriden",
            "Midwest",
            "Mills",
            "Moorcroft",
            "Moose",
            "Moran",
            "Mountain View",
            "Natrona",
            "Newcastle",
            "Opal",
            "Osage",
            "Otto",
            "Parkman",
            "Pavillion",
            "Pinedale",
            "Point Of Rocks",
            "Powder River",
            "Powell",
            "Ralston",
            "Ranchester",
            "Rawlins",
            "Recluse",
            "Reliance",
            "Riverton",
            "Robertson",
            "Rock River",
            "Rock Springs",
            "Rozet",
            "Saddlestring",
            "Saint Stephens",
            "Saratoga",
            "Savery",
            "Shawnee",
            "Shell",
            "Sheridan",
            "Shirley Basin",
            "Shoshoni",
            "Sinclair",
            "Smoot",
            "Story",
            "Sundance",
            "Superior",
            "Ten Sleep",
            "Teton Village",
            "Thayne",
            "Thermopolis",
            "Tie Siding",
            "Torrington",
            "Upton",
            "Van Tassell",
            "Veteran",
            "Vista West",
            "Walcott",
            "Wamsutter",
            "Wapiti",
            "Weston",
            "Wheatland",
            "Wilson",
            "Wolf",
            "Worland",
            "Wright",
            "Wyarno",
            "Yellowstone National Park",
            "Yoder"
        ]
    }
]

export default statesncities